// France
export const locale = {
	lang: 'fr',
	data: {
		WHAT_IF: {
			SIMULATION: { ACTUAL_VALUE: 'Valeur réelle' },
			GRAPH: {
				BASELINE_TIMESTAMP: 'Horodatage de référence',
				NO_DATA: 'Aucune donnée trouvée !',
				RUN_SIMULATION_TITLE: 'Exécutez une simulation pour afficher les résultats du graphique',
				RUN_SIMULATION_HINT: 'Cliquez sur « Exécuter » après avoir configuré les paramètres de simulation.',
				RAW_TAG_DEPENDENCY: 'Dépendance des tags bruts',
				BASELINE: 'Référence',
				SIMULATION: 'Simulation',
				SIMULATED: 'Simulé',
			},
			SEARCH: {
				PLACEHOLDER: 'Rechercher installation, système, unité ou tag',
				SEARCHING: 'Recherche…',
				NO_RESULTS: 'Aucune correspondance trouvée',
				ERROR: 'Échec de la recherche. Veuillez réessayer.',
			},
			TABLE: {
				DELTA_TOOLTIP: 'Variation absolue (Simulé − Référence)',
				DELTA_PERCENT_TOOLTIP: 'Variation en pourcentage par rapport à la référence',
				IMPACT_PROGRESS: 'Progression de l\'impact',
				IMPACT: 'Impact',
			},
			IMPACTED_KPI: {
				TITLE: 'KPI calculés impactés ({{count}})',
				NO_IMPACTED_KPIS: 'Aucun KPI impacté pour le moment',
				EMPTY_HINT: 'Sélectionnez des tags bruts à gauche pour voir l\'impact sur les KPI en aval.',
				LOADING: 'Chargement des tags calculés...',
				SELECTION_HINT: '{{checked}} sur {{total}} KPI sélectionnés dans le système principal — décochez pour exclure de la simulation. Les puces « alimenté par » indiquent quels tags bruts influencent chaque KPI. Les systèmes similaires partageant la même signature de tag sont listés ci-dessous comme impacts inter-systèmes en lecture seule.',
				CROSS_SYSTEM_IMPACT: 'Impact inter-systèmes',
				KPI_COUNT: '{{count}} KPI',
				TAG_PARAMETER: 'Tag / Paramètre',
				CALCULATED_TAG: 'Tag calculé',
				DRIVEN_BY: 'Alimenté par :',
			},
			PAGE: {
				TITLE: 'What-If',
				SELECT_RAW_TAGS_TITLE: 'Sélectionner les tags bruts à simuler',
				SELECT_RAW_TAGS_SUBTITLE: 'Choisissez des tags dans la hiérarchie ci-dessous',
				SIMULATION_SETUP_TITLE: 'Configuration de la simulation',
				SIMULATION_SETUP_SUBTITLE: 'Sélectionnez des tags ci-dessus pour commencer',
				RUN: 'Exécuter',
				RESET: 'Réinitialiser',
				NO_TAGS_SELECTED: 'Aucun tag sélectionné',
				NO_TAGS_SELECTED_DESC: 'Choisissez des tags bruts ci-dessus pour définir les changements.',
				CLICK_TIMESTAMP_HINT: 'Cliquez n\'importe où sur le graphique pour sélectionner un horodatage d\'état opérationnel.',
				CLICK_RANGE_HINT: 'Cliquez deux fois sur le graphique pour sélectionner la plage d\'état opérationnel.',
				SELECTED_OPERATING_STATE: 'État opérationnel sélectionné :',
				SELECTED_OPERATING_RANGE: 'Plage opérationnelle sélectionnée :',
				FIRST_POINT_PREFIX: 'Premier point :',
				FIRST_POINT_SUFFIX: '— cliquez à nouveau pour définir la fin de la plage.',
				SIMULATION_RESULTS: 'Résultats de la simulation',
				TABLE_VIEW: 'Vue tableau',
				RUN_SIMULATION_TABLE_TITLE: 'Exécutez une simulation pour voir les résultats du tableau',
				TABLE_UNAVAILABLE_PERIOD: 'La vue tableau n\'est pas disponible pour les simulations de période',
				SWITCH_TO_SINGLE_POINT: 'Passez au mode « Point unique » ou utilisez l\'onglet Vue graphique.',
				NO_KPI_ROWS: 'Aucune ligne de KPI à afficher',
				NO_KPI_ROWS_DESC: 'Tous les KPI impactés sont décochés. Sélectionnez des KPI dans l\'onglet KPI impactés pour les voir ici.',
				GRAPH_VIEW: 'Vue graphique',
				SIMULATION_TYPE_PERCENT: '% de variation',
				SIMULATION_TYPE_ABSOLUTE: 'Valeur absolue',
				TIME_CONTEXT_SINGLE: 'Point unique',
				TIME_CONTEXT_PERIOD: 'Période',
			},
			IMPACTED_KPIS_TAB_LABEL: 'KPI impactés',
			IMPACTED_KPIS_TAB_LABEL_COUNT: 'KPI impactés ({{count}})',
			HIERARCHY_TOOLTIP: {
				TAG_NAME: 'Nom de balise',
				TAG_ID: 'ID de balise',
				TAG_DESCRIPTION: 'Description',
				ASSET_NAME: "Nom de l'actif",
				SYSTEM_NAME: 'Nom du système',
			},
		},
		TRANSLATOR: {
			SELECT: 'choisissez votre langue',
		},
		VALIDATION: {
			REQUIRED: 'Ce champ est obligatoire',
			PATTERN: 'Format invalide',
			MIN: 'La valeur est trop petite',
			MAX: 'La valeur est trop grande',
			MIN_LENGTH: 'La valeur est trop courte',
			MAX_LENGTH: 'La valeur est trop longue',
			SELECT_AT_LEAST_ONE: 'Sélectionnez au moins une option',
			INVALID: 'Valeur invalide',
			FIELD_REQUIRED: '{{field}} est requis',
		},
		COMMON: {
			NO_MATCHES: 'Aucun résultat trouvé pour "{{keyword}}"',
			TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Essayez un mot clé différent ou effacez la recherche',
			SELECT_A_SYSTEM: 'Sélectionnez un système.',
			SELECT_DIFF_UNIT: 'Sélectionnez une unité ou un site différent',
			SELECT_DIFF: 'Sélectionnez un site, une unité ou un système différent',
			NO_TAGS_FOUND: 'Aucune étiquette trouvée',
			SELECT_FACILITY: 'Sélectionnez un site différent',
			ADDED_FROM_ROOTY: 'Ajouté depuis {{name}}',
		},
		COMMENT_POPUP: {
			TITLE: 'Laisser un commentaire',
			ENTER_MESSAGE: 'Saisissez votre message',
			COMMENT_PLACEHOLDER: 'Ajoutez un commentaire, utilisez @ pour identifier les membres de l\'équipe',
			FILE_SIZE_LIMIT_ERROR: 'Échec du téléchargement de {{fileName}} en raison de la limite de taille de fichier.',
			UPLOAD_FAILED_ERROR: 'Échec du téléchargement de {{fileName}}.',
			INVALID_FILES_ERROR: 'Aucun fichier valide sélectionné. Seuls les fichiers avec les extensions {{extensions}} sont autorisés',
		},
		REGENERATE_HYPOTHESES_POPUP: {
			TITLE: 'Régénérer les hypothèses',
			DESCRIPTION: 'Toutes les hypothèses seront régénérées à partir des retours fournis sur la chaîne causale, les recommandations et les preuves proposées. La version actuelle sera enregistrée dans l\'historique.',
			REGENERATION_CONTEXT: 'Contexte de régénération',
			TOTAL_FEEDBACKS: 'Total des retours',
			ADDED_AS_EVIDENCE: 'Ajouté comme preuve',
			APPROVED: 'Approuvé',
			RELEARNED: 'Réappris',
			SETTINGS: 'Paramètres',
			DOCUMENT_INSIGHTS: 'Informations sur les documents',
			SAP_INSIGHTS: 'Informations SAP',
			CONNECTED_SYSTEMS_REVIEW: 'Revue des systèmes connectés',
			ALERT_REVIEW_WINDOW: 'Fenêtre de revue des alertes',
			DAYS: 'Jours',
			RESET_AND_RERUN: 'Réinitialiser et relancer',
			RESET_AND_RERUN_INFO: 'Les hypothèses, retours, recommandations et preuves proposées précédents seront ignorés. L\'analyse RCA sera régénérée entièrement à partir des dernières données disponibles.',
			VERSION_HISTORY_NOTE: 'Les hypothèses actuelles seront enregistrées dans l\'historique des versions. Vous pouvez restaurer une version précédente à tout moment.',
			USER_CONSENT: 'Je comprends que le contexte RCA précédent ne sera pas utilisé pour cette exécution.',
			CANCEL: 'Annuler',
			REGENERATE_ALL: 'Tout régénérer',
			REGENERATE_ALL_TOOLTIP: 'Améliorer l\'analyse RCA actuelle à l\'aide du contexte existant',
			RESET_AND_RERUN_BTN: 'Réinitialiser et relancer',
			RESET_AND_RERUN_TOOLTIP: 'Générer une nouvelle analyse RCA à partir de zéro',
		},
		SHARE_REPORT_POPUP: {
			TITLE: 'Partager le rapport',
			ADD_PEOPLE: 'Ajouter des personnes',
			MESSAGE: 'Message',
			MESSAGE_PLACEHOLDER: 'Saisissez votre message (facultatif)',
			COPY_LINK: 'Copier le lien',
			CANCEL: 'Annuler',
			SEND: 'Envoyer',
		},
		FEEDBACK_POPUP: {
			PREVIOUSLY_APPROVED: 'Précédemment approuvé',
			PREVIOUSLY_RELEARNED: 'Précédemment réappris',
			SEE_LESS: 'Voir moins',
			SEE_MORE: 'Voir plus...',
			FEEDBACK_LABEL: 'Commentaire',
			FEEDBACK_TOOLTIP: 'Ce commentaire sera utilisé lors de la réexécution de la RCA.',
			CANCEL: 'Annuler',
			CONFIRM: 'Confirmer',
			RELEARNED_BY: 'Réappris par :',
			NO_REASON_ADDED: 'Aucune raison ajoutée',
		},
		ASK_ROOTY_POPUP: {
			ENTER_MESSAGE_TO_START: 'Saisissez votre message pour démarrer une discussion',
			MESSAGE_PLACEHOLDER: 'Saisissez votre message...',
		},
		ROOTY_CHAT: {
			FOLLOW_UP_SUGGESTIONS: 'Suggestions de suivi',
			ASK_TITLE: 'Demander à {{name}}',
			UPLOAD_TOOLTIP: 'Téléchargez des fichiers PDF, Word, Excel, PNG, JPG et JPEG pour que {{name}} les analyse.',
			DISCLAIMER: '{{name}} fournit des réponses assistées par IA qui peuvent ne pas toujours être exactes. Vérifiez avant d\'agir.',
			FEEDBACK_SUBTITLE: 'Sélectionnez le problème principal afin que nous puissions améliorer les futures réponses de {{name}}.',
			POPUP_TITLE: 'Demander à {{name}}',
			NOT_ENABLED: `{{name}} n'est pas activé pour l'utilisateur actuel.`,
			SHARE: 'Partager',
			RENAME: 'Renommer',
			DELETE: 'Supprimer',
			HISTORY: 'Historique',
			CLOSE: 'Fermer',
			SEARCH: 'Rechercher...',
			UNSAVED: 'Non enregistré',
			NO_HISTORY_HEADING: 'Aucun historique disponible.',
			NO_HISTORY_DESC: 'Nous n\'avons trouvé aucune donnée historique.',
			START_NEW_CHAT: 'Démarrer une nouvelle discussion',
			AGENT_CONTEXT_TOOLTIP: 'Contexte de l\'agent',
			CHAT_HISTORY_TOOLTIP: 'Historique des discussions',
			UNPIN: 'Détacher',
			PIN: 'Épingler',
			FULL_SCREEN: 'Plein écran',
			EXIT_FULL_SCREEN: 'Quitter le plein écran',
			EXPAND: 'Développer',
			COLLAPSE: 'Réduire',
			INTRO_TITLE: 'Bonjour ! Besoin d\'aide avec ce que vous regardez ?',
			INTRO_DESC: 'Demandez-moi n\'importe quoi ou je peux résumer cet écran, expliquer les tendances, comparer des éléments et suggérer les prochaines étapes.',
			SUGGESTIONS: 'Suggestions',
			SUGGESTION_1: 'Résumez cette RCA en 30 secondes (ce qui s\'est passé et pourquoi).',
			SUGGESTION_2: 'Quelle hypothèse est la plus étayée par les preuves présentées ici ?',
			SUGGESTION_3: 'Comparez les hypothèses : quelle est la preuve la plus solide pour chacune ?',
			CP_INTRO_TITLE: 'Bonjour ! Besoin d\'aide pour l\'optimisation de la capacité et la planification de scénarios ?',
			CP_INTRO_DESC: 'Je peux vous aider à créer des modèles de planification, tester des scénarios de déclenchement d\'unités, simuler la croissance de la demande de pointe et analyser la faisabilité en matière d\'énergie et d\'eau.',
			CP_SUGGESTION_1: 'Résumez le coût total de production, la consommation de combustible et la répartition par centrale pour cette exécution.',
			CP_SUGGESTION_2: 'Quelle est notre marge de réserve tournante et y a-t-il des heures de déficit ?',
			CP_SUGGESTION_3: 'Que se passerait-il si H5_GT se déconnectait pendant la demande de pointe ?',
			CP_SUGGESTION_4: 'Simulez une croissance de +5% de la demande de pointe pour ce scénario.',
			LOADING_EARLIER: 'Chargement de la conversation précédente…',
			SHOW_EARLIER: 'Afficher la conversation précédente',
			RESPONSE_STOPPED: 'Génération de réponse arrêtée',
			LOADING_ALT: 'Chargement',
			THINKING: 'Réflexion en cours',
			THOUGHT_FOR: 'A réfléchi pendant {{seconds}}s',
			DOWNLOAD_CSV: 'Télécharger le CSV',
			COPY_CSV: 'Copier le CSV',
			DOWNLOAD_IMAGE: 'Télécharger l\'image',
			COPY_IMAGE: 'Copier l\'image',
			WHAT_IF_SCENARIO_CREATED: 'Scénario What-If créé',
			CHANGE_APPLIED: 'Changement appliqué :',
			NEW_SCENARIO: 'Nouveau scénario :',
			VIEW_CONFIGURATION: 'Voir la configuration',
			RUN_OPTIMIZATION: 'Exécuter l\'optimisation',
			RESULTS_COMPARISON: 'Comparaison des résultats',
			ALL_IMPROVED: 'Tout s\'est amélioré',
			KPI: 'KPI',
			BASE: 'Base',
			WHAT_IF: 'What-If',
			YES: 'Oui',
			NO: 'Non',
			CHANGED: 'modifié',
			WHATIF_KPI_POWER_FEASIBLE: 'Puissance faisable',
			WHATIF_KPI_WATER_FEASIBLE: 'Eau faisable',
			WHATIF_KPI_EST_COST: 'Coût estimé',
			WHATIF_KPI_POWER_SHORTFALL: 'Déficit de puissance',
			WHATIF_KPI_WATER_SHORTFALL: 'Déficit d\'eau',
			WHATIF_KPI_AVG_GENERATION: 'Production moyenne',
			WHATIF_KPI_AVG_HEADROOM: 'Marge moyenne',
			WHATIF_KPI_TOTAL_STARTS: 'Démarrages totaux',
			WHATIF_KPI_AVG_WATER_OUTPUT: 'Production d\'eau moyenne',
			WHATIF_KPI_GAP_PERCENT: 'Écart %',
			WHATIF_POWER_BALANCE: 'Bilan de puissance (MW)',
			WHATIF_TIME_AXIS: 'Temps',
			WHATIF_POWER_AXIS: 'Puissance (MW)',
			WHATIF_WATER_OUTPUT: 'Production d\'eau (MIGD)',
			WHATIF_WATER_AXIS: 'Eau (MIGD)',
			WHATIF_TRACE_DEMAND: 'Demande',
			WHATIF_TRACE_GEN: 'Prod.',
			WHATIF_TRACE_WATER: 'Eau',
			NO_MAJOR_DIFF: 'Aucun KPI n\'a changé de plus de 5 % entre les deux scénarios.',
			VIEW_FULL_RESULTS: 'Voir tous les résultats',
			APPLY_AS_EVIDENCE: 'Appliquer comme preuve',
			ADDED_AS_EVIDENCE: 'Ajouté comme preuve',
			ALREADY_ADDED_AS_EVIDENCE: 'Déjà ajouté comme preuve',
			ADD_AS_EVIDENCE: 'Ajouter comme preuve',
			BRANCH_VISIBILITY_NOTICE: 'Les nouveaux messages ne sont visibles que par vous.',
			CONTINUE: 'Continuer',
			SEARCH_SCENARIOS: 'Rechercher des scénarios...',
			FILTER_SCENARIOS: 'Filtrer les scénarios',
			SOURCE: 'Source',
			ALL_SOURCES: 'Toutes les sources',
			HUMAN_MANUAL: 'Manuel (Humain)',
			AI_GENERATED: 'Généré par IA',
			STRATEGY_AUTO: 'Stratégie (Automatique)',
			DATE_MODIFIED: 'Date de modification',
			ALL_TIME: 'Toute la période',
			TODAY: 'Aujourd\'hui',
			LAST_7_DAYS: '7 derniers jours',
			RECENT: 'Récent',
			OFFICIAL: 'Officiel',
			ALL_SCENARIOS: 'Tous les scénarios',
			NO_SCENARIOS_MATCH: 'Aucun scénario ne correspond à "{{query}}"',
			DRAFT: 'Brouillon',
			DISMISS: 'Ignorer',
			CONTEXT_PREFIX: 'Contexte :',
			REMOVE_CONTEXT: 'Supprimer le contexte',
			SELECT_A_SCENARIO: 'Sélectionner un scénario',
			CLEAR_SCENARIO: 'Effacer le scénario',
			LATEST_RUN_DEFAULT: 'Dernière exécution (Par défaut)',
			DROP_FILES_HERE: 'Déposez les fichiers ici',
			COMPOSER_PLACEHOLDER: 'Posez une question ou faites une demande...',
			ADD_FILES_OR_IMAGES: 'Ajouter des fichiers ou des images',
			LANGUAGE: 'Langue',
			MIC_BLOCKED: 'L\'accès au microphone est bloqué. Autorisez la permission du microphone',
			USE_VOICE_INPUT: 'Utiliser la saisie vocale',
			VOICE_INPUT_ALT: 'Saisie vocale',
			STOP_RECORDING: 'Arrêter l\'enregistrement',
			STOP_RECORDING_ALT: 'Arrêter l\'enregistrement',
			STOP_GENERATION: 'Arrêter la génération',
			SEND_ALT: 'Envoyer',
			FEEDBACK_WHAT_WENT_WRONG: 'Qu\'est-ce qui n\'a pas fonctionné avec cette réponse ?',
			FEEDBACK_CATEGORY: 'Catégorie de commentaire',
			SELECT_AN_ISSUE: 'Sélectionner un problème',
			SELECT_CATEGORY_TO_CONTINUE: 'Veuillez sélectionner une catégorie pour continuer',
			ADDITIONAL_DETAILS_OPTIONAL: 'Détails supplémentaires (Facultatif)',
			FEEDBACK_COMMENT_PLACEHOLDER: 'Dites-nous en plus sur ce qui n\'allait pas.',
			CANCEL: 'Annuler',
			SUBMIT_FEEDBACK: 'Envoyer le commentaire',
			ERROR: 'Erreur',
			FEEDBACK_SUBMIT_ERROR: 'Le commentaire n\'a pas pu être envoyé. Veuillez réessayer.',
			TRY_AGAIN: 'Réessayer',
			OPEN_LINK: 'Ouvrir le lien',
			OPEN_DOCUMENT: 'Ouvrir le document',
			PAGE_PREFIX: 'Page-{{page}}',
			FEEDBACK_CATEGORY_INCORRECT_ANSWER: 'Réponse incorrecte',
			FEEDBACK_CATEGORY_DID_NOT_ANSWER: 'N\'a pas répondu à ma question',
			FEEDBACK_CATEGORY_MISSING_DATA: 'Données pertinentes manquantes',
			FEEDBACK_CATEGORY_INCORRECT_REASONING: 'Analyse ou raisonnement incorrect',
			FEEDBACK_CATEGORY_POOR_CHART: 'Graphique ou visualisation médiocre',
			FEEDBACK_CATEGORY_POOR_DOCUMENT: 'Réponse de document médiocre',
			FEEDBACK_CATEGORY_TOO_SLOW: 'La requête était trop lente',
			FEEDBACK_CATEGORY_INCOMPLETE: 'La réponse était incomplète',
			FEEDBACK_CATEGORY_OTHER: 'Autre',
			CHATBOT_PRIVATE: 'Privé',
			CHATBOT_INHOUSE_GPT: 'Inhouse GPT',
			LANGUAGE_ENGLISH_US: 'Anglais (US)',
			LANGUAGE_ARABIC: 'Arabe',
			MODE_AUTO: 'Auto',
			MODE_GENERAL: 'Général',
			MODE_DOCS: 'Documents',
			MODE_OPTIMIZER: 'Optimiseur',
			DATE_TODAY: 'Aujourd\'hui',
			DATE_YESTERDAY: 'Hier',
			DATE_THIS_WEEK: 'Cette semaine',
			DATE_LAST_WEEK: 'La semaine dernière',
			DATE_THIS_MONTH: 'Ce mois-ci',
			DATE_LAST_MONTH: 'Le mois dernier',
			DATE_OLDER: 'Plus ancien',
			CONTEXT: {
				FROM: 'Contexte depuis {{source}}',
				LAUNCHED_FROM: 'Rooty lancé depuis {{source}}',
				UPDATED: 'Contexte mis à jour',
				REMOVED: 'Contexte supprimé',
				APPLIED: 'Contexte appliqué',
				GENERAL: 'utilise désormais le contexte de discussion général',
				MORE: 'Plus',
				SEE_LESS: 'Voir moins',
				LABEL: {
					ALERT: 'Alerte',
					RCA: 'RCA',
					SCOPE: 'Périmètre',
					SYSTEM: 'Système',
					SCENARIO: 'Scénario',
					SIMULATION_TYPE: 'Type de simulation',
					PREVIOUS: 'Précédent',
					NEW: 'Nouveau',
					SOURCE: 'Source',
				},
				SOURCE: {
					ALERT: `Détails de l'alerte`,
					RCA: 'RCA',
					SYSTEM: 'Vue système',
					WHAT_IF: 'Analyse de simulation',
				},
				SUMMARY: {
					ALERT: 'Alerte {{value}}',
					RCA: `RCA pour l'alerte {{value}}`,
					SYSTEM: 'Système {{value}}',
					WHAT_IF: 'Simulation : {{value}}',
				},
			},
			TOAST_FEEDBACK_THANKS: 'Merci. Nous utiliserons cela pour améliorer Rooty.',
			TOAST_FEEDBACK_POSITIVE_THANKS: 'Merci pour votre retour.',
			TOAST_COPIED_MESSAGE: 'Message copié.',
			TOAST_LINK_COPIED: 'Copié',
			TOAST_CHAT_DELETED: 'Conversation supprimée',
			TOAST_CHAT_DELETE_FAILED: 'Échec de la suppression de la conversation.',
			TOAST_NEW_CHAT_STARTED: 'Nouvelle conversation démarrée',
		},
		AGENT_CONTEXT: {
			CONSIDERED: `Contexte d'agent pris en compte`,
			ITEMS: 'éléments',
			ADD: `Ajouter un contexte d'agent`,
			UPDATED: 'Mis à jour',
			DIALOG_DESC: `Capturez des consignes opérationnelles réutilisables pour {{name}} et la RCA.`,
			DIALOG_DISCLAIMER: `Ce contexte peut influencer les futures réponses de {{name}} et de la RCA pour des analyses similaires. Il n'affecte pas la détection d'anomalies ni les modèles prédictifs.`,
			SIDEPANEL_DESC: `Connaissances opérationnelles réutilisables disponibles pour {{name}} et la RCA.`,
			SIDEPANEL_EMPTY: `Capturez des connaissances opérationnelles réutilisables pour {{name}} et la RCA, telles que des consignes de raisonnement, des guides d'investigation et la terminologie.`,
			REMOVE_CONFIRM: `"<strong>{{title}}</strong>" sera supprimé et ne sera plus pris en compte par {{name}} ou la RCA.<br>Cette action est irréversible.`,
			TITLE: 'Contexte de l\'agent',
			READ_ONLY: 'Lecture seule',
			ADD_SHORT: 'Ajouter',
			CLOSE: 'Fermer',
			SEARCH_PLACEHOLDER: 'Rechercher par titre ou portée...',
			EDIT: 'Modifier',
			DELETE: 'Supprimer',
			EMPTY_HEADING: 'Aucun contexte d\'agent pour l\'instant',
			LAST_UPDATED_PREFIX: 'Dernière mise à jour',
			BY_PREFIX: 'Par',
			SECTION_CONTEXT_TYPE: '1. TYPE DE CONTEXTE',
			SECTION_SCOPE: '2. PORTÉE',
			SECTION_CONTEXT: '3. CONTEXTE',
			SELECT_SCOPE: 'Sélectionner la portée',
			CONTEXT_TITLE_LABEL: 'Titre',
			CONTEXT_TITLE_PLACEHOLDER: 'Saisir le titre du contexte',
			GUIDANCE_LABEL: 'Description des consignes',
			GUIDANCE_PLACEHOLDER: 'Saisir la description des consignes',
			PLAYBOOK_NAME_LABEL: 'Nom du playbook',
			PLAYBOOK_NAME_PLACEHOLDER: 'Saisir le nom du playbook',
			INVESTIGATION_STEPS_LABEL: 'Étapes d\'investigation',
			STEP_PLACEHOLDER: 'Saisir la description de l\'étape',
			ADD_STEP: '+ Ajouter une étape',
			TERM_HEADER: 'Terme',
			MEANING_HEADER: 'Signification',
			TERM_PLACEHOLDER: 'Ajouter un terme',
			MEANING_PLACEHOLDER: 'Saisir la signification',
			CANCEL: 'Annuler',
			CARD_REASONING_GUIDANCE_TITLE: 'Consignes de raisonnement',
			CARD_REASONING_GUIDANCE_DESC: 'Règles d\'interprétation spécifiques à l\'usine qui aident les agents IA à raisonner sur le comportement.',
			CARD_INVESTIGATION_PLAYBOOK_TITLE: 'Playbook d\'investigation',
			CARD_INVESTIGATION_PLAYBOOK_DESC: 'Flux de dépannage structuré pour un problème opérationnel récurrent.',
			CARD_TERMINOLOGY_TITLE: 'Terminologie',
			CARD_TERMINOLOGY_DESC: 'Alias, abréviations et conventions de nommage spécifiques à l\'usine.',
			SAVE_IN_PROGRESS: 'Enregistrement en cours. Veuillez patienter.',
			SCOPE_REQUIRED: 'Une sélection de portée est requise avant l\'enregistrement.',
			TITLE_REQUIRED: 'Un titre est requis avant l\'enregistrement.',
			GUIDANCE_DESC_REQUIRED: 'Une description des consignes est requise avant l\'enregistrement.',
			PLAYBOOK_NAME_REQUIRED: 'Un nom de playbook est requis avant l\'enregistrement.',
			STEPS_REQUIRED: 'Toutes les étapes d\'investigation doivent être remplies avant l\'enregistrement.',
			TERMINOLOGY_REQUIRED: 'Toutes les entrées de terminologie doivent avoir un terme et une signification avant l\'enregistrement.',
			SOME_ERROR_OCCURRED: 'Une erreur s\'est produite',
			EDIT_TITLE: 'Modifier le contexte de l\'agent',
			SAVE_CHANGES: 'Enregistrer les modifications',
			DELETE_CONTEXT_TITLE: 'Supprimer ce contexte ?',
			DELETED_SUCCESSFULLY: 'Supprimé avec succès.',
		SECTION_GUIDANCE: 'Consignes',
		TERMS_LABEL: 'Termes',
		REASONING_LABEL: 'Raisonnement',
		PLAYBOOK_LABEL: 'Playbook',
		},
		MENU: {
			NEW: 'Nouveau',
			ACTIONS: 'Actes',
			CREATE_POST: 'Créer un nouveau Post',
			PAGES: 'Pages',
			FEATURES: 'Fonctionnalités',
			APPS: 'Applications',
			HOME: 'Accueil',
			SYSTEM: 'Système',
			ANALYSIS: 'Analyse',
			CONFIGURATION: 'Configuration',
			ALERTS: 'Alertes',
			ALERT_TRIAGE: 'Triage des Alertes',
			KNOWLEDGE_GRAPH: 'Graphe de Connaissances',
			ASSET_EXPLORER: 'Explorateur d\'Actifs',
			LIBRARY: 'Bibliothèque',
			USER_MANAGEMENT: 'Gestion des Utilisateurs',
			MODEL_WIZARD: 'Assistant Modèle',
			DASHBOARD_WIZARD: 'Assistant Tableau de Bord',
			IOW: 'IOW',
			PROCESS: 'Processus',
			GENAI: 'GenAI',
			MAINTENANCE_OPTIMIZATION: 'Optimisation de la Maintenance',
			RCM: 'RCM',
			SETTINGS: 'Paramètres',
			HAZOP: 'Hazop',
			CASES: 'Cas',
			CAPACITY_OPTIMIZATION: 'Optimisation de la Capacité',
			WHAT_IF: 'What-if',
			HEALTH_METRICS: 'Métriques de Santé',
			PLATFORM_CONFIGURATION: 'Configuration de la plateforme',
			DATA_MANAGEMENT: 'Gestion des Données',
			PLATFORM_POLICIES: 'Politiques de Plateforme',
			CONNECTIONS_APIS: 'Connexions & APIs',
			MODULE_CONFIGURATION: 'Configuration des Modules',
			AI_MANAGEMENT: 'Gestion de l\'IA',
			ROOTY: '{{name}}',
			NOTIFICATION: 'Notification',
			HELP: 'Aide',
			PROFILE: 'Mon Profil',
			LOGOUT: 'Déconnexion',
			LANGUAGE: 'Langue',
			BASIC_USER_GUIDE: 'Guide d\'Utilisation de Base',
			ADVANCED_USER_GUIDE: 'Guide d\'Utilisation Avancé'
		},
		AUTH: {
			PASSWORD_REQUIREMENTS: {
				TITLE: 'Votre mot de passe doit inclure :',
				MIN_CHARACTERS: 'Au moins 8 caractères',
				UPPERCASE_LETTER: 'Au moins 1 lettre majuscule',
				NUMBER: 'Au moins 1 chiffre',
				SPECIAL_CHARACTER: 'Au moins 1 caractère spécial',
			},
			GENERAL: {
				OR: 'Ou',
				SUBMIT_BUTTON: 'Soumettre',
				NO_ACCOUNT: 'Ne pas avoir de compte?',
				SIGNUP_BUTTON: 'Registre',
				FORGOT_BUTTON: 'Mot de passe oublié',
				BACK_BUTTON: 'Back',
				PRIVACY: 'Privacy',
				LEGAL: 'Legal',
				CONTACT: 'Contact',
				VERIFY_BUTTON: 'Vérifier',
				ENTER_OTP: 'Saisir le code OTP',
				HAVE_ACCOUNT: 'J\'ai un compte',
			},
			LOGIN: {
				TITLE: 'Créer un compte',
				BUTTON: 'Sign in',
				SIGN_IN_MICROSOFT: 'Se connecter avec Microsoft',
				SIGN_IN_SAML: 'Se connecter avec SAML',
				REMEMBER_ME: 'Se souvenir de moi',
				SIGNING_IN: 'Connexion en cours. Veuillez patienter...',
				BPCL_WELCOME: 'Bienvenue dans la solution de performance des actifs basée sur l\'IA de BPCL !',
			},
			RESET: {
				TITLE: 'Réinitialiser le mot de passe',
				SUCCESS: 'Mot de passe modifié avec succès.',
				NEWPASSWORD: 'Nouveau mot de passe',
				REENTERNEWPASSWORD: 'Vérifier le mot de passe',
				VERIFICATION_CODE_SENT: 'Saisissez le code de vérification envoyé à',
				NO_CODE_RECEIVED: 'Vous n\'avez pas reçu le code ?',
				RESEND: 'Renvoyer',
				RESEND_IN: 'dans',
			},
			FORGOT: {
				TITLE: 'Mot de passe oublié ?',
				DESC: 'Entrez votre e-mail pour réinitialiser votre mot de passe',
				SUCCESS: 'Veuillez vérifier vos e-mails pour obtenir le code OTP.',
				REQUEST_RESET_BUTTON: 'Demander une réinitialisation du mot de passe',
				BACK_TO_SIGNIN: 'Retour à la connexion',
			},
			REGISTER: {
				TITLE: 'S\'inscrire',
				DESC: 'Entrez vos informations pour créer votre compte',
				SUCCESS: 'Votre compte a été enregistré avec succès.',
				ORGANIZATION_NAME: 'Nom de l\'organisation',
				NAME: 'Nom',
				AGREE_PREFIX: 'J\'accepte les',
				TERMS_CONDITIONS: 'conditions générales',
				EMAIL_ALREADY_REGISTERED: 'Cette adresse e-mail est déjà enregistrée.',
			},
			INPUT: {
				EMAIL: 'E-mail',
				EMAIL_ADDRESS: 'Adresse e-mail',
				FULLNAME: 'Nom complet',
				PASSWORD: 'Mot de passe',
				CONFIRM_PASSWORD: 'Confirmer le mot de passe',
				USERNAME: 'Nom d\'utilisateur'
			},
			PLACEHOLDER:{
				EMAIL: 'Saisir l\'adresse e-mail',
				PASSWORD: 'Saisir le mot de passe'
			},
			VERIFY:{
				VERIFY_EMAIL: 'Vérification de l\'e-mail',
				BACK_TO_SIGNIN: 'Retour à la connexion',
			},
			SUBSCRIPTION: {
				EXPIRED: 'Votre abonnement a expiré.',
				RENEW: 'Renouvelez maintenant ou contactez le support pour obtenir de l\'aide.',
			},
			VALIDATION: {
				INVALID: '{{name}} n\'est pas valide',
				INVALID_EMAIL: 'Entrez une adresse e-mail valide',
				REQUIRED: '{{name}} est requis',
				MIN_LENGTH: 'La longueur minimale de {{name}} est {{min}}',
				AGREEMENT_REQUIRED: 'L\'acceptation des conditions générales est requise',
				NOT_FOUND: 'Le {{name}} demandé est introuvable',
				INVALID_LOGIN: 'Les identifiants de connexion sont incorrects',
				INVALID_RESET: 'Le code OTP saisi est incorrect ou a expiré. Veuillez réessayer.',
				REQUIRED_FIELD: 'Champ obligatoire',
				MIN_LENGTH_FIELD: 'Longueur minimale du champ :',
				MAX_LENGTH_FIELD: 'Longueur maximale du champ :',
				INVALID_FIELD: 'Le champ n\'est pas valide',
				OTP_REQUIRED: 'Saisissez le code de vérification envoyé à votre adresse e-mail.'
			}
		},
		ECOMMERCE: {
			COMMON: {
				SELECTED_RECORDS_COUNT: 'Nombre d\'enregistrements sélectionnés: ',
				ALL: 'All',
				SUSPENDED: 'Suspended',
				ACTIVE: 'Active',
				FILTER: 'Filter',
				BY_STATUS: 'by Status',
				BY_TYPE: 'by Type',
				BUSINESS: 'Business',
				INDIVIDUAL: 'Individual',
				SEARCH: 'Search',
				IN_ALL_FIELDS: 'in all fields'
			},
			ECOMMERCE: 'éCommerce',
			CUSTOMERS: {
				CUSTOMERS: 'Les clients',
				CUSTOMERS_LIST: 'Liste des clients',
				NEW_CUSTOMER: 'Nouveau client',
				DELETE_CUSTOMER_SIMPLE: {
					TITLE: 'Suppression du client',
					DESCRIPTION: 'Êtes-vous sûr de supprimer définitivement ce client?',
					WAIT_DESCRIPTION: 'Le client est en train de supprimer ...',
					MESSAGE: 'Le client a été supprimé'
				},
				DELETE_CUSTOMER_MULTY: {
					TITLE: 'Supprimer les clients',
					DESCRIPTION: 'Êtes-vous sûr de supprimer définitivement les clients sélectionnés?',
					WAIT_DESCRIPTION: 'Les clients suppriment ...',
					MESSAGE: 'Les clients sélectionnés ont été supprimés'
				},
				UPDATE_STATUS: {
					TITLE: 'Le statut a été mis à jour pour les clients sélectionnés',
					MESSAGE: 'Le statut des clients sélectionnés a été mis à jour avec succès'
				},
				EDIT: {
					UPDATE_MESSAGE: 'Le client a été mis à jour',
					ADD_MESSAGE: 'Le client a été créé'
				}
			}
		},
		HEALTH_METRICS: {
			TITLE: 'Métriques de Santé',
			SYSTEM_MODEL_METRICS: 'Métriques du Système et du Modèle',
			DATA_FEED_HEALTH: 'Santé du Flux de Données',
			QC_CHECK: 'Vérification QC',
			QC: {
				RAW_TAG_QC: 'QC Balise Brute',
				CALCULATED_TAG_QC: 'QC Balise Calculée',
				MODEL_QC: 'QC Modèle',
				COMING_SOON: 'Bientôt disponible',
				CONFIGURATION: 'Configuration de Vérification QC',
				ALL_TAGS: 'Toutes les Balises',
				PROBLEM_TAGS: 'Balises Problématiques',
				SEARCH: 'Rechercher...',
				COLUMN_CONFIG: 'Configuration des Colonnes',
				ADD_TAG: 'Ajouter une Balise',
				EXPORT: 'Exporter',
				UPLOAD: 'Téléverser les Balises (Excel)',
				DOWNLOAD: 'Télécharger les Balises (Excel)',
				VIEW: 'Voir',
				EDIT: 'Modifier',
				NO_TAGS_FOUND: 'Aucune balise trouvée',
				ADD_DESCRIPTION: 'Ajouter une Description',
				ADD_UOM: 'Ajouter une Unité',
				COL_INDEX: '#',
				COL_SYSTEM_NAME: 'Nom du Système',
				COL_TAG_NAME: 'Nom de Balise',
				COL_TAG_ID: 'ID de Balise',
				COL_TAG_DESCRIPTION: 'Description de Balise',
				COL_UOM: 'Unité',
				COL_IR_UPPER: 'IR Supérieur',
				COL_TRIP_UPPER: 'Déclenchement Sup.',
				COL_ALARM_UPPER: 'Alarme Supérieure',
				COL_THRES_UPPER: 'Seuil Supérieur',
				COL_OPS_UPPER: 'Opération Sup.',
				COL_OPS_LOWER: 'Opération Inf.',
				COL_THRES_LOWER: 'Seuil Inférieur',
				COL_ALARM_LOWER: 'Alarme Inférieure',
				COL_TRIP_LOWER: 'Déclenchement Inf.',
				COL_IR_LOWER: 'IR Inférieur',
				COL_FLATLINE: 'Détection de Ligne Plate',
				COL_OUTLIER: 'Détection de Valeur Aberrante',
				COL_RANGE: 'Détection de Hors Portée',
				COL_MISSING_DATA: 'Détection de Données Manquantes',
				COL_FLATLINE_ALERT: 'Gén. Alerte de Ligne Plate',
				COL_OUTLIER_ALERT: 'Gén. Alerte de Valeur Aberrante',
				COL_RANGE_ALERT: 'Gén. Alerte de Hors Portée',
				COL_MISSING_DATA_ALERT: 'Gén. Alerte de Données Manquantes',
				COL_ATTENTION: 'Attention',
				COL_THRES_NOT: 'Not. Seuil',
				COL_KPI: 'KPI',
				COL_DIRECTIONALITY: 'Directionnalité',
				COL_IOW_LOWER: 'IOW Inférieur',
				COL_IOW_UPPER: 'IOW Supérieur',
				COL_ACTIONS: 'Actions',
				COL_DESCRIPTION: 'Description',
				EDIT_TAG: 'Modifier la Balise',
				LOWER: 'Inférieur',
				UPPER: 'Supérieur',
				INSTRUMENT_RANGE: 'Plage d\'Instrument',
				TRIP_LIMITS: 'Limites de Déclenchement',
				ALARM_LIMITS: 'Limites d\'Alarme',
				THRESHOLD_LIMITS: 'Limites de Seuil',
				DIRECTIONALITY: 'Directionnalité',
				IOW_CRITICALITY: 'Criticité IOW',
				FLATLINE_DETECTION: 'Détection de Ligne Plate',
				THRESHOLD_NOTIFICATION: 'Notification de Seuil',
				ASSET: 'Actif',
				CALCULATED_FLAG: 'Indicateur Calculé',
				REMARK: 'Remarque',
				REMARK_PLACEHOLDER: 'Saisir une Remarque pour Modifier',
				CANCEL: 'Annuler',
				SAVE: 'Enregistrer',
			},
			DATA_FEED: {
				TITLE: 'Santé du Flux de Données (Suivi)',
				ALL_TAGS: 'Toutes les Balises',
				GOOD_TAGS: 'Bonnes Balises',
				BAD_TAGS: 'Mauvaises Balises',
				GROUP_BY: 'Grouper par',
				DOWNLOAD: 'Télécharger',
				NO_TAGS_FOUND_TITLE: 'Aucune Balise Trouvée',
				NO_TAGS_FOUND_DESC: 'Vérifiez vos filtres et plages de dates',
				TAGS: 'Balises',
				SHOW: 'Afficher',
				MORE_TAGS: 'plus de balises',
				NO_TAGS: 'Aucune balise trouvée',
				SYSTEM_NAME: 'Nom du Système',
				VALUE: 'Valeur',
				QUALITY: 'Qualité',
				TIMESTAMP: 'Horodatage',
				TAG_NAME: 'Nom de la Balise',
				TAG_ID: 'ID de la Balise'
			},
			MODEL_HEALTH: {
				TITLE: 'Métriques du Système et Modèle',
				ALL_SYSTEMS: 'Tous les Systèmes',
				PROBLEM_SYSTEMS: 'Systèmes à Problèmes',
				NO_PROBLEM_SYSTEMS: 'Aucun Système à Problème trouvé',
				SEARCH: 'Rechercher...',
				REFRESH: 'Rafraîchir les Données',
				DOWNLOAD: 'Télécharger',
				SYSTEM_NAME: 'Nom du Système',
				STATUS: 'STATUT',
				DEPLOYED_VERSION: 'Version Déployée',
				LAST_DATA_PULL: 'Dernière Extraction',
				DATA_HEALTH: 'Santé des Données',
				MODEL_HEALTH: 'Santé du Modèle',
				PREDICTION_TIME: 'Temps de Prédiction',
				LAST_PREDICTION: 'Dernière Prédiction',
				PREDICTIONS_OLDER_THAN_2_HOURS: 'Prédictions > 2 heures = Systèmes à Problème',
				LAST_DATA_WRITTEN: 'Dernières Données Écrites',
				LAST_ANOMALY_WRITTEN: 'Dernière Anomalie Écrite',
				FETCH_STATUS: 'Statut d\'Extraction',
				FETCH_RATE: 'Taux d\'Extraction',
				FETCH_SAMPLING_RATE: 'Taux d\'Échantillonnage',
				PREDICTION_STATUS: 'Statut de Prédiction',
				PREDICTION_RATE: 'Taux de Prédiction',
				SAMPLING_RATE: 'Taux d\'Échantillonnage',
				ACTIONS: 'Actions',
				CUSTOMIZE_COLUMNS: 'Personnaliser les Colonnes',
				NO_DATA_MATCHING: 'Aucune donnée disponible pour l\'actif sélectionné',
				DEPLOYED_DATE: 'Date de déploiement',
				DEPLOYED_BY: 'Déployé par',
				DEPLOYMENT_NOTE: 'Note de déploiement',
				ACTIVE_ALERTS: 'Alertes actives',
				RETRAINING_RECOMMENDED: {
					TITLE: 'Réentraînement recommandé',
					DESCRIPTION: 'Une évaluation récente suggère que le modèle ne reflète peut-être plus le comportement opérationnel actuel. Les tags suivants contribuent le plus à cette recommandation.',
					CONTRIBUTING_TAGS: 'Tags contributeurs (jusqu\'à 5)',
					TAG_NAME_AND_ID: 'Nom et ID du tag',
					TAG_TOOLTIP: 'Nom: {{tagName}}\nTagID: {{tagId}}',
					CONTRIBUTION_SCORE: 'Score de contribution',
					LAST_EVALUATED: 'Dernière évaluation',
					MODEL_VERSION: 'Modèle',
					COPY_TAGS: 'Copier les tags',
					COPY_FULL_DETAILS: 'Copier les détails complets',
					RETRAIN_MODEL: 'Réentraîner le modèle',
					RETRAIN: 'Réentraîner',
					TIP_PREFIX: 'Conseil : cliquez sur la puce',
					TIP_SUFFIX: 'dans la colonne Santé du modèle pour savoir pourquoi le réentraînement est recommandé.',
					NO_TAGS: 'Aucun tag contributeur trouvé.',
					TAGS_COPIED: 'Tags copiés.\nDisponibles dans le presse-papiers.',
					DETAILS_COPIED: 'Détails copiés.\nDisponibles dans le presse-papiers.',
					RECOMMENDED_DATE_RANGE: 'Plage de dates recommandée pour le réentraînement',
					RECOMMENDED_DATE_RANGE_HINT: 'Utilisez cette plage de dates pour examiner et réentraîner le modèle avec les données les plus pertinentes.',
					NO_DATE_RANGE: 'Aucune plage de dates disponible pour réentraîner le modèle',
					ADD_COMMENT: 'Ajouter un commentaire',
					ADD_COMMENT_PLACEHOLDER: 'Ajouter une raison',
					START_RETRAINING: 'Démarrer le réentraînement',
					BACK: 'Retour',
					FORCE_INCLUDE_BANNER: 'Les régions recommandées ont été ajoutées automatiquement comme plages Force Include.',
					TRAINING_PERIOD: 'Période d\'entraînement',
					EXISTING_TRAINING_REGION: 'Région d\'entraînement existante',
					CURRENT_MODEL_VERSION: 'Version actuelle du modèle',
					RECOMMENDED_REGION: 'Région recommandée',
					FROM_MODEL_HEALTH_EVALUATION: 'Issue de l\'évaluation de santé du modèle',
					NO_TRAINING_RANGES: 'Aucune région d\'entraînement disponible.',
					LOADING_RANGES: 'Chargement des régions d\'entraînement...',
				}
			}
		},
		SHARED_MODULE: {
			COLUMN_CONFIG: {
				TITLE: 'Afficher les Colonnes',
				SEARCH: 'Rechercher...',
				SELECT_ALL: 'Tout Sélectionner',
				RESET_TO_DEFAULT: 'Réinitialiser'
			},
			CALCULATED_TAG_POPUP: {
				EXPRESSION: 'Expression',
				EXPRESSION_DESCRIPTION: 'Description de l\'expression'
			}
		},
		DATA_MANAGEMENT: {
			QC: {
				RUN_QC: 'Lancer le QC',
				RUN_QC_SELECTED: 'Lancer le QC sur la sélection',
				RUN_QC_TOOLTIP: 'Exécuter l\'agent de qualité des données sur les enregistrements actuels',
				RUNNING: 'QC en cours',
				DETAIL_TITLE: 'Enregistrement de maintenance',
				TAB_DETAILS: 'Détails',
				TAB_REVIEW: 'Revue',
				NO_DETAILS: 'Aucun détail disponible.',
				VIEW_DETAILS: 'Voir les détails',
				FIELDS: {
					NOTIFICATION_NO: 'N° d\'avis',
					ORDER: 'Ordre',
					TYPE: 'Type',
					EQUIPMENT: 'Équipement',
					EQUIPMENT_DESC: 'Description de l\'équipement',
					FUNCTIONAL_LOC: 'Poste technique',
					PLAN_GROUP: 'Groupe de planification',
					PLAN_GROUP_DESC: 'Description du groupe de planification',
					MAINTENANCE_PLANT: 'Site de maintenance',
					MAINTENANCE_PLANT_DESC: 'Description du site de maintenance',
					PLANT_SECTION: 'Section de site',
					PRIORITY: 'Priorité',
					DAMAGE: 'Dommage',
					DESCRIPTION: 'Description',
					STATUS: 'Statut',
					USER_STATUS: 'Statut utilisateur',
					CREATED_ON: 'Créé le',
					COMPLETED_ON: 'Terminé le',
					BREAKDOWN_DURATION: 'Durée de panne',
					INTERNAL_LABOUR: 'Coût de main-d\'œuvre interne',
					EXTERNAL_LABOUR: 'Coût de main-d\'œuvre externe',
					EXTERNAL_SERVICE: 'Coût de service externe'
				},
				LAST_RUN: 'Dernière exécution du QC',
				VIEW_FINDINGS: 'Voir les constats',
				FINDINGS_TITLE: 'Constats de qualité des données',
				NO_FINDINGS: 'Aucun problème trouvé pour cet enregistrement.',
				BLOCKERS: 'Bloquants',
				WARNINGS: 'Avertissements',
				RULE: 'Règle',
				FIELD: 'Champ',
				EVIDENCE: 'Preuve',
				RECOMMENDATION: 'Recommandation',
				CONFIG_TITLE: 'Règles de qualité des données',
				SCOPE_GLOBAL: 'Global',
				SCOPE_SYSTEM: 'Ce système',
				RULE_MANDATORY_FIELDS: 'Champs obligatoires',
				MANDATORY_FIELDS_LABEL: 'Champs requis',
				SEVERITY: 'Gravité',
				RULE_DESCRIPTION: 'Longueur de la description',
				MIN_LENGTH: 'Longueur minimale (caractères)',
				RULE_DATES: 'Cohérence des dates',
				ALLOW_COMPLETION_BEFORE_CREATION: 'Autoriser une date d\'achèvement antérieure à la date de création',
				RULE_DUPLICATES: 'Détection des doublons',
				WINDOW_DAYS: 'Fenêtre de doublons (jours)',
				RULE_PLANNING: 'Planification',
				REQUIRE_LABOR: 'Exiger la main-d\'œuvre sur les ordres de travail',
				RULE_COMPLETION: 'Achèvement',
				REQUIRE_ROOT_CAUSE: 'Exiger une cause racine sur les enregistrements achevés',
				RULE_TEXT_QUALITY: 'Qualité du texte (AI)',
				TEXT_QUALITY_HINT: 'Utilise le modèle de langage pour vérifier l\'orthographe et la qualité de la description',
				CHECK_SPELLING: 'Vérifier l\'orthographe',
				CHECK_DESCRIPTION_MEANING: 'Vérifier que la description est pertinente',
				CHECK_ROOT_CAUSE: 'Vérifier la pertinence de la cause racine',
				RULE_WORK_ORDER: 'Ordre de travail requis',
				WORK_ORDER_HINT: 'Signale un ordre de travail manquant uniquement lorsque la notification est terminée et appartient aux types de notification sélectionnés ci-dessous.',
				WORK_ORDER_TYPES_LABEL: 'Types de notification nécessitant un ordre de travail',
				RULE_SLA: 'SLA / Date requise',
				SLA_CHECK_OVERDUE: 'Signaler les notifications en retard par rapport à leur date d\'achèvement requise',
				SLA_CHECK_LATE: 'Signaler les notifications terminées après leur date d\'achèvement requise',
				RULE_BREAKDOWN_CONSISTENCY: 'Cohérence de l\'indicateur de panne',
				BREAKDOWN_CONSISTENCY_HINT: 'Vérifie l\'indicateur de panne (Effect) par rapport au temps d\'arrêt enregistré. Sélectionnez les valeurs Effect qui indiquent une panne sur ce site.',
				BREAKDOWN_EFFECT_VALUES_LABEL: 'Valeurs Effect indiquant une panne',
				RULE_AGING: 'Vieillissement / Arriéré',
				MAX_OPEN_DAYS: 'Nombre maximal de jours qu\'une notification peut rester ouverte',
				RULE_STATUS_CONSISTENCY: 'Cohérence de clôture du statut',
				STATUS_CONSISTENCY_HINT: 'Vérifie la date d\'achèvement par rapport au statut de clôture du workflow. Sélectionnez les codes de statut qui signifient \'clôturé\' sur ce site.',
				CLOSED_KEYWORDS_LABEL: 'Codes de statut signifiant clôturé',
				RULE_COST_SANITY: 'Vérification de cohérence des coûts',
			},
			TABS: {
				DOCUMENTS: 'Documents',
				TAGS: 'Balises',
				MAINTENANCE: 'Maintenance',
				PIDS: 'P&IDs',
				RELIABILITY: 'Fiabilité'
			},
			COMMON: {
				PROCESSING: 'Traitement',
				READY: 'Prêt',
				REVIEW: 'Revue',
				BLOCKED: 'Bloqué',
				PENDING: 'En attente',
				SEARCH: 'Rechercher...',
				SEARCH_RECORDS: 'Rechercher des enregistrements...',
				ADD_DOCUMENT: 'Ajouter un Document',
				NO_MATCHING: 'Aucun document trouvé.',
				LOADING: 'Chargement...',
				LOADING_MORE: 'Chargement plus de documents...',
				LOADING_MORE_RECORDS: 'Chargement plus d\'enregistrements...',
				CANCEL: 'Annuler',
				EDIT: 'Modifier',
				SAVE: 'Enregistrer',
				SAVING: 'Enregistrement...',
				ASK_ROOTY: 'Demander à Rooty',
				DOWNLOAD: 'Télécharger',
				IMPORT_DATA: 'Importer des données',
				REPLACE_FILE: 'Remplacer le fichier',
				UPLOAD: 'Télécharger'
			},
			FILTERS: {
				ALL_ISSUES: 'Tous les Problèmes',
				CHOOSE_ISSUES: 'Choisir les problèmes à afficher',
				ALL_CLASSES: 'Toutes les Classes',
				CHOOSE_CLASSES: 'Choisir les classes à afficher',
				GROUP_BY: 'Grouper par',
				ALL_TYPES: 'Tous les Types',
				EVENT_TYPES: 'Types d\'Événements',
				FILTER_ISSUE_TYPE: 'Type de Problème'
			},
			IMPORT_BANNER: {
				IMPORTING: 'Importation de {{ count }} documents',
				IMPORTING_AUTO: 'Importation de {{ uploaded }} documents, {{ remaining }} restants (Total: {{ total }})',
				INITIALIZING_AUTO: 'Initialisation de la synchronisation des documents...',
				AUTO_TAKE_MINS: 'Veuillez patienter pendant la synchronisation en arrière-plan...',
				TAKE_30_MINS: 'Cela peut prendre jusqu\'à 30 minutes.',
				IMPORTED_SUCCESS: '{{ count }} documents importés',
				SUMMARY: 'Résumé :',
				NEEDS_REVIEW: 'Nécessite une Revue',
				ALREADY_PRESENT: 'Déjà Présent',
				REMOVED_AT_SOURCE: 'Supprimé à la source',
				SYNC_FAILED: 'Échec de la synchronisation'
			},
			TABLE_COLUMNS: {
				DOCUMENT: 'Document',
				CLASS: 'Classe',
				DOC_TYPE: 'Type de Doc',
				STATUS: 'Statut',
				SOURCE: 'Source',
				ISSUES: 'Problèmes',
				LAST_UPDATED: 'Dernière Mise à Jour',
				ACTIONS: 'Actions',
				NOTIFICATION: 'Notification',
				EQUIPMENT: 'Équipement',
				DESCRIPTION: 'Description',
				TYPE: 'Type',
				MAINTENANCE_PLANT: 'Usine',
				FAILURE_MODE: 'Mode de Défaillance',
				SECTION: 'Section',
				DATES: 'Dates',
				CONTEXT: 'Contexte',
				TIME_HRS: 'Temps (h)',
				RCA: 'RCA',
				SOURCE_NAME: 'Nom de la Source',
				PATH: 'Chemin',
				SYNC_FREQUENCY: 'Fréquence',
				LAST_SYNCED: 'Dernière Sincronisation',
			},
			EMPTY_STATE: {
				NO_DOCS_TITLE: 'Aucun document importé',
				NO_DOCS_SUBTITLE: 'Ajoutez des documents manuellement ou avec l\'outil IA.',
				NO_MAINT_TITLE: 'Aucune donnée de maintenance',
				NO_MAINT_SUBTITLE: 'Sélectionnez "Importer des données" pour commencer à ajouter des données de maintenance.'
			},
			ADD_DOC_DIALOG: {
				FILE_UPLOAD: 'Téléversement de fichier',
				UPLOAD_MANUALLY: 'Téléverser manuellement',
				BULK_UPLOAD_TITLE: 'Téléversement en masse',
				BULK_UPLOAD_DESC: 'Téléchargez la structure, placez vos documents, puis téléversez le dossier.',
				DOWNLOAD_TEMPLATE: 'Télécharger le modèle',
				DRAG_DROP: 'Faites glisser votre fichier ici ou',
				BROWSE: 'parcourir',
				SUPPORTS: 'Supporte PDF, Word, Excel, images ou un ZIP pour import en masse.',
				SELECTED_FILES: 'Fichiers sélectionnés',
				APPLY_TO_ALL: 'Appliquer à tous:',
				CLASS: 'Classe',
				DOC_TYPE: 'Type de document',
				LINKED_TO: 'Lié à',
				SELECT_CLASS: 'Sélectionner une classe',
				SELECT_DOC_TYPE: 'Sélectionner un type',
				CHOOSE_LINK: 'Choisir où lier',
				FILE_SELECTED: 'Fichier sélectionné',
				FILES_SELECTED: 'Fichiers sélectionnés',
				CONFIRM_IMPORT: 'Confirmer / Importer',
				REPLACE_HINT: "Veuillez télécharger le bon fichier de remplacement pour ce document. Idéalement, il devrait s'agir du même fichier que celui initialement prévu.",
				DUPLICATE_BADGE: 'Doublon',
				DUPLICATES_SKIPPED_BANNER: '{{count}} fichier(s) en double détecté(s). Ils sont exclus et ne seront pas téléchargés.',
				DUPLICATES_SKIPPED_INLINE: '({{count}} doublon ignoré)',
				REMOVE_DUPLICATES: 'Supprimer les doublons'
			},
			DOC_VIEWER: {
				DOC_DETAILS: 'Détails du document',
				PREVIEW: 'Aperçu',
				FULL_SCREEN: 'Plein écran',
				NO_PREVIEW: 'Aucun aperçu disponible',
				NO_PREVIEW_DESC: 'Ce fichier ne peut pas être prévisualisé.',
				METADATA: 'Métadonnées',
				DOC_IDENTIFICATION: 'Identification',
				DOC_NAME: 'Nom du document',
				DOC_ID: 'ID du document',
				DOC_CLASS: 'Classe de document',
				DOC_TYPE: 'Type de document',
				MISSING: 'Manquant',
				DOC_SOURCE: 'Source',
				FILE_SIZE: 'Taille du fichier',
				FILE_UPLOAD_SOURCE: 'Téléversement de fichier',
				EXTERNAL_SOURCE: 'Externe (Sharepoint, etc)',
				VERSIONING: 'Contrôle des versions',
				UPLOADED_ON: 'Ajouté le',
				LAST_MODIFIED: 'Modifié le',
				EFFECTIVE_DATE: 'Date de début',
				EXPIRY_DATE: 'Date d\'expiration',
				REVISION: 'Révision',
				VERSION_1: 'Version 1',
				VERSION_2: 'Version 2',
				STATUS: 'Statut',
				STATUS_UPLOADING: 'Importation',
				STATUS_QUEUED: 'En file',
				STATUS_PROCESSING: 'Traitement',
				STATUS_READY: 'Prêt',
				STATUS_PENDING: 'En attente',
				LINKED_TO: 'Lié à',
				FACILITIES: 'Installations',
				UNITS: 'Unités',
				SYSTEMS: 'Systèmes',
				CHOOSE_LINK_DESC: 'Choisissez où lier',
				EXTRACTED_DATA: 'Données extraites',
				NO_EXTRACTED_DATA: 'Aucune donnée disponible.'
			},
			TOOLTIPS: {
				ISSUE_FILTER: 'Filtre de problèmes',
				CLASS_FILTER: 'Filtre de classe',
				CUSTOMIZE_COLUMNS: 'Personnaliser les colonnes',
				VIEW_DETAILS: 'Voir les détails',
				DELETE_FILE: 'Supprimer le fichier',
				STATUS_QUEUED_PROCESSING: "Votre document est en file d'attente et sera traité sous peu.",
				STATUS_READY: 'Votre document est traité et prêt à être utilisé.'
			},
			DEDUP_MENU: {
				TRIGGER_LABEL: 'Doublons',
				TITLE: 'Doublons résolus',
				SUMMARY: '{{dupes}} fichier(s) sur {{total}} sélectionné(s) ont des doublons',
				DESCRIPTION: "Les originaux sont conservés. Les {{unaffected}} autre(s) fichier(s) ne sont pas modifiés.",
				MERGE_TAGS: 'Supprimer les doublons, fusionner les tags ({{count}})',
				NO_MERGE_TAGS: 'Supprimer les doublons, NE PAS fusionner les tags ({{count}})',
				FAILURE: 'Échec de la suppression de certains doublons',
				TOAST_MERGED: '{{count}} fichier(s) en double supprimé(s). Les tags ont été fusionnés avec les fichiers originaux.',
				TOAST_NOT_MERGED: '{{count}} fichier(s) en double supprimé(s). Les tags du fichier original sont restés inchangés.'
			},
			CONNECTED_SOURCES: {
				CLOSE: 'Fermer',
				DISCONNECT_MSG: "La déconnexion de {{provider}} arrêtera la synchronisation des documents et empêchera UptimeAI d'accéder aux fichiers du compte {{provider}} connecté.<br/>Les documents déjà importés dans UptimeAI resteront disponibles, mais ils ne recevront plus de mises à jour de {{provider}}.",
				DISCONNECT_TITLE: 'Déconnecter l\'intégration {{provider}} ?',
				DISCONNECT_OK: 'Déconnecter {{provider}}',
				FETCH_SOURCES_FAILED: 'Échec de la récupération des sources connectées.',
				SOURCE_UPDATED_SUCCESS: 'Source mise à jour avec succès.',
				SOURCE_CONNECTED_SUCCESS: 'Source connectée avec succès.',
				TRIGGERING_SYNC: 'Déclenchement de la synchronisation...',
				SYNC_STARTED_SUCCESS: 'La synchronisation a démarré avec succès.',
				FAILED_TRIGGER_SYNC: 'Échec du déclenchement de la synchronisation.',
				INACTIVE_REASON_COVERED: 'Couvert par la source parente active \'{{name}}\' ({{path}})',
				REAL_TIME: 'Temps réel',
				ONE_TIME: 'Une fois',
				DAILY: 'Quotidien',
				HOURLY: "Toutes les heures",
				WEEKLY: "Hebdomadaire",
				MONTHLY: "Mensuel",
				NA: 'N/A',
				PAUSED: 'En pause',
				INACTIVE: 'Inactif',
				UNKNOWN: 'Inconnu',
				TITLE: 'Sources Connectées',
				ACTIVE: 'Actif',
				CONNECT_SOURCE: 'Connecter la Source',
				NO_SOURCES_HEADING: 'Aucune source connectée.',
				NO_SOURCES_CONTENT: 'Connectez une source pour importer des fichiers.',
				NEVER: 'Jamais',
				SYNC_NOW: 'Synchroniser maintenant',
				MONITOR: 'Surveiller',
				SETTINGS: 'Paramètres',
				DISCONNECT: 'Déconnecter',
				SYNC_ACTIVITY: 'Activité de Synchronisation',
				NO_RECENT_ACTIVITY: 'Aucune activité récente.',
				STATUS_SUCCESS: 'Succès',
				STATUS_PARTIAL: 'Partiel',
				STATUS_FAILED: 'Échoué',
				STATUS_RUNNING: 'En cours',
				SYNC_FAILED_ERROR: 'Échec de la synchronisation.',
				SYNC_STATS: '+ {{new}} nouveaux · {{updated}} mis à jour · {{skipped}} inchangés',
				SYNC_STATS_PARTIAL: '+ {{new}} nouveaux · {{updated}} mis à jour · {{skipped}} inchangés · {{failed}} échoués',
			},
			CONNECT_SOURCE: {
				PROVIDERS: {
					DOCUMENT_LOCATOR: {
						NAME: 'Document Locator',
						DESC: 'Connectez-vous à une base de données Document Locator pour synchroniser les documents en continu.'
					}
				},
				PROVIDER_FIELDS: {
					DOCUMENT_LOCATOR: {
						DIALECT: 'Type de base de données',
						HOST: 'Hôte du serveur',
						PORT: 'Port',
						DATABASE: 'Nom de la base de données',
						USER: 'Nom d\'utilisateur',
						PASSWORD: 'Mot de passe',
						ENCRYPT: 'Chiffrer la connexion',
						TRUST_CERT: 'Approuver le certificat du serveur',
						SP_FILE_INFO: 'Procédure d\'informations sur les fichiers',
						SP_FILE_CONTENT: 'Procédure de contenu des fichiers',
						SP_PLACEHOLDER: 'Saisissez le nom de la procédure stockée'
					}
				},
				TITLE: 'Connecter une Source',
				STEP_1: 'Se connecter à la source',
				STEP_2: 'Authentifier la source',
				STEP_3: 'Détails de la source',
				SHAREPOINT: 'SharePoint',
				SHAREPOINT_DESC: 'Connectez-vous aux bibliothèques SharePoint pour synchroniser continuellement les documents.',
				CONNECT_TO_SHAREPOINT: 'Se connecter à SharePoint',
				CONNECT_TO_PROVIDER: 'Se connecter à {{provider}}',
				CONNECTION_VERIFIED: 'Connexion vérifiée.',
				DESCRIPTOR_LOAD_FAILED: 'Impossible de charger la configuration de cette source.',
				TEST_CONNECTION_REQUIRED: 'Veuillez tester la connexion avec succès avant de vous connecter.',
				API_INTEGRATION: 'Intégration API',
				API_DESC: 'Connectez-vous aux APIs de gestion documentaire pour synchroniser les fichiers automatiquement.',
				CMMS: 'CMMS',
				CMMS_DESC: 'Connectez-vous à votre CMMS (SAP PM, Maximo, etc.) pour une synchronisation continue des documents.',
				COMING_SOON: 'Bientôt disponible',
				OAUTH_TAB: 'Se connecter avec Microsoft (OAuth)',
				TOKEN_TAB: 'Jeton d\'accès (manuel)',
				SIGN_IN_MICROSOFT: 'Se connecter avec Microsoft',
				OAUTH_DESC: 'Connectez votre compte Microsoft pour parcourir les bibliothèques SharePoint et importer des documents.',
				SECURE_AUTH: 'Authentification sécurisée',
				SECURE_AUTH_DESC: 'Utilise Microsoft OAuth. Vos identifiants ne sont jamais stockés dans cette application.',
				READ_ONLY: 'Accès en lecture seule',
				READ_ONLY_DESC: 'L\'application ne lit que les documents. Aucun fichier ne sera modifié ou supprimé dans SharePoint.',
				TOKEN_PLACEHOLDER: 'Collez votre jeton d\'accès SharePoint',
				TOKEN_WARNING: 'Les jetons d\'accès expirent. Envisagez OAuth pour une synchronisation ininterrompue.',
				MANUAL_AUTH_DESC: 'Entrez vos identifiants d\'inscription d\'application Azure. Ils sont stockés en toute sécurité sur le serveur.',
				TENANT_ID_LABEL: 'ID de locataire',
				TENANT_ID_PLACEHOLDER: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
				CLIENT_ID_LABEL: 'ID Client (ID d\'application)',
				CLIENT_ID_PLACEHOLDER: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
				CLIENT_SECRET_LABEL: 'Secret Client',
				CLIENT_SECRET_PLACEHOLDER: 'Collez la valeur de votre secret client',
				SAVE_CREDENTIALS: 'Enregistrer et continuer',
				STEP_CONNECTION_CONFIG: 'Configuration de connexion',
				APP_CONNECTION_CONFIG: 'Configuration de connexion de l\'application',
				NEW_CONNECTION: 'Nouvelle connexion',
				ACTIVE_CONNECTION_CONFIG: 'Configuration de connexion active',
				PROVIDER: 'Fournisseur',
				MICROSOFT_SHAREPOINT: 'Microsoft SharePoint',
				APP_ID: 'ID de l\'application (ID client)',
				REGISTER_CONFIG_DESC: 'Entrez les détails pour enregistrer une nouvelle configuration d\'informations d\'identification client/d\'enregistrement d\'application.',
				CONFIG_NAME_LABEL: 'Nom de la configuration',
				CONFIG_NAME_PLACEHOLDER: 'ex: SharePoint Production',
				BACK_TO_SELECTION: 'Retour à la sélection',
				SAVE_CONNECTION_BTN: 'Enregistrer la connexion',
				PLEASE_SELECT_CONNECTION: 'Veuillez d\'abord sélectionner ou enregistrer une configuration de connexion.',
				RESTORED_SESSION_FOR: 'Session authentifiée restaurée pour: {{user}}',
				PLEASE_COMPLETE_SIGNIN: 'Veuillez d\'abord terminer la connexion Microsoft.',
				SELECT_APP_REGISTRATION: 'Veuillez d\'abord sélectionner ou enregistrer une connexion d\'enregistrement d\'application.',
				FAILED_AUTH_URL: 'Échec de l\'obtention de l\'URL d\'autorisation Microsoft.',
				ERROR_REQ_AUTH_LINK: 'Erreur lors de la demande de lien d\'autorisation.',
				FILL_ALL_FIELDS: 'Veuillez remplir tous les champs de configuration de connexion.',
				APP_REG_SAVED: 'Configuration de l\'enregistrement de l\'application enregistrée avec succès.',
				FAILED_SAVE_CONFIG: 'Échec de l\'enregistrement de la configuration.',
				SITE_URL_LABEL: 'URL du site SharePoint (L\'URL complète de votre collection de sites SharePoint)',
				SITE_URL_PLACEHOLDER: 'https://company.sharepoint.com/sites/engineering',
				LIBRARY_PATH_LABEL: 'Chemin de la bibliothèque',
				LIBRARY_PATH_DESC: '(Chemin vers la bibliothèque de documents, ex. /Shared Documents/Equipment)',
				LIBRARY_PATH_PLACEHOLDER: '/Shared Documents/Equipment',
				FILE_TYPE_LABEL: 'Filtre de type de fichier (Importer uniquement les fichiers correspondant à ces types ; laisser vide pour tous)',
				SYNC_FREQUENCY: 'Fréquence de synchronisation',
				SYNC_AUTO: 'Auto (Temps réel)',
				SYNC_HOURLY: 'Toutes les heures',
				SYNC_DAILY: 'Quotidienne',
				SYNC_DAILY_DESC: 'Synchroniser toutes les 24 heures à une heure programmée',
				SYNC_WEEKLY: 'Hebdomadaire',
				SYNC_BIWEEKLY: 'Bimensuelle',
				SYNC_MONTHLY: 'Mensuelle',
				CONFLICT_LABEL: 'Résolution des conflits (Comment gérer les documents qui existent déjà dans le système)',
				CONFLICT_KEEP_NEWEST: 'Conserver la version la plus récente',
				TEST_CONNECTION: 'Tester la connexion',
				TEST_SUCCESS: 'Connexion réussie - {{count}} fichiers de documents correspondants trouvés',
				CANCEL: 'Annuler',
				CONNECT_AND_SYNC: 'Connecter et démarrer la synchronisation',
				AUTH_SUCCESS: 'Vous vous êtes authentifié avec succès. Cliquez sur Suivant ci-dessous pour configurer les détails de la source.',
				APP_ONLY_SYNC_DESC: 'La synchronisation via l\'application seule s\'exécute en arrière-plan à l\'aide de la configuration d\'inscription d\'application sélectionnée. Aucune connexion d\'utilisateur individuelle n\'est requise.',
				FILE_TYPE_FILTER_DESC: 'Importez uniquement les fichiers correspondant à ces types ; laissez non sélectionné pour importer tous les fichiers.',
				NEXT: 'Suivant',
				AUTHENTICATED_PROFILE: 'Profil Microsoft Authentifié',
				USER_NAME: 'Nom d\'utilisateur',
				EMAIL_ADDRESS: 'Adresse e-mail',
				SIGN_IN_DIFFERENT_ACCOUNT: 'Se connecter avec un autre compte'
			}
		},
		MODULE_CONFIGURATION: {
			TABS: {
				TRIAGE: 'Alert Triage', MAINTENANCE: 'Maintenance', COMING_SOON: 'Bientôt disponible' },
			COMMON: { CANCEL: 'Annuler', SAVE: 'Enregistrer', EDIT: 'Modifier', DOWNLOAD: 'Télécharger', UPLOAD: 'Téléverser', DELETE: 'Supprimer', SELECT_ALL: 'Tout sélectionner', SEARCH: 'Rechercher une activité...', EDIT_CONFIGURATION: 'Modifier la configuration', SAVE_CONFIGURATION: 'Enregistrer la configuration', APPLY_TEMPLATE: 'Appliquer le modèle', TEMPLATE_MANAGER: 'Gestionnaire de modèles', SAVED_CONFIGURATION: 'Configuration enregistrée', CONFIGURE: 'Configurer', BETA_ANALYTICS: 'Analytique β', UPDATE_TEMPLATE: 'Mettre à jour le modèle', SAVE_TEMPLATE: 'Enregistrer le modèle', FINISH_SAVE_PACKAGE: 'Terminer et enregistrer le paquet', DONE: 'Terminé', RE_GENERATE: 'Régénérer', YES: 'Oui', NO: 'Non', LOADING: 'Loading...', COPY: 'Copier', APPLYING_TEMPLATE: 'Application du modèle', LOADING_TEMPLATE: 'Chargement du modèle', TO: 'à' },
			HEADER: { CONFIG_FOR: 'Configurer PM, FMEA, CM pour :', SELECT_EQUIPMENT: 'Veuillez sélectionner un équipement' },
			EQUIPMENT_EMPTY: { TITLE: 'Sélectionner Un Équipement', DESC: 'Sélectionnez un équipement dans le panneau de hiérarchie pour le configurer', ACTIVITIES: 'activités PM, FMEA, CM.', NO_TEMPLATE_TITLE: 'Aucun Modèle Appliqué', NO_TEMPLATE_DESC: "Appliquez un modèle pour configurer les activités PM, FMEA et CM pour cet équipement." },
			COMING_SOON: { TITLE: 'Bientôt disponible', DESC: 'Cette fonctionnalité est actuellement en cours de développement et sera disponible dans une prochaine mise à jour.' },
			MANAGER: { TITLE: 'Gestionnaire de Modèles', EDIT_TEMPLATE: 'Modifier Le Modèle', LINKED_ASSETS: 'actifs liés', SUB_HEADER: 'Gérer les modèles réutilisables PM, CM et de mode de défaillance', COL_NAME: 'Nom du Modèle', COL_DESC: 'Description', COL_TYPE: 'Type', COL_ASSETS: 'Actifs Liés', COL_ASSET: 'Actifs', COL_CREATOR: 'Créé Par', COL_DATE: 'Dernière Modification', EMPTY_TITLE: 'Aucun modèle trouvé', EMPTY_DESC: 'Les modèles PM, CM et de modes de défaillance enregistrés apparaîtront ici.', SELECT_DESC: 'Sélectionnez un modèle prédéfini à appliquer à votre équipement.', SEARCH_TEMPLATE: 'Rechercher un modèle...', EQ_TEMPLATE_LIBRARY: 'Bibliothèque de modèles d\'équipement', COL_STATUS: 'Statut', STATUS_IN_PROGRESS: 'En cours', STATUS_READY: 'Prête à l\'emploi', STATUS_DEPRECATED: 'Obsolète', LIFECYCLE: 'Plus d\'actions', LOCK: 'Verrouiller et marquer comme prête', LOCK_HINT: 'Complétez le modèle à 100 % pour pouvoir le verrouiller.', UNLOCK: 'Déverrouiller', DEPRECATE: 'Marquer comme obsolète', REACTIVATE: 'Réactiver', DUPLICATING: 'Création du modèle dupliqué de {{name}}...' },
			UPLOAD: { TITLE_PM: 'Télécharger Modèle PM', TITLE_CM: 'Télécharger Modèle CM', TITLE_FM: 'Télécharger Modèle de Mode de Défaillance', TEMPLATE_NAME: 'Nom du modèle', ENTER_TEMPLATE: 'Entrez le nom du modèle', DRAG_DROP: 'Faites glisser votre fichier ici ou', BROWSE: 'parcourir', REMOVE_FILE: 'Supprimer le fichier' },
			PM: { TITLE: 'Configuration PM', CONFIG_FOR: 'Configuration de la check-list PM pour :', SELECT_HOW: 'Sélectionnez comment vous souhaitez configurer les activités PM', APPLY_TEMPLATE: 'Appliquer Le Modèle', IMPORT_SAP: 'Importer depuis SAP', UPLOAD_TEMPLATE: 'Télécharger un modèle', DOWNLOAD_TEMPLATE: 'Télécharger Le Modèle', CHECKLIST_TEMPLATE: 'Modèle de Check-list PM', SAVE_TEMPLATE: 'Enregistrer Le Modèle', EDIT_TEMPLATE: 'Modifier Le Modèle', OVERALL_VARS: 'Variables globales du niveau PM', OVERALL_TIME: 'Temps global (en heures)', MUST_BE_POSITIVE: 'Saisissez un nombre supérieur à 0', OVERALL_MANNING: 'Effectifs globaux', TECH_COUNT: 'Technicien (en nombre)', HELPER_COUNT: 'Assistant (en nombre)', COST_PARTS: 'Coût des pièces (le cas échéant) (en USD)', COST_CONS: 'Coût des consommables (en USD)', PM_INTERVAL: 'Intervalo PM actuel (en jours)', PROD_LOSS: 'Perte de production (en USD)', TAB_CHECKLIST: 'Check-list PM', ACTIVITIES_CHECKLIST: 'Check-list des activités PM', ACTIVITIES_CHECKLIST_DESC: 'Liste de toutes les activités PM définies dans ce modèle de check-list', ENRICH_ROOTY: 'Enrichir la check-list avec Rooty', ROOTY_LOADING: 'Rooty analyse vos activités PM...', ROOTY_BUNDLE_TITLE: 'Suggestions de regroupements d\'activités', ROOTY_BUNDLE_DESC: 'Examinez les regroupements suggérés ci-dessous. Confirmez pour continuer et générer les marqueurs de construction.', ROOTY_CONFIRM_BUNDLES: 'Tout est bon — Générer les marqueurs de construction', ROOTY_CONFIRM_FLAGS: 'Tout est bon — Générer le temps par activité', ROOTY_FLAGS_READY: 'Marqueurs de construction générés. Consultez les onglets ci-dessous.', ROOTY_FLAGS_OUTPUT: 'Analyse des marqueurs de construction', ROOTY_NO_SYSTEM: "Enregistrez l'Activité PM pour activer l'enrichissement", TAB_BUNDLES: 'Regroupements d\'activités', BUN_TITLE: 'Regroupements d\'activités PM', BUN_DESC: 'Regroupez les activités PM en ensembles logiques pour une planification efficace', TAB_FLAGS: 'Marqueurs de construction', FLAG_TITLE: 'Marqueurs de construction', FLAG_DESC: 'Classifiez les activités comme réglementaires, procédurales ou opérationnelles', TAB_TIME: 'Temps par activité', TIME_TITLE: 'Temps par activité', TIME_DESC: 'Estimez le temps requis pour chaque activité PM', TAB_BETA: 'Définir β', BETA_TITLE: 'Définir β', BETA_DESC: 'Définissez la sensibilité des CM/défaillances sur la fréquence PM pour chaque activité', RE_GENERATE: 'Régénérer', CHECKLIST_CONFIG: 'Configuration de la check-list PM', CONFIG_CHECKLIST_FOR: 'Configuration de la check-list pour :', ROOTY_CANNED_1: 'Lecture de la check-list...', ROOTY_CANNED_2: 'Analyse des activités PM...', ROOTY_CANNED_3: 'Préparation des suggestions...' },
			PM_APPLY: { TITLE: 'Bibliothèque de modèles de check-lists PM', STEP_1: 'Sélectionner Le Modèle', STEP_2: 'Sélectionner L\'Équipement', STEP_1_DESC: 'Sélectionnez un modèle de check-list PM prédéfini à appliquer à votre équipement. Les modèles contiennent des séquences d\'activités PM configurées à partir de meilleures pratiques.', EMPTY: 'Aucun modèle trouvé.', CONFIG_FOR: 'Modèle PM configuré pour', EXEC_SUCCESS: 's\'exécutant avec succès au-delà des limites d\'intervalle.', PM_ACTIVITIES: 'Activités PM', INTERVAL: 'Intervalle :', APPLIES_TO: 'S\'applique à :', EQ_TITLE: 'Sélectionner l\'équipement pour appliquer le modèle', EQ_SELECTED: 'Équipements Sélectionnés', SELECT_TEMPLATE: 'Sélectionner Le Modèle', APPLY_TEMPLATE: 'Appliquer Le Modèle' },
			CM: { TITLE: 'Configuration CM', CONFIG_FOR: 'Configuration des activités CM pour :', SELECT_HOW: 'Sélectionnez comment vous souhaitez configurer les activités CM', APPLY_TEMPLATE: 'Appliquer le modèle', UPLOAD_TEMPLATE: 'Télécharger un modèle', DOWNLOAD_TEMPLATE: 'Télécharger le modèle', CM_VARS: 'Variables de niveau CM', EQ_REDUNDANCY: 'Redondance d\'équipement', PROD_LOSS: 'Perte de production', TECH_COUNT: 'Nb de techniciens requis', HELP_COUNT: 'Nb d\'assistants requis', COST_CONS: 'Coût des consommables (le cas échéant)', SPARES_COST: 'Considérer le coût des pièces de rechange', YES: 'Oui', NO: 'Non', LABOUR_VARS: 'Variables de main-d\'œuvre', WRENCH_TIME_VARS: 'Variables de temps clé', WRENCH_WARNING: 'Les durées de panne peuvent inclure du temps d\'attente — les estimations de temps clé sont préférées aux valeurs basées sur la durée', COL_FAILURE_MODE: 'Mode de défaillance', COL_ACTIVITY: 'Activité', COL_CM_COUNT: 'Nombre CM', COL_WRENCH_TIME: 'Temps clé est. (h)', COL_CONFIDENCE: 'Confiance', COL_OVERRIDE: 'Remplacement (h)' },
			FM: { TITLE: 'Configuration des Modes de Défaillance', CONFIG_FOR: 'Configuration des modes de défaillance pour :', SELECT_HOW: 'Sélectionnez comment vous souhaitez configurer les modes de défaillance', SAVED_CONF: 'Configuration Enregistrée', RCM_ANALYSIS: 'Analyse RCM', APPLY_LIB: 'Appliquer à partir de la bibliothèque', APPLY_LIB_DESC: 'Utilisez des modèles de modes de défaillance prédéfinis pour votre classe d\'équipement', APPLY_LIB_AVAIL: 'Modèle disponible : Modèle de Pompe ACW', UPLOAD_RCM: 'Télécharger une analyse RCM précédente', UPLOAD_RCM_DESC: 'Importer des modes de défaillance à partir d\'un fichier d\'étude RCM existant (Excel/CSV)', NEW_STUDY: 'Créer une nouvelle étude FMEA', NEW_STUDY_DESC: 'Démarrer une nouvelle approche FMEA avec l\'assistant', APPLY_TEMPLATE: 'Appliquer le modèle', CREATE_ROOTY: 'Créer via ROOTY', UPLOAD_EXCEL: 'Télécharger depuis Excel', DOWNLOAD_TEMPLATE: 'Télécharger le modèle', COL_FM_ID: 'ID FM', COL_SUBSYSTEM: 'Sous-système', COL_COMPONENT: 'Composant', COL_FUNCTION: 'Fonction', COL_FUNC_FAIL: 'Défaillance fonctionnelle', COL_FAILURE_MODE: 'Mode de défaillance', COL_CONSEQUENCE_CAT: 'Catégorie de conséquence', COL_FAILURE_BEHAVIOR: 'Comportement de défaillance', COL_PDM_APPLICABILITY: 'Applicabilité PdM', COL_LIKELY_CAUSES: 'Causes probables', COL_SYMPTOMS: 'Symptômes / Indicateurs', COL_LOCAL_EFFECTS: 'Effets locaux', COL_SYSTEM_EFFECTS: 'Effets système', COL_PLANT_EFFECTS: 'Effets installation', COL_EFFECTS: 'Effets', COL_IMPACTS: 'Impacts', COL_EFFECT: 'Effet', COL_TYPE: 'Type', COL_STATUS: 'Statut', COL_EVIDENCES: 'Preuves', COL_TOTAL_COST: 'Coût total', COL_CATEGORY: 'Catégorie', COF_RATING: 'Évaluation CoF', COF_CATEGORY: 'Catégorie CoF', COST_SUMMARY: 'Résumé des coûts', REPAIR_COST: 'Coût de réparation (en USD)', SAFETY_RISK_COST: 'Coût du risque sécurité (en USD)', PROD_LOSS: 'Perte de production (en USD)', OUTAGE_DURATION: 'Durée de l\'interruption (en heures)', TOTAL_COST_USD: 'Coût total (en USD)', CONSEQUENCE_RATING: 'Évaluation des conséquences', SAFETY: 'Sécurité', OPERATIONAL: 'Opérationnel', ENVIRONMENTAL: 'Environnemental', REPUTATIONAL: 'Réputationnel', CLASSIFICATION_HIDDEN: 'Classification : Défaillance cachée', SUPPORTING_EVIDENCE: 'Preuves à l\'appui', VIEW_EVIDENCE: 'Voir le panneau de preuves complet', NO_FM_FOUND: 'Aucune configuration de modes de défaillance trouvée...', EXPAND_ADDITIONAL_INFO: 'Informations supplémentaires', PERF_STANDARD: 'Norme de performance', FM_ANCHOR_LEVEL: 'Niveau d\'ancrage FM', FM_TYPE: 'Type FM', SYMPTOM_CHILDREN: 'Symptômes enfants', CURRENT_CONTROLS: 'Contrôles actuels', EVIDENCE_SOURCE: 'Source de preuves', WO_EVIDENCE_REFS: 'Références preuves OT', VALIDATION_OUTCOME: 'Résultat de validation', UNVALIDATED_JUSTIFICATION: 'Justification non validée', CONFIDENCE: 'Confiance', PF_INTERVAL: 'Estimation intervalle P-F' },
			EDITOR: {
				SAVING: 'Enregistrement...',
				SAVE_TEMPLATE: 'Enregistrer le modèle',
				SAVE_ACTIVITY: 'Enregistrer l\'activité',
				SAVE_PACKAGE: 'Enregistrer le paquet d\'équipement',
				CREATE_TEMPLATE: 'Créer un modèle',
				EMPTY_TEMPLATE: 'Modèle vide',
				CREATE_VIA_ROOTY: 'Créer avec Rooty',
				SAVE_CONTINUE: 'Enregistrer et continuer',
				SAVE_TO_CONFIGURE: 'Enregistrez le modèle pour commencer à configurer PM, FMEA et CM.',
				DOWNLOAD: 'Télécharger le modèle',
				UPLOAD: 'Télécharger un modèle',
				PM_CHECKLIST: 'Check-list PM',
				FMEA_CONFIG: 'Configuration des modes de défaillance',
				CM_CHECKLIST: 'Check-list CM (Bientôt)',
				DESC: 'Description',
				TEMPLATE_NAME: 'Nom du modèle',
				OVERALL_PM_VARS: 'Variables globales du niveau PM',
				SAVE_PM_ACTIVITY: 'Enregistrer l\'activité PM',
				SAVE_FMEA_CONFIG: 'Enregistrer la configuration FMEA',
				SAVE_CM_CONFIG: 'Enregistrer la configuration CM',
					RE_GENERATE: 'Régénérer',
				SAVED_INTERNALLY: 'enregistré en interne avec succès :',
				DEFINE_PM: 'Définir la liste de contrôle PM',
				DEFINE_FM: 'Définir la configuration FMEA',
				DEFINE_CM: 'Définir la configuration CM',
				DEFINE_WRENCH_TIME: 'Définir les variables de temps de clé',
				DEFINE_DESC: 'Téléchargez un exemple ou importez un modèle complété pour générer.',
				NO_PM_ATTACHED: 'Pas de configuration PM jointe',
				NO_FM_ATTACHED: 'Pas de configuration des modes de défaillance jointe',
				NO_CM_ATTACHED: 'Pas de configuration CM jointe',
				PM_CONFIG_TAB: 'Configuration PM',
				FM_CONFIG_TAB: 'Configuration FMEA',
				CM_CONFIG_TAB: 'Configuration CM',
				PM_FM_MAPPING_TAB: 'Mappage PM -> FM',
				DEFINE_PM_FM: 'Définir le mappage PM-FM',
				DEFINE_PM_FM_DESC: 'Configurez les activités PM qui atténuent les modes de défaillance pour cet équipement.',
				PM_FM_MAPPING_MATRIX: 'Matrice de mappage PM-FM',
				PM_FM_MAPPING_SUBHEADER: 'Configurez les activités PM pour les modes de défaillance de {{equipment}}',
				PM_FM_SEARCH_PM: 'Rechercher une activité PM...',
				PM_FM_SHOW_ALL: 'Tout afficher',
				PM_FM_SHOW_MAPPED: 'Mappé',
				PM_FM_SHOW_UNMAPPED: 'Non mappé',
				PM_FM_SHOW_ZERO_COVERAGE: 'Sans couverture',
				PM_FM_LEGEND_FULL: '1 = Entièrement mappé',
				PM_FM_LEGEND_PARTIAL: '0,1-0,9 = Relation partielle',
				PM_FM_LEGEND_EMPTY: 'Vide = Non mappé',
				PM_FM_CONFIRM_ALL: 'Confirmer les restants',
				PM_FM_CONFIRM_ROW: 'Confirmer le mappage',
				PM_FM_UNMAP: 'Annuler le mappage',
				PM_FM_NO_PM_ATTACHED: 'Aucune activité PM configurée',
				PM_FM_NO_FM_ATTACHED: 'Aucun mode de défaillance configuré',
				PM_FM_STALE_BANNER: 'PM ou FMEA a changé depuis la génération de ce mappage. Les activités nouvelles ou modifiées apparaissent non mappées ci-dessous — mappez-les directement, ou utilisez Régénérer pour que Rooty réanalyse tout depuis le début (cela écrasera vos mappages validés).',
				PM_FM_REGENERATE: 'Régénérer',
				PM_FM_UNMAPPED_COUNT: '{{count}} non mappé(s)',
				PM_FM_ZERO_COVERAGE_HEADING: 'Modes de défaillance sans couverture',
				PM_FM_NEW_PM_PROPOSALS: 'Nouvelles propositions PM',
				PM_FM_ACCEPT_PROPOSAL: 'Accepter la proposition'
			}
		},
		CONFIGURATION: {
			CASES: {
				TITLE: 'Configuration des cas',
				LAST_UPDATED_BY: 'Dernière mise à jour par {{name}} - {{date}}',
				MATRIX_TITLE: 'Matrice d\'impact de probabilité',
				MATRIX_SUBTITLE: '(constante M1 — utilisable dans les calculs)',
				VALUE_INPUT_TITLE: 'Entrée de valeur',
				VALUE_INPUT_SUBTITLE: '(valeurs que les utilisateurs peuvent saisir dans les champs de valeur pour un cas)',
				CALCULATIONS_TITLE: 'Calculs',
				CALCULATIONS_SUBTITLE: '(calculs de valeur configurés par l\'utilisateur dans un cas)',
				OPTIONAL_TITLE: 'Optionnel',
				OPTIONAL_SUBTITLE: '(champs supplémentaires qui peuvent être ajoutés à un cas à des fins de suivi)',
				COL_CONSTANT: 'Constante',
				COL_UNIT_FIELD: 'Champ d\'unité',
				COL_FIELD_UOM: 'UoM du champ',
				COL_DEFAULT_VALUE: 'Valeur par défaut',
				COL_ACTIONS: 'Actions',
				COL_CALCULATION: 'Calcul',
				COL_UOM: 'UoM',
				COL_FORMULA: 'Formule',
				COL_FIELD: 'Champ',
				COL_VALUE: 'Valeur',
				COL_UNIT_OF_MEASURE: 'Unité de mesure',
				ADD: 'Ajouter',
				ADD_ROW: 'Ajouter une ligne',
				CANCEL: 'Annuler',
				SAVE: 'Enregistrer',
				SAVE_SUCCESS: 'Configuration des cas enregistrée avec succès',
				IMPACT: 'IMPACT',
				LIKELIHOOD: 'PROBABILITÉ',
				DELETE_ROW: 'Supprimer la ligne',
				PLACEHOLDER_UNIT_FIELD: 'Saisir le champ d\'unité',
				PLACEHOLDER_FIELD_UOM: 'Saisir le UoM du champ',
				PLACEHOLDER_DEFAULT_VALUE: 'Saisir la valeur par défaut',
				PLACEHOLDER_CALCULATION: 'Saisir le nom de calcul',
				PLACEHOLDER_UOM: 'Saisir le UoM',
				PLACEHOLDER_FORMULA: 'Saisir la formule',
				PLACEHOLDER_FIELD_NAME: 'Saisir le nom du champ',
				DUPLICATE_FIELD_NAME: 'Le nom du champ doit être unique',
				PLACEHOLDER_VALUE: 'Saisir la valeur',
				PLACEHOLDER_UNIT_OF_MEASURE: 'Saisir l\'unité de mesure',
				RESET_TO_DEFAULTS: 'Réinitialiser par défaut',
				RESET_MATRIX_CONFIRM_TITLE: 'Réinitialiser par défaut ?',
				RESET_MATRIX_CONFIRM_DESC: 'Cela réinitialisera la <strong>Matrice de Probabilité et d\'Impact</strong> à ses valeurs par défaut d\'origine. Toutes les modifications personnalisées effectuées seront perdues.',
				RESET_MATRIX_CONFIRM_OK: 'Confirmer',
				LOAD_ERROR: 'Échec du chargement de la configuration des cas',
				SAVE_ERROR: 'Échec de l\'enregistrement de la configuration des cas',
				RESET_ERROR: 'Échec de la réinitialisation de la configuration des cas',
				CONSTANT_USED_IN_FORMULA: 'Cette constante est utilisée dans une formule',
				FORMULA: {
					UNDEFINED_CONSTANT: 'La constante "{{constant}}" n\'est pas définie',
					INVALID_CHARACTER: 'La formule contient un caractère ou un opérateur non pris en charge',
					UNBALANCED_PARENTHESES: 'La formule contient des parenthèses non équilibrées',
					EMPTY_PARENTHESES: 'La formule contient des parenthèses vides',
					MISSING_OPERATOR: 'Il manque un opérateur entre les valeurs dans la formule',
					INVALID_OPERATOR_POSITION: 'La formule contient un opérateur à une position non valide',
					TRAILING_OPERATOR: 'La formule ne peut pas se terminer par un opérateur'
				}
			},
			FILTER: {
				TITLE: 'Filtres',
				SEARCH: 'Rechercher'
			},
			ASSET_TEMPLATE: {
				TITLE: 'Liste des modèles d\'actifs',
				SEARCH: 'Rechercher',
				TOOLTIP_ADD: 'Ajouter un nouvel actif',
				TOOLTIP_DELETE: 'Supprimer l\'actif',
				TOOLTIP_SYNC: 'Synchroniser',
				TOOLTIP_SYNC_PROGRESS: 'Synchronisation en cours',
				SYNC_STARTED_TOAST: 'Synchronisation du modèle d\'actif démarrée.',
				SYNC_COMPLETED_TOAST: 'Synchronisation du modèle d\'actif terminée.',
				SYNC_FAILED_TOAST: 'Échec de la synchronisation du modèle d\'actif{{errorSuffix}}.',
				COL_INDEX: 'N°',
				COL_TEMPLATE_NAME: 'Nom du modèle',
				COL_APPLICATION: 'Application',
				COL_CREATED_ON: 'Créé le',
				COL_ACTIONS: 'Actions',
				NO_RECORDS: 'Aucun enregistrement trouvé',
				NO_MATCHES: 'Aucun résultat trouvé pour "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Essayez un mot clé différent ou effacez la recherche',
				LOADING: 'Chargement...'
			},
			TAGS: {
				TOOLTIP_UPLOAD_SCADA: 'Importer le mappage SCADA des tags',
				TITLE: 'Liste des tags',
				SEARCH: 'Rechercher',
				TOOLTIP_ADD: 'Ajouter un nouveau tag',
				TOOLTIP_UPLOAD: 'Importer des tags',
				TOOLTIP_DOWNLOAD: 'Télécharger la liste des étiquettes',
				TOOLTIP_TAG_MAPPING: 'Accéder au mappage de tags',
				TOOLTIP_DELETE: 'Supprimer le tag',
				TOOLTIP_NO_FAILURE_MODES: 'Aucun mode de défaillance associé',
				TOOLTIP_VIEW_CHANGES: 'Voir les modifications',
				COL_INDEX: 'N°',
				COL_NAME: 'Nom',
				COL_TAG_ID: 'ID du tag',
				COL_SHARED: 'Partagé',
				COL_UNIT: 'Unité',
				COL_FAILURE_MODES: 'Mode(s) de défaillance',
				COL_MODELLING: 'Utilisé pour la modélisation',
				COL_CALCULATED: 'Calculé',
				COL_DESCRIPTION: 'Description',
				COL_ASSET: 'Actif',
				COL_ACTIONS: 'Actions',
				NO_TAGS: 'Aucune étiquette disponible pour l\'actif sélectionné'
			},
			FAILURE_MODE: {
				TITLE: 'Liste des modes de défaillance',
				SEARCH: 'Rechercher',
				TOOLTIP_UPLOAD: 'Importer les modes de défaillance',
				TOOLTIP_ADD: 'Ajouter un nouveau mode de défaillance',
				TOOLTIP_EDIT: 'Modifier le mode de défaillance',
				TOOLTIP_FILTER: 'Filtrer',
				TOOLTIP_DELETE: 'Supprimer',
				TOOLTIP_EDIT_DIRECTIONALITY: 'Modifier la directionnalité du tag',
				COL_INDEX: 'N°',
				COL_NAME: 'Nom',
				COL_DESCRIPTION: 'Description',
				COL_TAG: 'Tag',
				COL_ASSET: 'Actif',
				COL_RECOMMENDATIONS: 'Recommandations',
				COL_ACTIONS: 'Actions',
				NO_RECORDS: 'Aucun enregistrement trouvé'
			},
			DIGITIZATION: {
				TITLE: 'Liste de numérisation',
				SEARCH: 'Rechercher',
				TOOLTIP_ADD: 'Ajouter une nouvelle numérisation',
				TOOLTIP_DELETE: 'Supprimer la numérisation',
				COL_INDEX: 'N°',
				COL_MANUFACTURER: 'Fabricant',
				COL_MODEL: 'Modèle',
				COL_INDUSTRY_TYPE: 'Type d\'industrie',
				COL_MODIFIED_ON: 'Modifié le',
				COL_CREATED_ON: 'Créé le',
				NO_RECORDS: 'Aucun enregistrement trouvé',
				NO_MATCHES: 'Aucun résultat trouvé pour "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Essayez un mot clé différent ou effacez la recherche'
			},
			TABS: {
				ASSET_TEMPLATE: 'Modèle d\'actif',
				ASSETS: 'Actifs',
				DIGITIZATION: 'Numérisation',
				SETTINGS: 'Paramètres',
				CASES: 'Cas'
			},
			SETTINGS: {
				TITLE: 'Mettre à jour les paramètres',
				COL_INDEX: '#',
				COL_PAGE_NAME: 'Nom de la page',
				COL_LAST_UPDATED: 'Dernière mise à jour',
				COL_UPDATED_BY: 'Mis à jour par',
				TOOLTIP_SETTINGS: 'Paramètres',
				LOADING: 'Chargement des paramètres...',
				NO_SETTINGS: 'Aucun paramètre trouvé'
			},
			ASSETS: {
				TITLE: 'Liste des actifs',
				SEARCH: 'Rechercher',
				TOOLTIP_FILTER: 'Filtrer actif',
				TOOLTIP_DELETE: 'Supprimer actif',
				TOOLTIP_VIEW_CHANGES: 'Voir les modifications',
				COL_INDEX: 'N°',
				COL_NAME: 'Nom de l\'actif',
				COL_TYPE: 'Type d\'actif',
				COL_UNIT: 'Unité',
				COL_SYSTEM: 'Système',
				COL_APPLICATION: 'Application',
				COL_CONFIGURATION: 'Configuration',
				COL_INDUSTRY: 'Industrie',
				COL_AUTHOR: 'Auteur',
				COL_MAKE_MODEL: 'Marque & Modèle',
				COL_MAINTENANCE: 'Données de maintenance',
				NO_RECORDS: 'Aucun enregistrement trouvé',
				NO_MATCHES: 'Aucun résultat trouvé pour "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Essayez un mot clé différent ou effacez la recherche',
			},
			FM_MAPPING_MENU: {
				HIGH: 'Élevé',
				LOW: 'Bas',
				STABLE: 'Stable',
				REFERENCE: 'Référence',
				UNMAPPED: 'Non mappé',
				TOOLTIP_HIGH_PRIMARY: 'Élevé - Mode de défaillance primaire',
				TOOLTIP_HIGH_SECONDARY: 'Élevé - Mode de défaillance secondaire',
				TOOLTIP_LOW_PRIMARY: 'Bas - Mode de défaillance primaire',
				TOOLTIP_LOW_SECONDARY: 'Bas - Mode de défaillance secondaire',
				TOOLTIP_STABLE_PRIMARY: 'Stable - Mode de défaillance primaire',
				TOOLTIP_STABLE_SECONDARY: 'Stable - Mode de défaillance secondaire',
				TOOLTIP_REFERENCE: 'Mode de défaillance de référence',
				FM_LOGIC: 'Logique FM',
				HIGH_INCREASING: 'Élevé/Croissant',
				LOW_DECREASING: 'Bas/Décroissant',
				RULE_BASED: 'Basé sur des règles',
				UNMAP: 'Désassocier',
				RULE_BASED_CONDITION: 'Condition basée sur des règles',
				OPERATOR: 'Opérateur',
				COMPARE_TO: 'Comparer à',
				ENTER_VALUE: 'Saisir la valeur',
				NUMERIC_INPUT_ONLY: 'Entrée numérique uniquement',
				PREFERENCE: 'Préférence',
				APPLY: 'Appliquer'
			},
			QUICK_FILTER: {
				NO_MATCHES: 'Aucun résultat trouvé pour "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Essayez un mot clé différent ou effacez la recherche',
				CLOSE: 'Fermer',
			},
			DIGITIZATION_POPUP: {
				FORM_ERROR: 'Oh non ! Le fabricant et le nom du modèle sont déjà pris. Modifiez quelques éléments et essayez de soumettre à nouveau.',
				MANUFACTURER: 'Fabricant',
				MANUFACTURER_NAME: 'Nom du fabricant',
				MODEL: 'Modèle',
				MODEL_NAME: 'Nom du modèle',
				INDUSTRY_TYPE: 'Type d\'industrie',
				ENTER: 'Saisir',
				SELECT: 'Sélectionner',
				IS: 'est',
				CUT_IN_SPEED: 'Vitesse de démarrage(m/s)',
				CUT_IN_SPEED_LABEL: 'Vitesse de démarrage',
				CUT_OFF_SPEED: 'Vitesse d\'arrêt(m/s)',
				CUT_OFF_SPEED_LABEL: 'Vitesse d\'arrêt',
				CAPACITY_KWH: 'Saisir la valeur en KWH',
				CAPACITY: 'Capacité',
				IS_REQUIRED: 'est requis',
				SMALLER_THAN_CUTOFF: 'doit être inférieur au seuil de coupure',
				GREATER_THAN_CUTIN: 'doit être supérieur au seuil de démarrage',
				GREATER_THAN_ZERO: 'doit être supérieur à 0',
				POWER_CURVE: 'Courbe de puissance',
				REQUIRED: 'requis',
				UPLOAD_POWER_CURVE: 'Télécharger la courbe de puissance',
				DOWNLOAD_SAMPLE: 'Télécharger l\'exemple/fichier précédemment chargé',
				VIEW_POWER_CURVE: 'Voir les données de courbe de puissance téléchargées',
				ERROR_CODE_MAP: 'Carte des codes d\'erreur',
				UPLOAD_SCADA: 'Télécharger le code d\'événement SCADA',
				VIEW_SCADA: 'Voir les données de code d\'événement SCADA téléchargées',
				CANCEL: 'Annuler',
				CANCEL_TOOLTIP: 'Annuler les modifications',
				SAVE: 'Enregistrer',
				SAVE_TOOLTIP: 'Enregistrer les modifications'
			},
			FAILURE_MODE_POPUP: {
				FORM_ERROR: 'Oh non ! Modifiez quelques éléments et essayez de soumettre à nouveau.',
				NAME: 'Nom',
				IS: 'est',
				PRIORITY: 'Priorité',
				REQUIRED: 'requis',
				START_TIME: 'Heure de début (en heures)',
				START_TIME_LABEL: 'Heure de début',
				END_TIME: 'Heure de fin (en heures)',
				END_TIME_LABEL: 'Heure de fin',
				IS_REQUIRED: 'est requis',
				TIME_RANGE: 'la plage doit être comprise entre 0,1 et 48 heures',
				DESCRIPTION: 'Description',
				RELIABILITY_SAVINGS: 'Économies de fiabilité (potentiel)',
				MAINTENANCE_SAVINGS: 'Économies de maintenance (potentiel)',
				PERFORMANCE_SAVINGS: 'Économies de performance (potentiel)',
				REMARK: 'Remarque',
				REMARK_TO_EDIT: 'Remarque pour modification',
				ENTER: 'Saisir',
				CANCEL: 'Annuler',
				CANCEL_TOOLTIP: 'Annuler les modifications',
				SAVE: 'Enregistrer',
				SAVE_TOOLTIP: 'Enregistrer les modifications'
			},
			TAG_DIRECTIONALITY_POPUP: {
				FORM_ERROR: 'Oh non ! Modifiez quelques éléments et essayez de soumettre à nouveau.',
				TAG_NAME: 'Nom de l\'étiquette',
				DIRECTIONALITY: 'Directionnalité',
				SELECT: 'Sélectionner',
				CANCEL: 'Annuler',
				CANCEL_TOOLTIP: 'Annuler les modifications',
				SAVE: 'Enregistrer',
				SAVE_TOOLTIP: 'Enregistrer les modifications'
			},
			FM_RECOMMENDATION_POPUP: {
				FORM_ERROR: 'Oh non ! Modifiez quelques éléments et essayez de soumettre à nouveau.',
				RECOMMENDATION: 'Recommandation',
				IS: 'est',
				CATEGORY: 'Catégorie',
				SELECT: 'Sélectionner',
				SELECT_FAILURE: 'Sélectionner la défaillance',
				FAILURE: 'Défaillance',
				REMARK: 'Remarque',
				REMARK_TO_EDIT: 'Remarque pour modification',
				ENTER: 'Saisir',
				CANCEL: 'Annuler',
				CANCEL_TOOLTIP: 'Annuler les modifications',
				SAVE: 'Enregistrer',
				SAVE_TOOLTIP: 'Enregistrer les modifications'
			},
			TAGS_POPUP: {
				FORECASTING: 'Prévision',
				PERFORMANCE_DEGRADATION: 'Dégradation des performances',
				PERFORMANCE_DEGRADATION_HINT: '(Activer la prévision du temps avant intervention pour ce tag)',
				DYNAMIC_DEVIATION_THRESHOLD: 'Seuil de déviation dynamique',
				DEVIATION_LOW: 'Faible',
				DEVIATION_MEDIUM: 'Moyen',
				DEVIATION_HIGH: 'Élevé',
				ERRATIC_DETECTION: 'Détection erratique',
				ERRATIC_ALERT: 'Alerte erratique',
				MISSING_DATA_DETECTION: 'Détection de données manquantes',
				OUTLIER_DETECTION: 'Détection des valeurs aberrantes',
				OUT_OF_RANGE_DETECTION: 'Détection hors plage',
				DATA_QUALITY_ALERT_GENERATION: 'GÉNÉRATION D\'ALERTE DE QUALITÉ DES DONNÉES',
				DATA_QUALITY_ALERT_DESC: 'Choisissez les problèmes DQ détectés devant générer des alertes. Désactiver la génération d\'alertes n\'arrête pas le calcul DQ. Les valeurs apparaîtront toujours dans les tableaux DQ.',
				FLATLINE_ALERT: 'Alerte de ligne plate',
				MISSING_DATA_ALERT: 'Alerte de données manquantes',
				OUTLIER_ALERT: 'Alerte de valeur aberrante',
				OUT_OF_RANGE_ALERT: 'Alerte hors plage',
				ALERTS_NOTIFICATIONS_KPI: 'Alertes, notifications et KPI',
				OPERATIONAL_LIMITS: 'Limites opérationnelles',
				ADDITIONAL_SETTINGS: 'Paramètres Additionnels',
				NO_TAGS_WITH_TAGID_MAPPED: 'Aucun Tag trouvé avec TagId mappé.',
				FUNCTION_NAME: 'Nom de la fonction',
				DATA_QUALITY_DETECTION: 'Détection de la qualité des données',
				SELECT_TAG_TO_ADD_MORE: 'Sélectionnez la première balise pour activer l\'ajout de balises supplémentaires',
				ENTER_FORMULA: 'Entrer la formule*',
				LOWER: 'Inférieur',
				UPPER: 'Supérieur',
				START: 'Début',
				END: 'Fin',
				DEADLINE: 'Échéance',
				FORMULA_PLACEHOLDER: 'Entrez la formule. Ex. (t1+t2)*t3',
				SELECT_TAG: 'Sélectionner le tag',
				SELECT_KEY: 'Sélectionner la clé',
				VALUE: 'Valeur',
				FORM_ERROR: 'Oh non ! Modifiez quelques éléments et essayez de soumettre à nouveau.',
				TAG_NAME: 'Nom de l\'étiquette',
				DESCRIPTION: 'Description',
				TAG_ID: 'ID de l\'étiquette',
				UNIT: 'Unité',
				INSTRUMENT_RANGE: 'Plage d\'instrument',
				TRIP_LIMITS: 'Limites de déclenchement',
				THRESHOLD_ALERT: 'Alerte de seuil',
				THRESHOLD_ALERT_DELAY: 'Délai d\'alerte de seuil',
				IOW_CRITICALITY: 'Criticité IOW',
				DIRECTIONALITY: 'Directionnalité',
				DIRECTION: 'Direction',
				FLATLINE_DETECTION: 'Détection de ligne plate',
				ATTENTION: 'Attention',
				THRESHOLD_NOTIFICATION: 'Notification de seuil',
				KPI: 'KPI',
				STRING_CURRENT: 'Courant de chaîne',
				STRING_CAPACITY: 'Capacité de chaîne',
				SCADA_ERROR_CODES: 'Codes d\'erreur SCADA',
				COMMA_SEPARATED_ERROR_CODES: 'Ajouter des codes d\'erreur séparés par des virgules',
				ASSET: 'Actif',
				CALCULATED_FLAG: 'Indicateur calculé',
				REMARK: 'Remarque',
				REMARK_TO_EDIT: 'Remarque pour modification',
				FUNCTION_TABLE: 'Table des fonctions',
				PARAMETERS: 'Paramètres',
				CONSTANTS: 'Constantes',
				PLOT_CONTINUOUS: 'Tracer comme une tendance linéaire continue (ignorer les valeurs manquantes)',
				ENTER: 'Saisir',
				SELECT: 'Sélectionner',
				WRITE_CUSTOM_CODE: 'Écrire du code personnalisé',
				UPLOAD_TAGS: 'Télécharger les étiquettes',
				DOWNLOAD_CORRELATION_CSV: 'Télécharger le format CSV de corrélation',
				UPLOAD_CORRELATION_CSV: 'Télécharger le CSV de corrélation',
				DELETE: 'Supprimer',
				ADD: 'Ajouter',
				CANCEL: 'Annuler',
				CANCEL_TOOLTIP: 'Annuler les modifications',
				SAVE: 'Enregistrer',
				SAVE_TOOLTIP: 'Enregistrer les modifications',
				ALARM_LIMITS: 'Limites d\'alarme',
				THRESHOLD_LIMITS: 'Limites de seuil',
				CORRELATION_CSV_UPLOAD_LABEL: 'Télécharger le CSV de corrélation',
				TRIAL_RUN: 'Essai',
				SELECT_PYTHON_FUNCTION: 'Sélectionner une fonction Python',
				SEARCH_FUNCTIONS_PLACEHOLDER: 'Rechercher des fonctions...',
				NO_MATCHING_FUNCTION_FOUND: 'Aucune fonction correspondante trouvée',
				SELECT_FUNCTION_ERROR: 'Veuillez sélectionner une fonction Python',
				DEPRECATED: 'Obsolète',
				DEPRECATED_FORMULA_TOOLTIP: 'Cette formule est obsolète. Veuillez sélectionner la formule mise à jour.',
				DEPRECATED_FORMULA_ERROR: 'Cette formule est obsolète. Veuillez sélectionner la formule mise à jour.',
				CUSTOM_FORMULA_INVALID_VARS: 'Variable(s) invalide(s) utilisée(s)',
				CUSTOM_FORMULA_INVALID_SYNTAX: 'Variable(s)/expression mathématique invalide',
				CUSTOM_FORMULA_REQUIRED: 'La formule est requise',
				SEARCH_ASSETS_PLACEHOLDER: 'Rechercher des actifs...',
				NO_MATCHING_ASSET_FOUND: 'Aucun actif correspondant trouvé',
				SEARCH_DOTS: 'Rechercher...',
				NO_MATCHING_TAG_FOUND: 'Aucune étiquette correspondante trouvée',
				NO_TAGS_FOUND_WITH_TAGID_MAPPED: 'Aucune balise trouvée avec TagId associé.',
				SEARCH_PLAIN: 'Rechercher',
				NO_MATCHING_KEY_FOUND: 'Aucune clé correspondante trouvée',
				PARAMETER_NAME_HINT: 'Nom du paramètre',
				CONSTANT_NAME_HINT: 'Nom de la constante',
				DISPLAY_EXPRESSION: 'Expression d\'affichage',
				DISPLAY_EXPRESSION_PLACEHOLDER: 'Saisir l\'expression',
				EXPRESSION_DESCRIPTION: 'Description de l\'expression',
				EXPRESSION_DESCRIPTION_PLACEHOLDER: 'Saisir la description de l\'expression'
			},
			ASSET_TEMPLATE_DELETE: {
				TITLE: 'Confirmation de suppression de l\'actif',
				CONFIRM_MSG: 'Êtes-vous sûr de vouloir supprimer l\'actif ?',
				ASSOCIATED_ITEMS_MSG: 'Voulez-vous également supprimer les éléments suivants associés à l\'actif ?',
				DELETE_TAGS: 'Supprimer les étiquettes associées',
				DELETE_FAILURE_MODES: 'Supprimer les modes de défaillance associés',
				DELETING: 'Suppression...',
				CANCEL: 'Annuler',
				DELETE: 'Supprimer'
			},
			FM_INFO: {
				TITLE: 'Informations sur le mode de défaillance',
				TOOLTIP_ADD: 'Ajouter',
				TOOLTIP_EDIT: 'Modifier',
				TOOLTIP_UPLOAD: 'Télécharger',
				TOOLTIP_DOWNLOAD: 'Télécharger',
				TOOLTIP_EDIT_MAPPING: 'Modifier la correspondance',
				TOOLTIP_DELETE: 'Supprimer',
				TOOLTIP_VIEW_CHANGES: 'Voir les modifications',
				UPLOAD_FAILURE_MODES: 'Télécharger les modes de défaillance',
				UPLOAD_FM_TAG_MAPPINGS: 'Télécharger les correspondances défaillance-étiquette',
				DOWNLOAD_FAILURE_MODES: 'Télécharger les modes de défaillance',
				DOWNLOAD_FM_TAG_MAPPINGS: 'Télécharger les correspondances défaillance-étiquette',
				COL_FAILURE_MODE: 'Mode de défaillance',
				COL_START_TIME: 'Heure de début',
				COL_END_TIME: 'Heure de fin',
				COL_PRIORITY: 'Priorité',
				COL_ACTIONS: 'Actions',
				PRIORITY_DESCRIPTION: 'Description de la priorité d\'impact',
				NO_RECORDS: 'Aucun mode de défaillance disponible pour l\'actif sélectionné'
			},
			RECOMMENDATIONS: {
				TITLE: 'Recommandations',
				TOOLTIP_ADD: 'Ajouter',
				TOOLTIP_EDIT: 'Modifier',
				TOOLTIP_UPLOAD: 'Télécharger',
				TOOLTIP_DOWNLOAD: 'Télécharger',
				TOOLTIP_EDIT_MAPPING: 'Modifier la correspondance mécanismes-recommandations',
				TOOLTIP_DELETE: 'Supprimer',
				TOOLTIP_VIEW_CHANGES: 'Voir les modifications',
				UPLOAD_RECOMMENDATIONS: 'Télécharger les recommandations',
				UPLOAD_REC_FM_MAPPINGS: 'Télécharger les correspondances recommandation-FM',
				DOWNLOAD_RECOMMENDATIONS: 'Télécharger les recommandations',
				DOWNLOAD_REC_FM_MAPPINGS: 'Télécharger les correspondances recommandation-FM',
				COL_RECOMMENDATIONS: 'Recommandations',
				COL_CATEGORY: 'Catégorie',
				NO_RECORDS: 'Aucune recommandation disponible pour l\'actif sélectionné'
			},
			ASSET_TEMPLATE_SYNC: {
				SYNC_MSG: 'Les modifications suivantes ont été apportées au modèle d\'actif. Veuillez vérifier et décider si elles doivent être synchronisées avec les actifs créés à partir de ce modèle.',
				ASSETS: 'Actifs',
				SELECT_ALL: 'Tout sélectionner',
				TAGS: 'Étiquettes',
				FAILURES: 'Défaillances',
				RECOMMENDATIONS: 'Recommandations',
				CLOSE_TOOLTIP: 'Fermer le popup',
				CANCEL: 'Fermer',
				DONT_SYNC: 'Ne pas synchroniser',
				DONT_SYNC_TOOLTIP: 'Ne pas synchroniser les modifications',
				SYNC: 'Synchroniser',
				SYNC_TOOLTIP: 'Synchroniser les modifications'
			},
			TAG_TEMPLATE_LIST: {
				TITLE: 'Liste des étiquettes',
				SEARCH: 'Rechercher',
				TOOLTIP_SEARCH: 'Rechercher',
				TOOLTIP_ADD: 'Ajouter une nouvelle étiquette',
				TOOLTIP_UPLOAD: 'Télécharger les étiquettes',
				TOOLTIP_DOWNLOAD: 'Télécharger la liste des étiquettes',
				TOOLTIP_CLONE: 'Cloner l\'étiquette',
				TOOLTIP_DELETE: 'Supprimer l\'étiquette',
				TOOLTIP_VIEW_CHANGES: 'Voir les modifications',
				COL_INDEX: 'N°',
				COL_TAG_TYPE: 'Type d\'étiquette',
				COL_NAME: 'Nom',
				COL_DESCRIPTION: 'Description de l\'étiquette',
				COL_UNIT: 'Unité',
				COL_FAILURE_MODES: 'Mode(s) de défaillance',
				COL_DIRECTIONALITY: 'Directionnalité',
				COL_CALCULATED: 'Calculé',
				COL_ACTIONS: 'Actions',
				NO_RECORDS: 'Aucune étiquette disponible pour l\'actif sélectionné',
				TOOLTIP_NO_FM: 'Aucun mode de défaillance associé',
				NO_MATCHES: 'Aucun résultat trouvé pour "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Essayez un mot clé différent ou effacez la recherche',
				LOADING: 'Chargement...'
			},
			SUBSYSTEMS: {
				TITLE: 'Sous-systèmes',
				SEARCH: 'Rechercher'
			},
			ASSET_TEMPLATE_POPUP: {
				FORM_ERROR: 'Oh non ! Modifiez quelques éléments et essayez de soumettre à nouveau.',
				NAME: 'Nom',
				IS: 'est',
				ALREADY_TAKEN: 'Déjà pris',
				TEMPLATE_NAME: 'Nom du modèle',
				APPLICATION: 'Application',
				TEMPLATE_APPLICATION: 'Application du modèle',
				PLEASE_ENTER: 'Veuillez saisir',
				CANCEL: 'Annuler',
				CANCEL_TOOLTIP: 'Annuler les modifications',
				SAVE: 'Enregistrer',
				SAVE_TOOLTIP: 'Enregistrer les modifications'
			},
			ASSETS_FM_INFO: {
				TITLE: 'Informations sur le mode de défaillance',
				TOOLTIP_ADD: 'Ajouter',
				TOOLTIP_EDIT: 'Modifier',
				TOOLTIP_UPLOAD: 'Télécharger',
				TOOLTIP_DOWNLOAD: 'Télécharger',
				TOOLTIP_EDIT_MAPPING: 'Modifier étiquette vers mécanismes',
				TOOLTIP_DELETE: 'Supprimer',
				TOOLTIP_VIEW_CHANGES: 'Voir les modifications',
				UPLOAD_FAILURE_MODES: 'Télécharger les modes de défaillance',
				UPLOAD_FM_TAG_MAPPINGS: 'Télécharger les correspondances défaillance-étiquette',
				DOWNLOAD_FAILURE_MODES: 'Télécharger les modes de défaillance',
				DOWNLOAD_FM_TAG_MAPPINGS: 'Télécharger les correspondances défaillance-étiquette',
				COL_STATUS: 'Statut',
				COL_FAILURE_MODE: 'Mode de défaillance',
				COL_PRIORITY: 'Priorité',
				COL_START_TIME: 'Heure de début',
				COL_END_TIME: 'Heure de fin',
				COL_ACTIONS: 'Actions',
				PRIORITY_DESCRIPTION: 'Description de la priorité d\'impact',
				NO_RECORDS: 'Aucun mode de défaillance disponible pour l\'actif sélectionné'
			},
			TAG_FM_POPUP: {
				TITLE: 'Étiquette vers mécanismes',
				TAG_NAME: 'Nom de l\'étiquette',
				SEARCH_TAG: 'Rechercher l\'étiquette',
				CANCEL: 'Annuler',
				CANCEL_TOOLTIP: 'Annuler les modifications',
				SAVE: 'Enregistrer',
				SAVE_TOOLTIP: 'Enregistrer les modifications',
				NO_RECORDS: "Aucune étiquette ni mode de défaillance trouvés",
				NO_MATCHES: 'Aucun résultat trouvé pour "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Essayez un mot clé différent ou effacez la recherche',
			},
			ASSETS_RECOMMENDATIONS: {
				TITLE: 'Recommandations',
				TOOLTIP_ADD: 'Ajouter',
				TOOLTIP_EDIT: 'Modifier',
				TOOLTIP_UPLOAD: 'Télécharger',
				TOOLTIP_DOWNLOAD: 'Télécharger',
				TOOLTIP_EDIT_MAPPING: 'Modifier la correspondance mécanismes-recommandations',
				TOOLTIP_DELETE: 'Supprimer',
				TOOLTIP_VIEW_CHANGES: 'Voir les modifications',
				UPLOAD_RECOMMENDATIONS: 'Télécharger les recommandations',
				UPLOAD_REC_FM_MAPPINGS: 'Télécharger les correspondances recommandation-FM',
				DOWNLOAD_RECOMMENDATIONS: 'Télécharger les recommandations',
				DOWNLOAD_REC_FM_MAPPINGS: 'Télécharger les correspondances recommandation-FM',
				COL_RECOMMENDATIONS: 'Recommandations',
				COL_CATEGORY: 'Catégorie',
				COL_ACTIONS: 'Actions',
				NO_RECORDS: 'Aucune recommandation disponible pour l\'actif sélectionné'
			},
			REC_FM_POPUP: {
				TITLE: 'Mécanismes vers recommandations',
				RECOMMENDATION: 'Recommandation',
				CATEGORY: 'Catégorie',
				OFFLINE: 'Hors ligne',
				ONLINE: 'En ligne',
				CANCEL: 'Annuler',
				CANCEL_TOOLTIP: 'Annuler les modifications',
				SAVE: 'Enregistrer',
				SAVE_TOOLTIP: 'Enregistrer les modifications'
			},
			ASSET_DELETE: {
				TITLE: 'Confirmation de suppression d\'actif',
				CONFIRM_MSG: 'Êtes-vous sûr de vouloir supprimer l\'actif ?',
				ASSOCIATED_ITEMS_MSG: 'Voulez-vous également supprimer les éléments suivants associés à l\'actif ?',
				DELETE_TAGS: 'Supprimer les étiquettes associées',
				DELETE_FAILURE_MODES: 'Supprimer les modes de défaillance associés',
				DELETING: 'Suppression...',
				CANCEL: 'Annuler',
				DELETE: 'Supprimer'
			},
			ASSET_POPUP: {
				FORM_ERROR: 'Oh non ! Modifiez quelques éléments et essayez de soumettre à nouveau.',
				ASSET_NAME: 'Nom de l\'actif',
				ASSET_MODEL: 'Modèle de l\'actif',
				ASSET_ID: 'ID d\'actif',
				DEPLOYED_DATE: 'Date de déploiement',
				SYSTEM: 'Système',
				MAINTENANCE_DATA: 'Données de maintenance',
				PROVIDER_DATA: 'Données du fournisseur',
				ENTER: 'Saisir',
				SELECT: 'Sélectionner',
				CANCEL: 'Annuler',
				CANCEL_TOOLTIP: 'Annuler les modifications',
				SAVE: 'Enregistrer',
				SAVE_TOOLTIP: 'Enregistrer les modifications'
			},
			NAME_MAPPING: {
				TITLE_TAG_FM: 'Téléchargement étiquette vers mécanismes',
				TITLE_REC_FM: 'Téléchargement recommandation vers mécanismes',
				TAG_NAME_MAPPING: 'Correspondance du nom d\'étiquette',
				REC_NAME_MAPPING: 'Correspondance du nom de recommandation',
				TAG_NAME: 'Nom de l\'étiquette',
				RECOMMENDATION_NAME: 'Nom de recommandation',
				TAG_NAME_OPTIONS: 'Options du nom d\'étiquette',
				REC_NAME_OPTIONS: 'Options du nom de recommandation',
				OPTIONS_PLACEHOLDER: 'Options',
				NO_TAG_SUGGESTIONS: 'Aucune suggestion trouvée. Cette étiquette ne sera pas utilisée dans la correspondance finale.',
				TAG_DELETED_FROM_MAPPING: 'Étiquette supprimée de la correspondance',
				NO_REC_SUGGESTIONS: 'Aucune suggestion trouvée. Cette recommandation ne sera pas utilisée dans la correspondance finale.',
				REC_DELETED_FROM_MAPPING: 'Recommandation supprimée de la correspondance',
				FM_DELETED_FROM_MAPPING: 'Mode de défaillance supprimé de la correspondance',
				ACTIONS: 'Actions',
				FM_MAPPING: 'Correspondance de mode de défaillance',
				FM_NAME: 'Nom du mode de défaillance',
				FM_OPTIONS: 'Options de mode de défaillance',
				TOOLTIP_CLEAR: 'Effacer la sélection',
				TOOLTIP_DELETE_TAG: 'Supprimer l\'étiquette',
				TOOLTIP_UNDO_TAG: 'Annuler la suppression de l\'étiquette',
				TOOLTIP_DELETE_FM: 'Supprimer le mode de défaillance',
				TOOLTIP_UNDO_FM: 'Annuler la suppression du mode de défaillance',
				CANCEL: 'Annuler',
				CANCEL_TOOLTIP: 'Annuler les modifications',
				SAVE: 'Enregistrer',
				SAVE_TOOLTIP: 'Enregistrer les modifications'
			},
			TAG_TEMPLATE_POPUP: {
				ERRATIC_DETECTION: 'Détection erratique',
				ERRATIC_ALERT: 'Alerte erratique',
				MISSING_DATA_DETECTION: 'Détection de données manquantes',
				OUTLIER_DETECTION: 'Détection des valeurs aberrantes',
				OUT_OF_RANGE_DETECTION: 'Détection hors plage',
				DATA_QUALITY_ALERT_GENERATION: 'GÉNÉRATION D\'ALERTE DE QUALITÉ DES DONNÉES',
				DATA_QUALITY_ALERT_DESC: 'Choisissez les problèmes DQ détectés devant générer des alertes. Désactiver la génération d\'alertes n\'arrête pas le calcul DQ. Les valeurs apparaîtront toujours dans les tableaux DQ.',
				FLATLINE_ALERT: 'Alerte de ligne plate',
				MISSING_DATA_ALERT: 'Alerte de données manquantes',
				OUTLIER_ALERT: 'Alerte de valeur aberrante',
				OUT_OF_RANGE_ALERT: 'Alerte hors plage',
				ALERTS_AND_NOTIFICATIONS: 'Alertes et notifications',
				OPERATIONAL_LIMITS: 'Limites opérationnelles',
				DATA_QUALITY_DETECTION: 'Détection de la qualité des données',
				SELECT_TAG_TO_ADD_MORE: 'Sélectionnez la première balise pour activer l\'ajout de balises supplémentaires',
				LOWER_RANGE: 'Plage inférieure',
				UPPER_RANGE: 'Plage supérieure',
				LOWER: 'Inférieur',
				UPPER: 'Supérieur',
				ALARM_LIMITS: 'Limites d\'alarme',
				THRESHOLD_LIMITS: 'Limites de seuil',
				START: 'Début',
				END: 'Fin',
				FORMULA_PLACEHOLDER: 'Entrez la formule. Ex. (t1+t2)*t3',
				SELECT_TAG: 'Sélectionner le tag',
				VALUE: 'Valeur',
				DELETE: 'Supprimer',
				ADD: 'Ajouter',
				FORM_ERROR: 'Oh non ! Modifiez quelques éléments et essayez de soumettre à nouveau.',
				TAG_TYPE: 'Type d\'étiquette',
				TAG_NAME: 'Nom de l\'étiquette',
				TAG_DESCRIPTION: 'Description de l\'étiquette',
				DESCRIPTION: 'Description',
				UNIT: 'Unité',
				INSTRUMENT_RANGE: 'Plage d\'instrument',
				TRIP_LIMITS: 'Limites de déclenchement',
				THRESHOLD_ALERT: 'Alerte de seuil',
				THRESHOLD_ALERT_DELAY: 'Délai d\'alerte de seuil',
				DESIGN_VALUE: 'Valeur de conception',
				DIRECTIONALITY: 'Directionnalité',
				DIRECTION: 'Direction',
				IOW_CRITICALITY: 'Criticité IOW',
				FLATLINE_DETECTION: 'Détection de ligne plate',
				ATTENTION: 'Attention',
				THRESHOLD_NOTIFICATION: 'Notification de seuil',
				CALCULATED_FLAG: 'Indicateur calculé',
				PARAMETERS: 'Paramètres',
				CONSTANTS: 'Constantes',
				UPLOAD_TAGS: 'Télécharger les étiquettes',
				ENTER: 'Saisir',
				SELECT: 'Sélectionner',
				SELECT_PYTHON_FUNCTION: 'Sélectionner une fonction Python',
				SEARCH_FUNCTIONS_PLACEHOLDER: 'Rechercher des fonctions...',
				NO_MATCHING_FUNCTION_FOUND: 'Aucune fonction correspondante trouvée',
				SELECT_FUNCTION_ERROR: 'Veuillez sélectionner une fonction Python',
				SEARCH_TAG_TYPE_PLACEHOLDER: 'Rechercher un type d\'étiquette...',
				NO_MATCHING_TAG_TYPE_FOUND: 'Aucun type d\'étiquette correspondant trouvé',
				SEARCH_DOTS: 'Rechercher...',
				NO_MATCHING_TAG_FOUND: 'Aucune étiquette correspondante trouvée',
				PARAMETER_NAME_HINT: 'Nom du paramètre',
				CONSTANT_NAME_HINT: 'Nom de la constante',
				DISPLAY_EXPRESSION: 'Expression d\'affichage',
				DISPLAY_EXPRESSION_PLACEHOLDER: 'Saisir l\'expression',
				EXPRESSION_DESCRIPTION: 'Description de l\'expression',
				EXPRESSION_DESCRIPTION_PLACEHOLDER: 'Saisir la description de l\'expression',
				CANCEL: 'Annuler',
				CANCEL_TOOLTIP: 'Annuler les modifications',
				SAVE: 'Enregistrer',
				SAVE_TOOLTIP: 'Enregistrer les modifications'
			},
			TEMPLATE_NAME_MAPPING: {
				TITLE: 'Étiquette vers mécanismes',
				TAG_NAME_MAPPING: 'Correspondance du nom d\'étiquette',
				TAG_NAME: 'Nom de l\'étiquette',
				TAG_NAME_OPTIONS: 'Options du nom d\'étiquette',
				OPTIONS_PLACEHOLDER: 'Options',
				NO_TAG_SUGGESTIONS: 'Aucune suggestion trouvée. Cette étiquette ne sera pas utilisée dans la correspondance finale.',
				TAG_DELETED_FROM_MAPPING: 'Étiquette supprimée de la correspondance',
				FM_DELETED_FROM_MAPPING: 'Mode de défaillance supprimé de la correspondance',
				ACTIONS: 'Actions',
				FM_MAPPING: 'Correspondance de mode de défaillance',
				FM_NAME: 'Nom du mode de défaillance',
				FM_OPTIONS: 'Options de mode de défaillance',
				TOOLTIP_CLEAR: 'Effacer la sélection',
				TOOLTIP_DELETE_TAG: 'Supprimer l\'étiquette',
				TOOLTIP_UNDO_TAG: 'Annuler la suppression de l\'étiquette',
				TOOLTIP_DELETE_FM: 'Supprimer le mode de défaillance',
				TOOLTIP_UNDO_FM: 'Annuler la suppression du mode de défaillance',
				CANCEL: 'Annuler',
				CANCEL_TOOLTIP: 'Annuler les modifications',
				SAVE: 'Enregistrer',
				SAVE_TOOLTIP: 'Enregistrer les modifications'
			},
			FM_INFO_POPUP: {
				FORM_ERROR: 'Oh non ! Modifiez quelques éléments et essayez de soumettre à nouveau.',
				NAME: 'Nom',
				PRIORITY: 'Priorité',
				START_TIME: 'Heure de début (en heures)',
				START_TIME_LABEL: 'Heure de début',
				END_TIME: 'Heure de fin (en heures)',
				END_TIME_LABEL: 'Heure de fin',
				IS: 'est',
				REQUIRED: 'requis',
				DESCRIPTION: 'Description',
				RELIABILITY_SAVINGS: 'Économies de fiabilité (potentiel)',
				MAINTENANCE_SAVINGS: 'Économies de maintenance (potentiel)',
				PERFORMANCE_SAVINGS: 'Économies de performance (potentiel)',
				CANCEL: 'Annuler',
				CANCEL_TOOLTIP: 'Annuler les modifications',
				SAVE: 'Enregistrer',
				SAVE_TOOLTIP: 'Enregistrer les modifications'
			},
			TAG_FM_INFO_POPUP: {
				TITLE: "Mappage des modes de défaillance du modèle de tags",
				TAG_NAME: "Nom de l'étiquette",
				SEARCH_TAG: "Rechercher l'étiquette",
				NAME: "Nom",
				TAG_ID: "ID du tag",
				CANCEL: "Annuler",
				CANCEL_TOOLTIP: "Annuler les modifications",
				SAVE: "Enregistrer",
				SAVE_TOOLTIP: "Enregistrer les modifications",
				NO_RECORDS: "Aucune étiquette ni mode de défaillance trouvés",
				NO_MATCHES: 'Aucun résultat trouvé pour "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Essayez un mot clé différent ou effacez la recherche',
			},
			RECOMMENDATIONS_POPUP: {
				FORM_ERROR: 'Oh non ! Modifiez quelques éléments et essayez de soumettre à nouveau.',
				RECOMMENDATION: 'Recommandation',
				IS: 'est',
				CATEGORY: 'Catégorie',
				SELECT: 'Sélectionner',
				SELECT_FAILURE: 'Sélectionner la défaillance',
				FAILURE: 'Défaillance',
				CANCEL: 'Annuler',
				CANCEL_TOOLTIP: 'Annuler les modifications',
				SAVE: 'Enregistrer',
				SAVE_TOOLTIP: 'Enregistrer les modifications'
			},
			REC_TEMPLATE_FM_POPUP: {
				TITLE: 'Mécanismes vers recommandations',
				RECOMMENDATION: 'Recommandation',
				CATEGORY: 'Catégorie',
				OFFLINE: 'Hors ligne',
				ONLINE: 'En ligne',
				CANCEL: 'Annuler',
				CANCEL_TOOLTIP: 'Annuler les modifications',
				SAVE: 'Enregistrer',
				SAVE_TOOLTIP: 'Enregistrer les modifications'
			},
			SUBSYSTEM_TEMPLATE: {
				TITLE: 'Liste des modèles de sous-système',
				SEARCH: 'Rechercher',
				TOOLTIP_ADD: 'Ajouter un nouveau modèle de sous-système',
				TOOLTIP_EDIT: 'Modifier le modèle de sous-système',
				TOOLTIP_DELETE: 'Supprimer le modèle de sous-système',
				COL_INDEX: 'N°',
				COL_NAME: 'Nom',
				COL_DESCRIPTION: 'Description',
				COL_CREATED_ON: 'Créé le'
			},
			SUBSYSTEM_TEMPLATE_DELETE: {
				TITLE: 'Confirmation de suppression du modèle de sous-système',
				CONFIRM_MSG: 'Êtes-vous sûr de vouloir supprimer le modèle de sous-système ?',
				DELETING: 'Suppression en cours...',
				CANCEL: 'Annuler',
				DELETE: 'Supprimer'
			},
			SUBSYSTEM_TEMPLATE_POPUP: {
				ADD_TITLE: 'Ajouter un modèle de sous-système',
				EDIT_TITLE_PREFIX: 'Modifier le modèle de sous-système',
				NAME: 'Nom',
				DESCRIPTION: 'Description',
				NAME_TAKEN_ERROR: 'Ce nom est déjà pris',
				NAME_REQUIRED_ERROR: 'Le nom est requis',
				FORM_ERROR: 'Oh non ! Modifiez quelques éléments et essayez de soumettre à nouveau.',
				CANCEL: 'Annuler',
				CANCEL_TOOLTIP: 'Annuler les modifications',
				SAVE: 'Enregistrer',
				SAVE_TOOLTIP: 'Enregistrer les modifications'
			}

		},
		ADVANCED_ANALYSIS: {
			TABS: {
				ADVANCED_ANALYSIS: 'Analyse avancée',
				RENEWABLES: 'Énergies renouvelables',
				SUMMARY: 'Résumé',
				DOWNTIME: 'Temps d\'arrêt',
				UNDERPERFORMANCE: 'Sous-performance',
				CURTAILMENT: 'Réduction',
				SOILING_LOSS: 'Perte par encrassement',
				LOSS_BUCKETING: 'Classement des pertes',
				MAINTENANCE: 'Maintenance'
			},
			TOOLBAR: {
				SELECT_ANALYSIS: 'Sélectionner une analyse',
				SEARCH_ANALYSIS: 'Rechercher une analyse...',
				NO_MATCHING_ANALYSIS: 'Aucune analyse correspondante trouvée',
				PUBLIC: 'Public',
				SAVE_ALL: 'Tout enregistrer',
				TOOLTIP_SAVE_ALL: 'Enregistrer toutes les modifications',
				TOOLTIP_DOWNLOAD: 'Télécharger les statistiques pour toutes les analyses',
				ANALYSIS_TYPE: 'Type d\'analyse'
			},
			HEADER: {
				CREATED_BY: 'par',
				CREATED_ON: 'Créé le :'
			},
			EMPTY_STATE: {
				HEADING: 'Sélectionnez une analyse existante ou créez-en une nouvelle',
				CONTENT: 'Veuillez sélectionner ou ajouter une analyse.'
			},
			DESCRIPTION_LABEL: 'Description :',
			POPUP: {
				FORM_ERROR: 'Oups ! Modifiez quelques champs et réessayez.',
				NAME_PLACEHOLDER: 'Nom',
				NAME_ERROR_TAKEN: 'Déjà utilisé',
				NAME_HINT: 'Veuillez saisir',
				NAME_HINT_STRONG: 'Nom de l\'analyse',
				DESC_PLACEHOLDER: 'Description',
				DESC_ERROR_PREFIX: 'La description est',
				DESC_HINT: 'Veuillez saisir',
				DESC_HINT_STRONG: 'Description de l\'analyse',
				SELECT_FACILITY: 'Sélectionner une installation',
				SEARCH_FACILITY: 'Rechercher',
				NO_MATCHING_FACILITY: 'Aucune installation correspondante trouvée',
				TOOLTIP_CANCEL: 'Annuler les modifications',
				TOOLTIP_SAVE: 'Enregistrer les modifications',
				BTN_CANCEL: 'Annuler',
				BTN_SAVE: 'Enregistrer'
			},
			SAVE_CONFIRMATION: {
				TITLE: 'Modifications non enregistrées',
				MESSAGE: 'Il y a des modifications non enregistrées. Voulez-vous continuer ?',
				BTN_CANCEL: 'Annuler',
				BTN_SAVE_CONTINUE: 'Enregistrer et continuer',
				BTN_DISCARD: 'Ignorer les modifications et continuer'
			},
			COMMON: {
				BTN_OK: 'Ok',
				BTN_CANCEL: 'Annuler',
				BTN_CLOSE: 'Fermer',
				BTN_RESET: 'Réinitialiser',
				BTN_SAVE: 'Enregistrer',
				LOADING: 'Chargement...',
				NO_RECORDS: 'Aucun enregistrement trouvé',
				SEARCH: 'Rechercher',
				SEARCH_PLACEHOLDER: 'Rechercher...',
				TOOLTIP_DELETE: 'Supprimer',
				TOOLTIP_ADD: 'Ajouter',
				TOOLTIP_DOWNLOAD: 'Télécharger',
				TOOLTIP_CANCEL: 'Annuler les modifications',
				TOOLTIP_SAVE: 'Enregistrer les modifications',
				TOOLTIP_REMOVE_CARD: 'Supprimer la carte',
				DATE_RANGE: 'Plage de dates'
			},
			FILTER: {
				TITLE: 'Filtre',
				UNIT: 'Unité',
				SYSTEM: 'Système',
				SEARCH_SYSTEM: 'Rechercher un système...',
				NO_MATCHING_SYSTEM: 'Aucun système correspondant trouvé'
			},
			BUCKETING_FILTER: {
				FACILITY_TYPE: 'Type d\'installation',
				SELECT_FACILITY: 'Sélectionner une installation',
				TOOLTIP_CARD_VIEW: 'Vue en cartes',
				TOOLTIP_TABLE_VIEW: 'Vue en tableau',
				SEARCH_SYSTEM: 'Rechercher un système...',
				NO_SYSTEM_FOUND: 'Aucun système trouvé',
				GROUP_BY: 'Regrouper par :',
				ENABLE_CLUSTERING: 'Activer le clustering',
				SELECT_CLUSTER: 'Sélectionner un cluster',
				WIND_DIRECTION: 'Direction du vent',
				SELECTED_DATE_RANGE: 'Plage de dates sélectionnée',
				START_DATE: 'Date de début',
				END_DATE: 'Date de fin',
				CONFIGURE_LOSS: 'Configurer les pertes',
				SAP_FILTER_TITLE: 'Filtre champ(s) SAP :'
			},
			BUCKETING_TABLE: {
				SEARCH: 'Rechercher',
				SORT_BY: 'Trier par',
				SORT_NONE: 'Aucun',
				SORT_ASC: 'Croissant',
				SORT_DESC: 'Décroissant',
				COL_NAME: 'Nom',
				COL_GENERATION: 'Production (en MWh)',
				COL_EFFICIENCY: 'Efficacité de perf. (%)',
				COL_BREAKDOWN_COUNT: 'Nombre de pannes',
				COL_NOTIFICATION_COUNT: 'Nombre de notifications',
				COL_CLOSED: 'Fermé',
				COL_OPEN: 'Ouvert',
				COL_BLOCK: 'Bloc',
				COL_EFF_LOSS: 'Perte d\'efficacité',
				COL_INV: 'Onduleur',
				COL_TIME: 'Temps (hh:mm)',
				COL_CURTAILMENT_LOSS: 'Perte de réduction (MWh)',
				COL_GEN_LOSS: 'Perte de production (MWh)',
				COL_GEN_LOSS_NET: 'Perte de production (MWh)',
				COL_GEN_LOSS_MWH: 'PERTE DE PROD. (MWh)',
				COL_AVAILABILITY: 'Disponibilité',
				COL_REV_LOSS: 'Perte de revenus',
				COL_MAINTENANCE_COST: 'Coût de maintenance',
				COL_DOWNTIME: 'Temps d\'arrêt',
				COL_DURATION_PCT: 'Durée %',
				COL_MTTR: 'MTTR (hh:mm)',
				COL_ASSET: 'Actif',
				COL_MTBF: 'MTBF (hh:mm)',
				COL_IDEAL_GEN: 'Production idéale (KWh)',
				COL_SOILING_LOSS: 'Perte par encrassement (KWh)',
				COL_SOILING_LOSS_PCT: 'Perte par encrassement (% de la prod. idéale)',
				COL_SCHEDULED_DATE: 'Date de nettoyage prévue',
				COL_LAST_CLEANED: 'Dernier nettoyage',
				COL_LAST_CLEANED_DAYS: '(Jours écoulés)',
				COL_NOTIFICATION_NO: 'N° de notification',
				COL_EQUIPMENT_ID: 'ID équipement',
				COL_FUNCTIONAL_LOC: 'Emplacement fonctionnel',
				COL_EQUIPMENT: 'Équipement',
				COL_DESCRIPTION: 'Description',
				COL_CREATED_BY: 'Créé par',
				COL_CREATED_ON: 'CRÉÉ LE',
				COL_MAINTENANCE_PLANT: 'Site de maintenance',
				COL_PLAN_GROUP: 'Groupe de planification',
				COL_COMPLETED_ON: 'Terminé le',
				COL_COMPLETED_BY: 'Terminé par',
				COL_COMPONENT: 'Composant'
			},
			POWER_CURVE: {
				TITLE_PREFIX: 'Paramètres de courbe de puissance pour',
				OEM: 'Courbe de puissance OEM',
				CALCULATED: 'Courbe de puissance calculée',
				START_DATE: 'Date de début',
				STOP_DATE: 'Date de fin',
				DATE_RANGE_ERROR: 'La date de début doit être antérieure à la date de fin.',
				ADD_COMMENT: 'Ajouter un commentaire',
				COMMENT_ERROR: 'Veuillez saisir un commentaire valide.'
			},
			FILTER_MIN_MAX: {
				TOOLTIP: 'Filtre Min-Max',
				GREATER_THAN: 'Supérieur à',
				LESS_THAN: 'Inférieur à'
			},
			TAG_FILTER: {
				SELECT_TAG: 'Sélectionner un tag',
				NO_MATCHING_TAG: 'Aucun tag correspondant trouvé'
			},
			LIST_CARD: {
				NO_MATCHING_TAG: 'Aucun tag correspondant trouvé'
			},
			LIST_XY_CARD: {
				X_AXIS: 'Axe X',
				Y_AXIS: 'Axe Y',
				SEARCH_X: 'Rechercher X...',
				SEARCH_Y: 'Rechercher Y...',
				NO_MATCHING_X: 'Aucun X correspondant trouvé',
				NO_MATCHING_Y: 'Aucun Y correspondant trouvé'
			},
			CHART: {
				TOOLTIP_DOWNLOAD_TAG: 'Télécharger les données de tag',
				TOOLTIP_NO_ACCESS: 'Vous n\'avez pas accès aux unités et systèmes utilisés dans cet élément d\'analyse. Il a donc été désactivé.',
				TOOLTIP_REMOVE_FILTER: 'Supprimer le filtre',
				LOCK_X_AXIS: 'Verrouiller l\'axe X (Date)',
				MULTI_AXIS: 'Axes multiples',
				TRIP_LIMIT: 'Limite de déclenchement',
				ALARM_LIMIT: 'Limite d\'alarme',
				THRESHOLD_LIMIT: 'Limite de seuil',
				INSTRUMENT_RANGE: 'Plage de l\'instrument',
				LOCK_X_AXIS_ALERT_TOOLTIP: 'Impossible de déverrouiller dans la comparaison d\'alertes',
				TYPE_SIGNAL_VS_TIME: 'Signal vs Temps @ différentes périodes',
				TYPE_SIGNAL_VS_SIGNAL: 'Signal vs Signal @ différentes périodes',
				TYPE_STATE_SIGNAL: 'Analyse du signal pour les états de fonctionnement',
				TYPE_STATE_SIGNAL_VS_SIGNAL: 'Signal vs Signal sur les états de fonctionnement',
				TYPE_MULTISIGNAL: 'Analyse multi-signaux sur les états de fonctionnement',
				TYPE_MULTISIGNAL_VS_SIGNAL: 'Multi-signal vs Signal sur les états de fonctionnement',
				TYPE_FULL_SYSTEM: 'Comparaison système/équipement',
				TYPE_ALERT_COMPARISON: 'Comparaison d\'alertes'
			},
			TAG_DIALOG: {
				TITLE_PLACEHOLDER: 'Titre',
				DESC_PLACEHOLDER: 'Description',
				PLOT_TYPE_LABEL: 'Type de graphique',
				QUICK_PLOT: 'Graphique rapide',
				AXIS_TYPE_LABEL: 'Type d\'axe',
				AXIS_MULTI: 'Multiple',
				AXIS_SINGLE: 'Unique'
			},
			SUMMARY: {
				LOADING: 'Analyse des données en cours, veuillez patienter !',
				NO_DATA: 'Aucune donnée disponible.',
				NO_RENEWABLE_ASSETS: 'Aucun actif renouvelable trouvé',
				NO_RENEWABLE_ASSETS_SUBTITLE: 'Aucun actif ne correspond aux filtres sélectionnés',
				NO_SYSTEMS: 'Aucun système trouvé',
				NO_SYSTEMS_SUBTITLE: 'Aucun système ne correspond aux filtres et à la plage de dates sélectionnés.',
				NO_DOWNTIME_DATA: 'Aucune donnée de temps d\'arrêt disponible',
				NO_DOWNTIME_DATA_SUBTITLE: 'Les données de temps d\'arrêt ne sont pas disponibles pour les filtres et la plage de dates sélectionnés.',
				NO_PERFORMANCE_DATA: 'Aucune donnée de performance disponible',
				NO_PERFORMANCE_DATA_SUBTITLE: 'Les données de performance ne sont pas disponibles pour les filtres et la plage de dates sélectionnés.',
				NO_CURTAILMENT_DATA: 'Aucune donnée de réduction disponible',
				NO_CURTAILMENT_DATA_SUBTITLE: 'Les données de réduction ne sont pas disponibles pour les filtres et la plage de dates sélectionnés.',
				NO_LOSS_DATA: 'Aucune donnée de perte disponible',
				NO_LOSS_DATA_SUBTITLE: 'Les données de perte ne sont pas disponibles pour les filtres et la plage de dates sélectionnés.',
				NO_MAINTENANCE_DATA: 'Aucune donnée de temps de maintenance disponible',
				NO_MAINTENANCE_DATA_SUBTITLE: 'Les données de temps de maintenance ne sont pas disponibles pour les filtres et la plage de dates sélectionnés.',
				NO_SOILING_LOSS_DATA: 'Aucune donnée de perte par encrassement disponible',
				NO_SOILING_LOSS_DATA_SUBTITLE: 'Les données de perte par encrassement ne sont pas disponibles pour les filtres et la plage de dates sélectionnés.',
			},
			AVAILABILITY: {
				TIME_BASED: 'Disponibilité temporelle',
				ENERGY_BASED: 'Disponibilité énergétique',
				TARGET_SUFFIX: 'Cible',
				TOTAL_LOSS_TITLE: 'Perte totale (MWh)',
				ROW_DOWNTIME: 'Temps d\'arrêt (HH:MM)',
				ROW_LOST_PRODUCTION: 'Production perdue (MWh)',
				ROW_LOST_REVENUE: 'Revenus perdus',
				ROW_MTBF: 'MTBF (Temps moyen entre pannes - HH:MM)',
				ROW_MTTR: 'MTTR (Temps moyen de réparation - HH:MM)',
				COL_NAME: 'Nom',
				COL_VALUE: 'Valeur'
			},
			PERFORMANCE: {
				LOST_GENERATION: 'Production perdue (MWh)',
				LOST_REVENUE: 'Revenus perdus',
				BEST_PERFORMING: 'Meilleure performance',
				WORST_PERFORMING: 'Moins bonne performance',
				SHOW_TOP: 'Afficher le top :',
				TOTAL_LOSS_TITLE: 'Perte totale (MWh)',
				PERF_CURVE_TITLE: 'Courbe de performance',
				WIND_ROSE_TITLE: 'Rose des vents'
			},
			CURTAILMENT: {
				LOST_GENERATION: 'Production perdue (MWh)',
				LOST_REVENUE: 'Revenus perdus',
				SHOW_TOP: 'Afficher le top :',
				TOTAL_LOSS_TITLE: 'Perte totale (MWh)'
			},
			SOILING: {
				TOTAL_LOSS_TITLE: 'Perte totale (MWh)',
				SOILING_CURVE_SUFFIX: 'Courbe de perte par encrassement',
				TOOLTIP_SAVE: 'Enregistrer',
				TOOLTIP_CANCEL: 'Annuler',
				SECTION_SOILING: 'Encrassement',
				SECTION_TEMPERATURE: 'Température',
				SECTION_OTHERS: 'Autres',
				REF_SETTING: 'Paramètre de référence',
				CRS: 'CRS',
				SRS: 'SRS',
				SELECT_UNIT: 'Sélectionner une unité',
				SELECT_SYSTEM: 'Sélectionner un système',
				SELECT_ASSET: 'Sélectionner un actif',
				SELECT_TAG: 'Sélectionner un tag',
				SEARCH: 'Rechercher',
				SEARCH_SYSTEM: 'Rechercher un système...',
				NO_MATCHING_UNIT: 'Aucune unité correspondante trouvée',
				NO_MATCHING_SYSTEM: 'Aucun système correspondant trouvé',
				NO_MATCHING_ASSET: 'Aucun actif correspondant trouvé',
				NO_MATCHING_TAG: 'Aucun tag correspondant trouvé',
				APPLY_ON: 'Appliquer sur',
				CLEANING_CYCLE: 'Cycle de nettoyage',
				CLEANING_CYCLE_HINT: '(en jours)',
				BTN_START_EXPERIMENT: 'Démarrer l\'expérience',
				TOOLTIP_FORCE_STOP: 'Forcer l\'arrêt de l\'expérience en cours',
				TOOLTIP_UPLOAD_SOILING: 'Importer le ratio d\'encrassement',
				CLEANING_UPDATE: 'Mise à jour du nettoyage',
				TOOLTIP_UPLOAD_CLEANING: 'Importer le planning de nettoyage',
				TOOLTIP_DOWNLOAD_CLEANING: 'Télécharger le rapport de nettoyage',
				CHOOSE_DATE: 'Choisir une date',
				DATE_HINT: 'MM/JJ/AAAA',
				BTN_UPDATE: 'Mettre à jour'
			},
			LOSS: {
				LOST_GENERATION: 'Production perdue (MWh)',
				LOST_REVENUE: 'Revenus perdus',
				EFFECTIVE_PR: 'PR effectif',
				HIGHEST_LOSS_BUCKET: 'Catégorie de perte la plus élevée',
				LOSS_BUCKETING_TITLE: 'Classification des pertes (MWh)'
			},
			MAINTENANCE: {
				CHART_TITLE: 'Temps de maintenance (HH:MM)',
				BAD_ACTORS_TITLE: 'Top des mauvaises performances',
				NOTIFICATION_STATUS: 'Statut des notifications',
				SHDJ_DISTRIBUTION: 'Distribution SHDJ par unité',
				PENDING_DEFECTS_TITLE: 'Défauts en attente et rapports de vieillissement',
				COL_GROUP_SECTION: 'Groupe/Section',
				COL_0_30: '0 - 30 Jours',
				COL_31_90: '31 - 90 Jours',
				COL_91_180: '91 - 180 Jours',
				COL_181_365: '181 - 365 Jours',
				COL_365_500: '365 - 500 Jours',
				COL_GRAND_TOTAL: 'Total général',
				MONTHLY_DEFECTS_PREFIX: 'Statut mensuel des défauts -',
				TOTAL_MTD: 'Total des défauts MTD',
				YEARLY_DEFECTS_PREFIX: 'Statut annuel des défauts - EX',
				TOTAL_YTD: 'Total des défauts YTD',
				PM_COMPLIANCE_PREFIX: 'Rapport de conformité PM -',
				COL_EQUIPMENT: 'Équipement',
				COL_SCHEDULED: 'Planifié',
				COL_PENDING: 'En attente',
				COL_COMPLETED: 'Terminé',
				COL_COMPLIANCE: 'Conformité (%)'
			},
			MESSAGES: {
				SERVER_ERROR: 'Erreur interne du serveur',
				SAVE_SUCCESS: 'L\'analyse a été enregistrée avec succès.',
				UPDATE_SUCCESS: 'L\'analyse a été mise à jour.',
				ADD_SUCCESS: 'L\'analyse a été ajoutée.',
				COPY_SUCCESS: 'L\'analyse a été copiée.',
				CARD_GENERATED: 'Une nouvelle carte d\'analyse a été générée avec succès',
				POWER_CURVE_STARTED: 'Calcul de la courbe de puissance démarré pour',
				POWER_CURVE_FAILED: 'Échec du calcul de la courbe de puissance pour'
			}
		},
		NOTIFICATION_WIZARD: {
			HEADER_TITLE: 'Notifications',
			MARK_ALL_READ: 'Tout marquer comme lu',
			SETTINGS: 'Paramètres',
			TAB_ALL: 'Toutes',
			TAB_UNREAD: 'Nouvelles non lues',
			TAB_ASSIGNED: 'Assignées à moi',
			NOTIFICATIONS_SUFFIX: 'notifications',
			TOOLTIP_MARK_READ: 'Marquer comme lu',
			TOOLTIP_MARK_UNREAD: 'Marquer comme non lu',
			TOOLBAR_ITEM: 'élément',
			TOOLBAR_ITEMS: 'éléments',
			TOOLBAR_SELECTED: 'sélectionné(s)',
			TOOLBAR_MARK_READ: 'Marquer comme lu',
			TOOLBAR_MARK_UNREAD: 'Marquer comme non lu',
			TOOLBAR_CLEAR: 'Effacer les messages',
			ERROR_TITLE: 'Impossible de charger les notifications',
			ERROR_DESC: 'Une erreur s\'est produite lors de la récupération des notifications. Veuillez réessayer.',
			NOTIF_OFF_TITLE: 'Les notifications sont désactivées',
			NOTIF_OFF_DESC: 'Activez les notifications pour recevoir des mises à jour ici.',
			EMPTY_DEFAULT_TITLE: 'Aucune notification',
			EMPTY_DEFAULT_DESC: 'Vous n\'avez pas encore de notifications. Une fois reçues, elles apparaîtront ici.',
			EMPTY_CAUGHT_UP_TITLE: 'Vous êtes à jour.',
			EMPTY_UNREAD_DESC: 'Les nouvelles notifications d\'alertes et de mises à jour apparaîtront ici.',
			EMPTY_ASSIGNED_DESC: 'Les notifications qui vous sont assignées apparaîtront ici.',
			EMPTY_ALL_TITLE: 'Pas encore de notifications',
			EMPTY_ALL_DESC: 'Les mises à jour apparaîtront ici',
			GROUP_TODAY: 'Aujourd\'hui',
			GROUP_YESTERDAY: 'Hier',
			GROUP_THIS_WEEK: 'Plus tôt cette semaine',
			GROUP_THIS_MONTH: 'Plus tôt ce mois-ci',
			GROUP_LAST_MONTH: 'Le mois dernier',
			GROUP_OLDER: 'Mois précédent',
			SETTINGS_HEADER: 'Paramètres de préférence utilisateur',
			SETTINGS_TAB_NOTIFICATIONS: 'Notifications',
			SETTINGS_TAB_AUDIBLE: 'Alarmes sonores',
			SETTINGS_COL_TYPE: 'Type',
			SETTINGS_COL_EMAIL: 'E-mail',
			SETTINGS_COL_PLATFORM: 'Plateforme',
			SETTINGS_COL_AUDIBLE: 'Sonore',
			SETTINGS_ALERTS_HEADER: 'Alertes',
			SETTINGS_ALERTS_DESC: 'Notifications déclenchées lors de la génération d\'une nouvelle alerte.',
			SETTINGS_AUDIBLE_ALERTS_DESC: 'Jouer une alarme sonore lorsque ces alertes sont créées.',
			SETTINGS_NEW_ANOMALY: 'Nouvelles alertes d\'anomalie',
			SETTINGS_NEW_HIGH_ANOMALY: 'Nouvelles alertes d\'anomalie élevée',
			SETTINGS_NEW_LOW_ANOMALY: 'Nouvelles alertes d\'anomalie faible',
			SETTINGS_NEW_THRESHOLD: 'Nouvelles alertes de seuil',
			SETTINGS_OWNERSHIP_HEADER: 'Propriété et assignation des alertes',
			SETTINGS_OWNERSHIP_DESC: 'Notifications liées à la responsabilité des alertes.',
			SETTINGS_ALERT_OWNER: 'Assigné en tant que propriétaire d\'alerte',
			SETTINGS_ALERT_WATCHER: 'Assigné en tant qu\'observateur d\'alerte',
			SETTINGS_ACTIVITY_HEADER: 'Activité des alertes',
			SETTINGS_ACTIVITY_DESC: 'Contrôle si les utilisateurs reçoivent des mises à jour continues après l\'assignation.',
			SETTINGS_OWNED_ALERTS: 'Mises à jour sur les alertes possédées',
			SETTINGS_WATCHED_ALERTS: 'Mises à jour sur les alertes surveillées',
			SETTINGS_SYSTEM_HEADER: 'Mises à jour du système',
			SETTINGS_SYSTEM_DESC: 'Notifications liées aux opérations IA / système.',
			SETTINGS_MODEL_RETRAINING: 'Réentraînement du modèle terminé',
			SETTINGS_AUDIBLE_FOOTER_NOTE: 'L\'alarme sonore retentira une fois ou continuera à notifier à la fréquence sélectionnée jusqu\'à ce que vous cliquiez sur l\'alerte pour voir les détails.',
			PDF_HEADER: 'Gestion des cas - PDF généré',
			PDF_GENERATED_BEFORE: 'Le PDF de gestion des cas a été généré avec succès.',
			PDF_DOWNLOAD_LINK: 'Télécharger le PDF',
			PDF_GENERATED_AFTER: 'ou accédez-y via le lien envoyé à votre e-mail. Le lien de téléchargement expire le {{expiry}}.',
			PDF_LINK_EXPIRED_TOOLTIP: 'Ce lien de téléchargement a expiré. Générez à nouveau le PDF pour le télécharger.',
			ASSET_TEMPLATE_SYNC_STARTED_TITLE: 'Synchronisation du modèle d\'actif démarrée – {{templateName}}',
			ASSET_TEMPLATE_SYNC_COMPLETED_TITLE: 'Synchronisation du modèle d\'actif terminée – {{templateName}}',
			ASSET_TEMPLATE_SYNC_FAILED_TITLE: 'Échec de la synchronisation du modèle d\'actif – {{templateName}}'
		},
		MAINTENANCE_OPTIMIZATION: {
			// Main component
			HEADER_TITLE: 'Optimisation de la Maintenance',
			TAB_RESULTS: 'Résultats & Valeur',
			TAB_SCHEDULES: 'Plans PM',
			TAB_RUN_HISTORY: 'Historique des exécutions',

			// Run History
			RH_COL_SL_NO: 'N°',
			RH_COL_RUN_DATE: "Date d'exécution",
			RH_COL_NAME: 'Nom',
			RH_COL_CREATOR: 'Créateur',
			RH_COL_SCOPE: 'Portée',
			RH_COL_STATUS: 'Statut',
			RH_COL_TOTAL_VALUE: 'Valeur totale',
			RH_COL_APPROVED: 'Approuvé',
			RH_COL_ACTIONS: 'Actions',
			RH_VIEW: 'Voir',
			RH_EQUIPMENTS: 'équipements',
			RH_SEARCH_PLACEHOLDER: 'Rechercher des exécutions...',
			RH_EMPTY: "Aucune exécution d'optimisation trouvée pour la sélection actuelle.",
			RH_STATUS_PENDING: 'En attente',
			RH_STATUS_RUNNING: 'En cours',
			RH_STATUS_PROCESSING: 'Traitement',
			RH_STATUS_COMPLETED: 'Terminé',
			RH_STATUS_FAILED: 'Échoué',
			BTN_RUN_OPTIMIZATION: 'Lancer l\'optimisation',
			LAST_RUN_PREFIX: 'Dernière optimisation exécutée :',

			// PM Schedules
			PM_DOWNLOAD_TITLE: 'Options de téléchargement',
			PM_DOWNLOAD_SUBTITLE: 'Utilisez les boutons ci-dessous pour exporter les plans PM dans un format pouvant être chargé dans SAP ou votre CMMS :',
			PM_DOWNLOAD_ALL_TITLE: 'Tout télécharger (CSV)',
			PM_DOWNLOAD_ALL_DESC: 'Liste consolidée de toutes les activités PM',
			PM_DOWNLOAD_PER_EQ_TITLE: 'Rapports par Équipement',
			PM_DOWNLOAD_PER_EQ_DESC: 'Filtré sur l\'actif sélectionné dans la hiérarchie',
			PM_DOWNLOAD_CONSOLIDATED_TITLE: 'Plans Consolidés',
			PM_DOWNLOAD_CONSOLIDATED_DESC: 'Regroupé par nouvel intervalle',
			PM_SEARCH_PLACEHOLDER: 'Rechercher...',
			PM_GROUP_BY_INTERVAL: 'Regrouper par : Intervalle',
			PM_FILTER: 'Filtrer',
			PM_COL_ID: 'ID',
			PM_COL_NAME: 'Nom du Plan PM',
			PM_COL_ACCESS_CLASS: 'Classe d\'accès',
			PM_COL_BUNDLE_NAME: 'Nom du Lot',
			PM_COL_BUNDLE_ID: 'ID du Lot',
			PM_COL_PREV_INTERVAL: 'Intervalle PM précédent',
			PM_COL_CURR_INTERVAL: 'Intervalle PM actuel',
			PM_EACH: 'Tous les',
			PM_DAYS: 'jours',

			// Results & Values
			RV_TOTAL: 'Total',
			RV_POTENTIAL_VALUE: 'Valeur potentielle',
			RV_PM_SCHEDULING: 'Planification PM',
			RV_CM_REDUCTION: 'Réduction CM',
			RV_FAILURE_REDUCTION: 'Réduction des Pannes / Défaillances',
			RV_BY_REC_TYPE: 'Par Type de Recommandation',
			RV_TOTAL_ACTIVITIES: 'Total des Activités Inspectées',
			RV_INCREASES: 'Augmentations',
			RV_DECREASES: 'Diminutions',
			RV_NO_CHANGES: 'Aucun Changement',
			RV_REMOVE: 'Supprimer',
			RV_ADD: 'Ajouter',
			RV_WHERE_VALUE: 'Où Se Trouve la Valeur',
			RV_BY_STATUS: 'Par Statut',
			RV_TOTAL_SCHEDULES: 'Total des Plans',
			RV_PENDING: 'En attente',
			RV_APPROVED: 'Approuvé',
			RV_REJECTED: 'Rejeté',
			RV_SEARCH_PLACEHOLDER: 'Rechercher...',
			RV_GROUP_BY_SYSTEM: 'Regrouper par : Système',
			RV_FILTER: 'Filtrer',
			RV_COL_FREQ_REC: 'Recommandation de Fréquence',
			RV_COL_HIERARCHY: 'Hiérarchie / Noms PM',
			RV_COL_REC_INTERVAL: 'Intervalle Recommandé (jours)',
			RV_COL_SAVINGS: 'Économies Totales ($/an)',
			RV_COL_PM: 'PM ($/an)',
			RV_COL_CM: 'CM ($/an)',
			RV_COL_FAILURE_RISK: 'Risque de Panne ($/an)',
			RV_COL_APPROVE: 'Approuver / Rejeter',
			RV_COL_PM_ID: 'PM ID',
			RV_COL_ACTIVITY: 'Activité',
			RV_COL_ROLE: 'Rôle',
			RV_COL_STANDALONE: 'Autonome',
			RV_COL_EFFECTIVE: 'Effectif',
			RV_COL_EVIDENCE: 'Preuve',
			RV_COL_VALUE: 'Valeur',
			RV_COL_STATUS: 'Statut',
			RV_BH_CURRENT: 'Actuel',
			RV_BH_EFFECTIVE: 'Effectif',
			RV_BH_OUTCOME: 'Résultat',
			RV_BH_DRIVER: 'Moteur(s)',
			RV_BH_VALUE: 'Valeur',
			RV_BH_CONFIDENCE: 'Confiance',
			RV_BH_STATUS: 'Statut',
			RV_BH_ACTIVITIES: 'activités',
			RV_BH_DRIVERS: 'moteurs',
			RV_BH_OVERRIDES: 'remplacements',
			RV_BH_UNCHANGED: 'inchangé',
			RV_BH_NONE: 'Aucun',
			RV_BH_NO_CHANGE: 'Aucun changement',
			RV_BH_NA: 'n/a',
			RV_DEEP_DIVE: 'Analyse approfondie',
			RV_BUNDLE_SUMMARY: 'Résumé du groupe',
			RV_LAST_RUN: 'Dernière exécution',
			RV_NO_RESULTS: 'Aucun résultat d’optimisation pour cette sélection.',
			RV_SELECT_NODE: 'Sélectionnez une installation, une unité ou un système pour voir les résultats.',
			RV_LOADING: 'Chargement des résultats...',

			// MC Recommendation panel
			MC_PANEL_TITLE: 'Panneau Détaillé — Recommandation',
			MC_ASK_ROOTY: 'Demander à Rooty',
			MC_APPROVE: 'Approuver',
			MC_REJECT: 'Rejeter',
			MC_CURRENT_FREQ: 'Fréquence Actuelle',
			MC_REC_FREQ: 'Fréquence Recommandée',
			MC_SHOW: 'Afficher',
			MC_COMPACT: 'Compact',
			MC_ADVANCED: 'Avancé',
			MC_TAB_DECISION: 'Décision',
			MC_TAB_OBSERVATIONS: 'Observations',
			MC_TAB_FAILURE_MODES: 'Modes de Défaillance',
			MC_DECISION_TITLE: 'Décision',
			MC_WHY_NOW: 'POURQUOI MAINTENANT',
			MC_EXPECTED_VALUE: 'VALEUR ATTENDUE',
			MC_SECONDARY_ACTION: 'ACTION SECONDAIRE',
			MC_REC_CONFIDENCE: 'Confiance dans la Recommandation',
			MC_SAVINGS_BREAKDOWN: 'Détail des Économies',
			MC_TOTAL_ANNUAL_SAVINGS: 'Économies annuelles totales',
			MC_PREDICTIONS: 'Prédictions',
			MC_EXPECTED_OUTCOME: 'Résultat attendu si la recommandation est acceptée',
			MC_INTERVAL_SENSITIVITY: 'Sensibilité de l\'Intervalle (β / η)',
			MC_ANNUAL_CM_COUNT: 'Nombre Annuel de CM',
			MC_CURRENT_CM_COUNT: 'Nombre de CM actuel :',
			MC_PREDICTED_CM_COUNT: 'Nouveau nombre de CM prédit :',
			MC_ANNUAL_BD_COUNT: 'Nombre Annuel de Pannes',
			MC_CURRENT_BD_COUNT: 'Nombre de pannes actuel :',
			MC_PREDICTED_BD_COUNT: 'Nouveau nombre de pannes prédit :',
			MC_PM_FREQUENCY: 'Fréquence PM',
			MC_CURRENT: 'Actuel :',
			MC_RECOMMENDED: 'Recommandé :',
			MC_FM_LINK: 'onglet Modes de Défaillance',
			MC_OBS_REACTIVE_VS_PREVENTIVE: 'Ratio Coût Réactif vs Préventif',
			MC_OBS_CM_TIMING: 'Analyse de la Temporisation des Événements CM',
			MC_OBS_EARLY: 'Tôt',
			MC_OBS_MID: 'Milieu',
			MC_OBS_LATE: 'Tard',
			MC_OBS_POST_PM: 'Récurrence Post-PM',
			MC_OBS_EVIDENCE_LOG: 'Ouvrir le Journal de Preuves complet →',
			MC_FM_SERVED_BY: 'couvert par ce PM',
			MC_FM_SORT: 'Trier',
			MC_FM_BY_ROLE: 'Par Rôle',
			MC_FM_EXPAND_ALL: 'Tout Développer',
			MC_FM_PRIMARY: 'Primaire',
			MC_FM_SUPPORTING: 'Secondaire',
			MC_FM_INCIDENTAL: 'Incident',
			MC_FM_AGG_B: 'Agrégat B',
			MC_FM_CM_COUNT: 'Nombre CM /AN',
			MC_FM_BREAKDOWNS: 'Pannes / AN',
			MC_FM_DIAGNOSIS: 'Diagnostic',
			MC_FM_TIMING: 'Temporisation',
			MC_FM_SENSITIVITY: 'Sensibilité (β)',
			MC_FM_IMPACT: 'Impact',
			MC_FM_EVENTS: 'Événements',
			MC_FM_DATE_COL: 'Date',
			MC_FM_EVENT_COL: 'Événement',
			MC_FM_COST_COL: 'Coût',
			MC_FM_CLASS_COL: 'Classe',
			MC_TAG_INCREASE_FREQ: 'Augmenter la fréquence',
			MC_TAG_TIMING: 'basé sur le timing',
			MC_TAG_CASE2: 'Cas 2',
			MC_TAG_CBM: '+ filet de sécurité CBM',
			MCB_OPEN_EVIDENCE_LOG: 'Ouvrir le journal de preuves',
			MCB_DECISION_STANDALONE: 'Recommandation autonome',
			MCB_DECISION_EFFECTIVE: 'Recommandation effective du groupe',
			MCB_EFFECTIVE_IS_STANDALONE: 'Le résultat autonome est aussi le résultat effectif',
			MCB_EXPECTED_IMPACT: 'Impact attendu',
			MCB_EFFECTIVE_BUNDLE_RESULT: 'Résultat effectif du groupe',
			MCB_PM_COST: 'Coût PM',
			MCB_PM_COST_SUB: 'Dépense PM annuelle supplémentaire',
			MCB_CM_SAVINGS: 'Économies CM',
			MCB_CM_SAVINGS_SUB: 'Réduction annuelle attendue',
			MCB_BD_SAVINGS: 'Économies sur les pannes',
			MCB_BD_SAVINGS_SUB: 'Réduction annuelle attendue',
			MCB_NET_VALUE: 'Valeur annuelle nette',
			MCB_NET_VALUE_SUB: 'Après propagation du groupe',
			MCB_CONFIDENCE: 'Confiance',
			MCB_DRIVER_BASED: 'Basé sur le moteur',
			MCB_WHY: 'Pourquoi cette recommandation',
			MCB_ADVANCED_PENDING: 'Les détails avancés arrivent bientôt.',
			MCB_OBS_WHAT: 'Ce que le moteur a observé',
			MCB_OBS_ECONOMIC: 'Filtre économique',
			MCB_OBS_TIMING: 'Moment',
			MCB_OBS_POSTPM: 'Récurrence après PM',
			MCB_TIMING_DISTRIBUTION: 'Distribution temporelle',
			MCB_EARLY: 'Tôt',
			MCB_MIDDLE: 'Milieu',
			MCB_LATE: 'Tard',
			MCB_FM_BUILDUP: 'Constitution des modes de défaillance',
			MCB_FM_BUILDUP_SUB: 'La vue compacte montre la conclusion. La vue avancée expose le diagnostic, la prédiction, la confiance et la trace des preuves de chaque FM.',
			MCB_DETAILS: 'Détails',
			MCB_FM_DIAGNOSIS: 'Diagnostic',
			MCB_FM_EVIDENCE: 'Preuve',
			MCB_FM_TIMING: 'Moment',
			MCB_FM_CONTRIBUTION: 'Contribution',
			MCB_FM_STANDALONE: 'Autonome',
			MCB_FM_EFFECTIVE: 'Effectif',
			MCB_FM_ROUTE: 'Voie',
			MCB_FM_INTERVAL_CONTRIB: 'Contribution à l’intervalle',
			MCB_FM_VALUE: 'Valeur',
			MCB_FM_STATUS: 'Statut',
			MCB_FM_ADMIN_INTERPRETATION: 'Interprétation de l’administrateur',
			MCB_FM_INTERVAL_DRIVER: 'Moteur d’intervalle',
			MCB_FM_OVERRIDDEN: 'FM remplacé',
			MCB_FM_NON_INTERVAL: 'Hors intervalle',
			MCB_STANDALONE_NOT_REALIZED: 'L’économie autonome de {{code}} n’est pas réalisée et ne doit pas être ajoutée aux totaux de l’équipement ou du portefeuille.',
			MCB_CONF_DATA_SUFFICIENCY: 'Suffisance des données',
			MCB_CONF_TIMING_QUALITY: 'Qualité temporelle',
			MCB_CONF_MAPPING_QUALITY: 'Qualité de mappage',
			MCB_CONF_PRIOR_CONFIRMATION: 'Confirmation a priori',
			MCB_OBS_ACTIONABILITY: 'Actionnabilité',
			MCB_OBS_CONDITION_MODIFIER: 'Modificateur de condition',
			MCB_OBS_DATA_GATE: 'Porte de données',
			MCB_PRED_DETAILS: 'Détails de prédiction',
			MCB_PRED_B_BASE: 'Base B',
			MCB_PRED_ASSET_MODIFIER: 'Modificateur d’actif',
			MCB_PRED_B_OPTIMIZATION: 'Optimisation B',
			MCB_PRED_CM: 'Prédiction CM',
			MCB_PRED_BD: 'Prédiction BD',
			MCB_D_SEC_A: 'A. Porte de données et classification',
			MCB_D_SEC_B: 'B. Modèle temporel',
			MCB_D_SEC_C: 'C. Charge, condition et actionnabilité',
			MCB_D_SEC_D: 'D. Filtre économique et diagnostic',
			MCB_D_SEC_E: 'E. Constitution de B',
			MCB_D_SEC_F: 'F. Prédiction et valeur',
			MCB_D_SEC_G: 'G. Preuve des événements',
			MCB_D_ROUTE: 'Voie',
			MCB_D_PM_CYCLES: 'Cycles de PM',
			MCB_D_QUALIFYING_EVENTS: 'Événements qualifiants',
			MCB_D_MAPPING_CONFIDENCE: 'Confiance de mappage',
			MCB_D_MEAN_MX: 'Moyenne Mx',
			MCB_D_SPREAD: 'Dispersion Σx',
			MCB_D_EML: 'E/M/L',
			MCB_D_POSTPM: 'PostPM',
			MCB_D_RWCM_RAW: 'RWCM brut',
			MCB_D_EFF_CM_BURDEN: 'Charge CM effective',
			MCB_D_HM: 'Hm',
			MCB_D_GM: 'Gm',
			MCB_D_PM_BURDEN: 'Charge de PM',
			MCB_D_CM_BD_BURDEN: 'Charge CM + BD',
			MCB_D_RA_COST: 'Coût Ra',
			MCB_D_DIAGNOSIS: 'Diagnostic',
			MCB_D_B_BASE: 'Base B',
			MCB_D_DIRECTION: 'Direction',
			MCB_D_CONCENTRATION: 'Concentration',
			MCB_D_B_OPT: 'B Opt',
			MCB_D_INTERVAL: 'Intervalle',
			MCB_D_CM_PREDICTION: 'Prédiction CM',
			MCB_D_STANDALONE_NET: 'Net autonome',
			MCB_D_EFF_BUNDLE_NET: 'Net effectif du groupe',
			MCB_D_COL_EVENT: 'Événement',
			MCB_D_COL_DATE: 'Date',
			MCB_D_COL_CLASS: 'Classe',
			MCB_D_COL_BD: 'BD',
			MCB_D_COL_XE: 'x<sub>e</sub>',
			MCB_D_COL_COST: 'Coût',

			// Run Configuration Dialog
			RC_TITLE: 'Configuration d\'Exécution',
			RC_TAB_SCOPE: 'Portée',
			RC_TAB_CONFIGURE: 'Configurer',
			RC_TAB_IMPORT: 'Importer les Données',
			RC_TAB_DATA_QC: 'QC des Données',
			RC_TAB_MAPPING: 'Mappage',
			RC_SAVE: 'Enregistrer',
			RC_CANCEL: 'Annuler',
			RC_PREVIOUS: 'Précédent',
			RC_NEXT: 'Suivant',
			RC_RUN: 'Exécuter',
			RC_CONFIGURE_TITLE: 'Configurer l\'Analyse',
			RC_CONFIGURE_DESC: 'Définissez le profil d\'analyse, les seuils et les paramètres d\'ajustement. La plupart des utilisateurs doivent choisir un profil et n\'ajuster que les paramètres principaux. Les paramètres avancés contrôlent le comportement interne de l\'algorithme.',
			RC_ASSET_CLASS_TITLE: 'Remplacements de Classe d\'Actif',
			RC_ASSET_CLASS_DESC: 'Entrées A/B/C par classe pour les paramètres de tolérance au risque',
			RC_ANALYSIS_WINDOW_TITLE: 'Fenêtre d\'Analyse',
			RC_ANALYSIS_WINDOW_DESC: 'Définissez la période pour l\'analyse des données CMMS',
			RC_DURATION: 'Durée',
			RC_INITIAL_DATE: 'Date Initiale',
			RC_END_DATE: 'Date de Fin',
			RC_ANALYSIS_PERIOD_PREFIX: 'Période d\'Analyse :',
			RC_MONTHS: 'mois',
			RC_SAP_NOTIFICATIONS: 'Notifications SAP :',
			RC_FETCHING: 'Chargement...',
			RC_RECORDS: 'enregistrements',
			RC_ANALYSIS_PROFILE_TITLE: 'Profil d\'Analyse',
			RC_ANALYSIS_PROFILE_DESC: 'Définit tous les paramètres sur des valeurs par défaut précalibrées. Vous pouvez remplacer les valeurs individuelles ci-dessous.',
			RC_DATA_SUFFICIENCY_TITLE: 'Exigences de Suffisance des Données',
			RC_DATA_SUFFICIENCY_DESC: 'Quelle quantité de preuves est nécessaire avant que l\'algorithme agisse',
			RC_MIN_PM_CYCLES: 'Cycles PM Minimaux',
			RC_MIN_FM_EVENTS: 'Événements FM Minimaux',
			RC_RECENCY_HALF_LIFE: 'Demi-vie de Récence (h)',
			RC_POST_PM_WINDOW: 'Fenêtre Post-PM (j)',
			RC_CYCLES: 'cycles',
			RC_RESET_TO_BASE: 'Réinitialiser à la base',
			RC_PM_CM_RATIO_TITLE: 'Seuils de Ratio PM/CM (Ra)',
			RC_PM_CM_RATIO_DESC: 'Quand les dépenses PM sont-elles trop élevées ou trop faibles par rapport à la charge de pannes ? Les deux ratios sont toujours calculés et rapportés.',
			RC_PRIMARY_RATIO_LABEL: 'Ratio principal pour la logique de diagnostic',
			RC_OVER_MAINTAINED: 'Sur-entretenu (Cas 1)',
			RC_UNDER_MAINTAINED: 'Sous-entretenu (Cas 2)',
			RC_INTERVAL_ADJ_TITLE: 'Limites d\'Ajustement d\'Intervalle',
			RC_INTERVAL_ADJ_DESC: 'Changement maximum d\'intervalle par cycle de recommandation. Limites séparées pour extension vs réduction.',
			RC_INTERVAL_ROUNDING: 'Arrondi d\'Intervalle',
			RC_ROUND_TO: 'Arrondir à',
			RC_DIRECTION: 'Direction',
			RC_ADJ_MODE: 'Mode d\'Ajustement : Pourcentage',
			RC_ADVANCED_PARAMS_TITLE: 'Paramètres Avancés',
			RC_ADVANCED_PARAMS_DESC: 'Ajustement interne de l\'algorithme — analyse de temporisation, routage, sensibilité, niveaux de confiance',
			RC_ADVANCED_WARNING: 'Ces paramètres contrôlent le traitement interne des signaux. Les modifier sans comprendre les formules peut produire des résultats trompeurs. Le sélecteur de profil ci-dessus définit des valeurs par défaut raisonnables pour chacun. Ne remplacez que si vous avez une raison spécifique.',
			RC_PARAM_COL_PARAM: 'Paramètre',
			RC_PARAM_COL_DESC: 'Description',
			RC_PARAM_COL_EFFECT: 'EFFET',
			RC_PARAM_COL_VALUE: 'Valeur',
			RC_GOAL_SEEKER_TITLE: 'Mode Recherche d\'Objectif',
			RC_GOAL_SEEKER_DESC: 'Optimiser pour atteindre un objectif de réduction budgétaire spécifique',
			RC_GOAL_SEEKER_CURRENT: 'Actuel',
			RC_GOAL_SEEKER_TARGET: 'Réduction Cible :',
			RC_CONSTRAINTS: 'Contraintes',
			RC_EXCLUDE_CRITICALITY: 'Exclure les Criticités d\'Actifs',
			RC_EXCLUDE_EQ_TYPES: 'Exclure les Types d\'Équipements',
			RC_SCOPE_TITLE: 'Portée',
			RC_SCOPE_DESC: 'Définissez la portée de l\'exécution d\'optimisation.',
			RC_IMPORT_TITLE: 'Importer les Données',
			RC_IMPORT_DESC: 'Notifications SAP pour le système sélectionné sur la fenêtre d\'analyse configurée.',
			RC_PM_EVENTS: 'Événements PM',
			RC_CM_EVENTS: 'Événements CM',
			RC_FAILURE_EVENTS: 'Événements de Panne',
			RC_NO_RECORDS: 'Aucun enregistrement trouvé pour ce type d\'événement dans la fenêtre sélectionnée',
			RC_COL_NOTIFICATION: 'Notification',
			RC_COL_EQUIPMENT: 'Équipement',
			RC_COL_DESCRIPTION: 'Description',
			RC_COL_TYPE: 'Type',
			RC_COL_CREATED_ON: 'Créé le',
			RC_COL_COMPLETED_ON: 'Terminé le',
			RC_COL_PLAN_GROUP: 'Groupe de Plan',
			RC_DATA_QC_TITLE: 'QC des Données',
			RC_DATA_QC_DESC: 'Examiner les vérifications de qualité des données.',
			RC_MAPPING_TITLE: 'Mappage',
			RC_MAPPING_DESC: 'Configurer le mappage CM-FM.',
			RC_MAPPING_GROUP_BY: 'Regrouper par',
			RC_MAPPING_GROUP_FM: 'Mode de Défaillance',
			RC_MAPPING_GROUP_PREVENTABILITY: 'Prévisibilité',
			RC_MAPPING_SEARCH_PLACEHOLDER: 'Rechercher notification, ordre, équipement, description',
			RC_MAPPING_LOW_CONFIDENCE: 'Faible confiance',
			RC_MAPPING_EDITED: 'Modifié',
			RC_MAPPING_REGENERATE: 'Régénérer',
			RC_MAPPING_DOWNLOAD: 'Télécharger',
			RC_MAPPING_UPLOAD: 'Importer',
			RC_MAPPING_RESET_ALL: 'Réinitialiser tout',
			RC_MAPPING_COL_ORDER: 'Ordre #',
			RC_MAPPING_COL_EQUIPMENT_ID: 'ID Équipement',
			RC_MAPPING_COL_WO_DESC: 'Description OT',
			RC_MAPPING_COL_WO_TYPE: 'Type OT',
			RC_MAPPING_COL_MAPPED_FM: 'Mode de Défaillance Associé',
			RC_MAPPING_COL_PREVENTABILITY: 'Prévisibilité',
			RC_MAPPING_EVENT: 'événement',
			RC_MAPPING_EVENTS: 'événements',
			RC_MAPPING_AVG_FM_CONF: 'Conf. MD moy.',
			RC_MAPPING_AVG_PREV_CONF: 'Conf. Prév. moy.',
			RC_MAPPING_NO_RECORDS: "Aucune notification CM/BD disponible pour l'association",
			RC_MAPPING_NO_FILTERED_RESULTS: 'Aucune association ne correspond aux filtres actuels',
			RC_MAPPING_GENERATING: 'Association des événements CM/Panne aux modes de défaillance...',
			RC_MAPPING_GENERATION_ERROR: "Échec de la génération de l'association CM/BD → mode de défaillance.",
			RC_MAPPING_UNMAPPED: 'Non associé',
			RC_MAPPING_SYMPTOM_ONLY: 'Symptôme uniquement',
			RC_MAPPING_SYMPTOM_ONLY_TOOLTIP: "N'a pas pu être réattribué à un mode de défaillance de cause racine — exclu des calculs d'optimisation.",
			RC_MAPPING_UNMAPPED_CONF_TOOLTIP: "Confiance dans la détermination « aucune correspondance » elle-même, pas dans un mode de défaillance spécifique.",
			RC_MAPPING_NO_RATIONALE: 'Aucune justification fournie.',
			RC_MAPPING_DETAIL_IDENTITY_SOURCE: 'Identité et Source',
			RC_MAPPING_DETAIL_WO_CONTENT: 'Contenu du BT',
			RC_MAPPING_DETAIL_DURATION: 'Durée',
			RC_MAPPING_DETAIL_FM_MAPPING: 'Association MD',
			RC_MAPPING_DETAIL_PREVENTABILITY: 'Prévisibilité',
			RC_MAPPING_DETAIL_AUDIT: 'Audit',
			RC_MAPPING_DETAIL_EVENT_CLASS: "Type d'Ordre / Classe d'Événement",
			RC_MAPPING_DETAIL_SCHED_START: 'Début Prévu',
			RC_MAPPING_DETAIL_SCHED_FINISH: 'Fin Prévue',
			RC_MAPPING_DETAIL_ACTIVITY_CODE: "Code d'Activité",
			RC_MAPPING_DETAIL_DAMAGE_CODE: 'Code de Dommage',
			RC_MAPPING_DETAIL_CAUSE_CODE: 'Code de Cause',
			RC_MAPPING_DETAIL_MATERIAL_COST: 'Coût Matériel',
			RC_MAPPING_DETAIL_PERMIT_ISSUED: 'Permis Émis',
			RC_MAPPING_DETAIL_PERMIT_CLOSED: 'Permis Clôturé',
			RC_MAPPING_DETAIL_CM_DURATION: 'Durée CM (h)',
			RC_MAPPING_DETAIL_DURATION_SOURCE: 'Source de la Durée',
			RC_MAPPING_DETAIL_FM_ID_NAME: 'ID / Nom du MD',
			RC_MAPPING_DETAIL_FM_TYPE: 'Type de MD',
			RC_MAPPING_DETAIL_FAILURE_MODE_TYPE: 'Type de Mode de Défaillance',
			RC_MAPPING_DETAIL_CONFIDENCE: 'Confiance',
			RC_MAPPING_DETAIL_SOURCE: 'Source',
			RC_MAPPING_DETAIL_RE_ATTRIBUTED_FROM: 'Réattribué depuis',
			RC_MAPPING_DETAIL_SYMPTOM_ONLY: 'Symptôme Uniquement',
			RC_MAPPING_DETAIL_RATIONALE: 'Justification',
			RC_MAPPING_DETAIL_CLASS: 'Classe',
			RC_MAPPING_DETAIL_KEY_SIGNALS: 'Signaux Clés',
			RC_MAPPING_DETAIL_EDITED_BY: 'Modifié par',
			RC_MAPPING_DETAIL_EDITED_AT: 'Modifié le',
			RC_MAPPING_DETAIL_FM_AGENT_RUN: "Exécution de l'Agent MD",
			RC_MAPPING_DETAIL_PREVENTABILITY_AGENT_RUN: "Exécution de l'Agent de Prévisibilité",
			RC_MAPPING_DETAIL_EXISTING: 'Existant',
			RC_MAPPING_DETAIL_NOT_AVAILABLE: 'Non disponible',
			RC_MAPPING_REGEN_CONFIRM_TITLE: "Régénérer l'association ?",
			RC_MAPPING_REGEN_CONFIRM_MESSAGE: '{{count}} ligne(s) modifiée(s) manuellement seront régénérées, en utilisant vos corrections comme guide pour la nouvelle exécution.',

			// Select option labels
			OPT_6_MONTHS: '6 Mois',
			OPT_12_MONTHS: '12 Mois',
			OPT_15_MONTHS: '15 Mois',
			OPT_24_MONTHS: '24 Mois',
			OPT_36_MONTHS: '36 Mois',
			OPT_1_CYCLE: '1 Cycle (Agressif)',
			OPT_2_CYCLES: '2 Cycles (Base)',
			OPT_3_CYCLES: '3 Cycles (Conservateur)',
			OPT_WEEKLY: 'Hebdomadaire (7 Jours)',
			OPT_BIWEEKLY: 'Bihebdomadaire (14 Jours)',
			OPT_MONTHLY: 'Mensuel (30 Jours)',
			OPT_NEAREST: 'Le plus proche',
			OPT_UP: 'Vers le haut',
			OPT_DOWN: 'Vers le bas',
			OPT_CRIT_A: 'A (Critique)',
			OPT_CRIT_B: 'B (Important)',
			OPT_CRIT_C: 'C (Standard)',
			OPT_CRIT_D: 'D (Faible)',
			OPT_PROFILE_BASE_NAME: 'Base',
			OPT_PROFILE_BASE_SUBTITLE: 'Équilibré, par défaut',
			OPT_PROFILE_CONSERVATIVE_NAME: 'Conservateur',
			OPT_PROFILE_CONSERVATIVE_SUBTITLE: 'Moins de recommandations, confiance plus élevée',
			OPT_PROFILE_AGGRESSIVE_NAME: 'Agressif',
			OPT_PROFILE_AGGRESSIVE_SUBTITLE: 'Plus de recommandations, économies potentielles plus élevées',
			OPT_PCT_SHORTER_10: '10% plus court',
			OPT_PCT_SHORTER_20: '20% plus court',
			OPT_PCT_SHORTER_25: '25% plus court',
			OPT_PCT_SHORTER_50: '50% plus court',
			OPT_PCT_LONGER_10: '10% plus long',
			OPT_PCT_LONGER_20: '20% plus long',
			OPT_PCT_LONGER_25: '25% plus long',
			OPT_PCT_LONGER_50: '50% plus long'
		},
		USER_MANAGEMENT: {
			FORM_ERROR: 'Oups ! Modifiez quelques champs et réessayez.',
			CANCEL: 'Annuler',
			SAVE: 'Enregistrer',
			CANCEL_CHANGES: 'Annuler les modifications',
			SAVE_CHANGES: 'Enregistrer les modifications',
			NO_RECORDS: 'Aucun enregistrement trouvé',
			PLEASE_WAIT: 'Veuillez patienter....',
			SEARCH: 'Rechercher',
			ACTIONS: 'Actions',
			NAME: 'Nom',
			EMAIL: 'E-mail',
			PHONE: 'Téléphone',
			FACILITY: 'Installation',
			UNITS: 'Unités',
			SYSTEMS: 'Systèmes',
			SYSTEM: 'Système',
			UNIT: 'Unité',
			USER: 'Utilisateur',
			SELECT_FACILITY: 'Sélectionner une installation',
			SELECT_FACILITIES: 'Sélectionner des installations',
			SELECT_UNITS: 'Sélectionner des unités',
			SELECT_SYSTEMS: 'Sélectionner des systèmes',
			SELECT_SYSTEM: 'Sélectionner un système',
			SELECT_UNIT: 'Sélectionner une unité',
			SELECT_USER: 'Sélectionner un utilisateur',
			SEARCH_UNIT: "Rechercher une unité...",
			NO_MATCHING_UNIT: 'Aucune unité correspondante trouvée',
			SEARCH_SYSTEM: 'Rechercher un système...',
			NO_MATCHING_SYSTEM: 'Aucun système correspondant trouvé',
			ROLES: {
				LIST_TITLE: 'Liste des rôles',
				NEW_ROLE: 'Nouveau rôle',
				CREATE_ROLE_TOOLTIP: 'Créer un nouveau rôle',
				SEARCH_USER: 'Rechercher un utilisateur',
				FETCH_SELECTED: 'Récupérer la sélection',
				FETCH_SELECTED_TOOLTIP: 'Récupérer les rôles sélectionnés',
				COL_TITLE: 'Titre',
				VIEW_ROLE: 'Afficher',
				EDIT_ROLE: 'Modifier',
				ROLE_SUFFIX: 'rôle',
				DELETE_ROLE: 'Supprimer le rôle',
				PERMISSIONS_HEADING: 'Permissions :',
				ENTER_TITLE: 'Saisir un titre',
				TITLE_REQUIRED: 'Le titre est',
				TITLE_REQUIRED_STRONG: 'obligatoire',
				TITLE_HINT: 'Veuillez saisir',
				TITLE_HINT_STRONG: 'Titre',
			},
			USERS: {
				TAB_USERS: 'Utilisateurs',
				TAB_USER_GROUPS: "Groupes d'utilisateurs",
				USER_LIST: 'Liste des utilisateurs',
				FILTERED_USER_LIST: 'Liste des utilisateurs filtrée',
				SHOW_DEACTIVATED: 'Afficher les désactivés',
				DOWNLOAD_TOOLTIP: "Télécharger la liste d'utilisateurs",
				DOWNLOAD: 'Télécharger',
				NEW_USER: 'Nouvel utilisateur',
				NEW_USER_TOOLTIP: 'Créer un nouvel utilisateur',
				UPLOAD_USER: 'Importer un utilisateur',
				UPLOAD_USER_TOOLTIP: 'Créer plusieurs utilisateurs',
				SEARCH_USER: 'Rechercher un utilisateur',
				COL_SL_NO: 'N°',
				COL_USERNAME: "Nom d'utilisateur",
				COL_EMAIL: 'E-mail',
				COL_NAME: 'Nom',
				COL_ROLES: 'Rôles',
				COL_ADMIN: 'Admin',
				COL_ENTERPRISE_ADMIN: 'Admin entreprise',
				COL_PHONE: 'Téléphone',
				COL_LAST_ACTIVE: 'Dernière activité',
				COL_STATUS: 'Statut',
				STATUS_ACTIVE: 'Actif',
				STATUS_DEACTIVATED: 'Désactivé',
				EDIT_USER: "Modifier l'utilisateur",
				DELETE_USER: "Supprimer l'utilisateur",
			},
			USER_GROUPS: {
				TITLE: "Groupes d'utilisateurs",
				ADD_TOOLTIP: "Ajouter un groupe d'utilisateurs",
				NEW_GROUP: "Nouveau groupe d'utilisateurs",
				COL_SL_NO: 'N°',
				EDIT_TOOLTIP: "Modifier l'utilisateur",
				DELETE_TOOLTIP: "Supprimer l'utilisateur",
				NAME_REQUIRED: 'Le nom est',
				NAME_REQUIRED_STRONG: 'obligatoire',
				NAME_HINT: 'Veuillez saisir',
				NAME_HINT_STRONG: 'nom',
				NO_USER_GROUPS: "Aucun groupe d'utilisateurs créé pour le moment",
				CREATE_GROUP_GET_STARTED: "Créez un nouveau groupe d'utilisateurs pour commencer",
			},
			USER_EDIT: {
				USER_INFO_HEADING: "Informations de l'utilisateur",
				SYSTEM_ACCESS_HEADING: 'Accès système',
				FACILITY_ADMIN_HEADING: "Accès administrateur d'installation",
				MODULE_ACCESS_HEADING: 'Accès aux modules',
				EMAIL_LABEL: 'E-mail',
				EMAIL_HINT: "Saisir l'e-mail",
				PASSWORD_LABEL: 'Mot de passe',
				PASSWORD_HINT: '(Min. 8 caractères, au moins un caractère spécial, une majuscule et un chiffre)',
				PASSWORD_REQUIRED: 'Le mot de passe est',
				PASSWORD_REQUIRED_STRONG: 'obligatoire',
				NAME_LABEL: 'Nom',
				NAME_HINT: 'Saisir le nom',
				PHONE_LABEL: 'Téléphone',
				PHONE_HINT: 'Saisir le téléphone',
				PHONE_REQUIRED: 'Le numéro de téléphone est',
				PHONE_REQUIRED_STRONG: 'obligatoire',
				ENTERPRISE_ADMIN: 'Admin entreprise',
				OPT_WHATSAPP: 'Activer WhatsApp',
				INTERNAL: 'Interne',
				MODEL_RETRAINING: 'Réentraînement du modèle',
				FACILITIES_LABEL: 'Installations',
				SELECT_ALL: 'Tout sélectionner',
				MODULE_LABEL: 'Module',
				SELECT_MODULES_HINT: 'Sélectionner des modules',
				SEARCH_MODULES: 'Rechercher des modules...',
				NO_MATCHING_MODULE: 'Aucun module correspondant trouvé',
				MODULE_REQUIRED: 'Au moins un module doit être sélectionné.',
				SAVE_TOOLTIP: 'Enregistrer',
				CANCEL_TOOLTIP: 'Annuler',
			},
			UPLOAD_USERS: {
				TITLE: "Importer la liste d'utilisateurs",
				SELECT_CSV: 'Sélectionner un fichier CSV',
				CSV_REQUIRED: 'Le fichier CSV est',
				CSV_REQUIRED_STRONG: 'obligatoire',
				SELECT_FILE: 'Sélectionner un fichier',
				DOWNLOAD_FORMAT_TOOLTIP: 'Télécharger le format CSV',
				SUBMIT: 'Soumettre',
			},
			USER_POPUP: {
				EMAIL_REQUIRED: "L'e-mail est",
				EMAIL_REQUIRED_STRONG: 'obligatoire',
				EMAIL_HINT: 'Veuillez saisir',
				EMAIL_HINT_STRONG: 'E-mail',
				PASSWORD_REQUIRED: 'Le mot de passe est',
				PASSWORD_REQUIRED_STRONG: 'obligatoire',
				PASSWORD_HINT: 'Saisir',
				PASSWORD_HINT_STRONG: 'Mot de passe',
				NAME_REQUIRED: 'Le nom est',
				NAME_REQUIRED_STRONG: 'obligatoire',
				NAME_HINT: 'Saisir',
				NAME_HINT_STRONG: 'Nom',
				PHONE_REQUIRED: 'Le téléphone est',
				PHONE_REQUIRED_STRONG: 'obligatoire',
				PHONE_HINT: 'Veuillez saisir',
				PHONE_HINT_STRONG: 'Téléphone',
				FACILITY_HINT: 'Sélectionner',
				SYSTEM_HINT: 'Sélectionner',
				SYSTEMS_PLACEHOLDER: 'Systèmes',
				SYSTEM_HINT_STRONG: 'Système',
				FACILITY_HINT_STRONG: 'Installation',
			},
			CONFIRMATION: {
				REASON_REQUIRED: 'Le motif est obligatoire.',
			},
			USER_ROLES: {
				SELECT_ROLE: 'Sélectionner un rôle',
				ASSIGN_TOOLTIP: 'Attribuer un rôle',
				ASSIGN: 'Attribuer',
				ASSIGNED_ROLES: 'Rôles attribués :',
				REMOVE_TOOLTIP: 'Supprimer le rôle',
			},
			ADDRESS: {
				FORM_ERROR: 'Oups ! Modifiez quelques champs et réessayez.',
				ADDRESS_LINE: "Saisir la ligne d'adresse",
				ADDRESS_LINE_REQUIRED: "La ligne d'adresse est",
				ADDRESS_LINE_REQUIRED_STRONG: 'obligatoire',
				ADDRESS_LINE_HINT: 'Veuillez saisir',
				ADDRESS_LINE_HINT_STRONG: "Ligne d'adresse",
				CITY: 'Ville',
				CITY_REQUIRED: 'La ville est',
				CITY_REQUIRED_STRONG: 'obligatoire',
				CITY_HINT: 'Veuillez saisir',
				CITY_HINT_STRONG: 'Ville',
				STATE: "Saisir l'état/région",
				STATE_REQUIRED: "L'état est",
				STATE_REQUIRED_STRONG: 'obligatoire',
				STATE_HINT: 'Veuillez saisir',
				STATE_HINT_STRONG: 'État',
				POSTCODE: 'Saisir le code postal',
				POSTCODE_REQUIRED: 'Le code postal est',
				POSTCODE_REQUIRED_STRONG: 'obligatoire',
				POSTCODE_HINT: 'Veuillez saisir',
				POSTCODE_HINT_STRONG: 'Code postal',
			},
			SOCIAL: {
				FORM_ERROR: 'Oups ! Modifiez quelques champs et réessayez.',
				LINKEDIN: 'Saisir l\'adresse LinkedIn',
				LINKEDIN_HINT: 'Veuillez saisir',
				LINKEDIN_HINT_STRONG: 'LinkedIn',
				FACEBOOK: 'Saisir l\'adresse Facebook',
				FACEBOOK_HINT: 'Veuillez saisir',
				FACEBOOK_HINT_STRONG: 'Facebook',
				TWITTER: 'Saisir l\'adresse Twitter',
				TWITTER_HINT: 'Veuillez saisir',
				TWITTER_HINT_STRONG: 'Twitter',
				INSTAGRAM: 'Saisir l\'adresse Instagram',
				INSTAGRAM_HINT: 'Veuillez saisir',
				INSTAGRAM_HINT_STRONG: 'Instagram',
				ADDRESS_SUFFIX: 'adresse',
			},
			CHANGE_PASSWORD: {
				FORM_ERROR: 'Oups ! Les mots de passe ne correspondent pas.',
				PASSWORD: 'Saisir le mot de passe',
				PASSWORD_REQUIRED: 'Le mot de passe est',
				PASSWORD_REQUIRED_STRONG: 'obligatoire',
				PASSWORD_HINT: 'Veuillez saisir',
				PASSWORD_HINT_STRONG: 'Mot de passe',
				CONFIRM_PASSWORD: 'Confirmer le mot de passe',
				CONFIRM_REQUIRED: 'La confirmation est',
				CONFIRM_REQUIRED_STRONG: 'obligatoire',
				CONFIRM_HINT: 'Veuillez confirmer',
				CONFIRM_HINT_STRONG: 'Mot de passe',
				CHANGE_BUTTON: 'Changer le mot de passe',
				SAVE_CHANGES: 'Enregistrer les modifications',
			},
		},
		SYSTEM_VIEW: {
			PARTS: 'PIÈCES',
			ACTIVE: 'ACTIF',
			SYSTEM: 'Système',
			SEARCH_SYSTEM: 'Rechercher un système...',
			NO_MATCHING_SYSTEM: 'Aucun système correspondant trouvé',
			OPEN_ALERTS: 'ALERTES OUVERTES',
			ACTIVE_ALERTS: 'ALERTES ACTIVES',
			UNACK_ALERTS: 'ALERTES NON CONF.',
			RELIABILITY: 'FIABILITÉ',
			MEAN_TIME_BETWEEN_ALERTS: 'TEMPS MOYEN ENTRE ALERTES',
			UPTIME: 'DISPONIBILITÉ',
			DAYS: 'jours',
			PERFORMANCE_CURVES: 'COURBES DE PERFORMANCE',
			OPEN_IN_NEW_TAB: 'Ouvrir dans un nouvel onglet',
			TAB_ANOMALY: 'Anomalie',
			TAB_SYSTEM_DETAILS: 'Détails du système',
			TAB_DATA_QUALITY: 'Qualité des données',
			TAB_PERFORMANCE: 'Performance',
			CLEAR_SIMULATION: 'Effacer la simulation',
			SIMULATION: 'Simulation',
			CLICK_TO_START_PREDICTION: 'Cliquer pour démarrer la prédiction',
			PREDICTION_RUNNING: 'Prédiction en cours',
			NO_OF_DAYS: 'Nb de jours',
			OK: 'Ok',
			RESET: 'Réinitialiser',
			RETRAINING: 'Réentraînement',
			MORE: 'Plus',
			TAGS: 'Balises',
			SEARCH_TAG: 'Rechercher une balise...',
			NO_MATCHING_TAG: 'Aucune balise correspondante trouvée',
			ASSET_LABEL: 'Actif:',
			NAME_LABEL: 'Nom:',
			TAG_ID_LABEL: 'ID de balise:',
			CANCEL: 'Annuler',
			ASSETS: 'ACTIFS',
			SEARCH_ASSET: 'Rechercher un actif...',
			NO_MATCHING_ASSET: 'Aucun actif correspondant trouvé',
			RESET_ASSET_SELECTION: "Réinitialiser la sélection d'actif",
			DATA_QUALITY: {
				SEARCH_TAG: 'Rechercher une balise',
				DOWNLOAD_TOOLTIP: 'Télécharger le rapport de qualité des données des balises',
				DOWNLOAD: 'Télécharger',
				COL_TAG_NAME: 'Nom de balise',
				COL_MISSING_DATA: 'Données manquantes',
				COL_FLAT_LINE: 'Ligne plate',
				COL_OUTLIER: 'Valeur aberrante',
				COL_OUT_OF_RANGE: 'Hors plage',
				COL_TOTAL_INVALID_DATA: 'Total données invalides',
				COL_ACTIONS: 'Actions',
				MORE_ACTIONS: 'Plus d\'actions',
				NO_RECORDS: 'Aucun événement de qualité des données trouvé pour la plage de temps sélectionnée',
				LOADING: 'Chargement...',
				SHUTDOWN_TAG: 'Tag d\'arrêt',
				TRIP: 'Déclenchement',
				TRIP_LIMIT: 'Limite de déclenchement',
				ALARM: 'Alarme',
				ALARM_LIMIT: 'Limite d\'alarme',
				THRESHOLD: 'Seuil',
				THRESHOLD_LIMIT: 'Limite de seuil',
				INSTRUMENT: 'Instrument',
				INSTRUMENT_RANGE: 'Plage de l\'instrument',
			},
			SYSTEM_DETAILS: {
				NO_IMAGE_FOUND: 'Aucune image trouvée',
				ASSET_DETAILS: "Détails de l'actif",
				CURRENT_ALERTS_EQUIPMENT: 'Alertes actuelles/Équipement',
				EQUIPMENT_DISTRIBUTION: 'Distribution par équipement',
				TOP_FAILURE_MODES: 'Principaux modes de défaillance par équipement',
				CUSTOM_INPUTS: 'Entrées personnalisées',
				SELECT_TAG: 'Sélectionner une balise',
				UPDATE: 'Mettre à jour',
				SPECIFY_VALUE: 'Spécifier une valeur',
				TIMESTAMP: 'Horodatage',
				LAB_DATA: 'Données de laboratoire',
				NO_DATA_FOUND: 'Aucune donnée trouvée',
			},
			ALERT_SETTINGS: {
				TITLE: "Paramètres d'alerte",
				CANCEL: 'Annuler',
				FAILURE_MODE: 'Mode de défaillance',
				AGGREGATED_ANOMALY_SCORE: "Score d'anomalie agrégé",
				INSTRUMENT_HEALTH: "Santé de l'instrument/Qualité des données",
				FLATLINE: '1: Ligne plate',
				MISSING_DATA: '2: Données manquantes',
				OUT_OF_RANGE: '3: Hors plage',
				OUTLIERS: '4: Valeurs aberrantes',
			},
			DIAGNOSTICS: {
				TITLE: 'Diagnostics système',
				CANCEL: 'Annuler',
				ROOT_CAUSE_ICON_ALT: 'Icône de cause racine',
				NOT_GENERATED_YET: "Vous n'avez pas encore généré de diagnostics système.",
				RUN_TO_PROCEED: 'Veuillez exécuter les diagnostics pour continuer.',
				GENERATION_FAILED: 'La dernière génération de diagnostics système a échoué.',
				RUN_AGAIN: 'Veuillez relancer les diagnostics pour continuer.',
				GENERATE_NOW: 'Générer maintenant',
				REGENERATE: 'Régénérer',
				FAILED_AT: 'La génération des diagnostics système a échoué le',
				LAST_GENERATED: 'Dernière génération',
				GENERATING: 'Génération des diagnostics système',
				SEVERITY: 'Gravité:',
				ISSUE: 'Problème:',
				IMPACT: 'Impact:',
				ACTION: 'Action:',
				PRIORITY: 'Priorité:',
			},
			PERFORMANCE_CURVE: {
				TAG: 'Balise',
				FILTER_TAG_VALUE: 'Filtrer la valeur de balise',
				SEARCH_TAG: 'Rechercher une balise...',
				NO_TAG_FOUND: 'Aucune balise trouvée',
				GREATER_THAN: 'Supérieur à',
				LESS_THAN: 'Inférieur à',
				OK: 'Ok',
				DATE_RANGE: 'Plage de dates',
				START_DATE: 'Date de début',
				END_DATE: 'Date de fin',
				SELECT: 'Sélectionner',
			},
		},
		PLATFORM_CONFIGURATION: {
			HEADER_TITLE: 'Configuration de la plateforme',
			TABS: {
				ORGANISATION_SETUP: "Configuration de l'organisation",
				ASSET_REGISTRY: 'Registre des actifs',
				MODULE_HIERARCHY: 'Hiérarchie des modules',
				PROPERTY_TEMPLATES: 'Modèles de propriétés',
			},
			COMING_SOON: 'Bientôt disponible',
		},
		CUSTOMER_SETUP: {
			TABS: {
				CLIENT_SETUP: "Détails de l'organisation",
				FACILITY_SETUP: 'Installations',
				PLANT_ECONOMICS: 'Paramètres économiques',
			},
			COMMON: {
				SAVE_CHANGES: 'Enregistrer les modifications',
				CANCEL: 'Annuler',
				CONFIRM: 'Confirmer',
				EDIT: 'Modifier',
				DELETE: 'Supprimer',
				LOADING: 'Chargement...',
				SEARCH: 'Rechercher...',
				CLOSE: 'Fermer',
				SAVED_SUCCESSFULLY: 'Enregistré avec succès',
				ERROR_SAVING: "Erreur lors de l'enregistrement des modifications",
				TIMEZONE: 'Fuseau horaire',
				LATITUDE: 'Latitude',
				LONGITUDE: 'Longitude',
				SELECT_TIMEZONE: 'Sélectionner le fuseau horaire',
			},
			CLIENT: {
				TITLE: "Détails de l'organisation",
				SUBTITLE: "Configurer les détails de l'organisation",
				LOGO: 'Logo',
				UPLOAD_LOGO: 'Télécharger le logo',
				HQ_ADDRESS: 'Adresse du siège social',
				ENTERPRISE_NAME: "Nom de l'entreprise",
				INDUSTRY_SECTOR: 'Secteur industriel',
				STREET_ADDRESS: 'Adresse',
				CITY: 'Ville',
				STATE: 'État',
				COUNTRY: 'Pays',
				ZIP_CODE: 'Code postal',
				ZOOM_LEVEL: 'Niveau de zoom',
				BUSINESS: 'Activité',
				NOTES: 'Notes',
				SELECT_INDUSTRY_SECTOR: 'Sélectionner le secteur industriel',
				PLACEHOLDER_BUSINESS: "Veuillez saisir les détails de l'activité",
				PLACEHOLDER_NOTES: 'Veuillez saisir des notes',
			},
			FACILITY: {
				TITLE: 'Installations',
				SUBTITLE: 'Définir les emplacements et paramètres des installations',
				ADD_FACILITY: 'Ajouter une installation',
				GROUP_BY: 'Regrouper par',
				COL_NAME: 'Nom',
				COL_LOCATION: 'Emplacement',
				COL_CAPACITY: 'Capacité (MW)',
				COL_REGION: 'Région',
				COL_INDUSTRY: 'Industrie',
				NO_FACILITIES_SEARCH: 'Aucune installation trouvée.',
				TRY_ADJUSTING: "Essayez d'ajuster votre requête de recherche.",
				NO_FACILITIES_YET: "Aucune installation configurée pour l'instant.",
				CLICK_TO_GET_STARTED: "Cliquez sur 'Ajouter une installation' pour commencer.",
				DELETE_TITLE: "Supprimer l'installation",
				DELETE_DESCRIPTION: 'Êtes-vous sûr de vouloir supprimer définitivement l\'installation "{{name}}"?',
				DELETE_WAIT: "Suppression de l'installation...",
				DELETED_SUCCESS: 'Installation supprimée avec succès',
				DELETE_ERROR: "Erreur lors de la suppression de l'installation",
			},
			ADD_FACILITY_DIALOG: {
				TITLE_ADD: 'Ajouter une installation',
				TITLE_EDIT: "Modifier l'installation",
				UPDATED_SUCCESS: 'Installation mise à jour avec succès',
				UPDATE_ERROR: "Erreur lors de la mise à jour de l'installation",
				CREATED_SUCCESS: 'Installation créée avec succès',
				CREATE_ERROR: "Erreur lors de la création de l'installation",
				FACILITY_NAME: "Nom de l'installation",
				FACILITY_CODE: "Code de l'installation",
				LOCATION: 'Emplacement',
				REGION: 'Région',
				CURRENCY: 'Devise',
				INSTALLED_CAPACITY: 'Capacité installée (MW)',
				INDUSTRY: 'Industrie',
				GIS_LOCATION: 'Emplacement GIS',
				PLACEHOLDER_FACILITY_NAME: 'Nom de la centrale',
				PLACEHOLDER_LOCATION: 'Ville, État',
				SELECT_REGION: 'Sélectionner une région',
				SELECT_CURRENCY: 'Sélectionner une devise',
				SELECT_INDUSTRY: 'Sélectionner une industrie',
			},
			FACILITY_FORM: {
				TAB_FACILITY_INFO: "Informations sur l'installation",
				TAB_HISTORIAN_INFO: "Informations sur l'historian",
				TAB_SAP_INFO: 'Informations SAP',
				ENTERPRISE: 'Entreprise',
				ADDRESS: 'Adresse',
				CITY: 'Ville',
				STATE: 'État/Région',
				COUNTRY: 'Pays',
				ZIP: 'Code postal',
				ZOOM_LEVEL: 'Niveau de zoom',
				APPLICATION: 'Application',
				NOTES: 'Notes',
				CUSTOMER_ADVOCATE: 'Représentant client',
				HISTORIAN_TYPE: "Type d'historian",
				ACCESS_METHOD: "Méthode d'accès",
				ACCESS_URL: "URL d'accès",
				RESOURCE_URL: 'URL de ressource',
				DATA_FETCH_SETTINGS: 'Paramètres de récupération des données',
				FORWARD_AGGREGATE: "Transférer l'agrégat",
				FETCH_RATE: 'Fréquence de récupération',
				FETCH_RATE_UNIT: 'Unité de fréquence de récupération',
				ENABLE_SAMPLING: "Activer l'échantillonnage",
				SAMPLING_RATE: "Fréquence d'échantillonnage",
				SAMPLING_RATE_UNIT: "Unité de fréquence d'échantillonnage",
				PREDICTION_SETTINGS: 'Paramètres de prédiction',
				PREDICTION_RATE: 'Fréquence de prédiction',
				PREDICTION_RATE_UNIT: 'Unité de fréquence de prédiction',
				DQ_ALERTS: 'Alertes de qualité des données',
				START_DELAY: 'Délai de début (en heures)',
				END_DELAY: 'Délai de fin (en heures)',
				FUNCTIONAL_LOC_MAPPING: 'Mappage emplacement fonctionnel/ID équipement',
				UPLOAD_FUNCTIONAL_LOC: 'Téléverser les données emplacement fonctionnel/ID équipement',
				DOWNLOAD_FUNCTIONAL_LOC: 'Télécharger le mappage emplacement fonctionnel/ID équipement',
				SAP_DATA: 'Données SAP',
				UPLOAD_SAP_DATA: 'Téléverser les données SAP',
				DOWNLOAD_SAP_FORMAT: 'Télécharger le format de données SAP',
				UPDATE_SAP_DATA: 'Mise à jour des données de permis SAP',
				UPLOAD_UPDATE_SAP_DATA: 'Télécharger la mise à jour des données de permis SAP',
				DOWNLOAD_UPDATE_SAP_FORMAT: 'Télécharger le format de mise à jour des données de permis SAP',
				CMMS_WRITE_INTEGRATION: "Intégration d'écriture CMMS",
				CMMS_LAST_DATA_PULL: 'Dernière Extraction de Données CMMS',
				IP_ADDRESS: 'Adresse IP',
				USER_NAME: "Nom d'utilisateur",
				PASSWORD: 'Mot de passe',
				TEST: 'Test',
				TEST_WRITE_INTEGRATION: "Tester l'intégration d'écriture",
			},
			PLANT_ECONOMICS: {
				TITLE: 'Paramètres économiques',
				SUBTITLE: 'Configurer les facteurs économiques et les paramètres de coûts',
				SELECT_FACILITY_MSG: 'Veuillez sélectionner une installation pour gérer ses paramètres économiques.',
				SECTION_TITLE: "Paramètres d'économie de production",
				CHOOSE_FACILITY: 'Choisir une installation...',
				PRODUCTION_DETAILS: 'Détails de production',
				LABOR_SALARY: 'Paramètres de salaire du travail (par heure)',
				UPDATED_SUCCESS: "Économie de l'usine mise à jour avec succès",
				UPDATE_ERROR: "Erreur lors de la mise à jour de l'économie de l'usine",
				COST_PER_UNIT: 'Coût/Unité de production',
				CAPACITY_HOUR: 'Capacité/heure (ex. MWh)',
				REVENUE_HOUR: 'Revenus/heure',
				MARGIN_PERCENT: 'Marge (%)',
				OTHER_COSTS: "Autres coûts fixes d'inactivité",
				TECHNICIAN: 'Technicien',
				HELPER: 'Assistant',
				SUPERVISOR: 'Superviseur',
				MANAGER: 'Gestionnaire',
			},
		},
		MODEL_EXPLAIN: {
			TITLE: 'Expliquer les tags',
			SELECTED_TAG: 'Tag sélectionné',
			CAUSAL_TAGS: 'Tags causaux',
			TAG_SINGULAR: 'tag',
			TAG_PLURAL: 'tags',
			CONTRIBUTOR_SCORE: 'Score',
			NO_CONTRIBUTORS: 'Aucun tag contributeur trouvé pour cet horodatage.',
			LOADING_CAUSAL_TAGS: 'Chargement des tags causaux...',
			CLOSE: 'Fermer',
			ASSET: 'Actif',
			FULLSCREEN: 'Plein écran',
			EXIT_FULLSCREEN: 'Quitter le plein écran',
			EXPAND: 'Agrandir',
			COLLAPSE: 'Réduire',
			EXPLAIN: 'Expliquer',
		},
		FILE_PREVIEW: {
			LOADING_REPORT: "Chargement du rapport…",
			REPORT_IN_PROGRESS: "La génération du rapport est en cours. Revenez dans 5 minutes.",
			REPORT_FAILED: "Le rapport n'a pas pu être généré. Veuillez le partager à nouveau.",
		},
		ALERT_V2: {
			FORECAST: {
				TTF_SHORT: 'TTF',
				TTI_SHORT: 'TTI',
				DETAILS: 'Détails {{kind}}',
				NO_VALUES: 'Aucune valeur {{kind}} valide disponible.',
				ON_DEMAND_NO_FORECAST: 'Aucune prévision n\'est disponible à partir du point sélectionné. Faites glisser le marqueur vers un autre point et réessayez.',
				MIN: 'Min =',
				CURRENT_VALUE: 'Valeur actuelle',
				VS_BASELINE: 'vs référence',
				ACTIVE_DURATION: 'Durée active',
				SAMPLE_DENSITY: 'Densité d\'échantillonnage',
				FORECAST: 'Prévision {{kind}} =',
				TTF: {
					ALERT: {
						TITLE: 'TTF au niveau alerte',
						DESCRIPTION: 'TTF = min (TTF de chaque tag contributeur). Le dépassement prévu le plus proche détermine la valeur consolidée affichée ci-dessous.',
					},
					ALERT_LIST: {
						TITLE: 'TTF au niveau alerte',
						DESCRIPTION: 'TTF = min (TTF de chaque mode de défaillance). Le dépassement prévu le plus proche détermine la valeur consolidée affichée ci-dessous.',
					},
					FAILURE_MODE: {
						TITLE: 'TTF du mode de défaillance',
						DESCRIPTION: 'TTF = min (TTF de chaque tag contributeur). Le dépassement prévu le plus proche détermine la valeur consolidée affichée ci-dessous',
					},
					TAG: {
						TITLE: 'Niveau tag TTF',
						DESCRIPTION: 'Prévision du nombre de jours avant que la valeur projetée du tag ne dépasse sa limite d\'exploitation, d\'après le taux de variation récent extrapolé.',
					},
				},
				TTI: {
					ALERT_LIST: {
						TITLE: 'Temps avant intervention — niveau alerte',
						DESCRIPTION: 'La prévision d\'intervention la plus proche parmi les modes de défaillance de cette alerte.',
					},
					ALERT: {
						TITLE: 'Temps avant intervention — niveau alerte',
						DESCRIPTION: 'La prévision d\'intervention la plus proche de cette alerte parmi les indicateurs de dégradation des performances surveillés.',
					},
					FAILURE_MODE: {
						TITLE: 'Mode de défaillance — Temps avant intervention',
						DESCRIPTION: 'Intervention opérationnelle prévue la plus proche, basée sur les indicateurs de performance associés à ce mode de défaillance.',
					},
					TAG: {
						TITLE: 'Niveau tag — Temps avant intervention',
						DESCRIPTION: 'Intervention opérationnelle prévue la plus proche pour ce tag.',
					},
				},
			},
			DQ_SETTINGS: {
				TITLE: "Paramètres de qualité des données",
				DETECTION_TITLE: "Détection de la qualité des données",
				ALERT_GEN_TITLE: "Génération d'alertes de qualité des données",
				ALERT_GEN_DESC: "Choisissez les problèmes de DQ détectés qui doivent générer des alertes. La désactivation de la génération d'alertes n'arrête pas le calcul de DQ.",
				FLATLINE_DETECTION: "Détection de ligne plate",
				MISSING_DATA_DETECTION: "Détection de données manquantes",
				OUTLIER_DETECTION: "Détection de valeurs aberrantes",
				OUT_OF_RANGE_DETECTION: "Détection hors plage",
				ERRATIC_DETECTION: "Détection erratique",
				FLATLINE_ALERT: "Alerte de ligne plate",
				MISSING_DATA_ALERT: "Alerte de données manquantes",
				OUTLIER_ALERT: "Alerte de valeur aberrante",
				OUT_OF_RANGE_ALERT: "Alerte hors plage",
				ERRATIC_ALERT: "Alerte erratique",
				CLOSE_TOOLTIP: "Fermer"
			},
			DETAIL: {
				NO_DATA_URL: "Aucune donnée trouvée pour l'URL fournie.",
				NO_DATA_URL_DESC: "Veuillez vérifier l'URL saisie et réessayer.",
				FAILURE_MODES: "Modes de défaillance",
				SEARCH: "Rechercher...",
				SORT_FAILURE_SCORE: "Trier par score de défaillance",
				SORT_CREATION_DATE: "Trier par date de création",
				OTHER_ACTIVE_ALERTS: "Autres alertes actives",
				NEW_FAILURE: "Nouvelle défaillance ajoutée",
				ALERT_TITLE_PLACEHOLDER: "Titre de l'alerte",
				SEARCH_OWNER: "Rechercher le propriétaire...",
				SEARCH_WATCHERS: "Rechercher des observateurs..",
				ASSIGN_OWNER: "Attribuer un propriétaire",
				ADD_WATCHERS: "Ajouter des observateurs",
				VERSION_HISTORY: "Historique des versions",
				COPY_LINK: "Copier le lien de l'alerte",
				BOOKMARK: "Marquer l'alerte",
				REMOVE_BOOKMARK: "Supprimer le signet",
				FETCHING_SYSTEM_DETAILS: "Récupération des détails du système",
				RESTORE_VERSION: "Restaurer la version",
				CANNOT_DELETE_VERSION: "Impossible de supprimer des versions pendant que RCA est en cours",
				DELETE_VERSION: "Supprimer la version",
				EDIT: "Modifier",
				CLOSE: "Fermer",
				DOWNLOAD: "Télécharger",
				SHARE: "Partager",
				ANOMALY_SCORE: "Score d'anomalie",
				TIMELINE: "Chronologie",
				VERSIONS: "Versions",
				NO_DATA_AVAILABLE: "Aucune donnée disponible",
				EXPORT_REPORT: "Exporter le rapport",
				TIME_TO_FAILURE_IN: "Temps avant défaillance en {{unit}}",
				TIME_TO_INTERVENTION_IN: "Temps avant intervention en {{unit}}",
				SWITCH_TO_FM_VIEW: 'Passer à la vue FM',
				SWITCH_TO_RCA_VIEW: 'Passer à la vue RCA',
				CREATED_ON: 'Créé le',
				MENU_CREATED_ON: 'Créé le',
				STATE: 'État',
				DUE_DATE: 'Date d\'échéance',
				STATUS: 'Statut',
				OWNER: 'Propriétaire',
				WATCHERS: 'Observateurs',
				WATCHER: 'Observateur',
				LAST_RUN_PREFIX: 'Dernière exécution :',
				MENU_LAST_RUN: 'Dernière exécution',
				RUN_NOW: 'Exécuter maintenant',
				MENU_RUN_NOW: 'Exécuter maintenant',
				MORE: 'Plus',
				REPORT_ISSUE: 'Signaler un problème',
				NAV: {
					THRESHOLD: 'Seuil',
					DATA_QUALITY: 'Qualité des données',
					ACTIVITY_LOGS: 'Journaux d\'activité',
					DISCUSSION: 'Discussion',
					ANALYSIS_VIEWS: 'Analyse et vues',
					RETRAIN_MODEL: 'Réentraîner le modèle',
					FEEDBACK: 'Commentaires',
					DISPLAY_TAGS: 'Afficher les tags',
					PREFERRED_SETTINGS: 'Paramètres préférés',
					DOCUMENTS: 'Documents',
					WORK_ORDERS: 'Ordres de travail',
					ROOT_CAUSE_ANALYSIS: 'Analyse des causes profondes',
				},
				TAGS_TOOLTIP: "Tags",
				TIME_TO_TRIP: "Temps avant défaillance",
				DAYS: "jours",
				CMMS_NUMBER: "Numéro GMAO",
				STACKED_VIEW: "Vue empilée",
				OVERLAY_VIEW: "Vue superposée",
				GRID_VIEW: "Vue en grille",
				NO_RECOMMENDATIONS: "Aucune recommandation à afficher",
				RECOMMENDATIONS: "Recommandations",
				RECOMMENDATION_POPUP: {
					ADD_PLACEHOLDER: "Ajouter une recommandation",
					ADD: "Ajouter",
					CANCEL: "Annuler",
					UPDATE: "Mettre à jour",
					EMPTY_TITLE: "Aucune recommandation disponible",
					EMPTY_HINT: "Ajoutez une recommandation pour l’afficher ici.",
				},
				SEARCH_CATEGORY: "Rechercher une catégorie...",
				NO_CATEGORY: "Aucune catégorie correspondante trouvée",
				SELECT_CATEGORY: "Sélectionner une catégorie",
				SEARCH_COMPONENT: "Rechercher un composant...",
				NO_COMPONENT: "Aucun composant correspondant trouvé",
				SELECT_COMPONENT: "Sélectionner un composant",
				SEARCH_ERROR: "Rechercher une erreur...",
				NO_ERROR_FOUND: "Aucune erreur correspondante trouvée",
				SELECT_ERROR: "Sélectionner une erreur",
				ALERT_DETAILS_TITLE: "Détails de l'alerte",
				EMPTY_DATA_ALT: "Aucune donnée",
				NO_OPEN_FAILURE_MODES: "Aucun mode de défaillance ouvert.",
				RELATED_ALERTS: "Alertes associées",
				TOP_CONTRIBUTING_TAGS: "Principales balises contribuant au score d'anomalie",
				NO_TAGS_TO_DISPLAY: "Aucune balise à afficher.",
				NO_DATA_ALT: "Aucune donnée",
				SELECT_FM_OR_ADD_TAGS: "Sélectionnez un mode de défaillance ou ajoutez des balises pour afficher les graphiques.",
				BREAKDOWN_CATEGORY_LABEL: "Catégorie de panne",
				BREAKDOWN_COMPONENT_LABEL: "Composant de panne",
				BREAKDOWN_ERROR_LABEL: "Erreur",
				SAVE: "Enregistrer",
				FILTER_TAGS: "Filtrer les tags",
				NO_MATCHING_RESULT: "Aucun résultat correspondant",
				START_TYPING: "Commencez à taper pour voir les tags correspondants.",
				NO_MATCHING_RESULTS: "Aucun résultat correspondant",
				CLOSE_TOOLTIP: "Fermer",
				EDIT_DISABLED: "Vous êtes en mode lecture seule pour cet établissement",
				MULTI_SELECT_DISABLED: "Seul le propriétaire de l'alerte peut sélectionner plusieurs modes de défaillance",
				SPLIT_MERGE_OWNER: "Seul un propriétaire de l'alerte peut séparer les modes de défaillance.",
				SPLIT_MERGE_STATUS: "Seules les alertes avec certains statuts peuvent être séparées ou fusionnées.",
				SPLIT_MERGE_APPROVED: "Seuls les modes de défaillance approuvés ou non traités peuvent être séparés vers une nouvelle alerte ou fusionnés avec une alerte existante.",
				SPLIT_MERGE_ACTION: "Déplacer les modes de défaillance vers une nouvelle alerte ou fusionner avec une existante.",
				SPLIT_MERGE_IN_PROGRESS: "Une séparation ou fusion est en cours pour cette alerte. Veuillez attendre la fin de l'opération.",
				SPLIT_MERGE_DISMISS: "Fermer",
				TITLE_EMPTY: "Veuillez saisir un titre.",
				TITLE_TOO_LONG: "Le titre ne peut pas dépasser 60 caractères.",
				MAINTENANCE_RECORDS_DIALOG: "Enregistrements de maintenance existants détectés.<br>Voulez-vous les supprimer pour procéder au réapprentissage?",
				FAILURE_DELETED: "Mode de défaillance \"{{name}}\" supprimé avec succès",
				FAILURE_DELETE_ERROR: "Une erreur s'est produite lors de la suppression de \"{{name}}\". Veuillez réessayer.",
				FAILURE_ADDED: "Mode de défaillance \"{{name}}\" ajouté avec succès",
				USED_IN_MODEL: "Utilisé dans le modèle et le tag calculé",
				ONGOING: "En cours",
				FAILURE_TIMELINE: {
					TITLE: "Chronologie de \"{{name}}\"",
					SORT_BY: "Trier par",
					SORT_TIMELINE: "Chronologie",
					SORT_ASSETS: "Actifs",
					LIMIT_TO_SYSTEM: "Limiter les résultats à ce système",
					ASSET: "Actif",
					REASON: "Raison",
					RECOMMENDATIONS: "Recommandations",
					NOT_AVAILABLE: "NA",
					NO_DATA: "Aucune donnée trouvée.",
					MENU_LABEL: "Chronologie des défaillances",
				},
			},
			RCA: {
				CREATE_WORK_ORDER: "Créer un ordre de travail",
				GENERATING: "Génération de l'analyse des causes racines",
				GENERATE: "Générer l'analyse des causes racines",
				PERCENT_COMPLETED: "% complété",
				GO_BACK: "Retour",
				RUN_NOW: "Exécuter maintenant",
				CANCEL: "Annuler",
				NOTIFY_ME: "Me notifier",
				ALREADY_IN_PROGRESS: "La génération RCA est déjà en cours",
				RERUN: "Réexécuter",
				VIEW_TRACES: "Voir les traces",
				TITLE: "Analyse des causes racines",
				HYPOTHESES: "Hypothèses",
				COMMENTS: "commentaires",
				EVIDENCE_POINTS: "points de preuve",
				DISCUSSION_TOOLTIP: "Pour discussion interne avec votre équipe",
				APPROVED: "Approuvé",
				APPROVE: "Approuver",
				EDIT: "Modifier",
				RELEARNED: "Réappris",
				RELEARN: "Réapprendre",
				SUSPECTED_CAUSE: "Cause suspectée",
				CAUSAL_CHAIN: "Chaîne causale",
				STEPS: "étapes",
				RECOMMENDATIONS: "Recommandations",
				CHART_TAGS: "Tags du graphique",
				EXPORT_AS_PDF: "Exporter en PDF",
				PROPOSED_EVIDENCE: "Preuves proposées",
				ADD_TO_EVIDENCE: "Ajouter comme preuve",
				EVIDENCE_ADDED_BY: "Ajouté le {{date}} à {{time}} par {{user}}",
				EVIDENCE_ADDED: "Ajouté le {{date}} à {{time}}",
				ALREADY_ADDED: "Déjà ajouté comme preuve",
				DRAG_TO_REORDER: "Cliquer et faire glisser pour réorganiser",
				TABS: {
					TAGS: "Tags",
					WORK_ORDERS: "Ordres de travail",
					DOCUMENTS: "Documents",
					SYSTEM_DETAILS: "Détails du système",
				},
				EMPTY: {
					NO_TAGS_EVIDENCE: "Aucun tag ajouté comme preuve",
					NO_TAGS_EVIDENCE_DESC: "Les graphiques de tags apparaîtront ici lorsque des tags seront proposés comme preuves.",
					NO_WORK_ORDERS: "Aucun ordre de travail lié",
					NO_WORK_ORDERS_DESC: "Les ordres de travail apparaîtront ici lorsque des enregistrements de maintenance seront associés.",
					NO_DOCUMENT_EVIDENCE: "Aucune preuve documentaire",
					NO_DOCUMENT_EVIDENCE_DESC: "Ajoutez un document existant ou téléchargez-en un nouveau.",
					UPLOAD_NEW_DOCUMENT: "Téléverser un nouveau document",
					NO_PROPOSED_EVIDENCE: "Aucune preuve proposée",
					NO_PROPOSED_EVIDENCE_DESC: "Ajoutez des tags, ordres de travail, documents ou références P&ID pour soutenir cette hypothèse.",
					NO_TAGS_LINKED: "Aucun tag lié",
					NO_TAGS_LINKED_DESC: "Les graphiques de tags apparaîtront ici lorsque des tags seront ajoutés à cette hypothèse.",
					SELECT_TAG_HEADING: "Aucun tag sélectionné",
					SELECT_TAG_DESC: "Cliquez sur un tag de l'hypothèse à gauche, ou faites glisser des tags ici, pour afficher leurs graphiques.",
					NO_DOCUMENTS: "Aucun document disponible",
					NO_DOCUMENTS_DESC: "Les manuels techniques, rapports et PDFs apparaîtront ici lorsqu'ils seront liés à cette hypothèse.",
					NO_SYSTEM_DETAILS: "Aucun détail système disponible",
					NO_SYSTEM_DETAILS_DESC: "Les P&IDs, spécifications système et détails techniques apparaîtront ici lorsque les données seront liées.",
				},
				WO: {
					WORK_ORDER: "Ordre de travail",
					MANUALLY_ADDED: "Ajouté manuellement",
					DESCRIPTION: "Description",
					NOTIFICATION_NO: "N° notification",
					TYPE: "Type",
					EQUIPMENT: "Équipement",
					PLANNING_GROUP: "Groupe de planification",
					STATUS: "Statut",
					USER_STATUS: "Statut utilisateur",
					CREATED_BY: "Créé par",
					COMPLETED_BY: "Terminé par",
					CREATED_ON: "Créé le",
					COMPLETED_ON: "Terminé le",
					CAUSE: "Cause",
					CAUSE_DESC: "Desc. cause",
					ACTIVITY_GROUP: "Groupe d'activité",
					ACTIVITY_DESC: "Desc. activité",
					SEE_LESS: "Voir moins",
					SEE_MORE: "Voir plus",
					ADDED_WITH_ROOTY: "Ajouté avec {{name}}",
					ADDED_MANUALLY: "Ajouté manuellement",
				},
				PDF: {
					ALERT_REPORT: "Rapport d'alerte",
					HYPOTHESIS: "Hypothèse",
					TITLE_LABEL: "Titre",
					SYSTEM: "Système",
					TYPE: "Type",
					CREATED_ON: "Créé le",
					OWNER: "Propriétaire",
					STATE: "État",
					DUE_DATE: "Date d'échéance",
					STATUS: "Statut",
					WATCHERS: "Observateurs",
					HYPOTHESES_PREFIX: "Hypothèses",
					PAGE: "Page",
					ZOOM: "Zoom :",
					SIZE: "Taille :",
				},
				FEEDBACK: {
					APPROVE_HEADER: "Approuver les hypothèses",
					RELEARN_HEADER: "Réapprendre les hypothèses",
					COMMENT_PLACEHOLDER: "Ajouter vos commentaires ou notes...",
					REVISION_INFO: "Requis pour la révision",
				},
				SNACKBAR: {
					REPORT_QUEUED: "Rapport demandé. Nous enverrons un lien de téléchargement à {{email}} dès qu'il sera prêt.",
					RCA_COMPLETED: "Génération RCA terminée avec succès.",
					RCA_NOTIFY: "Vous serez notifié une fois la génération RCA terminée.",
					RCA_FAILED: "Échec de la génération RCA.",
					REPORT_REQUEST_FAILED: "Impossible de demander le rapport. Veuillez réessayer.",
					REMOVE_WO_ERROR: "Erreur lors de la suppression de l'ordre de travail des preuves.",
					NO_RCA_DATA_AVAILABLE: "Aucune donnée RCA disponible. Veuillez exécuter une RCA pour générer des informations.",
				},
				POPUP: {
					APPROVE_HYPOTHESES: "Approuver les hypothèses",
					APPROVE_CAUSAL: "Approuver l'étape de la chaîne causale",
					APPROVE_RECOMMENDATION: "Approuver la recommandation",
					RELEARN_HYPOTHESES: "Réapprendre les hypothèses",
					RELEARN_CAUSAL: "Réapprendre l'étape de la chaîne causale",
					RELEARN_RECOMMENDATION: "Réapprendre la recommandation",
				},
				DIALOG: {
				ADD_TAG_EVIDENCE: "Ajouter ce tag comme preuve proposée?",
				ADD_DOCS_EVIDENCE: "Ajouter {{count}} document(s) comme preuve proposée?",
				ADD_WOS_EVIDENCE: "Ajouter cet ordre de travail comme preuve?",
				REMOVE_RC_EVIDENCE_DESC: "Supprimer cette preuve de cause racine? Cette action est irréversible.",
					REMOVE_EVIDENCE_TITLE: "Confirmation",
					REMOVE_EVIDENCE_DESC: "Supprimer cette preuve ? Cette action est irréversible.",
					ERROR_TITLE: "Erreur !",
					OK: "OK",
					CONFIRM: "Confirmer",
					CANCEL: "Annuler",
					EVIDENCE_LOCKED: "Les preuves RCA ne peuvent pas être déplacées vers la section des preuves proposées.",
				},
				EVIDENCE_CONTEXT: {
					ADD_TITLE: "Ajouter un contexte pour cette preuve",
					EDIT_TITLE: "Modifier le contexte de cette preuve",
					CLOSE: "Fermer",
					SUBTITLE: "Aidez RCA à comprendre pourquoi cette preuve est pertinente et comment elle doit être utilisée lors de la prochaine exécution.",
					FIELD_LABEL: "Pourquoi cette preuve est-elle pertinente ?",
					FIELD_LABEL_OPTIONAL: "Pourquoi cette preuve est-elle pertinente ? (Facultatif)",
					FIELD_PLACEHOLDER: "Ex. : Cet ordre de travail mentionne une fuite au joint avant l'arrêt de la pompe.",
					FIELD_ERROR: "Veuillez fournir un contexte pour continuer",
					CANCEL: "Annuler",
					UPDATE_CONTEXT: "Mettre à jour le contexte",
					ADD_EVIDENCE: "Ajouter une preuve",
					ABORT_TITLE: "La preuve ne sera pas ajoutée",
					ABORT_DESC: "RCA a besoin d'une courte description pour comprendre comment cette preuve doit être utilisée. Si vous annulez maintenant, cette preuve ne sera pas prise en compte lors de la prochaine exécution de RCA.",
					ABORT_CANCEL: "Annuler l'ajout de la preuve",
					ABORT_GO_BACK: "Retour",
				},
			},
			METRICS2: {
				PENDING_DEFECT: "Défaut en attente",
			},
			METRICS: {
				HEALTH_SCORE: "Score de santé",
				TOTAL_ALERTS: "Total des alertes",
				UNACKNOWLEDGED: "Non reconnu",
				REVIEWING: "En cours de révision",
				PENDING: "En attente",
				UNKNOWN: "Inconnu",
			},
			OVERVIEW: {
				SYSTEM_OVERVIEW: "Aperçu du système",
				SYSTEM_HEALTH_INDICATORS: "Indicateurs de santé du système",
				PRIORITY_ACTIONS: "Actions prioritaires",
				PRIORITY_TOOLTIP: "Ce qui nécessite votre attention maintenant. Alertes d'anomalie non reconnues et en attente - Défaut signalé.",
				NO_PRIORITY_ACTIONS: "Aucune action prioritaire",
				ALL_CAUGHT_UP: "Tout est à jour - rien ne nécessite une attention immédiate ",
				MONITORING_TRACKING: "Surveillance et suivi",
				MONITORING_TOOLTIP: "Éléments de moindre priorité suivis. Alertes d'anomalie avec statut En cours et Sous surveillance.",
				IN_PROCESS: "En cours",
				ON_WATCH: "Sous surveillance",
				RUNNING_STATE: "État de fonctionnement",
				AT_RISK: "À risque",
				REVIEW: "À revoir",
				HEALTHY: "Sain",
				CURRENT: "Actuel",
				THRESHOLD: "Seuil",
				NO_DATA_FOUND: "Aucune donnée trouvée",
				VIEW_ALL: "Tout voir →",
				NO_ALERTS_ARE: "Aucune alerte {{title}}",
				NO_DATA: "Aucune donnée",
			},
			TABLE: {
				HEADERS: {
					STATUS: "Statut",
					ALERT_NAME: "Nom de l'alerte",
					SYSTEM_NAME: "Nom du système",
					TYPE: "Type",
					LOSS: "Perte (kWh)",
					START: "Début",
					STOP: "Arrêt",
					DURATION: "Durée",
					LAST_ACTIVE: "Dernière activité",
					CREATED_ON: "Créé le",
					STATE: "État",
					OWNER: "Propriétaire",
					WATCHERS: "Observateurs",
					FORECAST: "Prévision",
					CATCH: "Capture",
					UPPER_LIMIT: "Limite supérieure",
					VALUE: "Valeur",
					LOWER_LIMIT: "limite inférieure",
					LAST_SYSTEM_UPDATE: "Dernière mise à jour système",
					LAST_USER_UPDATE: "Dernière mise à jour utilisateur",
					DISCUSSION: "Discussion",
					TOTAL_VALUE: "Valeur totale",
					RELIABILITY_SAVING: "Économie de fiabilité",
					MAINTENANCE_SAVING: "Économie de maintenance",
					PERFORMANCE_SAVING: "Économie de performance",
					ALERT_DRIVEN_MAINTENANCE: "Maintenance pilotée par alertes",
				},
				NEW_FAILURE_ADDED: "Nouveau mode de défaillance ajouté",
				TIME_TO_TRIP_DAYS: "Temps avant défaillance {{n}} jours",
				OPEN_IN_NEW_TAB: "Ouvrir dans un nouvel onglet",
				RCA_AVAILABLE: "Analyse des causes profondes disponible",
				ASSIGN_OWNER: "Attribuer un propriétaire",
				ADD_WATCHERS: "Ajouter des observateurs",
				SEARCH_OWNER: "Rechercher un propriétaire...",
				SEARCH_WATCHERS: "Rechercher des observateurs...",
				NO_APPROVED_FM: "Aucun mode de défaillance approuvé trouvé",
				EXTRA_MORE: "+ {{count}} de plus",
				CUSTOMIZE_COLUMNS: "Personnaliser les colonnes",
				BOOKMARK_ALERT: "Ajouter l'alerte aux favoris",
				REMOVE_BOOKMARK: "Retirer le favori",
				VIEW_ONLY_MODE: "Vous êtes en mode lecture seule pour cette installation",
				SYSTEM_TOOLTIP: "Système : {{system}}\nUnité : {{unit}}\nInstallation : {{facility}}",
			},
			UTILS: {
				STATUS: {
					UNACK: "Non reconnu",
					IN_PROCESS: "En cours",
					ON_WATCH: "Sous surveillance",
					PENDING_DEFECT: "En attente - Défaut signalé",
					CLOSED_MAINT_DEFERRED: "Fermé - Maintenance reportée",
					CLOSED_NO_ACTION: "Fermé - Aucune action prévue",
					CLOSED_RESOLVED: "Fermé - Résolu",
					REJECTED: "Rejeté",
				},
				STATE: {
					TENTATIVE: "Provisoire",
					ACTIVE: "Actif",
					RETURNED_TO_NORMAL: "Retour à la normale",
					CLOSED: "Fermé",
					NOISE_DISCARDED: "Bruit/Rejeté",
				},
				TYPE: {
					H_ANOMALY: "Anom. élevée",
					L_ANOMALY: "Anom. faible",
					DATA_QUALITY: "Qualité des données",
					USER_REPORTED: "Signalé par utilisateur",
					THRESHOLD: "Seuil",
					DIAGNOSIS: "Diagnostic",
					DIGITAL: "Numérique",
				},
				SUBTYPE: {
					OUTLIER: "Valeur aberrante",
					OUT_OF_RANGE: "Hors plage",
					FLATLINE: "Ligne plate",
					MISSING: "Manquant",
					UNKNOWN: "Inconnu",
					PAINT_BRUSHING: "Paint Brushing",
				},
				THRESHOLD_ALERT: "Alerte de seuil",
				DATA_QUALITY_ALERT: "Alerte de qualité des données",
				TITLE_TOOLTIP: "Titre : {{title}}",
				TITLE_ID_TOOLTIP: "Titre : {{title}}\nID d'alerte : {{id}}",
				DAYS: "{{n}} jours",
				HOURS: "{{n}} heures",
				DAYS_SHORT: "{{n}}j",
				HOURS_SHORT: "{{n}}h",
				POTENTIAL: "(Potentiel)",
			},
			DOC_PREVIEW: {
				PREVIEW_DOCUMENT: "Aperçu du document",
				CLOSE: "Fermer",
				DOWNLOAD_FILE: "Télécharger le fichier",
			},
			LIST: {
				ALERTS_COUNT: "{{count}} alertes",
				SHOW_MORE_ALERTS: "Afficher {{count}} alertes de plus",
				COLUMN_SAVED: "La vue des colonnes a été enregistrée",
				SOMETHING_WENT_WRONG: "Une erreur est survenue, veuillez réessayer",
				TAKES_FEW_SECONDS: "Cela peut prendre quelques secondes...",
				BULK_RESULT: "{{msg}} pour {{success}} alertes sur {{total}}.",
				STATUS_CLOSED_NO_ACTION: "Statut défini sur Fermé - Aucune action prévue",
				ACTION_UPDATED: "{{action}} mis à jour",
				ACTION_STATUS: "Statut",
				ACTION_BOOKMARK: "Favori",
				ACTION_SUBSCRIBERS: "Abonnés",
			},
			DIALOG: {
				ADD_COMMENT: "Ajouter un commentaire*",
				COMMENT_REQUIRED: "Veuillez ajouter un commentaire pour continuer",
				ADD_A_REASON: "Ajouter une raison",
				SELECTED_FAILURE_MODES: "Modes de défaillance sélectionnés",
				SELECT_ALL: "Tout sélectionner",
				CANCEL: "Annuler",
				CLOSE: "Fermer",
				ADD: "Ajouter",
				OK: "Ok",
				MARK_AS_CATCH: "Marquer comme détecté",
			},
			APPROVE: {
				TITLE: "Approuver le mode de défaillance",
				EDIT_TITLE: "Modifier - Approuver le mode de défaillance",
				RECOMMENDATIONS_FOR: "Recommandations pour {{name}}",
				ADD_RECOMMENDATION_PLACEHOLDER: "Ajouter une recommandation...",
				APPROVE: "Approuver",
				UPDATE: "Mettre à jour",
			},
			RELEARN: {
				TITLE: "Réapprendre le mode de défaillance",
				RELEARN: "Réapprendre",
			},
			BULK_UPDATE: {
				PROCESSING: "Traitement en cours",
				COMPLETED: "Mise à jour groupée terminée !",
				DOWNLOAD_REPORT: "Télécharger le rapport",
				SELECT_DUE_DATE: "Sélectionner la date d'échéance",
				DUE_DATE_HINT: "La date d'échéance est par défaut de 28 jours à compter d'aujourd'hui et peut être ajustée si nécessaire.",
				DUE_DATE_TOOLTIP: "Sélectionnez une date d'échéance pour l'alerte sélectionnée",
				UPDATED_SUCCESSFULLY: "Mis à jour avec succès",
				UPDATE_FAILED: "Échec de la mise à jour",
				SHOWING: "Affichage de {{shown}}/{{total}}",
			},
			SPLIT_MERGE: {
				TITLE: "Diviser/Fusionner le mode de défaillance",
				SUBTITLE: "Déplacez les modes de défaillance approuvés ou non traités vers une nouvelle alerte ou fusionnez-les avec une alerte existante.",
				APPROVED: "Approuvé",
				APPROVED_ON: "Approuvé le {{date}}",
				APPROVED_FAILURE_MODES: "Modes de défaillance approuvés",
				FAILURE_MODES: "Modes de défaillance",
				TAB_CREATE: "Créer une nouvelle alerte",
				TAB_MERGE: "Fusionner avec existante",
				ALERT_TITLE: "Titre de l'alerte",
				SYSTEM: "Système",
				UNIT: "Unité",
				SEVERITY: "Gravité",
				SELECT_SEVERITY: "Sélectionner la gravité",
				OWNER: "Propriétaire",
				CREATED_ON: "Créé le",
				STATUS: "Statut",
				SELECT_TARGET_ALERT: "Sélectionner l'alerte cible",
				SEARCH_PLACEHOLDER: "Rechercher...",
				LOADING: "Chargement...",
				NOT_OWNER_MESSAGE: "Vous n'êtes pas le propriétaire de l'alerte avec un statut « En cours », « Sous surveillance », « Aucune action prévue » ou « Défaut signalé en attente ».",
				PROCESSING_TOOLTIP: "Traitement en cours, veuillez patienter !",
				PROCESSING: "Traitement en cours...",
				SUBMIT_CREATE: "Créer une nouvelle alerte",
				SUBMIT_MERGE: "Fusionner avec l'alerte",
				VIEW_CREATE: "Ouvrir la nouvelle alerte",
				VIEW_MERGE: "Ouvrir l'alerte",
				GO_BACK: "Retour",
				SUCCESS_CREATE: "Nouvelle alerte créée avec succès.",
				SUCCESS_MERGE: "Fusionné avec succès avec l'alerte existante.",
				FAILED_CREATE: "La création de l'alerte a échoué. Veuillez réessayer.",
				FAILED_MERGE: "La fusion de l'alerte a échoué. Veuillez réessayer.",
				PENDING: "Demande en file d'attente. Elle sera traitée une fois le lot de prédiction en cours terminé.",
				CONFLICT: "Une demande de division/fusion est déjà en cours pour cette alerte.",
				CONFLICT_DESTINATION: "Une demande de division/fusion est déjà en cours pour l'alerte de destination.",
				TITLE_PLACEHOLDER_EXAMPLE: 'CESR-C-20250807-IPNK',
				SYSTEM_PLACEHOLDER_EXAMPLE: 'GAS TURBINE TRAIN D',
				UNIT_PLACEHOLDER_EXAMPLE: 'COGEN',
				OWNER_PLACEHOLDER_EXAMPLE: 'Ronald Richards',
				CREATED_ON_PLACEHOLDER_EXAMPLE: '25 août 2025',
			},
			FILTER: {
				FILTER_BY: "Filtrer par",
				SEARCH_BY_ALERT_NAME: "Rechercher par nom d'alerte...",
				CLEAR_SEARCH: "Effacer la recherche",
				STATE: "État",
				ANOMALY: "Anomalie",
				ACTIVE: "Actif",
				RETURNED_TO_NORMAL: "Retour à la normale",
				OTHER_ALERT_TYPES: "Autres types d'alerte",
				CATCH: "Capture",
				TRUE: "Vrai",
				FALSE: "Faux",
				AGENTS: "Agents",
				HAS_RCA: "Avec analyse des causes racines",
				NO_RCA: "Sans analyse des causes racines",
				BOOKMARK_AND_CASES: "Favoris et dossiers",
				ONLY_TRACKED_CASES: "Uniquement les alertes avec dossiers suivis",
				DIAGNOSIS_CONDITIONS: "Conditions de diagnostic",
				TRIP_BREAKDOWN: "Déclenchement/Panne",
				UNDER_PERFORMANCE: "Sous-performance",
				SMB_DOWN: "SMB hors service",
				SMB_UNDER_PERF: "SMB sous-performance",
				CURTAILMENT: "Écrêtage",
				OUT_OF_ENV_SCOPE: "Hors du périmètre environnemental",
				DATA_QUALITY_TYPE: "Type de qualité des données",
				OUTLIER: "Valeur aberrante",
				OUT_OF_RANGE: "Hors plage",
				FLATLINE: "Ligne plate",
				MISSING: "Manquant",
				TAG_STATUS: "Statut du tag",
				TAG_STATUS_INFO: "Applicable uniquement aux alertes DQ",
				USED_IN_MODEL: "Utilisé dans le modèle",
				DROPPED_TAGS: "Tags abandonnés",
				WATCHERS: "Observateurs",
				SEARCH_PLACEHOLDER: "Commencez à taper pour rechercher",
				CLEAR_ALL: "Tout effacer",
			},
			COLUMNS: {
				NUMBER: "Numéro",
				ALERT_NAME: "Nom de l'alerte",
				STATUS: "Statut",
				SYSTEM: "Système",
				TYPE: "Type",
				DATE: "Date",
				CREATED_ON: "Créé le",
				STATE: "État",
				OWNER: "Propriétaire",
				WATCHERS: "Observateurs",
				CATCH: "Capture",
				FORECAST: "Prévision",
				UPPER_LIMIT: "Limite supérieure",
				VALUE: "Valeur",
				LOWER_LIMIT: "Limite inférieure",
				LAST_SYSTEM_UPDATE: "Dernière mise à jour système",
				LAST_USER_UPDATE: "Dernière mise à jour utilisateur",
				TOTAL_VALUE: "Valeur totale",
				RELIABILITY_SAVINGS: "Économies de fiabilité",
				MAINTENANCE_SAVINGS: "Économies de maintenance",
				PERFORMANCE_SAVINGS: "Économies de performance",
				ALERT_DRIVEN_MAINTENANCE: "Maintenance pilotée par alertes",
				DISCUSSION: "Discussion",
				LOSS: "Perte (kWh)",
				START: "Début",
				STOP: "Arrêt",
				DURATION: "Durée",
			},
			NO_ALERTS: {
				TITLE: "Aucune alerte trouvée",
				SUBTITLE: "Modifiez les filtres ou la plage de dates pour voir les résultats",
			},
			COLUMN_CONFIG: {
				SHOW_COLUMNS: "Afficher les colonnes",
				SEARCH_PLACEHOLDER: "Commencez à taper pour rechercher",
				SELECT_ALL: "Tout sélectionner",
				RESET_TO_DEFAULT: "Réinitialiser par défaut",
			},
			PAGE_TITLE: "Alertes",
			OVERVIEW_TAB: "Aperçu",
			SEARCH_PLACEHOLDER: "Rechercher...",
			NO_MATCHING_RESULTS: "Aucun résultat correspondant",
			SEARCH_OWNER_PLACEHOLDER: "Rechercher un propriétaire...",
			SELECT_OWNERS: "Sélectionner les propriétaires",
			ALL_STATUSES: "Tous les statuts",
			STATUS_FILTER: "Filtre de statut",
			CHOOSE_STATUSES: "Choisir les statuts à afficher",
			FILTERS: "Filtres",
			GROUP_BY: "Grouper par",
			MORE: "Plus",
			SELECT_ALERTS_FOR_CASE: "Sélectionnez les alertes que vous souhaitez associer à ce dossier",
			SHOWING_RESULTS_FOR: 'Affichage des résultats pour "{{term}}"',
			CHIP: {
				THRESHOLD: "Seuil",
				HIGH_ANOMALY_SHORT: "Anom. élevée",
				LOW_ANOMALY_SHORT: "Anom. faible",
				DATA_QUALITY: "Qualité des données",
				DIAGNOSIS: "Diagnostic",
			},
			TYPE: {
				THRESHOLD: "Seuil",
				HIGH_ANOMALY: "Anomalie élevée",
				LOW_ANOMALY: "Anomalie faible",
				DATA_QUALITY: "Qualité des données",
				DIAGNOSIS: "Diagnostic",
			},
			AUTO_REFRESH: {
				LABEL: "Actualisation auto",
				OFF: "Désactivé",
				LIVE: "En direct",
				MIN_5: "5 minutes",
				MIN_15: "15 minutes",
				MIN_30: "30 minutes",
				HOUR_1: "1 heure",
			},
			MORE_MENU: {
				EXPORT_DATA: "Exporter les données",
				EXPAND_ALL_GROUPED: "Développer tous les éléments groupés",
				COLLAPSE_ALL_GROUPED: "Réduire tous les éléments groupés",
				EXPAND_ALL_WITHIN_GROUP: "Développer tous les éléments du groupe",
				COLLAPSE_ALL_WITHIN_GROUP: "Réduire tous les éléments du groupe",
				SWITCH_TO_CLASSIC: "Passer à la vue classique",
			},
			TOOLTIP: {
				TYPE_NEW_EVENTS: "{{type}} nouveaux événements",
				TYPE_ALERTS: "{{count}} alertes {{type}}",
				COUNT_NEW_EVENTS: "{{count}} nouveaux événements",
				COUNT_TYPE_NEW_EVENTS: "{{count}} nouveaux événements {{type}}",
				SYSTEM_OPEN_ALERTS: "Système : {{name}}\nAlertes ouvertes : {{count}}",
				UNIT_OPEN_ALERTS: "Unité : {{name}}\nAlertes ouvertes : {{count}}",
				FACILITY_OPEN_ALERTS: "Installation : {{name}}\nAlertes ouvertes : {{count}}",
				EDIT_DISABLED_CLOSED: "Les actions de modification sont désactivées pour les alertes fermées/rejetées.",
			},
		},
		MODEL_WIZARD: {
		NO_CUSTOMER_TAGS_AVAILABLE: 'Aucun tag client disponible',
		MAP_CUSTOMER_TAGS_CONTENT: "Ajoutez ou importez des tags client pour les mapper avec les tags d'actifs.",
		SYSTEM_SUMMARY: {
			TITLE: "Résumé technique du système",
			GENERATE: "Générer le résumé",
			PLACEHOLDER: "Fournissez un résumé technique détaillé du système, ou générez-en un à partir des documents disponibles et des systèmes connectés.",
			HELPER: "Vous pouvez modifier le résumé généré ou en rédiger un manuellement.",
			DRAWER_TITLE: "Générer le résumé technique du système",
			SOURCE_DOCS: "Documents sources",
			SOURCE_DOCS_DESC: "Sélectionnez les documents qui expliquent la conception, le fonctionnement, la logique de contrôle ou le comportement des équipements du système.",
			DOCS_SELECTED: "Documents sélectionnés",
			SELECT_DOCUMENTS: "Sélectionner des documents",
			UPLOAD_TITLE: "Téléverser des documents complémentaires",
			UPLOAD_DESC: "Téléversez des fichiers supplémentaires qui ne sont pas déjà disponibles dans le gestionnaire de documents.",
			UPLOAD_FAILED: "Échec du téléversement",
			VIEW_FILE: "Voir le fichier",
			PROCESSING: "Traitement...",
			COMPLETED: "Terminé",
			FAILED: "Échec",
			DUPLICATE_UPLOAD: "« {{name}} » est déjà ajouté — téléversement en double ignoré.",
			ALREADY_UPLOADED_USED: "« {{name}} » est déjà téléversé et utilisé pour l'entraînement.",
			CONNECTED_SYSTEMS: "Systèmes connectés",
			CONNECTED_DESC: "Ajoutez des systèmes en amont, en aval ou parallèles qui influencent le comportement de ce système.",
			UPSTREAM: "Systèmes en amont",
			SELECT_UPSTREAM: "Sélectionner les systèmes en amont",
			DOWNSTREAM: "Systèmes en aval",
			SELECT_DOWNSTREAM: "Sélectionner les systèmes en aval",
			PARALLEL: "Systèmes parallèles",
			SELECT_PARALLEL: "Sélectionner les systèmes parallèles",
			SEARCH_SYSTEM: "Rechercher un système",
			SEARCH_FACILITY: "Rechercher une installation",
			SEARCH_UNIT: "Rechercher une unité",
			NO_SYSTEMS: "Aucun système trouvé",
			OPTIONAL_META: "Métadonnées système facultatives",
			OPTIONAL_META_DESC: "Des détails facultatifs peuvent améliorer la qualité du résumé technique généré.",
			PRIMARY_COMPONENT: "Composant principal",
			FLUID_MEDIUM: "Fluide / Milieu",
			CRITICAL_CONTROL_NODES: "Nœuds de contrôle critiques",
			AUXILIARY_SYSTEMS: "Systèmes auxiliaires",
			DIAG_UPSTREAM: "Marqueur de diagnostic - Défaillance en amont",
			DIAG_DOWNSTREAM: "Marqueur de diagnostic - Défaillance en aval",
			ADDITIONAL_CONTEXT: "Ajouter un contexte supplémentaire",
			OPTIONAL: "Facultatif",
			DOCUMENTS_COUNT: "documents",
			CONNECTED_COUNT: "systèmes connectés",
			VIEW_SOURCES: "Voir les sources",
			VIEW_SOURCES_DESC: "Documents et systèmes connectés utilisés pour générer cette description.",
			NO_DOCS_USED: "Aucun document n'a été utilisé pour générer cette description.",
			NO_SYSTEMS_USED: "Aucun système connecté n'a été utilisé pour générer cette description.",
			NO_SOURCES: "Aucune source disponible",
			NO_SOURCES_DESC: "Aucun document ni système connecté n'a été utilisé pour générer cette description.",
			REGENERATE: "Régénérer",
			CLICK_TO_EDIT: "Cliquer pour modifier",
			GENERATION_STARTED: "Génération de la description du système… cela peut prendre un moment.",
			ALREADY_IN_PROGRESS: "Une description est déjà en cours de génération pour ce système. Veuillez attendre la fin avant de régénérer.",
			GENERATION_FAILED: "Échec de la génération de la description du système.",
			GENERATION_FAILED_TEXT: "Échec de la génération du système.",
			LAST_UPDATED: "Dernière mise à jour",
			BY: "par",
			DOCUMENTS: "Documents",
			SELECT_DOCS_TITLE: "Sélectionner les documents sources",
			SELECT_DOCS_DESC: "Sélectionnez des documents au niveau de l'installation, de l'unité ou du système qui expliquent la conception, le fonctionnement, la logique de contrôle ou le comportement des équipements du système.",
			DOCUMENT_SCOPE: "Portée du document",
			SCOPE_FACILITY: "Installation",
			SCOPE_UNIT: "Unité",
			SCOPE_SYSTEM: "Système",
			SEARCH_SCOPE_FACILITY: "Rechercher une installation",
			SEARCH_SCOPE_UNIT: "Rechercher une installation, unité",
			SEARCH_SCOPE_SYSTEM: "Rechercher une installation, unité, système",
			SEARCH_SCOPE: "Rechercher une portée",
			NO_SCOPES: "Aucune portée correspondante trouvée. Essayez un autre mot-clé.",
			ALL_TYPES: "Tous les types",
			SEARCH_DOCS: "Rechercher des documents...",
			UPDATED: "Mis à jour",
			NO_DOCS_TITLE: "Aucun document trouvé",
			NO_DOCS_DESC: "Aucun document correspondant n'est disponible. Essayez de modifier les filtres.",
			LOADING_MORE: "Chargement de documents supplémentaires...",
			SELECTED_DOCS: "Documents sélectionnés",
			ADD: "Ajouter",
			DOCUMENTS_WORD: "documents",
			ADD_DOCUMENTS: "Ajouter des documents",
			CANCEL: "Annuler",
			REGENERATE_CONFIRM_TITLE: "Régénérer la description du système ?",
			REGENERATE_CONFIRM_MESSAGE: "La régénération remplacera la description actuelle du système par une nouvelle. Cette action est irréversible.",
		},
			ESCALATION_CONFIG: {
				TITLE: "Configuration de l'escalade",
				DELAY_LABEL: "Délai d'escalade (en jours)",
				LEVEL_LABEL: "Niveau",
				LEVEL_PLACEHOLDER: "Entrez le niveau",
				SELECT_USERS: "Sélectionner des utilisateurs",
				SEARCH_USERS_PLACEHOLDER: "Rechercher par identifiants e-mail",
				NO_MATCHING_EMAIL: "Aucun identifiant e-mail correspondant trouvé",
				EMAILS_LABEL: "Ajouter des identifiants e-mail séparés par des virgules",
				EMAILS_PLACEHOLDER: "abc@gmail.com, def@gmail.com",
				ADD_LEVEL: "+ Ajouter un niveau",
				ADD_LEVEL_TOOLTIP: "Ajouter un niveau",
				REMOVE_TOOLTIP: "Supprimer",
				CONFIG_TYPE_UNIT: "Utiliser la configuration de l'unité",
				CONFIG_TYPE_CUSTOM: "Utiliser une configuration personnalisée",
				CONFIG_TYPE_NONE: "Aucune configuration d'escalade",
			},
			NO_ASSET_TAGS_FOUND: 'Aucune étiquette d’actif disponible',
			NO_MAPPED_TAGS_FOUND: 'Aucune étiquette mappée disponible',
		ASSET_INFORMATION: "Informations sur les actifs",
		NO_ASSET_FOUND: "Aucun actif trouvé",
		EQUIPMENT: "Équipement",
		TEMPLATE: "Modèle",
		APPLICATION: "Application",
		INDUSTRY: "Secteur",
		CONFIGURATION_COL: "Configuration",
		MODEL_CONFIGURATION: "Configuration du modèle",
		MODELING_TECHNIQUE: "Technique de modélisation",
		SCALER: "Mise à l'échelle",
		SMOOTHING: "Lissage",
		SELECT_SMOOTHING_FUNCTION: "Sélectionner la fonction de lissage",
		SMOOTHING_FUNCTION: "Fonction de lissage",
		WINDOW_SIZE: "Taille de fenêtre",
		IN_HOURS: "en heures",
		IN_DAYS: "(en jours)",
		SIGMA: "Sigma",
		POLYNOMIAL_ORDER: "Ordre du polynôme",
		VALUE_REQUIRED: "La valeur est requise",
		VALUE_MIN_1: "La valeur doit être supérieure ou égale à 1",
		NONE: "Aucun",
		ANOMALY_SCORE_CALC_METHOD: "Méthode de calcul du score d'anomalie",
		ANOMALY_CALC_DEFAULT: "Par défaut (RMS de tous les tags)",
		ANOMALY_CALC_NEW: "Nouveau (somme des RMS des tags de l'actif)",
		PREDICTION_TIME_PERIOD: "Période de prédiction",
		TRAINING_TIME_PERIOD: "Période d'entraînement",
		CALENDAR_SELECTION: "Sélection par calendrier",
		CHART_BASED_SELECTION: "Sélection par graphique",
		START_TIME: "Heure de début",
		END_TIME: "Heure de fin",
		START_TIME_REQUIRED: "L'heure de début est requise",
		END_TIME_REQUIRED: "L'heure de fin est requise",
		STARTUP_TRAINING_BUFFER: "Tampon d'entraînement au démarrage",
		SHUTDOWN_TRAINING_BUFFER: "Tampon d'entraînement à l'arrêt",
		TRAINING_BUFFER_GROUP: "Tampon d'entraînement",
		TRAINING_BUFFER_STARTUP_SHORT: "Démarrage (en jours)",
		TRAINING_BUFFER_SHUTDOWN_SHORT: "Arrêt (en jours)",
		TRAINING_CONDITIONS: "Conditions d'entraînement",
		METHOD1_RANGE_FILTER: "Méthode 1 : Filtre de plage",
		METHOD2_CONDITION_FILTER: "Méthode 2 : Filtre de condition",
		LOAD_TAG: "Tag de charge",
		REFERENCE_TAG: "Tag de référence",
		NUM_OF_BINS: "Nombre de classes",
		QUANTILE_CONDITION: "Condition de quantile",
		LESS_THAN: "Inférieur à",
		GREATER_THAN: "Supérieur à",
		EQUAL_TO: "Égal à",
		VALUE: "Valeur",
		TAG: "Tag",
		MIN: "Min",
		MAX: "Max",
		CONDITION: "Condition",
		AND: "Et",
		OR: "Ou",
		ADD: "Ajouter",
		CLOSE: "Fermer",
		ADD_NOTE: "Ajouter une note",
		VIEW_NOTE: "Voir la note",
		VIEW_EDIT_NOTE: "Voir/modifier la note",
		NOTE_FOR_DATE_RANGE: "pour la plage de dates {{range}}",
		ENTER_NOTES: "Saisissez vos notes ici",
		SEARCH_TAGS: "Rechercher des tags...",
		NO_MATCHING_TAGS: "Aucun tag correspondant trouvé",
		SELECT_TRAINING_REGIONS: "Sélectionner automatiquement les régions d'entraînement",
		ADD_TRAINING_RANGE: "Ajouter une plage d'entraînement",
		DELETE_TRAINING_RANGE: "Supprimer la plage d'entraînement",
		NAME: "Nom",
		TAG_ID: "ID du tag",
		UNIT_SETUP: "Configuration de l'unité",
		SCHEMATIC: "Schéma",
		EQUIPMENT_LIST: "Liste des équipements",
		UNITS: 'Unités',
		CAPACITY: 'Capacité',
		SYSTEM_INFORMATION: 'Informations système',
		DESCRIPTION: 'Description',
		CRITICALITY: 'Criticité',
		COMMENTS: 'Commentaires',
		SEARCH: 'Rechercher',
		NO_UNIT_FOUND: 'Aucune unité trouvée',
		NO_SYSTEM_FOUND: 'Aucun système trouvé',
		CUSTOMER: 'Client',
		FACILITY: 'Installation',
		UNIT: 'Unité',
		SYSTEM: 'Système',
		ORIGINAL_AUTHOR: 'Auteur original',
		TRAINING_DATASET: 'Jeu de données d\'entraînement',
		VALIDATION_LOSS: 'Perte de validation',
		LAST_DEPLOYED: 'Dernier déployé',
		ON: 'Activé',
		SELECTED_VERSION: 'Version sélectionnée',
		DEPLOYED_PERIOD: 'Période de déploiement',
		STATUS: 'Statut',
		MARK_AS_IMPORTANT: 'Marquer comme important',
		DISABLE: 'Désactiver',
		DELETE: 'Supprimer',
		DELETE_VERSION_TOOLTIP: 'Supprimer la version',
		TAB_FACILITY_SETUP: 'Configuration de l\'installation',
		TAB_TAG_MAPPING: 'Mappage des balises',
		TAB_DATA_SYNC: 'Synchronisation des données',
		TAB_DATA_IMPORT: 'Importation et traitement des données',
		TAG_MAPPING_REQUIRED_TOOLTIP: 'Le mappage des balises doit être complété, puis cet onglet sera activé.',
		TAB_MODEL_BUILDING: 'Construction du modèle',
		RECALCULATING_TOOLTIP: 'Recalcul en cours',
		CUSTOMER_TAG_LIST: 'Liste des balises client',
		TAGS_BTN: 'Balises',
		MODEL_BUILDING_CONFIG_TOOLTIP: 'Configuration de l\'étape de construction du modèle',
		TAGS_TO_BE_MAPPED: 'Tags à mapper',
		UPLOAD_SYSTEM_TAGS: 'Télécharger les tags système',
		DOWNLOAD_FACILITY_TAGS: 'Télécharger les tags d\'installation',
		ASSETS_PLACEHOLDER: 'ACTIFS',
		SEARCH_IN_ALL_FIELDS: 'Rechercher dans tous les champs',
		COL_NAME: 'Nom',
		COL_DESCRIPTION: 'Description',
		COL_UNIT: 'Unité',
		CUSTOMER_TAGS: 'Tags client',
		UPLOAD_TAGS_TOOLTIP: 'Télécharger les tags',
		DOWNLOAD_TAGS_TOOLTIP: 'Télécharger les tags',
		TAG_MAPPING_NO_ASSET_TOOLTIP: 'Au moins 1 actif doit être créé pour effectuer le mappage des tags',
		MAP_SELECTED: 'Mapper la sélection',
		IMPORT_WO_MAPPING: 'Importer le mappage WO',
		TAGS_MAPPED: 'Tags mappés',
		SAVE_CHANGES: 'Enregistrer les modifications',
		UNMAP_SELECTED: 'Démapper la sélection',
		UNMAPPED_TAGS: 'Tags non mappés',
		COL_TAG_NAME: 'Nom du tag',
		COL_ASSET: 'Actif',
		COL_TAG_ID: 'ID du tag',
		COL_THRESHOLD_HIGH: 'Seuil haut',
		COL_THRESHOLD_LOW: 'Seuil bas',
		COL_TRIP_HIGH: 'Déclenchement haut',
		COL_TRIP_LOW: 'Déclenchement bas',
		COL_ALARM_HIGH: 'Alarme haute',
		COL_ALARM_LOW: 'Alarme basse',
		COL_DIRECTIONALITY: 'Directionnalité',
		COL_FLATLINE_DETECTION: 'Détection de signal plat',
		COL_MISSING_DATA_DETECTION: 'Détection de données manquantes',
		COL_OUTLIER_DETECTION: 'Détection des valeurs aberrantes',
		COL_RANGE_DETECTION: 'Détection hors plage',
		COL_FLATLINE_ALERT_GENERATION: 'Génération d\'alerte de signal plat',
		COL_MISSING_DATA_ALERT_GENERATION: 'Génération d\'alerte de données manquantes',
		COL_OUTLIER_ALERT_GENERATION: 'Génération d\'alerte de valeur aberrante',
		COL_RANGE_ALERT_GENERATION: 'Génération d\'alerte hors plage',
		COL_ATTENTION: 'Attention',
		COL_THRESHOLD_NOTIFICATION: 'Notification de seuil',
		COL_KPI: 'KPI',
		SHOW_COLUMNS_TOOLTIP: 'Afficher les colonnes',
		VIEW_CHANGES_TOOLTIP: 'Voir les modifications',
		EDIT_TAG_TOOLTIP: 'Modifier le tag',
		VIEW_PIDS_TOOLTIP: 'Voir les PIDs',
		IN_PROGRESS: 'En cours',
		CORRECT_RECORDS_MSG: 'Veuillez corriger les enregistrements avec des erreurs et télécharger à nouveau.',
		DOWNLOAD_ERROR_RECORDS: 'Télécharger les enregistrements d\'erreur',
		RELEVANT_INFORMATION: 'Informations pertinentes',
		PIDS_PANEL: 'P&IDs',
		IMAGES_PANEL: 'Images',
		TEST_REPORTS_PANEL: 'Rapports de test',
		PROCEDURES_PANEL: 'Procédures',
		TAG_DATA: 'Données de tag',
		SEARCH_TAG: 'Rechercher un tag',
		SEARCH_ASSET: 'Rechercher un actif',
		EXPORT_DQ_METRICS_TOOLTIP: 'Exporter les métriques DQ',
		EXPORT: 'Exporter',
		TAG_SELECTION_PLACEHOLDER: 'Sélection de tag',
		PREPROCESSING_STATS_PLACEHOLDER: 'Statistiques de prétraitement',
		TAG_MAPPING_PLACEHOLDER: 'Mappage de tag',
		TAG_TYPE_PLACEHOLDER: 'Type de tag',
		OPERATING_REGION_PLACEHOLDER: 'Région d\'exploitation',
		COL_PLOT: 'Graphique',
		COL_CORR: 'Corr.',
		COL_MODEL: 'Modèle',
		COL_TAGS: 'Tags',
		SHUTDOWN_TAG_TOOLTIP: 'Tag d\'arrêt',
		COL_MAX: 'Max',
		COL_MIN: 'Min',
		COL_STD_DEV: 'Écart-type',
		COL_AGGREGATE_TAG: 'Tag agrégé',
		COL_MEAN_SHIFT: 'Décalage de moyenne',
		COL_VARIANCE: 'Variance',
		COL_MEAN: 'Moyenne',
		COL_DEVIATION_SCORE: 'Score de déviation',
		COL_OP_UPPER: 'Op. Supérieur',
		COL_OP_LOWER: 'Op. Inférieur',
		COL_NANS: 'NaNs',
		COL_OUTLIERS: 'Valeurs aberrantes',
		COL_FLATLINE: 'Signal plat',
		COL_OUT_OF_RANGE: 'Hors plage',
		COL_TOTAL_INVALID_DATA: 'Total des données invalides',
		NO_RECORDS_FOUND: 'Aucun enregistrement trouvé',
		NO_DATA_AVAILABLE_SYSTEM: 'Aucune donnée disponible pour le système sélectionné. Extrayez de nouvelles données ou téléchargez',
		CHOOSE_MODEL_VERSION_MSG: 'Choisissez une version de modèle pour afficher les graphiques de tags',
		SELECT_PLOT_CHECKBOX_MSG: 'Cochez la case Graphique d\'un tag pour afficher le graphe',
		TAG_CORRELATION_TITLE: 'Corrélation des tags',
		TAG_CORRELATION_CONDITION_PLACEHOLDER: 'Condition de corrélation des tags',
		CORR_GREATER_THAN_OPTION: 'Afficher les tags avec des corrélations supérieures à',
		CORR_LESS_THAN_OPTION: 'Afficher les tags avec des corrélations inférieures à',
		CORR_VALUE_PLACEHOLDER: 'Valeur de corrélation',
		SELECT_RANGE_LABEL: 'Sélectionner une plage',
		SELECT_RANGE_TOOLTIP: 'Faites glisser sur le graphique pour choisir une plage de dates',
		REMOVE_RANGE_LABEL: 'Supprimer la plage',
		REMOVE_RANGE_TOOLTIP: 'Faites glisser sur le graphique pour exclure une plage de dates de la modélisation',
		SYSTEM_DATA_FILTER_LABEL: 'Filtre de données système',
		SELECTED_DATE_RANGES_LABEL: 'Plage(s) de dates sélectionnée(s) :',
		CONFIRM_SELECTION: 'Confirmer la sélection',
		REMOVED_DATE_RANGES_LABEL: 'Plage(s) de dates supprimée(s) :',
		EDIT_MODEL_TITLE: 'Modifier le modèle',
		FORM_ERROR_MSG: 'Oups ! Modifiez quelques éléments et réessayez.',
		OP_LOWER_PLACEHOLDER: 'Op. Inférieur',
		OP_UPPER_PLACEHOLDER: 'Op. Supérieur',
		REQUIRED: 'Requis',
		CANCEL_CHANGES_TOOLTIP: 'Annuler les modifications',
		CANCEL: 'Annuler',
		SAVE_DATA_TOOLTIP: 'Enregistrer les données',
		SAVE: 'Enregistrer',
		SIMULATION: 'Simulation',
		SHOW_FAILURE_INFO: 'Afficher les infos de défaillance',
		OK: 'Ok',
		RESET_ASSET_SELECTION_TOOLTIP: 'Réinitialiser la sélection d\'actifs',
		CLOSE_CROSSHAIR_TOOLTIP: 'Fermer le réticule',
		CROSSHAIR: 'Réticule',
		LOADING: 'Chargement...',
		NO_FAILURE_MODE_FOUND: 'Aucun mode de défaillance trouvé.',
		MODEL_PARAMETERS_PANEL: 'Paramètres du modèle',
		BOILER_HEALTH_PANEL: 'Santé de la chaudière',
		ALERT_PARAMETERS_PANEL: 'Paramètres d\'alerte',
		FAILURE_PARAMETERS_PANEL: 'Paramètres de défaillance',
		APPLY_SOURCE_VERSION_FEEDBACK: 'Appliquer le retour de version source',
		COMMENT_PLACEHOLDER: 'Commentaire',
		SAVE_MODEL: 'Enregistrer le modèle',
		SAVE_MODEL_TOOLTIP: 'Enregistrer le modèle',
		RESAVE: 'Ré-enregistrer',
		RESAVE_TOOLTIP: 'Ré-enregistrer le modèle',
		DEPLOY_MODEL_TOOLTIP: 'Déployer le modèle',
		DEPLOY_TAG_UNMAPPED_TOOLTIP: `Le déploiement n'est pas autorisé car le modèle {{version}} contient des tag(s) qui ont été dissociés du système`,
		DEPLOY: 'Déployer',
		GO_LIVE_CSV_TOOLTIP: 'Mettre en ligne avec CSV Streaming/Historian',
		GO_LIVE: 'MISE EN LIGNE',
		GO_LIVE_OPTIONS_TITLE: 'Options de mise en ligne',
		DATA_SOURCE_TYPE_PLACEHOLDER: 'Type de source de données',
		HISTORIAN_OPTION: 'Historian',
		START_PREDICTION_FROM: 'Démarrer la prédiction à partir de',
		FROM_DATE_REQUIRED: 'La date de début est',
		GO_LIVE_BTN: 'Mettre en ligne',
		GO_LIVE_TOOLTIP: 'Mettre en ligne',
		THRESHOLD_PLACEHOLDER: 'Seuil',
		AUTOMATIC_OPTION: 'Automatique',
		MANUAL_OPTION: 'Manuel',
		RISK_PROFILE_PLACEHOLDER: 'Profil de risque',
		CREATE_CONDITION: 'Créer une condition',
		RETURN_CONDITION: 'Condition de retour',
		EXCEED_FOR_PLACEHOLDER: 'Dépasser pendant',
		OUT_OF_PLACEHOLDER: 'Sur',
		DOWN_FOR_PLACEHOLDER: 'Descendre pendant',
		ALARM_THRESHOLD_PLACEHOLDER: 'Seuil d\'alarme',
		ADD_TOOLTIP: 'Ajouter',
		GENERATE_ALERT_TOOLTIP: 'Générer une alerte',
		UPDATE: 'Mettre à jour',
		SELECT_DATE_PLACEHOLDER: 'Sélectionner une date',
		DATE_REQUIRED_ERROR: 'La date est',
		HEALTH_PLACEHOLDER: 'Santé',
		REMOVE_TOOLTIP: 'Supprimer',
		GENERATE_BOILER_HEALTH_TOOLTIP: 'Générer la santé de la chaudière',
		ANOMALY_WT_THRESHOLD_PLACEHOLDER: 'Seuil d\'anomalie pondérée',
		LOW_OPTION: 'Faible',
		MEDIUM_OPTION: 'Moyen',
		HIGH_OPTION: 'Élevé',
		CUTOFF_PARTIAL_MATCH: 'Seuil pour correspondance partielle',
		IN_PERCENTAGE_HINT: 'en pourcentage',
		CUTOFF_FULL_MATCH: 'Seuil pour correspondance complète',
		UPDATE_FAILURE_TOOLTIP: 'Mettre à jour la défaillance',
		START_DELAY_PLACEHOLDER: 'Délai de début',
		NO_OF_HOURS_HINT: '(nombre d\'heures)',
		END_DELAY_PLACEHOLDER: 'Délai de fin',
		GROUPING: 'Groupement',
		DOWN_CONDITION_PLACEHOLDER: 'Condition de descente',
		ANOMALY_SCORE_THRESHOLD: 'Seuil de score d\'anomalie',
		FILTER_FAILURE_PLACEHOLDER: 'Filtrer les défaillances',
		VALUE_BETWEEN_0_1: 'Entrez une valeur entre 0 et 1',
		FEEDBACKS: 'Retours',
		LIVE_FEEDBACKS: 'Retours en temps réel',
		PREVIOUS_FEEDBACKS: 'Retours précédents',
		BAND_LEARNING_BEHAVIOUR: 'Comportement d\'apprentissage des bandes',
		CONSERVATIVE: 'Conservateur',
		CONSERVATIVE_TOOLTIP: 'Crée des bandes plus étroites autour de la région d\'entraînement sélectionnée',
		MODERATE: 'Modéré',
		MODERATE_TOOLTIP: 'Crée des bandes équilibrées autour de la région d\'entraînement sélectionnée',
		AGGRESSIVE: 'Agressif',
		AGGRESSIVE_TOOLTIP: 'Crée des bandes plus larges autour de la région d\'entraînement sélectionnée',
		UPDATE_FEEDBACK: 'Mettre à jour le retour',
		UPDATE_PARAMETERS_TOOLTIP: 'Mettre à jour les paramètres',
		DATA_IMPORT_PANEL: 'Importation de données',
		PRE_PROCESSING_PANEL: 'Prétraitement',
		CSV_OPTION: 'CSV',
		UPLOADED_CSV_OPTION: 'CSV téléchargé',
		SELECT_SOURCE_HINT: 'Sélectionner la source pour importer des données',
		SAMPLING_RATE_PLACEHOLDER: 'Taux d\'échantillonnage',
		SAMPLING_RATE_REQUIRED: 'Taux d\'échantillonnage',
		IN_MINUTES_HINT: '(en minutes)',
		SELECT_CSV_FILE_PLACEHOLDER: 'Sélectionner un fichier CSV',
		CSV_FILE_REQUIRED: 'Le fichier CSV est',
		SELECT_FILE_BTN: 'Sélectionner un fichier',
		DATA_SYNC_MORE_DATA_TOOLTIP: 'Pour obtenir plus de données, allez dans l\'onglet Synchronisation des données et faites une demande d\'extraction de données.',
		DATA_SET_NAME_PLACEHOLDER: 'Nom du jeu de données',
		IMPORT_TOOLTIP: 'Importer',
		IMPORT_DATA: 'Importer des données',
		STATE_IDENTIFICATION_PANEL: 'Identification d\'état',
		EXCLUDE_REGION_PANEL: 'Exclure la région',
		PRE_PROCESSING_CONFIG_PANEL: 'Configuration de prétraitement',
		MODEL_TAG_SELECTION_PANEL: 'Sélection de tags du modèle',
		PROCESS_TOOLTIP: 'Traiter',
		PROCESS_DATA: 'Traiter les données',
		SHUTDOWN_TAG_PLACEHOLDER: 'Tag d\'arrêt',
		CONDITION_PLACEHOLDER: 'Condition',
		LESS_THAN_OPTION: 'Inférieur à',
		GREATER_THAN_OPTION: 'Supérieur à',
		EQUAL_TO_OPTION: 'Égal à',
		VALUE_PLACEHOLDER: 'Valeur',
		SHUTDOWN_CONDITION_PLACEHOLDER: 'Condition d\'arrêt',
		AND_OPTION: 'Et',
		OR_OPTION: 'Ou',
		SHUTDOWN_SPAN_PLACEHOLDER: 'Durée d\'arrêt',
		IN_HOURS_HINT: '(en heures)',
		SHUTDOWN_TRANSITION_PLACEHOLDER: 'Transition d\'arrêt',
		STARTUP_TRANSITION_PLACEHOLDER: 'Transition de démarrage',
		EXCLUDE_REGION_TAG_PLACEHOLDER: 'Tag de région exclue',
		EXCLUDE_CONDITION_PLACEHOLDER: 'Condition d\'exclusion',
		OUTLIER_DETECTION_METHOD: 'Méthode de détection des valeurs aberrantes',
		OUTLIER_DETECTION_THRESHOLD: 'Seuil de détection des valeurs aberrantes',
		SIGMA_HINT: 'Sigma',
		INTERPOLATION_METHOD: 'Méthode d\'interpolation',
		INTERPOLATION_CONFIG: 'Configuration d\'interpolation',
		FLATLINE_THRESHOLD_TIME: 'Temps seuil de signal plat',
		FLATLINE_TIME_BASE: 'Base de temps de signal plat',
		HOURS_OPTION: 'Heures',
		MINUTES_OPTION: 'Minutes',
		SECONDS_OPTION: 'Secondes',
		CROSS_CORRELATION: 'Corrélation croisée',
		// pre-processing-configuration-form: row group titles + short field labels
		OUTLIER_DETECTION_GROUP: 'Détection des valeurs aberrantes',
		INTERPOLATION_GROUP: 'Interpolation',
		FLATLINE_GROUP: 'Signal plat',
		LABEL_METHOD: 'Méthode',
		LABEL_THRESHOLD: 'Seuil',
		LABEL_CONFIGURATION: 'Configuration',
		FLATLINE_DETECTION_SHORT: 'Détection',
		FLATLINE_THRESHOLD_TIME_SHORT: 'Temps seuil',
		FLATLINE_TIME_BASE_SHORT: 'Base de temps',
		DATA_DENSITY_THRESHOLD: 'Seuil de densité de données pour la sélection de tags',
		DATA_DENSITY_REQUIRED: 'Le seuil de densité de données est',
		GLOBAL_PREPROCESSING: 'Prétraitement global',
		RANGE_PREPROCESSING: 'Prétraitement de plage',
		DENSITY_HINT: 'Densité',
		REFRESH_TABLE_DATA_TOOLTIP: 'Actualiser les données du tableau',
		LAST_DATA_PULL_LABEL: 'Dernier tirage de données :',
		UPLOAD_CSV_TOOLTIP: 'Télécharger CSV',
		NO_RAW_TAGS_TOOLTIP: 'Il n\'y a pas de tags bruts dans ce système, le fichier ne peut donc pas être téléchargé',
		UPLOAD_BTN: 'Télécharger',
		ANOTHER_PROCESS_RUNNING_TOOLTIP: 'Un autre processus est en cours d\'exécution',
		NO_RAW_TAG_MAPPED_TOOLTIP: 'Aucun tag brut n\'est mappé avec ce système',
		NEW_DATA_PULL_REQUEST: 'Nouvelle demande de tirage de données',
		ADD_NEW_DATA_PULL_TOOLTIP: 'Ajouter une nouvelle demande de tirage de données',
		DELETE_SYSTEM_DATA_TOOLTIP: 'Supprimer les données système',
		STOP_DATA_PULL_TOOLTIP: 'Arrêter le tirage de données',
		COL_SERIAL_NO: 'N°',
		COL_DATA_REQUESTED_FOR: 'Données demandées pour',
		COL_REQUESTED_ON: 'Demandé le',
		COL_ACCESS_METHOD: 'Méthode d\'accès',
		COL_REQUEST_TYPE: 'Type de demande',
		COL_FILE_NAME: 'Nom du fichier',
		COL_PULLED_BY: 'Extrait par',
		COL_DATA_RECEIVED: 'Données reçues',
		COL_ACTIONS: 'Actions',
		DATA_REPULL_TOOLTIP: 'Ré-extraction de données',
		TAG_PULL_REQUEST: 'Demande de tirage de tags',
		COL_VALUE: 'Valeur',
		COL_MISSING: 'Manquant',
		COL_OUTLIER: 'Valeur aberrante',
		TRIP_LIMIT_TOOLTIP: 'Limite de déclenchement',
		TRIP_LABEL: 'Déclenchement',
		ALARM_LIMIT_TOOLTIP: 'Limite d\'alarme',
		ALARM_LABEL: 'Alarme',
		THRESHOLD_LIMIT_TOOLTIP: 'Limite de seuil',
		THRESHOLD_LABEL: 'Seuil',
		INSTRUMENT_RANGE_TOOLTIP: 'Plage d\'instrument',
		INSTRUMENT_LABEL: 'Instrument',
		HIGH_LABEL: 'Élevé :',
		LOW_LABEL: 'Bas :',
		AVG_LABEL: 'Moy. :',
		DATA_PULL_REQUEST: 'Demande de tirage de données',
		SELECT_TAGS_PLACEHOLDER: 'Sélectionner des tags',
		FROM_DATE_PLACEHOLDER: 'Date de début',
		SELECT_FROM_DATE_HINT: 'Date de début',
		TO_DATE_PLACEHOLDER: 'Date de fin',
		TO_DATE_REQUIRED: 'La date de fin est',
		SELECT_TO_DATE_HINT: 'Date de fin',
		PULL_DATA_TOOLTIP: 'Extraire les données',
		PULL_DATA: 'Extraire les données',
		STATUS_PANEL: {
			SUMMARY: 'Résumé',
			TAG_SUMMARY: 'Résumé des tags',
			RECORDS: 'Enregistrements',
			TOTAL_TAGS: 'Total des tags',
			TAGS_IN_MODEL: 'Tags dans le modèle',
			TAGS_MAPPED_TO_FM: 'Tags associés à un mode de défaillance',
			TAGS_WITH_NO_FM: 'Tags sans mode de défaillance',
			PROCESSING_TIME: 'Temps de traitement',
			TRAINING_TIME: 'Temps d\'entraînement',
			TOTAL_TAGS_DROPPED: 'Total des tags exclus',
			ALERTS_GENERATED: 'Alertes générées',
			PRECISION_PREVIOUS: 'Précision précédente',
			PRECISION_CURRENT: 'Précision actuelle',
			PHASE_DATA_IMPORT: 'Import de données',
			PHASE_PREPROCESSING: 'Prétraitement des données',
			PHASE_MODELING: 'Modélisation',
			PHASE_ALERT_FEEDBACK: 'Retour sur les alertes',
			PHASE_READY_TO_DEPLOY: 'Prêt à déployer',
			DROPPED_TAGS: 'Tags exclus',
			CALCULATED_TAGS_DROPPED: 'Tags calculés exclus',
			RAW_TAGS_DROPPED: 'Tags bruts exclus',
			TAGS_DROPPED_PREPROCESSING: 'Exclus au prétraitement',
			TAGS_DROPPED_MANUALLY: 'Exclus manuellement',
			HIGH_DEVIATION_TAGS: 'Tags à forte déviation',
			EXPORT: 'Exporter',
			COL_TAG_NAME: 'Nom du tag',
			COL_TAG_ID: 'ID du tag',
			COL_DESCRIPTION: 'Description',
			COL_UNIT: 'Unité',
			COL_CALCULATED: 'Calculé',
			COL_DROPPED_DUE_TO: 'Exclu en raison de',
			COL_REASON: 'Raison',
			YES: 'Oui',
			NO: 'Non',
			DROPPED_DUE_IMPORT: 'Import',
			DROPPED_DUE_PREPROCESSING: 'Prétraitement',
			DROPPED_DUE_MANUAL: 'Manuel',
			DROPPED_DUE_UNKNOWN: '—',
			NO_TAGS_DROPPED: 'Aucun tag exclu pour le moment',
			NO_HIGH_DEVIATION: 'Exécutez la construction du modèle pour renseigner les tags à forte déviation',
			NO_HIGH_DEVIATION_EMPTY: 'Aucun tag à forte déviation trouvé',

			PHASE_DEPLOYED: 'Déployé',
			DROPPED_DUE_CALCULATED: 'Calculé',
			STEP_STATUS: 'Statut',
			STEP_STATUS_COMPLETED: 'Terminé',
			STEP_PREPROCESSING_TIME: 'Temps de prétraitement',
			STEP_TRAINING_TIME: 'Temps d\'entraînement',
			STEP_PREDICTION_TIME: 'Temps de prédiction',
			STEP_ALERTS_GENERATED: 'Alertes générées',
			STEP_PRECISION_CURRENT: 'Précision actuelle',
			STEP_PRECISION_PREVIOUS: 'Précision précédente',
			REASON_UNSELECTED_FROM_MODEL: 'Désélectionné du modèle',
			REASON_INVALID_DATA: '{{percent}}% de données invalides',
			STEP_SECONDS_VALUE: '{{value}} s',
		},
		UPLOAD_CSV_TITLE: 'Télécharger CSV',
		},
		CASES: {
			WORK_ORDER: {
				CREATE_TITLE: 'Créer une notification d\'ordre de travail',
				CREATE_DESC: 'Créer une notification d\'ordre de travail pour ce cas',
				DESCRIPTION: 'Description',
				DESCRIPTION_PLACEHOLDER: 'Décrivez les travaux à effectuer (obligatoire)',
				DESCRIPTION_REQUIRED: 'La description est obligatoire',
				PRIORITY: 'Priorité',
				DUE_DATE: 'Date d\'échéance',
				ASSIGNED_TO: 'Assigné à',
				ESTIMATED_HOURS: 'Heures estimées',
				HOURS_PLACEHOLDER: 'Saisir les heures',
				CANCEL: 'Annuler',
				CONFIRM: 'Confirmer',
				UNASSIGNED: 'Non assigné',
				CREATED: 'Ordre de travail {{number}} créé',
				CREATED_PLAIN: 'Ordre de travail créé',
				FAILED: 'Impossible de créer l\'ordre de travail',
				CREATE_BUTTON: 'Créer un ordre de travail',
				NONE_YET: 'Aucun ordre de travail pour l\'instant',
				VIEW_TITLE: 'Ordre de travail {{number}}',
				VIEW_SUB: 'Ordre de travail créé à partir de ce cas',
				CREATED_BY: 'Créé par {{name}}',
			},
			TRIAGE: {
				FROM_TRIAGE: 'Cas issu du triage des alertes',
				FROM_TRIAGE_DESC: 'Les alertes de ce cas sont dans le triage des alertes ; ouvrez-les là-bas pour voir leur télémétrie et leurs preuves',
				HIERARCHY: 'Hiérarchie du triage des alertes',
				NO_FLOC: 'Aucun poste technique',
				ALERTS: 'Alertes de triage',
				ADD_ALERTS: 'Ajouter des alertes',
				ADD_ALERTS_TIP: 'Rechercher des alertes de triage et les ajouter à ce cas',
				AUTO_FIND: 'Recherche automatique',
				AUTO_FIND_TIP: 'Alertes regroupées avec celles de ce cas ou sur le même poste technique autour de l\'événement',
				AUTO_FIND_DESC: 'Groupe de lot ou même poste technique dans la fenêtre autour de l\'alerte source',
				EVENT_START: 'Début de l\'événement',
				VIA_SOURCE: 'Source',
				VIA_MANUAL: 'Ajoutée',
				VIA_AUTO: 'Trouvée automatiquement',
				ALERT_MISSING: 'N\'est plus dans la file de triage',
				OPEN_TRIAGE: 'Ouvrir dans le triage des alertes',
				REMOVE_ALERT: 'Retirer du cas',
				SEARCH_PLACEHOLDER: 'Rechercher par ID d\'alerte, tag, nom ou poste technique…',
				SEARCHING: 'Recherche…',
				NO_MATCH: 'Aucune alerte correspondante',
				ADD: 'Ajouter',
				NO_SUGGESTIONS: 'Aucune autre alerte dans cette fenêtre',
				REASON_GROUP: 'Même groupe de lot',
				REASON_FLOC: 'Même poste technique à ±{{hours}} h',
				SELECT_ALL: 'Tout sélectionner',
				ADD_SELECTED: 'Ajouter la sélection ({{count}})',
				EVIDENCE: 'Preuves',
				KIND_FACT: 'Faits',
				KIND_TAG: 'Tags',
				KIND_MAINTENANCE: 'Maintenance',
				KIND_REPORT: 'Rapports',
				KIND_NOTE: 'Notes',
				NO_EVIDENCE: 'Aucune preuve pour l\'instant',
				REMOVE_EVIDENCE: 'Retirer la preuve',
				ADD_EVIDENCE_PLACEHOLDER: 'Ajouter à {{kind}}…',
				BY_AGENT: 'Agent de triage',
				BY_ENGINEER: 'Ingénieur',
				ALERT_REMOVED: 'Alerte retirée du cas',
				ALERTS_ADDED: '{{count}} alerte(s) ajoutée(s)',
				EVIDENCE_ADDED: 'Preuve ajoutée',
				EVIDENCE_REMOVED: 'Preuve retirée',
				ACTION_FAILED: 'L\'action a échoué',
				HIERARCHY_SOURCE: 'Hiérarchie',
				SOURCE_TRIAGE: 'Triage des alertes',
				SOURCE_PLATFORM: 'Systèmes de la plateforme',
				SELECT_FLOC: 'Poste technique',
				ROOT: 'Tout',
				FLOC_SEARCH: 'Rechercher un code ou nom de poste technique…',
				FLOC_REQUIRED: 'Sélectionnez un poste technique',
				NO_CHILDREN: 'Aucun niveau inférieur',
				RELATED_TRIAGE_ALERTS: 'Alertes de triage (facultatif)',
				SELECT_ALERTS: 'Sélectionner des alertes',
			},
			SELECT_STATUS: 'Sélectionner le statut',
			SELECT_CATEGORY: 'Sélectionner la catégorie',
			UNASSIGNED: 'Non assigné',
			UNKNOWN_CREATOR: 'Créateur inconnu',
			ALL_CASES: 'Tous les cas',
			CREATE_CASE: 'Créer un cas',
			CASE_MANAGEMENT: 'Gestion des cas',
			UNKNOWN: 'Inconnu',
			UNCATEGORIZED: 'Non catégorisé',
			TITLE: 'Cas',
			SEARCH_PLACEHOLDER: 'Rechercher...',
			NO_MATCHING_RESULTS: 'Aucun résultat correspondant',
			SEARCH_OWNER_PLACEHOLDER: 'Rechercher un propriétaire...',
			SEARCH_WATCHERS_PLACEHOLDER: 'Rechercher des observateurs...',
			SELECT_OWNERS: 'Sélectionner les propriétaires',
			FILTERS: 'Filtres',
			GROUP_BY: 'Grouper par',
			MORE: 'de plus',
			CASES_COUNT: '{{count}} cas',
			NO_CASES_FOUND: 'Aucun cas disponible',
			SYSTEM_TAGS: 'Tags système',
			CHECK_FILTERS_DATE_RANGE: 'Modifiez les filtres ou la plage de dates pour voir les résultats',
			CHIP: {
				OPEN: 'Ouvert',
				PENDING: 'En attente',
				CLOSED: 'Fermé',
			},
			GROUP_BY_OPTION: {
				NONE: 'Aucun',
				STATUS: 'Statut',
				CATEGORY: 'Catégorie',
				SYSTEM: 'Système',
				OWNER: 'Propriétaire',
				CREATOR: 'Créateur'
			},
			STATUS_OPTION: {
				1: 'Notification au client',
				2: 'Notification au site',
				3: 'Enquête sur site',
				4: 'Maintenance en attente',
				5: 'Maintenance différée',
				6: 'Arrêt en attente',
				7: 'Cas résolu',
				8: 'Aucune action requise'
			},
			CATEGORY_OPTION: {
				1: 'Fiabilité',
				2: 'Processus',
				3: 'Instrumentation',
				4: 'Mécanique',
				5: 'Électrique',
				6: 'Démarrage/Arrêt',
				7: 'Autre'
			},
			COLUMNS: {
				SELECT: 'Sélectionner',
				NUMBER: 'Numéro',
				CASE_ID: 'ID du cas',
				CASE_NAME: 'Nom du cas',
				SYSTEM_NAME: 'Nom du système',
				ALERT_NAME: 'Nom de l\'alerte',
				CATEGORY: 'Catégorie',
				STATUS: 'Statut',
				CATCH: 'Catch',
				SOURCE: 'Source',
				OWNER: 'Propriétaire',
				WATCHERS: 'Observateurs',
				CREATED_BY: 'Créé par',
				CREATED_ON: 'Créé le',
				SYSTEM_ANALYSIS: 'Analyse et interprétation du système',
				DUE_DATE: 'Date d\'échéance',
				ESTIMATED_VALUE: 'Valeur estimée',
				AGREED_VALUE: 'Valeur convenue',
				LAST_MODIFIED: 'Dernière modification',
				RCH: 'Hypothèse de cause racine',
				FEEDBACK_OUTCOME: 'Commentaires et résultat',
				WORK_ORDER: 'Ordre de travail',
				POTENTIAL_IMPACT: 'Impact potentiel',
			},
			MANAGEMENT: {
				FAILURE_MODE: 'Mode de défaillance',
				SELECTED_VIEW: 'Vue sélectionnée',
				USER_PREFERENCE_SETTINGS: 'Paramètres de préférence de l\'utilisateur',
				CASES_LAYOUT: 'Mise en page des cas',
				SIMPLIFIED: 'Simplifié',
				ADVANCED_DEFAULT: 'Avancé (par défaut)',
				LINKED_ALERT_REMOVED: 'Alerte liée supprimée',
				LINKED_ALERT_REMOVED_DESC: 'L\'alerte liée à ce cas n\'est plus disponible',
				LINK_NEW_ALERT: 'Lier une nouvelle alerte',
				DRAG_TO_REORDER: 'Click and drag to reorder',
				NO_TAGS_AVAILABLE_FOR_FM: 'Aucune étiquette disponible pour ce mode de défaillance.',
				NO_TAGS_AVAILABLE_FOR_ALERT: 'Aucune étiquette disponible pour cette alerte.',
				NO_TAGS_ADDED: 'Aucun tag ajouté',
				ADD_TAGS_FROM_DISPLAY_TAGS: 'Utilisez le panneau Afficher les tags à droite pour ajouter des tags à ce cas',
				VIEW_SETTINGS: 'Paramètres d\'affichage',
				DISPLAY_TAGS: 'Afficher les tags',
				ASSET: 'Actif',
				SELECT_STATUS: 'Sélectionner le statut',
				SELECT_CATEGORY: 'Sélectionner la catégorie',
				SEARCH_OWNER: 'Rechercher un propriétaire...',
				SEARCH_WATCHERS: 'Rechercher des observateurs...',
			},
			TOOLTIP: {
				OPEN_IN_NEW_TAB: 'Ouvrir dans un nouvel onglet',
				CUSTOMIZE_COLUMNS: 'Personnaliser les colonnes',
				ONLY_OWNER_CATCH_TOOLTIP: 'Seul le propriétaire du cas peut marquer cela comme un catch',
				ONLY_OWNER_EDIT_TOOLTIP: 'Seul le propriétaire ou le créateur du cas peut modifier cela',
				MARKED_AS_CATCH_TOOLTIP: 'Marqué comme Catch. Ouvrir les détails du cas pour mettre à jour.',
				NOT_MARKED_AS_CATCH_TOOLTIP: 'Non marqué comme Catch. Ouvrir les détails du cas pour modifier cela.',
				OPEN_CASE: '{{count}} cas ouvert',
				OPEN_CASES: '{{count}} cas ouverts',
				PENDING_CASE: '{{count}} cas en attente',
				PENDING_CASES: '{{count}} cas en attente',
				OPEN_TOOLTIP: 'Cas ouverts (comprend) :\nNotification au client\nNotification au site\nEnquête sur site',
				PENDING_TOOLTIP: 'Action en attente (comprend) :\nMaintenance en attente\nMaintenance différée\nArrêt en attente',
				CLOSED_TOOLTIP: 'Cas fermés (comprend) :\nCas résolu\nAucune action requise'
			},
			COMMON_DIALOG: {
				SELECT_ALL: 'Tout sélectionner',
				REPORT_PDF_FILE_NAME: 'Nom du fichier PDF du rapport',
				INCLUDE_EVIDENCE_ATTACHMENTS: 'Inclure les pièces jointes de preuve',
				GENERATING_REPORT_FOR: 'Vous générez un rapport pour {{count}} cas suivis',
				SELECT_FMS_TIMELINE: 'Sélectionnez les modes de défaillance dans la chronologie pour les ajouter au cas.',
				SELECT_FMS_FOR_RECOMMENDATIONS: 'Sélectionner les modes de défaillance pour les recommandations',
				RECOMMENDATIONS_FOR: 'Recommandations pour {{name}}',
				NO_RECS_FOR_FM: 'Aucune recommandation pour ce mode de défaillance.',
				NO_OPEN_FMS: 'Aucun mode de défaillance ouvert.',
				NO_FMS_SELECTED: 'Aucun mode de défaillance sélectionné. Sélectionnez-en un ou plusieurs pour continuer.',
				FMS_SELECTED: '{{count}} mode(s) de défaillance sélectionné(s)',
				SELECT_FMS_TO_CONTINUE: 'Sélectionnez au moins un mode de défaillance pour continuer',
				SELECT_RECS_TO_CONTINUE: 'Sélectionnez au moins une recommandation pour continuer',
				SELECT_ANALYSIS_TO_CONTINUE: 'Sélectionnez au moins une analyse pour continuer',
				SELECT_VIEW_TO_CONTINUE: 'Sélectionnez au moins une vue pour continuer',
				SELECT_ITEM_TO_CONTINUE: 'Sélectionnez au moins un élément pour continuer',
				ADD_SELECTED_RECOMMENDATIONS: 'Ajouter les recommandations sélectionnées',
				ADD_SELECTED_ANALYSIS: 'Ajouter les analyses sélectionnées',
				ADD_SELECTED_VIEWS: 'Ajouter les vues sélectionnées',
				ADD_SELECTED_FAILURE_MODES: 'Ajouter les modes de défaillance sélectionnés',
			},
			FILTER: {
				FILTER_BY: 'Filtrer par',
				SEARCH_PLACEHOLDER: 'Rechercher par nom ou ID...',
				STATUS: 'Statut',
				CATEGORY: 'Catégorie',
				CATCH: 'Catch',
				CREATED_BY: 'Créé par',
				WATCHERS: 'Observateurs',
				CLEAR_ALL: 'Effacer tout'
			},
			DETAILS: {
				CASE_NARRATIVE: 'Description du cas',
				SYSTEM_ANALYSIS: 'Analyse et interprétation du système',
				RCH: 'Hypothèse de cause racine',
				POTENTIAL_IMPACT: 'Impact potentiel',
				PROPOSED_ACTIONS: 'Actions proposées',
				FEEDBACK_OUTCOME: 'Retour d\'information & Résultat',
				WORK_ORDER: 'Ordre de travail',
				MARK_AS_CATCH: 'Marquer comme catch',
				SYSTEM_ANALYSIS_PLACEHOLDER: 'Résumer ce qui a été observé, quand cela a commencé et l\'état de fonctionnement actuel…',
				RCH_PLACEHOLDER: 'Décrire la cause racine suspectée ou confirmée. Associer à des FM ou à des événements si pertinent...',
				TAG_RELATED_FAILURE_MODES: 'Modes de défaillance associés au tag',
				ADD_FAILURE_MODES_TOOLTIP: 'Ajouter des modes de défaillance',
				ADD_FMS: 'Ajouter FM',
				RECOMMENDED_ACTIONS: 'Action(s) recommandée(s)',
				ADD_SELECTED: 'Ajouter sélectionné',
				ADD_SELECTED_RECOMMENDATIONS_TOOLTIP: 'Ajouter les recommandations sélectionnées',
				ADD_RECOMMENDATIONS_TOOLTIP: 'Ajouter des recommandations',
				ADD_MORE: 'Ajouter plus',
				ADD_MORE_RECOMMENDATIONS_TOOLTIP: 'Ajouter plus de recommandations',
				PROPOSED_ACTIONS_PLACEHOLDER: 'Actions proposées, calendriers, risques si non exécutées...',
				POTENTIAL_IMPACT_PLACEHOLDER: 'Décrire l\'impact commercial/opérationnel potentiel (par ex. risque d\'arrêt, perte de qualité, sécurité, coût)...',
				FEEDBACK_OUTCOME_PLACEHOLDER: 'Notes du site, actions mises en œuvre, leçons apprises…',
				WORK_ORDER_PLACEHOLDER: 'ex. WO-2026-001248 (Saisissez le numéro ou la référence de l\'ordre de travail de votre système de maintenance.)',
				CANCEL: 'Annuler',
				SAVE: 'Enregistrer',
				EVIDENCE_ATTACHMENTS: 'Preuves et pièces jointes',
				SAVED_ANALYSIS: 'Analyses enregistrées',
				NO_SAVED_ANALYSIS_AVAILABLE: 'Aucune analyse enregistrée disponible',
				ADD_SAVED_ANALYSIS: 'Ajouter une analyse enregistrée',
				ADD_ANALYSIS: 'Ajouter une analyse',
				LINK_ALERT_TO_ADD_ANALYSIS: 'Associez une alerte liée avec une analyse enregistrée pour l\'ajouter ici',
				SAVED_VIEWS: 'Vues enregistrées',
				ONLY_OWNERS_SAVE_TAG_VIEWS: 'Seul le propriétaire de l\'alerte ou du cas peut enregistrer ou modifier les vues de tags.',
				SAVE_CURRENT_TAG_VIEW: 'Enregistrer la vue actuelle des tags',
				SAVE_CURRENT_VIEW: 'Enregistrer la vue actuelle',
				NO_SAVED_VIEWS_AVAILABLE: 'Aucune vue enregistrée disponible',
				ADD_SAVED_VIEWS: 'Ajouter des vues enregistrées',
				ADD_VIEW: 'Ajouter une vue',
				LINK_ALERT_TO_ADD_VIEWS: 'Associez une alerte liée avec des vues enregistrées pour les ajouter ici',
				TAG_RELATED_ALERTS: 'Alertes associées au tag',
				ADD_ALERTS: 'Ajouter des alertes',
				UPLOAD_EVIDENCES: 'Télécharger des preuves',
				UPLOAD_PLACEHOLDER: 'Joindre, glisser-déposer ou coller des preuves…',
				VALUE_IMPACT: 'Impact de Valeur',
				VALUE_CALCULATION_INPUTS: 'Données de Calcul de Valeur',
				LIKELIHOOD: 'Probabilité (%)',
				IMPACT: 'Impact',
				LIKELIHOOD_IMPACT_MATRIX: 'Matrice de Probabilité et d\'Impact',
				SAVINGS: 'Économies',
				CONTRIBUTION_FACTOR: 'Facteur de Contribution',
				ESTIMATED_VALUE: 'Valeur Estimée (USD)',
				AGREED_VALUE: 'Valeur Convenue (USD)',
				TOTAL_PRODUCTION_LOST: 'Production Totale Perdue (KBOE)',
				TOTAL_FLARING_AVOIDED: 'Torchage Total Évité (MT CO2)',
				PRODUCTIVITY: 'Productivité (Heures)',
				EMISSIONS: 'Émissions (Tonnes)',
				SELECT_VALUE: 'Sélectionner une Valeur',
				ENTER_VALUE: 'Saisir une Valeur',
				EXPORT_AS_PDF: 'Exporter en PDF',
				SAVE_CASE_FIRST: 'Veuillez d\'abord enregistrer le cas',
				GENERATE_PDF: 'Générer le PDF',
				SEND_VIA_EMAIL: 'Envoyer par e-mail',
				SHARE_VIA_EMAIL: 'Partager par e-mail',
				CLEAR_ALL: 'Effacer tout',
				CLEAR_ALL_TOOLTIP: 'Effacer toutes les informations',
				SAVE_TOOLTIP: 'Enregistrer les informations',
				OPTIONAL_FIELD_SAVE_ERROR: "Échec de l'enregistrement des modifications des champs optionnels"
			},
			EMAIL: {
				SEND_VIA_MAIL: 'Envoyer par e-mail',
				RECEIVER_EMAIL_IDS: 'Adresses e-mail des destinataires',
				SEARCH_USER: 'Rechercher un utilisateur',
				SELECT_ENTER_EMAIL_IDS: 'Sélectionner/Saisir les adresses e-mail',
				DONE: 'Terminé',
				SELECT: 'Sélectionner',
				PLEASE_SELECT_RECIPIENTS: 'Veuillez sélectionner les destinataires',
				SUBJECT: 'Objet',
				DEFAULT_SUBJECT: 'Uptime AI : Cas créé',
				ASSET: 'Équipement',
				OWNER: 'Propriétaire',
				CREATED_BY: 'Créé par',
				CREATED_ON: 'Créé le',
				CASE_STATUS: 'Statut du cas',
				CATEGORY: 'Catégorie',
				MODIFIED_ON: 'Modifié le',
				CASE_NAME: 'Nom du cas',
				USERS: 'Utilisateurs',
				CANCEL: 'Annuler',
				SEND_EMAIL: 'Envoyer l\'e-mail',
				PLEASE_SELECT_RECIPIENTS_TOOLTIP: 'Veuillez sélectionner les destinataires',
			},
			NOTIFICATION: {
				FMS_ADDED_SUCCESS: 'Modes de défaillance ajoutés avec succès',
				ANALYSIS_ADDED_SUCCESS: 'Analyses sélectionnées ajoutées avec succès',
				VIEWS_ADDED_SUCCESS: 'Vues sélectionnées ajoutées avec succès',
				FMS_ADDED_SUCCESS_ALT: 'Modes de défaillance sélectionnés ajoutés avec succès',
				ALL_RECOMMENDATIONS_ADDED: 'Toutes les recommandations des modes de défaillance approuvés ont été ajoutées',
				RECOMMENDATIONS_ADDED_SUCCESS: 'Recommandations sélectionnées ajoutées avec succès',
				GENERATING_PDF: 'Génération de votre PDF… Nous vous l\'enverrons par e-mail lorsqu\'il sera prêt.',
				NO_VALID_FILES: 'Aucun fichier valide sélectionné. Seuls les fichiers avec les extensions {{extensions}} sont autorisés',
				UPLOAD_SIZE_LIMIT: 'Le téléchargement de {{name}} a échoué en raison de la limite de taille du fichier.',
				UPLOAD_FAILED: 'Le téléchargement de {{name}} a échoué.',
				FAILED_TO_GENERATE_PDF: 'Échec de la génération du PDF',
				BULK_REPORT_TITLE: 'Génération du rapport de cas agrégé',
				PREPARING_DOWNLOAD: 'Préparation de votre téléchargement. Cela peut prendre un moment.',
				CSV_DOWNLOAD_SUCCESS: 'CSV téléchargé avec succès',
				CSV_DOWNLOAD_FAILED: 'Échec de l\'exportation du CSV',
				SELECT_STATUS_TO_SAVE: 'Veuillez sélectionner le statut du cas pour l\'enregistrer',
				SELECT_CATEGORY_TO_SAVE: 'Veuillez sélectionner la catégorie du cas pour l\'enregistrer',
				CASE_ADDED_SUCCESS: 'Cas ajouté avec succès',
				CASE_UPDATED_SUCCESS: 'Cas mis à jour avec succès',
				ENTER_TITLE_TO_PROCEED: 'Veuillez saisir un titre pour continuer'
			}
		},
		IOW: {
			FACILITY: 'Installation',
			SELECT_FACILITY: 'Sélectionner une installation',
			SEARCH_FACILITY: 'Rechercher une installation...',
			NO_FACILITY_FOUND: 'Aucune installation correspondante',
			UNIT: 'Unité',
			SELECT_UNIT: 'Sélectionner une unité',
			SEARCH_UNIT: 'Rechercher une unité...',
			NO_UNIT_FOUND: 'Aucune unité correspondante',
			SYSTEM: 'Système',
			SELECT_SYSTEM: 'Sélectionner un système',
			SEARCH_SYSTEM: 'Rechercher un système...',
			NO_SYSTEM_FOUND: 'Aucun système correspondant',
			TAGS: 'Tags',
			SELECT_TAGS: 'Sélectionner des tags',
			SEARCH_TAG: 'Rechercher un tag...',
			NO_TAG_FOUND: 'Aucun tag correspondant',
			CASE_STATUS: 'Statut du cas',
			EXCEEDANCE_TYPE: 'Type de dépassement',
			SELECT_EXCEEDANCE_TYPE: 'Sélectionner le type de dépassement',
			SELECT_ALL: 'Tout sélectionner',
			ANALYSE_TOP_TRENDS: 'Analyser les 20 principales tendances',
			SAVE: 'Enregistrer',
			COPY: 'Copier',
			ADD_NEW: 'Ajouter',
			EDIT: 'Modifier',
			DELETE: 'Supprimer',
			DOWNLOAD: 'Télécharger',
			ACTIVE_EXCEEDANCES: 'Dépassements actifs',
			DATE_RANGE_DISABLED_TOOLTIP: "La sélection de plage de dates n'est pas applicable lorsque le filtre de dépassement actif est sélectionné.",
			SELECT_DATE_RANGE: 'Sélectionner une plage de dates',
			ENTER_DATE_RANGE: 'Saisir une plage de dates',
			START_DATE: 'Date de début',
			END_DATE: 'Date de fin',
			APPLY_TIME_CHANGE: "Appliquer le changement de période",
			SUMMARY: 'Résumé',
			SELECT_SYSTEM_MESSAGE: 'Veuillez sélectionner un système pour voir les dépassements.',
			LOADING: 'Chargement...',
			NO_EXCEEDANCE_FOUND: 'Aucun dépassement trouvé.',
			NO_ACTIVE_EXCEEDANCE_FOUND: 'Aucun dépassement actif trouvé.',
			NO_DATA_AVAILABLE: 'Aucune donnée disponible pour la période sélectionnée',
			TRY_SELECTING_DIFFERENT_RANGE: 'Essayez de sélectionner une autre période',
			CRUNCHING_DATA: 'Traitement des données en cours, veuillez patienter !',
			TOTAL_EXCEEDANCES: 'Nombre total de dépassements système',
			GROUP_TRENDS: 'Regrouper les tendances',
			TRENDS_PER_CHART: 'Tendances / graphique (jusqu’à 8)',
			CANCEL: 'Annuler',
			PROCEED: 'Continuer',
			SELECT: 'Sélectionner',
			SELECT_DATE_RANGE_LABEL: 'Sélectionner une plage de dates',
			DATE_RANGE: 'Plage de dates',
			DATE_RANGE_REQUIRED: 'La plage de dates est requise.',
			REGROUP_EXCEEDENCES: 'Regrouper les dépassements',
			DURATION_MINUTES: 'Durée (en min.)',
			DURATION_REQUIRED: 'La durée est requise.',
			ENTER_VALID_NUMBER: 'Veuillez saisir un nombre valide.',
			DOWNLOAD_TITLE: 'Télécharger le rapport IOW',
			GROUP_BY_SYSTEM: 'Grouper par système',
			GROUP_BY_UOM: 'Grouper par unité de mesure',
			GROUP_COUNT_REQUIRED: 'Le nombre de groupes est requis.',
			MIN_VALUE_2: 'La valeur minimale est 2.',
			MAX_VALUE_8: 'La valeur maximale est 8.',
			GROUP_COUNT_INVALID: 'Le nombre de groupes est invalide.',
			WATCHERS: 'Observateurs',
			CLOSE: 'Fermer',
		},
		CAPACITY_OPTIMIZATION: {
			COMMON: {
				SAVE: 'Enregistrer',
				CANCEL: 'Annuler',
				DELETE: 'Supprimer',
				EDIT: 'Modifier',
				CLOSE: 'Fermer',
				LOADING: 'Chargement...',
				SEARCH: 'Rechercher...',
				ACTIONS: 'Actions',
				NAME: 'Nom',
				DESCRIPTION: 'Description',
				STATUS: 'Statut',
				TYPE: 'Type',
				CREATED: 'Créé',
				LAST_UPDATED: 'Dernière mise à jour',
				DOWNLOAD: 'Télécharger',
				UPLOAD: 'Envoyer',
				IMPORT: 'Importer',
				EXPORT: 'Exporter',
				RUN: 'Exécuter',
				STOP: 'Arrêter',
				YES: 'Oui',
				NO: 'Non',
				APPLY: 'Appliquer',
				RESET: 'Réinitialiser',
				CONFIRM: 'Confirmer',
				BACK: 'Retour',
				NEXT: 'Suivant',
			},
			NAV: {
				SCENARIOS: 'Scénarios',
				DASHBOARD: 'Tableau de bord',
				COMPARISON: 'Comparaison',
				SETTINGS: 'Paramètres',
				MODELS: 'Modèles',
				SIMULATION: 'Simulation',
				REALTIME: 'Temps réel',
				TOPOLOGY: 'Topologie',
				STRATEGIC: 'Stratégique',
			},
			LANDING: {
				TITLE: 'Optimisation de la capacité',
				SUBTITLE: 'Optimisez la production d\'énergie et d\'eau à travers votre flotte',
			},
			SCENARIO: {
				TITLE: 'Bibliothèque de scénarios',
				NEW_SCENARIO: 'Nouveau scénario',
				SEARCH_SCENARIO: 'Rechercher un scénario',
				DUPLICATE: 'Dupliquer',
				RUN_OPTIMIZATION: 'Lancer l\'optimisation',
				FORCE_STOP: 'Arrêt forcé',
				VIEW_RESULTS: 'Voir les résultats',
				SCENARIO_NAME: 'Nom du scénario',
				CLASSIFICATION: 'Classification',
				SOLVER: 'Solveur',
				RUN_MODE: 'Mode d\'exécution',
				STATUS_READY: 'Prêt',
				STATUS_RUNNING: 'En cours',
				STATUS_COMPLETED: 'Terminé',
				STATUS_FAILED: 'Échoué',
				PROMOTE: 'Promouvoir',
				ALTERNATIVE_SOLVER: 'Solveur alternatif',
			},
			CONFIG: {
				TITLE: 'Configuration du scénario',
				TABS: {
					AVAILABILITY: 'Disponibilité des actifs',
					DEMAND: 'Prévision de la demande',
					CONSTRAINTS: 'Contraintes',
					SOLVER: 'Solveur & Exécution',
					TESTING: 'Profils de test',
					GROWTH_FACTOR: 'Facteur de croissance',
					SWRO_AVAILABILITY: 'Disponibilité SWRO',
				},
				HORIZON: 'Horizon (h)',
				STEP: 'Pas (min)',
				START_HOUR: 'Heure de début',
				TARGET_DATE: 'Date cible',
				LATITUDE: 'Latitude',
				LONGITUDE: 'Longitude',
				PERF_CURVE: 'Source de la courbe de performance',
				OEM_CURVES: 'Courbes de conception OEM',
				HISTORICAL_ML: 'Données historiques (ML)',
				PLANNING_OFFLINE: 'Planification (hors ligne)',
				LIVE_REALTIME: 'En direct (temps réel)',
				UPLOAD_CSV: 'Envoyer CSV',
				DOWNLOAD_CSV: 'Télécharger CSV',
				POWER_MW: 'Puissance (MW)',
				WATER_MIGD: 'Eau (MIGD)',
				POWER_IMPORT: 'Import d\'énergie',
				POWER_EXPORT: 'Export d\'énergie',
				WATER_IMPORT: 'Import d\'eau',
				WATER_EXPORT: 'Export d\'eau',
				INITIAL_STATUS: 'État initial',
				DURATION_IN_STATE: 'Durée dans l\'état (heures)',
				ON: 'ACTIVÉ',
				OFF: 'DÉSACTIVÉ',
			},
			CONSTRAINTS: {
				TITLE: 'Configuration des contraintes',
				ANCILLARY_SERVICES: 'Services auxiliaires',
				MIN_UP_DOWN_TIME: 'Durée min. marche/arrêt',
				RAMP_LIMITS: 'Limites de montée en charge',
				FIXED_LOADS: 'Charges fixes',
				AGC_DISPATCH: 'Dispatching AGC',
				ALLOW_LOAD_SHEDDING: 'Autoriser le délestage',
				ALLOW_WATER_SHORTAGE: 'Autoriser la pénurie d\'eau',
				ENFORCE_FUEL_LIMITS: 'Appliquer les limites de carburant',
				SPINNING_RESERVE: 'Réserve tournante (MW)',
				OPERATING_RESERVE: 'Réserve opérationnelle (MW)',
				WATER_RESERVE: 'Réserve d\'eau (MIGD)',
			},
			GROWTH_FACTOR: {
				TITLE: 'Configuration du facteur de croissance',
				ADJUSTMENT_TYPE: 'Type d\'ajustement',
				VALUE: 'Valeur du facteur de croissance',
				TARGET_METRIC: 'Métrique cible',
				START_TIME: 'Heure de début',
				END_TIME: 'Heure de fin',
			},
			SWRO: {
				TITLE: 'Configuration de disponibilité SWRO',
				SELECT_PLANTS: 'Sélectionner les installations SWRO',
				FLAT_VALUE: 'Valeur de disponibilité fixe',
			},
			DASHBOARD: {
				TITLE: 'Résultats de l\'optimisation',
				STATION_FILTER: 'Filtre de station',
				ALL_STATIONS: 'Toutes les stations',
				TOTAL_COST: 'Coût total',
				POWER_GENERATION: 'Production d\'énergie',
				WATER_PRODUCTION: 'Production d\'eau',
				FUEL_CONSUMPTION: 'Consommation de carburant',
			},
			COMPARISON: {
				TITLE: 'Comparaison de scénarios',
				SEARCH_SCENARIO: 'Rechercher un scénario',
				BASELINE: 'Référence',
				SELECT_BASELINE: 'Sélectionner la référence',
			},
			SETTINGS: {
				TITLE: 'Paramètres',
				PLATFORM: 'Configuration de la plateforme',
				DATA_MGMT: 'Gestion des données',
				MODULE_CONFIG: 'Configuration du module',
				TAGS: 'Étiquettes',
				TEMPLATES: 'Modèles',
				TOPOLOGY: 'Topologie',
				TRAINING: 'Formation',
				USERS: 'Utilisateurs',
			},
			PLATFORM_SETUP: {
				TITLE: 'Configuration de la plateforme et des installations',
				ENTERPRISE_NAME: 'Nom de l\'entreprise',
				STREET_ADDRESS: 'Adresse',
				CITY: 'Ville',
				STATE: 'État/Région',
				COUNTRY: 'Pays',
				ZIP_CODE: 'Code postal',
				LATITUDE: 'Latitude',
				LONGITUDE: 'Longitude',
				INDUSTRY: 'Secteur',
				TIMEZONE: 'Fuseau horaire',
				BUSINESS: 'Activité',
				NOTES: 'Notes',
				COST_PER_UNIT: 'Coût par unité ($)',
				CAPACITY_PER_HOUR: 'Capacité par heure',
				REVENUE_PER_HOUR: 'Revenus par heure ($)',
				OPERATIONAL_MARGIN: 'Marge opérationnelle (%)',
				TECHNICIAN_SALARY: 'Salaire technicien ($/h)',
				HELPER_SALARY: 'Salaire aide ($/h)',
			},
			USER_MGMT: {
				TITLE: 'Gestion des utilisateurs',
				ADD_USER: 'Ajouter un utilisateur',
				USERNAME: 'Nom d\'utilisateur',
				DISPLAY_NAME: 'Nom affiché',
				PASSWORD: 'Mot de passe',
				ROLE: 'Rôle',
				ADMIN: 'Administrateur',
				SUPER_USER: 'Super utilisateur',
				USER: 'Utilisateur',
				NO_PERMISSION: 'Vous n\'avez pas la permission d\'accéder à cette section.',
			},
			SIMULATION: {
				TITLE: 'Simulation de sensibilité',
				TARGET_EQUIPMENT: 'Équipement cible',
				SWEEP_PARAMETER: 'Paramètre de balayage',
				START_VALUE: 'Valeur de départ',
				END_VALUE: 'Valeur finale',
				STEPS: 'Étapes',
				RUN_SWEEP: 'Lancer le balayage',
			},
			REALTIME: {
				TITLE: 'Tableau de bord temps réel',
				CONFIRMED_TARGET: 'Cible confirmée',
				SELECT_DATE: 'Sélectionner une date',
				SCENARIO_NAME: 'Nom du scénario',
				HORIZON_HOURS: 'Horizon (heures)',
				SOLVER: 'Solveur',
				PERF_CURVE: 'Courbe de performance',
				START_MODE: 'Mode de démarrage',
				RAMP_LIMITS: 'Limites de montée en charge',
				MIN_UP_DOWN: 'Durée min. marche/arrêt',
				ANCILLARY: 'Services auxiliaires',
				IMPORT_SCENARIO: 'Importer depuis un scénario',
			},
			TOPOLOGY: {
				TITLE: 'Topologie SCADA',
				POWER_VIEW: 'Énergie',
				WATER_VIEW: 'Eau',
				AUTO_CORRECT: 'Correction automatique',
				FLEET_OVERVIEW: 'Vue d\'ensemble de la flotte',
			},
			DEMAND: {
				HORIZON: 'Horizon (h)',
				STEP: 'Pas (min)',
				START_HOUR: 'Heure de début',
				UPDATE_PLAN: 'Mettre à jour le plan de demande',
				UPDATE_PLAN_TOOLTIP: 'Rééchantillonner toutes les tables de planification sur la nouvelle grille temporelle, en interpolant les valeurs déjà saisies.',
				UPDATE_PLAN_HINT: 'Paramètres de planification modifiés — cliquez sur Mettre à jour le plan de demande pour rééchantillonner les tables.',
				SOLAR_INPUT: 'Entrée solaire',
				SOLAR_PHASES_ACTIVE: 'phases actives',
			},
			TAG_EXPLORER: {
				TITLE: 'Explorateur de tags',
				SUBTITLE: 'Tracez les valeurs historiques de n’importe quel tag mappé. Les points sont agrégés côté serveur afin qu’une plage étendue reste fluide.',
				TAGS: 'Tags',
				TAGS_PLACEHOLDER: 'Sélectionnez jusqu’à 10 tags',
				TAGS_SEARCH_PLACEHOLDER: 'Rechercher par paramètre ou nom de tag...',
				START_DATE: 'Date de début',
				END_DATE: 'Date de fin',
				PLOT: 'Tracer',
				LOADING_TAGS: 'Chargement de la liste des tags...',
				QUERYING: 'Interrogation des données historiques...',
				NO_DATA_FOR: 'Aucune donnée dans cette plage pour :',
				UNITS_DROPPED: 'Le graphique affiche deux unités à la fois ; les séries en {{units}} n’ont pas été tracées.',
				BUCKET_HINT: 'Agrégé par intervalles de {{bucket}}.',
				COL_PARAMETER: 'Paramètre',
				COL_TAG: 'Tag',
				COL_UNIT: 'Unité',
				COL_POINTS: 'Points',
				COL_MIN: 'Min.',
				COL_MAX: 'Max.',
				COL_AVERAGE: 'Moyenne',
				GROUP_SYSTEM_DEMAND: 'Demande du système',
				GRID_POWER_DEMAND: 'Demande électrique du réseau',
				GRID_WATER_DEMAND: 'Demande en eau du réseau',
				AXIS_TIME: 'Temps',
				AXIS_VALUE: 'Valeur',
				REQUEST_FAILED: 'Échec de la requête ({{status}})',
				SERVER_UNREACHABLE: 'Impossible de joindre le serveur.',
			},
		},
		DISPLAY_TAGS: {
			HEADER: 'Afficher les autres tags',
			CLOSE: 'Fermer',
			SEARCH_PLACEHOLDER: 'Rechercher...',
			FILTER_TOOLTIP: 'Filtrer les tags',
			SELECT_SYSTEM: 'Sélectionner un système',
			ALL_SYSTEMS: 'Tous les systèmes',
			FILTER_BY: 'Filtrer par',
			ALL_TAGS: 'Tous les tags',
			MODELED_TAGS: 'Tags modélisés',
			SHOW_CALCULATED_TAGS: 'Afficher les tags calculés',
			NO_MATCHING_RESULTS: 'Aucun résultat correspondant',
			START_TYPING: 'Commencez à taper pour voir les tags correspondants.',
		},
		PROCESS: {
      LIST_TABLE: {
				NO_CURRENT_BATCHES_TITLE: 'Aucun lot en cours',
				NO_CURRENT_BATCHES_CONTENT: 'Les lots actifs ou en cours d’exécution apparaîtront ici une fois qu’un processus démarre.',
				NO_PAST_BATCHES_TITLE: 'Aucun lot passé',
				NO_PAST_BATCHES_CONTENT: 'Les lots terminés, arrêtés ou en échec apparaîtront ici une fois l’exécution d’un lot terminée.'
			},
			LIST: {
				PAGE_TITLE: 'Processus',
				SEARCH_PLACEHOLDER: 'Rechercher par ID de lot',
				CURRENT_BATCHES_TAB: 'Lots en cours',
				PAST_BATCHES_TAB: 'Lots passés',
				FILTER: {
					SYSTEM: 'Système',
					SEARCH_SYSTEM: 'Rechercher un système',
					CREATED_BETWEEN: 'Créé entre',
					STARTED_ON: 'Démarré le',
					CLEAR_DATE: 'Effacer la date',
					OWNER: 'Responsable',
					SEARCH_OWNER: 'Rechercher un responsable',
				},
			},
			TABLE: {
				COL_BATCH_NAME_ID: 'Nom / ID du lot',
				COL_START_DATE_TIME: 'Date / heure de début',
				COL_END_DATE_TIME: 'Date / heure de fin',
				COL_LAST_UPDATED: 'Dernière mise à jour',
				COL_DURATION: 'Durée',
				COL_RUN_TIME: "Temps d\'exécution",
				COL_STATUS: 'Statut',
				COL_OWNER: 'Responsable',
				COL_WATCHERS: 'Observateurs',
				COL_PERCENT_COMPLETE: 'Pourcentage complété',
				COL_PROJECTED_PRODUCT: 'Produit prévu',
				COL_FINAL_PRODUCT: 'Produit final',
				SELECT_COLUMNS: 'Sélectionner les colonnes',
				SAVE_VIEW: 'Enregistrer la vue',
				APPLY: 'Appliquer',
				LOADING: 'Chargement...',
				NO_RECORDS: 'Aucun enregistrement trouvé',
			},
			DETAILS: {
				TITLE_PREFIX: 'Détails du processus',
				BATCH_NAME: 'Nom du lot',
				FACILITY: 'Installation',
				UNIT: 'Unité',
				SYSTEM: 'Système',
				STATUS: 'Statut',
				START_DATE_TIME: 'Date / heure de début',
				LAST_UPDATED: 'Dernière mise à jour',
				OVERLAY: 'Superposition',
				STACKED: 'Empi lé',
				GRID: 'Grille',
				SELECT_OWNER: 'Sélectionner un responsable',
				WATCHERS_TOOLTIP: 'Observateurs',
				FILTER: {
					LAB_PARAMETERS: 'Paramètres de laboratoire',
					BATCH: 'Lot',
					OTHERS: 'Autres',
					SEARCH_BATCH: 'Rechercher un lot',
				},
				GOLDEN_BATCH_BAND: 'Bande lot doré',
				PREDICTION: 'Prédiction',
			},
		},
		DYNAMIC_DASHBOARD: {
			DASHBOARD_WIZARD: 'Assistant de tableau de bord',
			ADD_NEW_DASHBOARD: 'Ajouter un nouveau tableau de bord',
			CREATE_DASHBOARD: 'Créer un tableau de bord',
			SEARCH: 'Rechercher',
			EDIT_MODE: 'Mode édition',
			SAVE_DASHBOARD: 'Enregistrer le tableau de bord',
			PUBLIC: 'Public',
			PRIVATE: 'Privé',
			SENSOR_DATA: 'Données capteur',
			NON_SENSOR_DATA: 'Données non-capteur',
			ENTER_DATE_RANGE: 'Saisir une plage de dates',
			START_DATE: 'Date de début',
			END_DATE: 'Date de fin',
			APPLY_TIME_CHANGE: 'Appliquer le changement de temps',
			MORE: 'Plus',
			NOTHING_CREATED: "Vous n'avez encore rien créé",
			LOADING: 'Chargement...',
			NO_DATA: 'Aucune donnée disponible pour les attributs sélectionnés',
			CONFIGURE_ATTRIBUTES: 'Configurer les attributs à afficher',
			SELECT_CHART_TYPE: 'Sélectionner le type de graphique',
			CONFIG_ONLY_WIDGET: 'Ce widget est uniquement de configuration. Aucun graphique ne sera affiché.',
			TYPE_OF_CONFIG: 'Type de configuration :',
			GROUP_KEY: 'Clé de groupe :',
			SPECIFICATION_LIMIT: 'Limite de spécification',
			PLEASE_ADD_STATS: 'Veuillez ajouter une carte de statistiques',
			ADD_ATTRIBUTES: 'Ajouter des attributs à afficher',
			PROCESSING_DATA: 'Traitement des données en cours, veuillez patienter...',
			EDIT: 'Modifier',
			DUPLICATE: 'Dupliquer',
			REMOVE: 'Supprimer',
			CANCEL: 'Annuler',
			SAVE: 'Enregistrer',
			BACK: 'Retour',
			PERFORMANCE_CURVE_OF: 'Courbe de performance de',
			NO_WIDGETS_AVAILABLE: 'Aucun widget disponible. Ajoutez un widget pour commencer',
			TAB_EMPTY_STATES: {
				ALL: {
					HEADING: 'Aucun tableau de bord pour le moment',
					CONTENT: 'Créez votre premier tableau de bord pour suivre les indicateurs clés, les tendances et les insights en un seul endroit.',
				},
				MY_DASHBOARD: {
					HEADING: 'Aucun tableau de bord créé par vous',
					CONTENT: 'Les tableaux de bord que vous créez apparaîtront ici.',
				},
				SHARED: {
					HEADING: 'Aucun tableau de bord partagé pour le moment',
					CONTENT: 'Les tableaux de bord partagés avec vous par d\'autres apparaîtront ici.',
				},
				PRIVATE: {
					HEADING: 'Aucun tableau de bord privé pour le moment',
					CONTENT: 'Les tableaux de bord que vous créez et gardez privés apparaîtront ici.',
				},
				SEARCH: {
					HEADING: 'Aucun tableau de bord trouvé',
					CONTENT: 'Essayez un autre mot-clé ou effacez la recherche.',
				},
			},
			SLICER_POPUP: {
				SELECT_ALL: 'Select All',
				PREVIEW: 'Preview',
				APPLY_AND_CLOSE: 'Apply & Close',
				APPLYING: 'Applying...',
      		},
			COLLABORATOR: {
				TITLE_SUFFIX: 'Collaborateurs',
				SEARCH_PLACEHOLDER: 'Rechercher par nom ou e-mail',
				COLLABORATED_WITH: 'Collaboré avec',
				USERS: 'utilisateurs',
				ALL_USERS: 'Tous les utilisateurs',
				OWNER: 'Propriétaire',
				CANCEL: 'Annuler',
				SAVE: 'Enregistrer',
				CANCEL_CHANGES: 'Annuler les modifications',
				SAVE_CHANGES: 'Enregistrer les modifications',
				ROLE: {
					FULL: 'Complet',
					FULL_DESC: 'Accès complet',
					EDIT: 'Modifier',
					EDIT_DESC: 'Accès en lecture et modification',
					VIEW: 'Afficher',
					VIEW_DESC: 'Accès en lecture seule',
				},
			},
			EDIT_PANEL: {
				CREATE_PANEL: 'Créer un panneau',
				EDIT_PANEL: 'Modifier le panneau',
				CANCEL: 'Annuler',
				SAVE: 'Enregistrer',
				SELECT_CHART_TYPE: 'Type de graphique',
				ADD_TITLE: 'Titre',
				PANEL_NAME: 'Nom du panneau',
				ADDITIONAL_GRAPH_OPTIONS: 'Options de graphique supplémentaires',
				SETTINGS: 'Paramètres',
			},
			DASHBOARD_POPUP: {
				TITLE: 'Tableau de bord',
				SELECT_TYPE: 'Sélectionner le type de tableau de bord',
				TYPE_DASHBOARD: 'Tableau de bord',
				TYPE_CONFIG: 'Configuration',
				TYPE_PERFORMANCE_CURVES: 'Courbes de performance',
				NAME: 'Nom',
				NAME_TAKEN: 'Ce nom est déjà utilisé',
				NAME_REQUIRED: 'Le nom est obligatoire',
				LEVEL: 'Niveau',
				SELECT_LEVEL: 'Sélectionner le niveau',
				FACILITY: 'Installation',
				SELECT_FACILITY: 'Sélectionner une installation',
				FACILITY_REQUIRED: "L'installation est obligatoire",
				UNIT: 'Unité',
				SELECT_UNIT: 'Sélectionner une unité',
				UNIT_REQUIRED: "L'unité est obligatoire",
				CANCEL: 'Annuler',
				SAVE: 'Enregistrer',
			},
			TAG_PANEL: {
				ENABLE_QUICK_PLOT: 'Activer le tracé rapide',
				SELECT_UNITS: 'Sélectionner des unités',
				SEARCH_UNIT: 'Rechercher une unité...',
				NO_UNIT_FOUND: 'Aucune unité correspondante trouvée',
				SELECT_SYSTEMS: 'Sélectionner des systèmes',
				SEARCH_SYSTEM: 'Rechercher un système...',
				NO_SYSTEM_FOUND: 'Aucun système correspondant trouvé',
				ADD: 'Ajouter',
				PREVIEW: 'Aperçu',
				PREVIEW_CHART: 'Aperçu du graphique',
				DRAG_AND_DROP: 'Glisser-déposer',
				COPY: 'Copier',
				DELETE: 'Supprimer',
				EDIT: 'Modifier',
				LABEL: 'Libellé',
				TAG: 'Balise',
				X_TAG: 'Balise X',
				Y_TAG: 'Balise Y',
				Z_TAG: 'Balise Z',
				SEARCH_TAG: 'Rechercher une balise...',
				NO_TAG_FOUND: 'Aucune balise correspondante trouvée',
				DESIGN_VALUE_TAG: 'Balise de valeur de conception',
				CALC_TYPE: 'Type de calcul',
				CALC_ORIGINAL: 'Original',
				CALC_AVERAGE: 'Moyenne',
				CALC_MOVING_AVG: 'Moyenne mobile',
				CALC_MAX: 'Maximum',
				CALC_MIN: 'Minimum',
				CALC_SUM: 'Somme',
				CALC_MEDIAN: 'Médiane',
				CALC_MOVING_DELTA: 'Delta mobile',
				CALC_COUNT_EVENT: 'Compter les événements',
				AGGREGATE: 'Agréger',
				AGGREGATE_WINDOW: "Fenêtre d'agrégation",
				COUNT_WINDOW: 'Fenêtre de comptage',
				AGGREGATE_WINDOW_UNIT: "Unité de fenêtre d'agrégation",
				COUNT_WINDOW_UNIT: 'Unité de fenêtre de comptage',
				WINDOW_SIZE: 'Taille de la fenêtre',
				MINUTES: 'Minute(s)',
				HOURS: 'Heure(s)',
				DAYS: 'Jour(s)',
				WEEKS: 'Semaine(s)',
				GREATER_THAN: 'Supérieur à',
				LESS_THAN: 'Inférieur à',
				EQUAL_TO: 'Égal à',
				RESET_FILTER: 'Réinitialiser le filtre',
				SELECT_AXIS: 'Sélectionner un axe',
				X_AXIS: 'Axe X',
				Y_AXIS: 'Axe Y',
				SPEC_LABEL: 'Libellé (max. 6 caractères)',
				DESCRIPTION: 'Description',
				VALUE: 'Valeur',
				ENABLE_TREND_CHART: 'Activer le graphique de tendance',
				ADD_TITLE: 'Ajouter un titre',
				ADD_SUBTITLE: 'Ajouter un sous-titre',
				UNIT: 'Unité',
				SELECT_ICON: 'Sélectionner une icône',
				SEARCH_ICONS: 'Rechercher des icônes...',
				FORMULA: 'Formule',
				FORMULA_PLACEHOLDER: 'Saisir la formule, ex. (A+B)*C',
				ERROR_INVALID_VARS: 'Variable(s) invalide(s) utilisée(s)',
				ERROR_INVALID_SYNTAX: 'Expression mathématique invalide',
				ERROR_FORMULA_REQUIRED: 'La formule est obligatoire',
				ERROR_LESS_THAN_THRESHOLD: "Cette valeur doit être inférieure au seuil 'Inférieur à'.",
				ERROR_GREATER_THAN_THRESHOLD: "Cette valeur doit être supérieure au seuil 'Supérieur à'.",
				SELECT_CHILDREN: 'Sélectionner des enfants',
				AT_LEAST_ONE: 'Au moins 1 option doit être sélectionnée',
				TITLE_REQUIRED: 'Le titre est obligatoire',
				TITLE_DUPLICATE: 'Ce titre est déjà utilisé pour une autre formule',
				ADD_A_TITLE: 'Ajouter un titre',
				DELETE_BUTTON: 'Supprimer',
			},
			SENSOR_TABLE_CONFIG: {
				ADD_ROW: 'Ajouter une ligne',
				ADD_COLUMN: 'Ajouter une colonne',
				COLUMN_NAME: 'Nom de la colonne',
				DELETE_COLUMN: 'Supprimer la colonne',
				DATE_FILTER: 'Filtre de date',
				ROWS: 'Lignes',
				NUMBER_OF_ROWS: 'Nombre de lignes',
				SELECT_TAG: 'Sélectionner une balise',
				CONFIGURE_TAG: 'Configurer la balise',
				DELETE_ROW: 'Supprimer la ligne',
				APPLY_DATE_FILTERS: 'Appliquer des filtres de date aux colonnes',
				NONE: 'Aucun',
				SELECT_FY_START: "Sélectionner le 1er jour de l'exercice fiscal",
				CANCEL: 'Annuler',
				APPLY: 'Appliquer',
				SEARCH_TAG: 'Rechercher une balise...',
				NO_TAG_FOUND: 'Aucune balise correspondante trouvée',
				GREATER_THAN: 'Supérieur à',
				LESS_THAN: 'Inférieur à',
				EQUAL_TO: 'Égal à',
				LESS_GREATER_ERROR: "La valeur 'Inférieur à' doit être supérieure à la valeur 'Supérieur à'.",
				IGNORE_NULLS: 'Ignorer les valeurs nulles',
				AGGREGATION: 'Agrégation',
				DEFINE_COLOR: 'Définir la valeur de balise pour la couleur du texte',
				LESSER_THAN: 'Inférieur à',
				PICK_COLOR: 'Choisir une couleur',
				COLOR: 'Couleur',
				LESSER_THAN_ERROR: 'La valeur doit être inférieure à la valeur supérieure définie.',
				GREATER_THAN_ERROR: 'La valeur doit être supérieure à la valeur inférieure définie.',
				BETWEEN: 'Entre',
				AND: 'Et',
				BETWEEN_RANGE_ERROR: 'Saisissez une plage valide — la valeur inférieure doit être inférieure à la supérieure.',
			},
			RECENT: 'Récent',
			FAVOURITES: 'Favoris',
			CREATED_BY_ME: 'Créé par moi',
			TAB_ALL: 'Tous',
			TAB_MY_DASHBOARD: 'Mon tableau de bord',
			TAB_SHARED: 'Partagé',
			TAB_PRIVATE: 'Privé',
			ALL_DASHBOARDS: 'Tous les tableaux de bord',
			MY_DASHBOARDS: 'Mes tableaux de bord',
			SHARED_DASHBOARDS: 'Tableaux de bord partagés',
			PRIVATE_DASHBOARDS: 'Tableaux de bord privés',
			COL_NAME: 'Nom',
			COL_CREATED_ON: 'Créé le',
			COL_UPDATED_ON: 'Mis à jour le',
			COL_OWNED_BY: 'Propriétaire',
			COL_SHARED: 'Partagé',
			COPY_LINK: 'Copier le lien',
			RENAME: 'Renommer',
			OPEN_IN_NEW_TAB: 'Ouvrir dans un nouvel onglet',
			SELECT: 'Sélectionner',
			SELECT_PERFORMANCE_CURVE: 'Sélectionner la courbe de performance',
			MENU_EDIT_DASHBOARD: 'Modifier le tableau de bord',
			MENU_COPY_DASHBOARD: 'Copier le tableau de bord',
			MENU_PUBLISH: 'Publier',
			MENU_UNPUBLISH: 'Dépublier',
			MENU_DELETE_DASHBOARD: 'Supprimer le tableau de bord',
			MONGO: {
				SELECT_GRAPH_FIRST: '*Sélectionner d\'abord le type de graphique',
				LABEL_USED: 'Étiquette déjà utilisée',
				REQUIRED: '*Obligatoire',
				DEFINE_RELATION: 'Définir la relation',
				INVALID_VARIABLE: 'Variable invalide dans la formule.',
				INVALID_RELATION: 'Relation invalide avec la source.',
				INVALID_FORMULA_SYNTAX: 'Syntaxe de formule invalide.',
				SOURCE: 'Source',
				ATTRIBUTE: 'Attribut',
				DISPLAY_ATTRIBUTE: 'Afficher l\'attribut',
				GROUP_BY_ATTR: 'Grouper par',
				AGGREGATION: 'Agrégation',
				OPEN_FILTERS: 'Ouvrir les filtres',
				REMOVE_COLUMN: 'Supprimer la colonne',
				ADD_ATTRIBUTE: 'Ajouter un attribut',
				RAW_ATTRIBUTE: 'Attribut brut',
				CALC_ATTRIBUTE: 'Attribut calculé',
				ADD_RAW_ATTRIBUTE_COL: 'Ajouter une colonne d\'attribut brut',
				ADD_CALC_ATTRIBUTE_COL: 'Ajouter une colonne d\'attribut calculé',
				GROUP_BY: 'Grouper par',
				GROUP_DISPLAY_TYPE: 'Type d\'affichage de groupe',
				SORT_BY: 'Trier par',
				SORT_ASC: 'A → Z',
				SORT_DESC: 'Z → A',
				SIDE_BY: 'Côte à côte',
				NA: 'N/A',
				STACK_BY: 'Empiler par',
				NO_OF_BINS: 'Nombre de bacs',
				SLICERS: 'Segments (sélectionner jusqu\'à {{limit}})',
				SELECT_UP_TO: 'Sélectionner jusqu\'à',
				DRILL_DOWN: 'Exploration',
				DRILL_DOWN_ATTRS: 'Attributs pour l\'exploration (sélectionner jusqu\'à {{limit}})',
				SELECT_ATTRS: 'Sélectionner des attributs',
			},
			TAG_AGG: {
				SELECT_TAG: 'Sélectionner une étiquette',
				SELECT_AGGREGATE_TYPE: 'Sélectionner le type d\'agrégation',
				ENABLE_AGGREGATE: 'Activer l\'agrégation',
			},
			SIDE_PANEL: {
				SETTINGS: 'Paramètres',
				SAVE: 'Enregistrer',
				CLOSE: 'Fermer',
				PANEL: 'Panneau',
				AXIS: 'Axe',
				GRAPH_OPTIONS: 'Options du graphique',
				SELECT_CONFIG_TYPE: 'Sélectionner le type de configuration',
				EXCEL_CONFIG: 'Configuration Excel',
				TAG_GROUP: 'Groupe d\'étiquettes',
				PANEL_DESCRIPTION: 'Description du panneau',
				X_AXIS_MIN: 'Min axe X',
				X_AXIS_MAX: 'Max axe X',
				X_AXIS_UNIT: 'Unité axe X',
				Y_AXIS_UNIT: 'Unité axe Y',
				SHOW_LEGEND: 'Afficher la légende',
				OVERLAP_LEGENDS: 'Superposer les légendes',
				TABLE_MODE: 'Mode tableau',
				TITLE_COLOR: 'Couleur du titre',
				BORDER_COLOR: 'Couleur de la bordure',
				TREND_CHART_COLOR: 'Couleur du graphique de tendance',
				UPLOAD: 'Téléverser',
				DOWNLOAD: 'Télécharger',
				UPLOAD_BASE_CURVE: 'Téléverser la courbe de base',
				BASE_CURVE_FORMAT: 'Format de la courbe de base',
				DELETE_CURVE_GRAPH: 'Supprimer le graphique de courbe',
			},
			SINGLE_STATS: {
				ADD_STAT: 'Ajouter une statistique',
				COLOR_PICKER: 'Sélecteur de couleur',
				COLOR_TITLE: 'Titre',
				COLOR_BORDER: 'Bordure',
				COLOR_ICON: 'Icône',
				COLOR_ICON_OUTLINE: 'Contour d\'icône',
				NO_ICON_FOUND: 'Aucune icône correspondante trouvée',
			},
		},
		SCHEDULER: {
			LIST: {
				TITLE: 'Liste des planifications',
				HEADER_TITLE: 'Planificateur de rapports',
				NEW_SCHEDULER_TOOLTIP: 'Créer une nouvelle planification',
				NEW_SCHEDULER: 'Nouvelle planification',
				COL_TITLE: 'Titre',
				COL_MEDIUM: 'Moyen',
				COL_SUBJECT: 'Objet',
				COL_RUNS: 'Exécutions',
				COL_MODIFIED_ON: 'Modifié le',
				COL_CREATED_ON: 'Créé le',
				COL_ACTIONS: 'Actions',
				EDIT_TOOLTIP: 'Modifier la planification',
				DELETE_TOOLTIP: 'Supprimer la planification',
				MEDIUM_EMAIL: 'E-mail',
				MEDIUM_SMS: 'SMS',
				MEDIUM_CALL: 'Appel',
				SCHEDULER_DELETED: 'Planification supprimée',
				DELETE_FAILED: 'Échec de la suppression',
				OKAY: 'Ok',
				NO_REPORT: 'Aucun rapport trouvé'
			},
			DETAILS: {
				TITLE: 'Planification',
				CREATE_TITLE: 'Créer une planification',
				EDIT_DETAILS_TITLE: 'Modifier les détails',
				SCHEDULE_DETAILS_TITLE: 'Détails de la planification',
				CANCEL: 'Annuler',
				SAVE: 'Enregistrer',
				SELECT_FACILITY: 'Sélectionner un site',
				LOADING: 'Chargement...',
				SCHEDULE_RECURRING_REPORTS: 'Planifier des rapports récurrents',
				MONTHS: 'Mois',
				ALL: 'Tous',
				DAY: 'Jour',
				EVERY: 'Tous les',
				TH_DAY: 'e jour',
				WEEKDAYS: 'Jours de la semaine',
				TIME: 'Heure',
				SELECT_TIME: 'Sélectionner l\'heure',
				HOUR: 'Heure',
				MINUTE: 'Minute',
				FILE_NAME_LABEL: 'Nom du fichier',
				REPORT_NAME_LABEL: 'Nom du rapport',
				ENTER_NAME: 'Saisir le nom',
				REPORT_TITLE: 'Titre du rapport (20 caractères max.)',
				ENTER_TITLE: 'Saisir le titre',
				REPORTING_INTERVAL: 'Intervalle de rapport',
				MEDIUM: 'Moyen',
				TEMPLATE_NAME: 'Nom du modèle',
				SUBJECT: 'Objet',
				ENTER_SUBJECT: 'Saisir l\'objet',
				SELECT_USERS: 'Sélectionner des utilisateurs',
				SEARCH_BY_EMAIL: 'Rechercher par adresses e-mail',
				NO_MATCHING_EMAIL: 'Aucune adresse e-mail correspondante trouvée',
				ADD_EMAILS_LABEL: 'Ajouter des adresses e-mail séparées par des virgules',
				OKAY: 'Ok',
				SELECT_AT_LEAST_ONE_UNIT: 'Sélectionnez au moins une unité',
				SELECT_AT_LEAST_ONE_SYSTEM: 'Sélectionnez au moins un système',
				SELECT_USER_OR_EMAIL: 'Sélectionnez au moins un utilisateur ou ajoutez une/des adresse(s) e-mail',
				INVALID_EMAILS: 'Adresse(s) e-mail invalide(s) saisie(s)',
			},
			TEMPLATES: {
				DAILY_REPORT: 'Rapport quotidien',
				BIWEEKLY_REPORT: 'Rapport bihebdomadaire',
				KPI_REPORT_THERMAL: 'Rapport KPI - Thermique',
				ALERT_STATUS_UPDATE_REPORT: 'Rapport de mise à jour du statut des alertes',
				DATA_QUALITY_REPORT: 'Rapport de qualité des données',
				DATA_LAG_REPORT: 'Rapport de latence des données',
				IOW_REPORT: 'Rapport IOW',
				SERVER_EXCEPTION_REPORT: 'Rapport des exceptions serveur',
			},
			REPORTING_INTERVALS: {
				LAST_8_HOURS: 'Dernières 8 heures',
				LAST_12_HOURS: 'Dernières 12 heures',
				LAST_24_HOURS: 'Dernières 24 heures',
				TODAY: 'Aujourd\'hui',
				YESTERDAY: 'Hier',
				LAST_7_DAYS: 'Derniers 7 jours',
				THIS_WEEK: 'Cette semaine',
				PREVIOUS_WEEK: 'Semaine précédente',
				LAST_15_DAYS: 'Derniers 15 jours',
				LAST_30_DAYS: 'Derniers 30 jours',
				THIS_MONTH: 'Ce mois-ci',
				PREVIOUS_MONTH: 'Mois précédent',
				THIS_QUARTER: 'Ce trimestre',
				PREVIOUS_QUARTER: 'Trimestre précédent',
				LAST_3_MONTHS: 'Derniers 3 mois',
				LAST_6_MONTHS: 'Derniers 6 mois',
				LAST_12_MONTHS: 'Derniers 12 mois',
				THIS_YEAR: 'Cette année',
				PREVIOUS_YEAR: 'Année précédente',
			},
		},
		ANALYSIS_VIEWS: {
			UNABLE_TO_CREATE_ANALYSIS_TEMPLATE: 'Impossible de créer un modèle d\'analyse à partir de plusieurs installations',
			TITLE: 'Analyse et vues',
			CLOSE: 'Fermer',
			EXPORT_TO_EXTERNAL: 'Exporter les tags sélectionnés vers un système externe',
			SAVED_ANALYSIS: 'Analyse enregistrée',
			CREATE_NEW: 'Créer nouveau',
			SAVED_VIEWS: 'Vues enregistrées',
			SAVE_CURRENT_VIEW: 'Enregistrer la vue actuelle',
			SAVE_DISABLED_TOOLTIP: 'Seul le propriétaire de l\'alerte peut enregistrer ou modifier les vues de tags.',
			TEMPLATE_TAG: '[Modèle]',
			SNAPSHOT_TAG: '[Instantané]',
			EDIT: 'Modifier',
			DELETE: 'Supprimer',
			SAVED_DASHBOARDS: 'Tableaux de bord enregistrés',
			NO_DASHBOARDS: 'Aucun tableau de bord enregistré disponible',
		},
		THRESHOLD_PANEL: {
			TITLE: 'Seuil',
			CLOSE: 'Fermer',
			ONGOING: 'En cours',
			SHOW_LESS: 'Afficher moins',
			SEE_MORE: 'Voir plus',
		},
		ACTIVITY_LOGS: {
			TITLE: 'Journaux d\'activité',
			ACTIONS: 'Actions ({{count}})',
			CLOSE: 'Fermer',
			SEARCH_PLACEHOLDER: 'Rechercher...',
		},
		FEEDBACK_RIGHT_NAV: {
			TITLE: 'Commentaires',
			CLOSE: 'Fermer',
			APPROVED: 'Approuvé',
			RELEARNED: 'Réappris',
			QUOTE_APPROVED_HYPOTHESIS: 'Hypothèse approuvée',
			QUOTE_RELEARNED_HYPOTHESIS: 'Hypothèse réapprise',
			QUOTE_APPROVED_CAUSAL: 'Étape de chaîne causale approuvée',
			QUOTE_RELEARNED_CAUSAL: 'Étape de chaîne causale réapprise',
			QUOTE_APPROVED_RECOMMENDATION: 'Recommandation approuvée',
			QUOTE_RELEARNED_RECOMMENDATION: 'Recommandation réapprise',
			QUOTE_OTHER: 'Autre',
			FILE_ALT: 'Fichier',
			EMPTY_HEADING: 'Aucun commentaire disponible',
			EMPTY_CONTENT: 'Approuvez ou réapprenez pour ajouter un commentaire.',
		},
		DISCUSSION: {
			TITLE: 'Discussion',
			COMMENTS_COUNT: 'Commentaires ({{count}})',
			CLOSE: 'Fermer',
			CREATE_CASE_TITLE: 'Créez un dossier pour gérer les suivis',
			CREATE_CASE: 'Créer un dossier',
			BACK: 'Retour',
			THREAD_BY: 'Fil par',
			SEARCH_PLACEHOLDER: 'Rechercher...',
			NO_COMMENTS_HEADING: 'Aucun commentaire ici',
			NO_COMMENTS_BODY: 'Laissez votre premier commentaire pour démarrer la discussion sur ce sujet.',
			EDITED: 'Modifié',
			RCA_VERSION_DELETED: 'Version RCA supprimée',
			COMMENT_DELETED: 'Ce commentaire a été supprimé.',
			COMMENT_DELETED_ALT: 'Ce commentaire a été supprimé.',
			REPLY_SINGULAR: 'réponse',
			REPLY_PLURAL: 'réponses',
			LAST_REPLY: 'Dernière réponse',
			REPLY_PROMPT: 'Répondre...',
			COMMENT_PLACEHOLDER: 'Ajoutez un commentaire, utilisez @ pour identifier les membres de l\'équipe',
			REPLY_TO_COMMENT_PLACEHOLDER: 'Répondre au commentaire...',
		},
		RETRAIN_MODEL: {
			TITLE: 'Réentraîner le modèle',
			CLOSE: 'Fermer',
			CURRENT_MODEL_DETAILS: 'Détails du modèle actuel',
			DEPLOYED_VERSION_LABEL: 'Version déployée - Date / Heure',
			LAST_PREDICTION_LABEL: 'Dernière prédiction - Date / Heure',
			FORM_ERROR: 'Oups ! Modifiez quelques éléments et réessayez.',
			TRAINING_PERIOD: 'Période d\'entraînement',
			DATE_RANGE_SELECTION_METHOD: 'Méthode de sélection de la plage de dates',
			SELECT_TRAINING_MODE_ARIA: 'Sélectionner le mode de sélection d\'entraînement',
			CALENDAR_SELECTION: 'Sélection par calendrier',
			CHART_BASED_SELECTION: 'Sélection basée sur le graphique',
			VIEW_EDIT_NOTE: 'Voir / Modifier la note',
			ADD_NOTE: 'Ajouter une note',
			ADD_TRAINING_RANGE: 'Ajouter une plage d\'entraînement',
			DELETE_TRAINING_RANGE: 'Supprimer la plage d\'entraînement',
			ADVANCED_SETTINGS: 'Paramètres avancés',
			BAND_LEARNING_BEHAVIOUR: 'Comportement d\'apprentissage de bande',
			SELECT_BAND_LEARNING_ARIA: 'Sélectionner le comportement d\'apprentissage de bande',
			CONSERVATIVE_TOOLTIP: 'Crée des bandes plus étroites autour de la région d\'entraînement sélectionnée',
			CONSERVATIVE: 'Conservateur',
			MODERATE_TOOLTIP: 'Crée des bandes équilibrées autour de la région d\'entraînement sélectionnée',
			MODERATE: 'Modéré',
			AGGRESSIVE_TOOLTIP: 'Crée des bandes plus larges autour de la région d\'entraînement sélectionnée',
			AGGRESSIVE: 'Agressif',
			PREDICTION_SMOOTHING_SETTINGS: 'Paramètres de lissage des prédictions',
			SMOOTHING: 'Lissage',
			WINDOW_SIZE: 'Taille de la fenêtre',
			WINDOW_SIZE_PLACEHOLDER: 'Taille de la fenêtre (en heures)',
			VALUE_IS: 'La valeur est',
			REQUIRED: 'requise',
			VALUE_MIN: 'La valeur doit être supérieure ou égale à',
			POLYNOMIAL_ORDER: 'Ordre polynomial',
			SIGMA: 'Sigma',
			SELECT_ATTENTION_TAGS: 'Sélectionner les tags d\'attention',
			SEARCH_PLACEHOLDER: 'Rechercher...',
			NO_MATCHING_TAGS: 'Aucun tag correspondant trouvé',
			SHOW_ALL_TAGS: 'Afficher tous les tags',
			SHOW_ATTENTION_TAGS_ONLY: 'Afficher uniquement les tags d\'attention',
			MODELING_TECHNIQUE: 'Technique de modélisation',
			AUTO_ENCODER: 'Auto-encodeur',
			ATTENTION_AUTO_ENCODER: 'Auto-encodeur d\'attention',
			CANCEL_TOOLTIP: 'Annuler les modifications',
			CANCEL: 'Annuler',
			RETRAIN_DEPLOY_TOOLTIP: 'Réentraîner et déployer',
		},
		ROOT_CAUSE_RECOMMENDATION: {
			CLOSE: 'Fermer',
			ICON_ALT: 'Icône de cause racine',
			NOT_GENERATED_MESSAGE: 'Vous n\'avez pas encore généré l\'analyse des causes profondes. Veuillez la générer pour continuer.',
			FAILED_MESSAGE: 'Votre dernière analyse des causes profondes a échoué.<br> Veuillez la générer à nouveau pour continuer.',
			GENERATE_NOW: 'Générer maintenant',
			REFRESH: 'Actualiser',
			LAST_GENERATED: 'Dernière génération',
			GENERATING: 'Génération de l\'analyse des causes profondes',
			LOADER_ALT: 'chargement',
			LIKE_ALT: 'J\'aime',
			DISLIKE_ALT: 'Icône Je n\'aime pas',
			MONETARY_VALUE: 'Valeur monétaire',
			FAILURE_HISTORY: 'Historique des défaillances',
			INFO_CARD_ARIA: 'Carte d\'information',
			PREVIOUS_FAILURE_MODES: 'Modes de défaillance précédents',
			HYPOTHESIS_PREFIX: 'Hypothèse',
			MOST_LIKELY: '(Le plus probable)',
			CASCADES_AS_FOLLOWS: '.Cette cause profonde se propage probablement comme suit :',
			AGREE: 'D\'accord',
			PARTIALLY_AGREE: 'Partiellement d\'accord',
			DISAGREE: 'Pas d\'accord',
			TELL_US_MORE: 'Dites-nous en plus :',
			FEEDBACK_PLACEHOLDER: 'N\'hésitez pas à ajouter des détails spécifiques',
			CANCEL: 'Annuler',
			SUBMIT: 'Envoyer',
		},
		RIGHT_PANEL_DOCUMENTS: {
			TITLE: 'Documents',
			CLOSE: 'Fermer',
			SEARCH_PLACEHOLDER: 'Rechercher...',
			FILTER_TAGS: 'Filtrer les tags',
			EMPTY_HEADING: 'Aucun document disponible',
		},
		MONETORY_VALUE_DIALOG: {
			TITLE: 'Valeurs Monétaires',
			CURRENCY_HINT: 'Les valeurs monétaires sont saisies en {{currency}}',
			RELIABILITY: 'Fiabilité',
			MAINTENANCE: 'Maintenance',
			PERFORMANCE: 'Performance',
			POTENTIAL_SUFFIX: ' (Potentiel)',
			ENTER_VALUE: 'Saisir une valeur',
			COMMENT_REQUIRED_ERROR: 'Le commentaire ne peut pas être vide.',
			AMOUNT_REQUIRED_ERROR: 'Au moins une valeur doit être saisie.',
			COMMENT: 'Commentaire',
			COMMENT_PLACEHOLDER: 'Ajoutez votre commentaire',
			CANCEL: 'Annuler',
			SAVE: 'Enregistrer',
		},
		FAILURE_MODE_DETAILS: {
			TITLE: 'Détails du mode de défaillance',
			OPEN_ALERT: 'Ouvrir l\'alerte',
			TTF_ALT: 'TTF',
			ADD_MONETARY_VALUE: 'Ajouter une valeur monétaire',
			CMMS_NUMBER_TOOLTIP: 'Numéro CMMS',
			MORE_SUFFIX: 'de plus',
			ADD_CMMS_NUMBER: 'Ajouter un numéro CMMS',
			BREAKDOWN_CATEGORY: 'Catégorie de répartition',
			BREAKDOWN_COMPONENT: 'Composant de répartition',
			ERROR_LABEL: 'Erreur',
			TAG_CHARTS_SUFFIX: 'graphiques de tags',
		},
		DATA_QUALITY_PANEL: {
			TITLE: 'Qualité des Données',
			CLOSE: 'Fermer',
			SEE_LESS: 'Voir moins',
			SEE_MORE: 'Voir plus',
		},
		FAILURE_TIMELINE_PANEL: {
			SORT_BY: 'Trier par :',
			ASSET: 'Actif :',
			REASON: 'Raison :',
			RECOMMENDATIONS: 'Recommandations :',
			NA: 'N/D',
		},
		REPORT_ISSUE_SIDEPANEL: {
			TITLE: 'Signaler un problème',
			SUBTITLE: 'Dites-nous ce qui n\'a pas fonctionné avec l\'agent RCA.',
			CLOSE: 'Fermer',
			WARNING_BANNER: 'Cela ne mettra pas à jour ni ne relancera la RCA actuelle. Pour améliorer une hypothèse, une chaîne causale ou une recommandation, utilisez les options de commentaires au sein de la RCA.',
			SECTION_TITLE: 'Qu\'est-ce qui n\'a pas fonctionné ?',
			SECTION_HINT: 'Sélectionnez tout ce qui s\'applique.',
			ISSUES_ERROR: 'Sélectionnez au moins une option.',
			DETAILS_ERROR: 'Ajoutez des détails sur le problème rencontré.',
			DETAILS_LABEL_REQUIRED: 'Détails supplémentaires (Requis)',
			DETAILS_LABEL_OPTIONAL: 'Détails supplémentaires (Facultatif)',
			DETAILS_PLACEHOLDER: 'Par exemple, la RCA a identifié la tendance de pression correcte mais a conclu que la pompe avait causé l\'événement, alors que l\'historique de maintenance indiquait une défaillance de vanne.',
			DISCLAIMER: 'En soumettant ce rapport, les données RCA pertinentes et les journaux d\'activité seront partagés avec l\'équipe UptimeAI autorisée pour investigation.',
			CANCEL: 'Annuler',
			SUBMIT_REPORT: 'Envoyer le rapport',
			RUN_RCA_FIRST: 'Exécutez une RCA avant de signaler un problème avec l\'agent.',
			SUBMITTED_SUCCESS: 'Problème signalé avec succès',
			SUBMIT_FAILED: 'Échec du signalement du problème. Veuillez réessayer.',
			OPT_PLATFORM_DATA_LABEL: 'Les données pertinentes de la plateforme n\'ont pas été prises en compte',
			OPT_PLATFORM_DATA_HINT: 'La RCA n\'a pas utilisé toutes les alertes, tags, tendances, événements ou autres données pertinentes disponibles sur la plateforme.',
			OPT_EVIDENCE_LABEL: 'Les documents ou preuves n\'ont pas été correctement pris en compte',
			OPT_EVIDENCE_HINT: 'Les documents téléchargés, les preuves proposées ou d\'autres informations à l\'appui ont été ignorés ou mal interprétés.',
			OPT_USER_INPUT_LABEL: 'Ma contribution n\'a pas été correctement prise en compte',
			OPT_USER_INPUT_HINT: 'La RCA n\'a pas correctement pris en compte le contexte, les instructions, les notes ou les commentaires que j\'ai fournis lors de cette investigation ou lors de précédentes exécutions.',
			OPT_CAUSAL_LABEL: 'Le raisonnement causal était incorrect',
			OPT_CAUSAL_HINT: 'La RCA a pris en compte des informations pertinentes mais est parvenue à une conclusion incorrecte.',
			OPT_WEIGHTED_LABEL: 'Les preuves ont été pondérées de manière incorrecte',
			OPT_WEIGHTED_HINT: 'La RCA s\'est trop concentrée sur un seul point de données et n\'a pas suffisamment pris en compte d\'autres preuves importantes.',
			OPT_UNSUPPORTED_LABEL: 'Une conclusion n\'était pas étayée par des preuves',
			OPT_UNSUPPORTED_HINT: 'La RCA a généré une affirmation ou une conclusion sans données ou preuves suffisantes à l\'appui.',
			OPT_RECOMMENDATION_LABEL: 'La recommandation n\'était pas exploitable',
			OPT_RECOMMENDATION_HINT: 'La recommandation était trop générale, peu pratique ou peu utile sur le plan opérationnel.',
			OPT_UNCLEAR_LABEL: 'L\'explication n\'était pas claire',
			OPT_UNCLEAR_HINT: 'Le raisonnement était difficile à comprendre ou ne fournissait pas assez de justification.',
			OPT_OTHER_LABEL: 'Autre',
			OPT_OTHER_HINT: 'Signalez un problème qui n\'est pas répertorié ci-dessus.',
		},
		LIBRARY: {
			TITLE: 'Bibliothèque',
			SUBTITLE: 'Plans P&ID et documents d\'ingénierie (manuels, fiches techniques, listes d\'alarmes / déclenchements) au même endroit.',
			SEARCH: 'Rechercher plans, documents, équipements ou un tag (ex. PT-0940)…',
			TAB_PIDS: 'P&ID',
			TAB_DOCS: 'Manuels et données',
			PIDS: {
				LOADING: 'Chargement des plans…',
				FAILED: 'Les plans n\'ont pas pu être chargés.',
				LOCATED: 'Plans montrant {{tag}}',
				NOT_LOCATED: '{{tag}} ne figure sur aucun plan indexé.',
				NO_MATCH: 'Aucun plan ne correspond à la recherche.',
				TAGS: '{{count}} tags',
				PICK: 'Choisissez un plan à gauche, ou recherchez un tag pour trouver les plans qui le montrent.',
				VIEW_DRAWING: 'Plan',
				VIEW_PDF: 'PDF complet',
				PDF_LOADING: 'Chargement du PDF…',
				PDF_FAILED: 'Le PDF de ce plan n\'est pas disponible.',
				OTHER: 'Autres plans',
				REFERENCE: 'Légendes et index des plans',
			},
			DOCS: {
				LOADING: 'Chargement des documents…',
				FAILED: 'Les documents n\'ont pas pu être chargés.',
				EMPTY: 'Aucun document.',
				NO_MATCH: 'Aucun document ne correspond à la recherche.',
				PICK: 'Choisissez un document pour le lire ici.',
				GROUP_ITEM: 'Sur cet emplacement',
				GROUP_ABOVE: 'De {{floc}}',
				GROUP_BELOW: 'Sous cet emplacement',
				GROUP_TYPE: '{{type}}',
			},
		},
		ASSET_EXPLORER: {
			FLOC: {
				TITLE: 'Arborescence des actifs – {{facility}} (postes techniques SAP)',
				SEARCH_PLACEHOLDER: 'Rechercher un poste technique, un équipement ou un tag historien…',
				SEARCH_HINT: 'Les actifs correspondants sont listés ci-dessous ; choisissez une suggestion de tag pour l’afficher sur le P&ID.',
				HIDE_EMPTY: 'Masquer les postes sans tags',
				HIDE_EMPTY_HINT: 'Masque les postes techniques sans tag historien dans leur sous-arborescence. Les ensembles et les groupes non affectés restent affichés.',
				NODE_HITS: 'Actifs correspondants ({{count}})',
				CLOSE_HITS: 'Fermer les résultats',
				NODE_SEARCH_FAILED: 'La recherche d’actifs a échoué. Réessayez.',
				NO_NODE_HITS: 'Aucun actif ne correspond à « {{query}} ».',
				REVEAL_FAILED: 'Impossible d’ouvrir cet actif dans l’arborescence.',
				TREE_EMPTY: 'L’arborescence des actifs est vide.',
				TREE_HIDDEN: '{{count}} postes sans tags masqués',
				CHILDREN_FAILED: 'Impossible de charger les enfants de ce nœud.',
				CHILDREN_HIDDEN: '{{count}} postes enfants sans tag historien sont masqués.',
				COUNT_TIP: '{{count}} tags historien dans cette sous-arborescence',
				PATH: 'Chemin de l’actif',
				UNASSIGNED_NAME: 'Tags non affectés',
				UNASSIGNED_TIP: 'Tags historien sans poste technique ni ensemble, regroupés par le code système du nom de tag',
				UNASSIGNED_NOTE: 'Ces tags historien n’ont ni poste technique SAP ni ensemble d’équipements. Ils sont regroupés ici uniquement par le code système du nom de tag (ou au niveau du site s’il n’y en a pas) ; leur équipement est inconnu.',
				PACKAGE_NOTE: 'Ensemble de machines tournantes : ses tags sont affectés à l’ensemble dans sa globalité, pas à un poste technique SAP unique.',
				LEVEL_SITE: 'Site',
				LEVEL_SYSTEM: 'Système',
				LEVEL_SUBSYSTEM: 'Sous-système',
				LEVEL_EQUIPMENT: 'Équipement',
				LEVEL_PACKAGE: 'Ensemble',
				LEVEL_UNASSIGNED: 'Non affecté',
				KIND_FLOC: 'Poste technique SAP',
				KIND_PACKAGE: 'Ensemble d’équipements',
				KIND_UNASSIGNED: 'Groupe de tags non affectés',
				SUBTREE_TAGS: '{{count}} tags dans la sous-arborescence',
				LOOP_TAGS_BADGE: '{{count}} tags d’ensemble de la même boucle',
				PIDS_SHOWING: 'Sur {{count}} P&ID',
				PROP_FLOC: 'Code poste technique',
				PROP_CODE: 'Code d’ensemble',
				PROP_LEVEL: 'Niveau',
				PROP_KIND: 'Type',
				PROP_LOOP: 'Numéro de boucle',
				PROP_OWN_TAGS: 'Tags sur ce nœud',
				PROP_SUBTREE_TAGS: 'Tags de la sous-arborescence',
				WITH_DATA: '{{count}} avec données',
				N_TAGS: '{{count}} tags',
				INCLUDE_SUBTREE: 'Inclure la sous-arborescence',
				TAGS_OWN_NOTE: 'Tags placés directement sur ce nœud.',
				TAGS_SUBTREE_NOTE: 'Tags placés sur ce nœud et sur tous les nœuds en dessous.',
				DETAIL_FAILED: 'Impossible de charger ce nœud. Réessayez.',
				NO_OWN_TAGS: 'Aucun tag historien n’est placé sur ce nœud.',
				NO_OWN_TAGS_LOOP: 'Aucun tag historien n’est placé sur ce poste technique lui-même ; les tags d’ensemble partageant son numéro de boucle sont listés ci-dessous.',
				TRUNCATED: 'Affichage des {{shown}} premiers tags sur {{total}}.',
				FILTER_TAGS: 'Filtrer les tags…',
				NO_FILTER_MATCH: 'Aucun tag ne correspond au filtre.',
				COL_RULE: 'Règle de placement',
				COL_DATA: 'Données',
				PLACED_AT: 'Sur',
				LOOP_TITLE: 'Tags d’ensemble partageant ce numéro de boucle ({{count}})',
				LOOP_EXPLAIN: 'Ces tags appartiennent à des ensembles de machines tournantes, pas à ce poste technique. Ils sont listés car leur nom porte le numéro de boucle {{loop}}, le même que cet équipement. Ils ne sont pas comptés dans les totaux de tags de ce nœud.',
				LOOP_GROUP: 'Boucle {{loop}} · ensemble {{package}} ({{count}})',
				OPEN_PACKAGE: 'Ouvrir l’ensemble',
				PID_GROUP_NODE: 'Montre {{name}}',
				PID_NODE_FOUND: '{{name}} (son symbole d’équipement ou ses tags) figure sur {{count}} plan(s).',
				PID_NODE_NONE: 'Aucun P&ID numérisé ne montre {{name}} ni ses premiers tags.',
				CHIPS_MORE: '{{shown}} tags du nœud sur {{total}} affichés ; ajoutez-en d’autres depuis le tableau Aperçu ou la recherche.',
				RULE_FLOC_CURATED: 'Poste (validé)',
				RULE_FLOC_CURATED_HINT: 'Poste technique issu de la table validée de correspondance tag–équipement.',
				RULE_FLOC_BACKFILLED: 'Poste (complété)',
				RULE_FLOC_BACKFILLED_HINT: 'Poste technique issu de la correspondance tag–actif de l’historien, utilisée quand la table validée n’en a pas.',
				RULE_FLOC_WELL: 'Poste via puits sous-marin',
				RULE_FLOC_WELL_HINT: 'Tag sous-marin placé sur le poste de l’arbre de production de son puits (ou le poste du puits) d’après le numéro de puits du nom.',
				RULE_FLOC_LOOP: 'Poste via numéro de boucle',
				RULE_FLOC_LOOP_HINT: 'Placé sur l’unique poste d’équipement dont le code se termine par le numéro de boucle du tag.',
				RULE_PACKAGE_PREFIX: 'Ensemble via préfixe',
				RULE_PACKAGE_PREFIX_HINT: 'Affecté à un ensemble d’équipements ; placé sous le sous-système codé dans le nom du tag.',
				RULE_PACKAGE_SITE: 'Ensemble (site)',
				RULE_PACKAGE_SITE_HINT: 'Affecté à un ensemble d’équipements ; le nom ne code aucun sous-système, il reste donc au niveau du site.',
				RULE_UNASSIGNED: 'Non affecté (préfixe)',
				RULE_UNASSIGNED_HINT: 'Ni poste technique ni ensemble ; regroupé sous le sous-système codé dans le nom du tag.',
				RULE_SITE: 'Site',
				RULE_SITE_HINT: 'Ni poste technique, ni ensemble, ni code de sous-système ; conservé au niveau du site.',
			},
			TITLE: 'Hiérarchie des actifs – {{facility}}',
			BREADCRUMB: 'Explorateur d’actifs',
			RELOAD: 'Recharger',
			LOADING_TREE: 'Chargement de la hiérarchie des actifs…',
			LOAD_FAILED: 'Impossible de charger la hiérarchie des actifs. Réessayez.',
			SEARCH_PLACEHOLDER: 'Rechercher un équipement ou un tag historien…',
			SEARCH_HINT: 'La saisie filtre l’arborescence ; choisissez un tag pour l’afficher sur le P&ID.',
			TREE_EMPTY: 'Aucun actif ne correspond à la recherche.',
			EXPAND: 'Développer',
			COLLAPSE: 'Réduire',
			LEVEL_KICKER: 'Niveau {{level}}',
			NODE_ID: 'ID',
			TAGS_MAPPED: '{{count}} tags historien',
			PIDS_LINKED: '{{count}} P&ID liés',
			TAB_OVERVIEW: 'Vue d’ensemble',
			TAB_PID: 'P&ID',
			TAB_TELEMETRY: 'Séries temporelles',
			TAB_DOCS: 'Documents',
			DOCS: {
				VIEW: 'Documents ({{count}})',
				HINT: 'Manuels, fiches techniques et listes d\'alarmes / déclenchements de {{name}} et des emplacements au-dessus.',
				ALSO_PIDS: 'Aussi sur {{count}} feuilles P&ID',
				OPEN_LIBRARY: 'Ouvrir la bibliothèque',
				EMPTY: 'Aucun document n\'est lié à cet emplacement ni aux emplacements au-dessus.',
			},
			OPEN_KG: 'Ouvrir dans le graphe de connaissances',
			VIEW_ALERTS: 'Voir les alertes',
			VIEW_PID: 'Voir le P&ID',
			VIEW_TELEMETRY: 'Voir les séries temporelles',
			DESCRIPTION: 'Description',
			NO_DESCRIPTION: 'Aucune description enregistrée pour cet actif.',
			CHILDREN: 'Actifs enfants ({{count}})',
			PROPERTIES: 'Propriétés',
			TAGS_TITLE: 'Tags historien ({{count}})',
			NO_TAGS: 'Aucun tag historien n’est associé à cet actif.',
			COL_TAG: 'Tag',
			COL_COMPONENT: 'Composant',
			COL_RANGE: 'Plage de fonctionnement',
			COL_UNIT: 'Unité',
			COL_ACTIONS: 'Actions',
			LOCATE_ON_PID: 'Afficher sur le P&ID',
			PLOT: 'Tracer',
			NO_SELECTION: 'Sélectionnez un actif dans la hiérarchie ou recherchez un tag.',
			LEVEL: {
				FACILITY: 'Installation',
				SYSTEM: 'Système',
				SUBSYSTEM: 'Sous-système',
				EQUIPMENT: 'Équipement',
				COMPONENT: 'Composant',
				INSTRUMENT: 'Instrument',
			},
			PID: {
				SHEET: 'Plan',
				SEARCH_SHEETS: 'Rechercher des plans…',
				SEARCH_ON_DRAWING: 'Trouver un tag sur ce plan…',
				NO_MATCHES: 'Aucun tag de ce plan ne correspond.',
				FILTER_ALL: 'Tous',
				FILTER_INSTRUMENTS: 'Instruments',
				FILTER_EQUIPMENT: 'Équipements',
				FILTER_NONE: 'Aucun',
				GROUP_LOCATED: 'Plans montrant {{tag}}',
				GROUP_NODE: 'Liés à {{name}}',
				GROUP_ALL: 'Tous les plans ({{count}})',
				SOURCE_DIGITISED: 'numérisé',
				SOURCE_TEXT: 'indexé par texte',
				SOURCE_NEEDS_OCR: 'OCR requis',
				SOURCE_CATALOGUED: 'catalogué',
				SOURCE_BLANK: 'sans texte',
				DETECTIONS: '{{count}} éléments',
				LOCATING: 'Recherche de {{tag}} sur les P&ID…',
				LOCATE_FAILED: 'Impossible de rechercher {{tag}} sur les P&ID.',
				NOT_ON_PID: '{{tag}} n’apparaît sur aucun P&ID numérisé.',
				FOUND_ON: '{{tag}} figure sur {{count}} plan(s)',
				CLEAR_LOCATE: 'Effacer',
				TYPE_INSTRUMENT: 'Instrument',
				TYPE_EQUIPMENT: 'Équipement',
				CONFIDENCE: 'Confiance {{pct}} %',
				CANONICAL: 'Tag canonique',
				HISTORIAN_TAG: 'Tag historien',
				NOT_LINKED: 'Non lié à un tag historien',
				PLOT: 'Tracer dans les séries temporelles',
			},
			PID_VIEWER: {
				ZOOM_IN: 'Zoom avant',
				ZOOM_OUT: 'Zoom arrière',
				FIT: 'Ajuster à la vue',
				FOCUS_HIGHLIGHT: 'Aller au tag mis en évidence',
				FULLSCREEN: 'Plein écran',
				EXIT_FULLSCREEN: 'Quitter le plein écran',
				LOADING: 'Chargement du plan…',
				NO_DRAWING: 'Aucun plan sélectionné.',
				LOAD_FAILED: 'Impossible de charger ce plan.',
				NO_IMAGE: 'Aucune image pour ce plan',
				NO_IMAGE_HINT: 'Le plan est numérisé ({{count}} éléments, {{highlighted}} mis en évidence) mais son image n’est pas disponible.',
				PAN_HINT: 'Glisser pour déplacer · molette pour zoomer',
				ASPECT_WARNING: 'Les tailles de l’image et du plan diffèrent ; les cadres peuvent être décalés.',
				HISTORIAN_TAG: 'Tag historien',
				NOT_LINKED: 'Non lié',
				CLICK_HINT: 'Cliquer pour sélectionner',
				UNTAGGED: 'Élément sans tag',
			},
			TAG_SEARCH: {
				SEARCHING: 'Recherche…',
				FAILED: 'La recherche de tags a échoué. Réessayez.',
				NO_RESULTS: 'Aucun tag historien ne correspond à « {{query}} ».',
				HAS_DATA: 'Données disponibles',
				NO_DATA: 'Aucune donnée',
				ALREADY_ADDED: 'Déjà sélectionné',
			},
			TELEMETRY: {
				ACTIVE_TAGS: 'Tags sur le graphique ({{count}} / {{max}})',
				SEARCH_PLACEHOLDER: 'Rechercher des tags historien à ajouter…',
				DROPPED: '{{max}} tags au maximum : {{tag}} a été retiré.',
				REMOVE: 'Retirer du graphique',
				WINDOW: 'Fenêtre temporelle',
				WINDOW_7D: '7 j',
				WINDOW_30D: '30 j',
				WINDOW_90D: '90 j',
				WINDOW_1Y: '1 an',
				CHART_TITLE: 'Séries temporelles de l’historien',
				POINTS: '{{count}} points',
				LOADING: 'Chargement des séries temporelles…',
				NO_DATA: 'Aucune mesure pour les tags sélectionnés dans cette fenêtre.',
				NO_TAGS: 'Recherchez un tag ou choisissez-en un ci-dessus pour le tracer.',
				SUMMARY: 'Synthèse',
				LATEST: 'Dernier',
				MIN: 'Min',
				MAX: 'Max',
				MEAN: 'Moyenne',
			},
		},
		TRIAGE: {
			RULE_SIGNALS: {
				TITLE: 'What this rule measures',
				MEASURED: 'Measured',
				CONTEXT: 'Context',
				HAS_READINGS: 'Readings before the alert',
				NO_READINGS: 'No readings in the 24 h before the alert',
				SOURCE: 'Mapping from {{source}}',
				GUESSED: 'Shell\'s configuration does not list this rule\'s inputs; the charted signals were chosen by the agent from the well\'s sensors.',
			},
			BASIS: {
				NO_RESULT: 'No decision yet: run the agent on this alert.',
				RECOMMENDATIONS: 'Recommendations',
				NO_RECOMMENDATIONS: 'The agent made no recommendations for this alert.',
				FINAL_HYPOTHESES: 'Final hypotheses (adjudicator)',
				NO_FACT_SPAN: 'This run did not record which evidence it read.',
				LINK_RCA: 'Deep RCA · {{count}} verified facts',
				LINK_EVIDENCE: 'Evidence used',
			},
			PFLOW: {
				ALERT_DRAWINGS: 'Drawings the alert equipment is on (open with the alert context)',
				TAB: 'Process flow',
				TITLE: 'Block flow (process units)',
				CHECKED_LEGEND: 'Checked by the agent ({{n}})',
				OPEN_MAP: 'Open process map',
				OPEN_ON_MAP: 'Show on process map',
				ALERT_UNIT: 'Alert\'s unit',
				STATE_MOVED: 'Moved',
				STATE_HELD: 'Steady',
				STATE_NODATA: 'No data',
				TIMING_BEFORE: 'before the alert',
				TIMING_TOGETHER: 'with the alert',
				TIMING_AFTER: 'after the alert',
				TIMING_EARLIER: '> 48 h earlier',
				KEY_SENSORS: 'Key sensors (click to chart)',
				CHART_IT: 'chart it on the right',
				ON_DRAWING: 'Equipment on the alert\'s drawing',
			},
			STEP_PANEL: {
				DQ: 'Data quality of the readings before the alert',
				NO_DQ: 'No data-quality assessment was recorded for this alert.',
				STATE: 'Alert tag with the machine\'s run indicator',
				LIMITS: 'Limits of this tag and when they applied',
				RULE: 'The detector and the tags it watches',
				EQUIPMENT: 'Sensors on this equipment — click one to chart it on the right',
				PROCESS: 'Live P&ID — click a tag to chart it on the right',
				NO_ANOMALY: 'The run has no anomaly-model analysis for this alert.',
			},
			DOCPAGE: {
				MAXIMIZE: 'Maximize',
				RESTORE: 'Restore',
				MARKING: 'Finding the cited passage on this page…',
				MARKING_TERMS: 'Finding the search words on this page…',
				MARK_FAILED: 'The page is shown, but the passage could not be located on it.',
				PAGE_OF: 'page {{page}} of {{pages}}',
				PREV: 'Previous page',
				NEXT: 'Next page',
				CITED_FOUND: 'The red box marks the passage the triage relied on.',
				OCR: 'This page is a scan, read by OCR, so the box position is approximate.',
				CITED_MISSING: 'The cited words could not be found on this page image (the scan reads differently); the passage is the one quoted in the triage.',
				CITED_ON: 'The cited passage is on page {{page}}.',
				LOADING: 'Loading the page…',
				CLOSE: 'Close',
			},
			DOCS: {
				REFERRED: 'Referred documents',
				ALL: 'All documents',
				SEARCH_PLACEHOLDER: 'Filter by name — press Enter to search inside the documents',
				SEARCH_INSIDE: 'Search inside',
				WHOLE_SITE: 'Whole site',
				RESULTS: 'Pages matching “{{q}}”',
				NO_RESULTS: 'No page matches these words.',
				PAGE: 'p.{{n}}',
				USED: 'Passages the triage used',
				USED_HINT: 'Click a passage to open its page with the passage in a red box',
				CITED: 'cited',
				VIEW_PAGE: 'View page',
			},
			SEE: {
				RULE: 'Rule, delay and replay: see Source Alert',
				SENSORS: 'Sensors on this machine: see System Details',
				TAGS: 'Plot them: see Tags',
				CONNECTED: 'Upstream and downstream units: see System details › Process flow',
				PID: 'P&ID drawings: see System details',
				WORK_ORDERS: 'Open work: see Work Orders',
				ALERTS: 'Earlier alerts: see Alerts',
				REPORTS: 'Shift reports: see Reports',
				REASONING: 'How the agent reasoned: see Reasoning',
			},
			PANE_SPLIT_HINT: 'Drag to resize; double-click to reset',
			RELATED: {
				TITLE: 'Related alerts',
				HELP: 'Found by the known-issue check: earlier alerts on this equipment known before this alert\'s cut-off, and later alerts that linked to this one. Each alert keeps its own label.',
				NONE: 'No related alert found.',
				ISSUE_SIZE: 'Issue of {{n}} alerts',
				REL_COVERED_BY: 'Service already raised',
				REL_SAME_CONDITION: 'Same condition',
				REL_SAME_EVENT: 'Same event',
				DIR_EARLIER: 'earlier alert',
				DIR_LATER: 'later alert',
				SCORE: 'score {{s}}',
				STATUS_PROPOSED: 'Proposed',
				STATUS_CONFIRMED: 'Confirmed',
				STATUS_REJECTED: 'Rejected',
				CONFIRM: 'Confirm',
				REJECT: 'Reject',
				CHIP: 'Same issue as {{n}} other alert(s)',
				CHIP_TIP: 'The known-issue check found {{n}} other alert(s) on the same condition. Open the alert to see them under Related alerts, and confirm or reject the link.',
				CHIP_PROPOSED: 'Some links still await review.',
			},
			QUEUE_RUN: {
				BUTTON: 'Triage selected',
				HINT: 'Run the Triage Agent on each selected alert, one alert at a time per run (never grouped); a few run at once.',
				STARTED: 'Triaging {{n}} alerts individually',
				PROGRESS: 'Triage: {{done}} of {{total}} done, {{running}} running',
				DONE: 'Triage finished for {{n}} alerts ({{failed}} failed)',
			},
			LABEL_SETTINGS: {
				PROPOSALS_TITLE: 'Proposed mapping changes ({{n}})',
				PROPOSALS_HELP: 'Reviewers agreed with the agent\'s finding but expected another customer label. Apply moves the finding in the editor below; it is accepted when you save the new version.',
				N_ALERTS: '{{n}} alerts',
				APPLY: 'Apply to mapping',
				APPLIED: 'Applied — save to accept',
				REJECT: 'Reject',
				TAB_SETTINGS: 'Settings',
				TAB_LABELS: 'Labels',
				INTRO: 'The agent decides an internal finding; the mapping turns it into the label the customer sees. A change saves a new version (v{{v}} is in force) and relabels every alert at once, without re-running triage.',
				EXTERNAL_TITLE: 'External labels',
				EXTERNAL_HELP: 'The labels shown in the queue and reported to the customer. The outcome drives the approve button: close, act (raise the action type) or hold for review. Saved labels cannot be deleted, only retired; their keys are permanent.',
				COL_NAME: 'Name / key',
				COL_CUSTOMER: 'Customer value',
				COL_OUTCOME: 'Outcome',
				COL_ACTION: 'Action type',
				COL_COLOR: 'Colour',
				COL_SCORED: 'Scored as',
				COL_ACTIVE: 'Active',
				UP: 'Move up',
				DOWN: 'Move down',
				REMOVE: 'Remove (never saved)',
				FALLBACK: 'fallback',
				CUSTOMER_NONE: 'Not exported',
				ACTION_PH: 'e.g. service_notification',
				OUTCOME_CLOSE: 'Close',
				OUTCOME_ACTION: 'Action',
				OUTCOME_HOLD: 'Hold for review',
				NOT_SCORED: 'Not scored',
				NEW_KEY: 'New key, e.g. valid_monitor',
				NEW_NAME: 'Name shown to users',
				ADD: 'Add label',
				KEY_RULE: 'Key: 3–41 lower-case letters, digits or underscores, starting with a letter.',
				KEY_TAKEN: 'That key is already used (keys are never reused, even after retiring).',
				NAME_REQUIRED: 'Give the label a name.',
				FALLBACK_LABEL: 'Fallback label',
				FALLBACK_HELP: 'Used when a finding has no mapping. Must be active and hold for review.',
				MAPPING_TITLE: 'Mapping: external label ← internal findings',
				MAPPING_HELP: 'Each external label (left) owns the agent findings on the right. Every finding belongs to exactly one label. Click a finding to move it. Amber findings differ from the default mapping.',
				UNMAPPED: '{{n}} findings are not mapped; they would show as the fallback label.',
				N_FINDINGS: '{{n}} findings',
				NONE: 'No findings mapped',
				RETIRED_NONE: 'Retired: owns no findings',
				DEFAULT_WAS: 'default: {{x}}',
				CHECK_N: 'Check {{n}}',
				MOVE_TO: 'Move “{{x}}” to',
				BY_CHECK: 'View by triage check',
				NO_CHANGES: 'No changes.',
				PREVIEWING: 'Checking the change…',
				MOVING: '{{n}} triaged alerts would change label.',
				DISCARD: 'Discard',
				SAVE: 'Save new version',
				SAVED: 'Label mapping v{{v}} saved',
				HISTORY: 'Versions',
				IN_FORCE: 'in force',
				RESTORE: 'Load into editor',
				RESTORE_REASON: 'Restore the mapping of v{{v}}',
			},
			LABELS: {
				FINDING_TIP: 'Shown to Shell as “{{label}}” (label mapping v{{v}}, Settings → Labels).',
				FINDING: 'Finding',
				SOURCE_AGENT: 'Agent',
				SOURCE_POLICY: 'Policy',
				SOURCE_HUMAN: 'Reviewer',
				SOURCE_DERIVED: 'Derived',
				MAPPING: 'Mapping v{{v}} → {{label}}',
				MAPPING_TIP: 'The finding is turned into the customer label by the label mapping in Settings › Labels. Changing the mapping relabels alerts without re-running triage.',
				ALSO_FOUND: 'Also found',
				CHECK: 'check {{n}}',
				SECONDARY_ACTION: 'Also found: {{names}}. That finding leads to an action, but the main finding closes the alert. Review before closing.',
				INTERNAL_COLUMN: 'Finding',
			},
			ACT: {
				APPROVED_CLOSED: 'Approved and closed',
				CLOSED: 'Closed – False alert',
				CLOSED_FLAGGED: 'Closed – False alert · rule flagged for tuning',
				CLOSE_ALERT: 'Close alert',
				CLOSE_CONFIRM: 'Close alert',
				CLOSE_TITLE: 'Close as False – No Action',
				CREATE_INSTRUMENT_WO: 'Create instrument WO',
				CREATE_SERVICE: 'Create Service',
				DUE_DATE: 'Due date',
				EQUIPMENT: 'Equipment',
				EVIDENCE_ATTACHED: 'Evidence attached (click to leave one out)',
				FEED_CONFIRM: 'Report issue',
				FEED_LEAD: 'The alert was raised on values that are not measurements. The issue goes to {{owner}}; no work order is raised because no transmitter is broken.',
				FEED_REPORTED: 'Data-feed issue reported to {{owner}}',
				FEED_TITLE: 'Report data-feed issue',
				FEWER_FIELDS: 'Show fewer fields',
				FLAG_RULE: 'Flag rule for tuning',
				FROM_AGENT: 'from the agent',
				FROM_DQ_POLICY: 'from DQ policy',
				LINKED: 'Linked to {{id}} and closed',
				LINKED_ALERT: 'Linked alert',
				LINK_CLOSE: 'Link & close',
				LINK_CONFIRM: 'Link & close',
				LINK_LEAD: 'This condition is already covered by an open record. The alert is linked to it and closed as Valid – No Action.',
				LINK_TITLE: 'Link to the known issue',
				LOADING: 'Preparing the form…',
				MORE_FIELDS: 'Show more fields',
				NOTE: 'Note (optional)',
				NOTE_PLACEHOLDER: 'Add context for the SME team…',
				NO_EVIDENCE: 'Nothing cited to attach',
				NO_REPLAY: 'The detector\'s rule could not be replayed on the raw data, so no fix is suggested.',
				OPEN_CASE: 'Open case',
				OWNER: 'Owner',
				OWNER_ME: 'Me',
				PREFILLED: 'prefilled',
				PRIORITY: 'Priority',
				PROBLEM: 'Problem',
				RECOMMENDATION: 'Recommendation',
				REPORT_FEED: 'Report data-feed issue',
				ROUTE_TO: 'Route to',
				SENT_TO: 'Sent to {{owner}}.',
				SERVICE_CONFIRM: 'Create Service',
				SERVICE_CREATED: 'Service case #{{id}} created',
				SERVICE_NAME: 'Title',
				SERVICE_TITLE: 'Create Service',
				TAG: 'Tag',
				UNDO: 'Undo',
				UNDONE: 'Action undone',
				WO_CONFIRM: 'Create work order',
				WO_CREATED: 'Work order {{id}} created · {{route}}',
				WO_TITLE: 'Create instrument work order',
			},
			CHIPS: {
				UNACK_HINT: '{{n}} not yet acknowledged',
			},
			RULE: {
				FLAGGED_SHORT: 'Rule flagged',
				FLAGGED_TIP: 'The detector rule was flagged for tuning',
			},
			SETTINGS: {
				DEFAULT: 'Default',
				FROM_DEFAULT: 'default',
				FROM_FACILITY: 'facility',
				FROM_EQUIPMENT: 'this equipment',
				HISTORY: 'Change history',
				LOADING: 'Loading settings…',
				NO_HISTORY: 'No change yet: every value is the code default.',
				N_CHANGED: '{{n}} changed',
				OPEN: 'Triage settings',
				OPEN_HINT: 'Flatline, delays, HIL in memory, routing',
				READ_ONLY: 'Only an administrator can change these settings.',
				REASON: 'Reason for the change (required)',
				RESET: 'Reset',
				RE_EVAL: 'changes results',
				RE_EVAL_CHANGED: 'Run the golden set before relying on this change',
				RE_EVAL_HINT: 'Changing this changes triage results: run the golden set before relying on it',
				RE_EVAL_NOTE: 'Each change is a new version; every triage run records the version it used. Settings marked "changes results" need a golden-set run before you rely on them.',
				SAVE: 'Save',
				SAVED: 'Settings saved as version {{v}}',
				SAVE_FAILED: 'The settings could not be saved',
				SCOPE: 'Applies to',
				SCOPE_FACILITY: 'The whole facility',
				SUBTITLE: 'Version {{v}}',
				TITLE: 'Alert Triage settings',
			},
			TREE: {
				ALL_OPEN: 'All open alerts',
				CLEAR_FILTER: 'Show all nodes',
				NO_ACTION_TOTAL: 'No action',
				SHOWING_ONLY: 'Showing: {{cls}} only',
				SHOW_NODES_WITH: 'Show nodes with',
			},
			KG: {
				CLICK_TO_COLLAPSE: 'Cliquez pour replier',
				NO_EXACT: 'Aucun nœud ne s\'appelle « {{tag}} »',
				PICK_MATCH: 'Ces nœuds correspondent en partie, un par partie de l\'installation — choisissez-en un à explorer :',
				BREADCRUMB_OPS: 'Opérations offshore',
				BREADCRUMB_TWINS: 'Jumeaux topologiques',
				BREADCRUMB_GRAPH: 'Graphe de connaissances Shell Vito',
				TITLE: 'Graphe de connaissances interactif de l\'installation',
				NODES: '{{n}} nœuds',
				RELATIONSHIPS: '{{n}} relations',
				LIVE: 'Neo4j en direct',
				CENTER_PLACEHOLDER: 'Tag central (ex. PT-1502, MTR-0900)…',
				EXPLORE: 'Explorer',
				HOPS: 'Profondeur',
				HOPS_1: '1 saut : voisins directs',
				HOPS_2: '2 sauts : équipements voisins',
				HOPS_3: '3 sauts : topologie élargie',
				SHOW_TYPE: 'Afficher ce type',
				HIDE_TYPE: 'Masquer ce type',
				ZOOM_IN: 'Zoom avant',
				ZOOM_OUT: 'Zoom arrière',
				FIT: 'Ajuster à l\'écran',
				SHOWING: '{{shown}} nœuds affichés sur {{total}}',
				SHOW_MORE: 'Afficher {{n}} de plus',
				EXPAND_ALL: 'Déplier tous les groupes',
				COLLAPSE_ALL: 'Replier les groupes',
				HINT: 'Survolez pour les noms · cliquez sur un groupe pour le déplier · cliquez sur un nœud pour l\'inspecter · glissez pour déplacer, défilez pour zoomer',
				LOADING: 'Lecture du graphe de connaissances…',
				LOAD_FAILED: 'Échec du chargement du graphe de connaissances',
				CLICK_TO_EXPAND: 'Cliquez pour lister et déplier',
				GROUP: 'NŒUDS GROUPÉS',
				COLLAPSE_GROUP: 'Replier le groupe',
				CENTER_ON_NODE: 'Centrer le graphe sur ce nœud',
				PROPERTIES: 'Propriétés du nœud',
				LOADING_RELATIONS: 'Chargement des relations…',
				OUTGOING: 'Relations sortantes ({{n}})',
				INCOMING: 'Relations entrantes ({{n}})',
				TYPE: {
					Equipment: 'Équipement',
					ControlValve: 'Vanne de régulation',
					Instrument: 'Instrument',
					Event: 'Alerte',
					Event_PostJune2026: 'Alerte (après juin 2026)',
					Alert: 'Alerte',
					TripEvent: 'Événement de déclenchement',
					RootCause: 'Cause racine',
					PhaScenario: 'Scénario PHA',
					Detector: 'Détecteur',
					Measurement: 'Mesure',
					Document: 'Document',
					PIDDrawing: 'Schéma P&ID',
					FLOC: 'FLOC',
					ProcessLine: 'Ligne de procédé',
					System: 'Système',
				},
			},
			LIBRARY: {
				TITLE: 'Spécialiste bibliothèque',
				EXCERPTS_N: '{{n}} extraits · {{docs}} documents',
				NONE: 'Aucun manuel dans le périmètre',
				LIMITS_N: '{{n}} limites indiquées',
				SCOPE: 'Recherché pour',
				HINT: 'Manuels constructeur, fiches techniques et listes d\'alarmes et de déclenchements de cet équipement (par FLOC), recherchés par sens et par mots. L\'agent les cite en LIB-n.',
				QUESTIONS: 'Questions posées',
				NONE_HINT: 'Aucun manuel ni fiche technique n\'est classé pour cet équipement ou ses FLOC parents.',
				STATED_LIMITS: 'Limites indiquées pour cet instrument',
				EXCERPTS: 'Extraits',
			},
			LIMITS: {
				ROW_FOUND: 'The red box marks the row this limit was read from.',
				OPEN_PAGE: 'Open the source page',
				OPEN_ROW: 'Open the source row',
				HIDE_SOURCE: 'Hide the source',
				SHEET_TITLE: 'Source row in the Shell workbook',
				SHEET_UNAVAILABLE: 'The workbook could not be read.',
				SHEET_ROWS: '{{n}} row(s) name this tag, of {{total}}',
				SHEET_NO_ROW: 'No row in this sheet names the tag.',
				SHEET_ROW: 'Row {{n}}',
				AT_ALERT: 'In force at the alert ({{t}}) marked',
				IN_FORCE: 'in force',
				NOT_IN_FORCE: 'not in force then',
				FROM: 'from {{from}}',
				QUOTED_FROM: 'quoted {{from}} – {{to}}',
				MAPPING_REVIEW: 'instrument ↔ tag mapping under review',
				DCS: 'DCS limit tags (historian)',
				AT_ALERT_VALUE: 'at the alert: {{v}}',
				TITLE: 'Limites',
				CLOSEST: '{{kind}} {{value}} · {{headroom}}% de marge',
				NONE: 'Aucune limite connue',
				RULE_BREACHED: 'Règle de variation TMP atteinte',
				HINT: 'Toutes les limites d\'ingénierie connues du tag (consigne PSV / DCS / PTM du TMP Shell, SimpleLimits, valeurs du manuel dans la même unité) comparées à la dernière lecture et au max. ou min. 24 h avant l\'alerte.',
				NONE_HINT: 'Aucune limite TMP, SimpleLimits, détecteur ou manuel n\'est connue pour ce tag.',
				SOURCE: 'Source',
				LIMIT: 'Limite',
				VALUE: 'Valeur',
				EXTREME_24H: 'Max. / min. 24 h',
				HEADROOM: 'Marge',
				STATUS: 'Statut',
				RATE_RULES: 'Règles de variation TMP',
				LARGEST_CHANGE: 'plus forte variation {{value}}',
				BREACHED: 'Dépassée',
				NOT_BREACHED: 'Non dépassée',
				DETECTOR: 'Configuration du détecteur',
				CONFLICT: 'Valeurs TMP contradictoires :',
				REACHED: 'Atteinte',
				NEAR: 'Proche',
				CLEAR: 'Large',
				NO_READING: 'Pas de lecture',
			},
			PREFS: {
				TITLE: 'Préférences',
				HEIGHT: 'Hauteur préférée des graphiques',
				CONDENSED: 'Compacte',
				NORMAL: 'Normale',
				EXPANDED: 'Agrandie',
				LIMITS_AND_VALUES: 'Limites et valeurs des tags',
				SHOW: 'Afficher',
				HIDE: 'Masquer',
				OTHER: 'Lignes de limite affichées par défaut',
				TRIP_LINE: 'Ligne de déclenchement',
				ALARM_LINE: 'Ligne d\'alarme',
				THRESHOLD_LINE: 'Ligne de seuil',
				INSTRUMENT_LINE: 'Ligne de plage instrument',
				NOTE: 'S\'applique à tous les graphiques de triage. La bande ombrée est l\'épisode du mode de défaillance (début du signal jusqu\'au retour à la normale). Les limites proviennent uniquement des données Shell chargées (TMP, SimpleLimits).',
				RESET: 'Rétablir les valeurs par défaut',
			},
			PLAYBOOK: {
				TITLE: 'Vérifications du guide du site',
				META: '{{count}} règles évaluées',
				META_HINT: 'Règles tirées des notes de vérification du site pour ce détecteur, en vigueur à l’heure de l’alerte, testées sur les éléments antérieurs à la date limite',
				LEGEND: '✓ vérifié · ✗ non vérifié · ? non évaluable. Une vérification SAUF SI vérifiée bloque la règle ; les parties non vérifiables sont jugées par l’agent.',
				OPEN_RULE: 'Ouvrir la règle dans Apprentissages',
				DISPOSITION_HINT: 'Ce que fait la pratique du site quand cette règle s’applique',
				UNLESS_HINT: 'Exceptions : si l’une est vérifiée, la règle ne s’applique pas',
				JUDGED_BY_AGENT: 'Jugé par l’agent',
				JUDGED_HINT: 'Cette partie n’est pas vérifiable automatiquement ; l’agent l’évalue à partir des éléments',
				VALUE_YES: 'vérifié',
				VALUE_NO: 'non vérifié',
				VALUE_UNKNOWN: 'non évaluable',
				ST_MATCHED: 'Correspond',
				ST_MATCHED_HINT: 'Toutes les vérifications QUAND sont vérifiées et aucune exception',
				ST_PARTLY: 'Correspond en partie',
				ST_PARTLY_HINT: 'Les vérifications automatiques sont vérifiées ; les parties jugées par l’agent décident si elle s’applique pleinement',
				ST_EXCEPTED: 'Exceptée',
				ST_EXCEPTED_HINT: 'Elle s’appliquerait, mais une exception (SAUF SI) est vérifiée',
				ST_UNDETERMINED: 'Indéterminée',
				ST_UNDETERMINED_HINT: 'Une vérification n’a pas pu être évaluée avec les éléments antérieurs à la date limite',
				ST_NOT_MATCHED: 'Ne correspond pas',
				ST_NOT_MATCHED_HINT: 'Une vérification QUAND n’est pas vérifiée',
			},
			LEARNING_CHECK: {
				OR: 'ou',
				HOURS: '{{n}} h',
				DAYS: '{{n}} jours',
				ON_ITEM: 'sur cet équipement',
				V_STOPPED: 's’est arrêtée',
				V_STARTED: 'a démarré',
				V_RESTARTED: 'a redémarré',
				V_SHUTDOWN_OR_STARTUP: 's’est arrêtée ou a démarré',
				V_NO_SIGNIFICANT_CHANGE: 'aucun changement notable',
				V_PROCESS_OR_OPERATING_CHANGE: 'un changement de procédé ou d’exploitation',
				V_SINGLE_TAG_DEPARTURE: 'un seul tag qui s’écarte',
				V_MIXED: 'des motifs mixtes',
				V_CONSISTENT: 'cohérent avec le normal',
				V_MOVED_TOGETHER: 'ont bougé avec lui',
				MACHINE_EVENT: 'la machine {{events}} dans les {{window}}',
				MACHINE_EVENT_NO_WINDOW: 'la machine {{events}}',
				MACHINE_EVENT_ANY: 'un arrêt ou démarrage de la machine dans les {{window}}',
				SINCE_RESTART: 'la machine a redémarré au plus {{window}} avant l’alerte',
				RUNNING: 'la machine en marche à l’heure de l’alerte',
				NOT_RUNNING: 'la machine à l’arrêt à l’heure de l’alerte',
				WITHIN_BASELINE: 'le tag d’alerte revenu dans sa plage normale à l’heure de l’alerte',
				OUTSIDE_BASELINE: 'le tag d’alerte hors de sa plage normale à l’heure de l’alerte',
				SUSTAINED: 'un écart durable par rapport au normal',
				NOT_SUSTAINED: 'aucun écart durable par rapport au normal',
				CHART_PATTERN: 'les courbes montrent {{patterns}}',
				CHART_PATTERN_ANY: 'un motif de courbe est lu',
				MULTIVARIATE: 'le modèle multivarié indique {{values}}',
				MULTIVARIATE_ANY: 'le modèle multivarié a un verdict',
				CONNECTED: 'systèmes connectés : {{values}}',
				CONNECTED_ANY: 'les systèmes connectés ont été lus',
				MOVED_TOGETHER: 'les tags liés ont bougé ensemble',
				NOT_MOVED_TOGETHER: 'les tags liés n’ont pas bougé ensemble',
				OPEN_WORK: 'avis ou ordre de travail ouvert sur cet équipement',
				NO_OPEN_WORK: 'aucun avis ni ordre de travail ouvert sur cet équipement',
				COHORT: 'de nombreuses alertes simultanées dans le même système (cause commune)',
				NO_COHORT: 'pas de rafale d’alertes dans le même système',
				SENSOR_FAULT: 'le capteur est défaillant ou ses données inutilisables',
				SENSOR_OK: 'les données du capteur sont utilisables',
				RETURNED: 'le signal est revenu à la normale avant l’heure de l’alerte',
				NOT_RETURNED: 'le signal n’était pas revenu à la normale à l’heure de l’alerte',
				SHIFT_LOG: 'un rapport de quart récent (fenêtre de {{window}}) mentionne « {{query}} »',
				NO_SHIFT_LOG: 'aucun rapport de quart récent (fenêtre de {{window}}) ne mentionne « {{query}} »',
				RECENT_WORK: 'des travaux de maintenance récents (fenêtre de {{window}}) correspondant à « {{query}} »',
				NO_RECENT_WORK: 'aucun travail de maintenance récent (fenêtre de {{window}}) correspondant à « {{query}} »',
				OTHER_ALERTS: 'au moins {{n}} autres alertes du même détecteur dans les {{window}}',
				PRIOR_ALERTS: 'au moins {{n}} alertes antérieures sur ce tag (fenêtre de {{window}})',
				PRIOR_ALERTS_EVER: 'au moins {{n}} alertes antérieures sur ce tag',
			},
			LEARNING_EDIT: {
				TITLE: 'Modifier l’apprentissage',
				ASOF_WARNING: 'L’enregistrement crée la version v{{next}}, en vigueur dès maintenant. Le triage des alertes antérieures conserve la version en vigueur à leur date (as-of).',
				F_TITLE: 'Titre',
				RECOMPILE: 'Les vérifications automatiques seront recompilées à partir de la nouvelle condition.',
				ACTIVE_HINT: 'l’agent le consulte',
				RETIRED_HINT: 'retiré dès maintenant',
				REASON: 'Motif de la modification',
				REASON_HINT: 'Conservé avec la nouvelle version et affiché dans son historique.',
				NO_CHANGES: 'Rien n’a encore changé.',
				SAVE: 'Enregistrer la nouvelle version',
				SAVED: 'Enregistré en v{{version}}, en vigueur dès maintenant ; les triages antérieurs gardent la version précédente.',
			},
			LEARNING_DETAIL: {
				TITLE: 'Apprentissage',
				EDIT: 'Modifier',
				CLOSE: 'Fermer',
				EFFECTIVE: 'en vigueur depuis le {{date}}',
				SUPPORT: 'Appui : {{support}}',
				CONSISTENCY: 'cohérence {{pct}}',
				MANUAL_FIELDS: 'défini à la main : {{fields}}',
				CONDITION: 'Condition',
				EXCEPTIONS: 'Exceptions',
				CHECKS: 'Vérifications automatiques',
				CHECKS_HINT: 'La condition traduite en faits que l’agent peut vérifier sur les éléments disponibles à l’heure de l’alerte ; le reste est jugé par l’agent.',
				CHECKS_STALE: 'La condition a été modifiée : ses vérifications automatiques sont en cours de recompilation et ne sont pas utilisées d’ici là.',
				WHEN: 'Quand',
				UNLESS: 'Sauf si',
				MANUAL: 'Jugé par l’agent',
				NO_CHECKS: 'Aucune condition vérifiable automatiquement',
				GROUPS: 'Groupes de capteurs concernés par ses alertes',
				TYPICAL_TAGS: 'Tags typiques',
				QUOTES: 'Extrait des notes de vérification',
				GRAPH: 'Voisinage dans le graphe de connaissances',
				GRAPH_MISSING: 'Pas encore dans le graphe de connaissances.',
				REL_DETECTOR: 'Pour le détecteur',
				REL_FLOC: 'Sur le poste technique',
				REL_SUPERSEDES: 'Remplace',
				NO_LINKS: 'Aucun lien vers un détecteur, un emplacement ou une version antérieure.',
				SIMILAR: 'Apprentissages similaires',
				NO_SIMILAR: 'Aucun apprentissage actif proche par le sens.',
				OPEN_SIMILAR: 'Ouvrir cet apprentissage',
				ASOF_NOTE: 'Les versions ne sont jamais modifiées sur place : un triage à l’instant t utilise la version en vigueur à t.',
				NOW: 'maintenant',
				CHANGED: 'Modifié :',
				SHOW_DIFF: 'Voir les différences de la règle',
				HIDE_DIFF: 'Masquer les différences',
				F_TITLE: 'titre',
				F_RULE: 'règle',
				F_DISPOSITION: 'décision',
				F_STATUS: 'statut',
				F_CONDITION: 'condition',
				F_EXCEPTIONS: 'exceptions',
				F_SUPPORT: 'appui',
				SHOW_ALL_SOURCES: 'Afficher les {{count}}',
			},
			PID: {
				CLICK_TO_PLOT: 'Cliquer pour tracer',
				NO_HISTORIAN_DATA: 'Pas de données d\'historien',
				MORE_TAGS: '+{{count}} autres tags sur cet élément',
				NO_DATA_AT_ALERT: 'Aucune mesure dans les 72 h avant l\'alerte',
				CLICKABLE_COUNT: '{{clickable}} tags sur {{total}} ont des données',
				TAGS_FAILED: 'Impossible de charger les tags de ce plan',
				HIDE_LEGEND: 'Masquer la légende',
				SHOW_LEGEND: 'Afficher la légende',
				LEGEND_DATA: 'Avec données d\'historien (cliquer)',
				LEGEND_NO_DATA: 'Pas de données d\'historien',
				LEGEND_ALERT: 'Tag de l\'alerte',
				LEGEND_RELATED: 'Même équipement / boucle que l\'alerte',
				LEGEND_SUGGESTED: 'Suggéré à examiner',
				ONLY_WITH_DATA: 'Seulement les tags avec données',
				SHEET_N: 'feuille {{sheet}}',
				BACK: 'Retour',
				BACK_TIP: 'Retour à la feuille précédente ({{count}} dans l\'historique)',
				SHOW_PANEL: 'Afficher le panneau',
				HIDE_PANEL: 'Masquer le panneau',
				FROM_UPSTREAM: 'Depuis l\'amont',
				TO_DOWNSTREAM: 'Vers l\'aval',
				RESIZE: 'Faire glisser pour redimensionner le panneau',
				ON_DRAWING: 'Sur le plan',
				LOCATE_ITEM: 'Afficher sur le plan',
				FROM_OTHER_SHEET: 'Sélectionné sur une autre feuille',
				ITEM_TAGS: 'Tags de cet élément ({{count}})',
				SWITCH_TIP: 'cliquer pour tracer ce tag à la place',
				ADD_TO_CHART: 'Ajouter au graphique',
				REMOVE_FROM_CHART: 'Retirer du graphique',
				ON_CHART: '{{count}} / {{max}} sur le graphique',
				ALERT_WINDOW: 'Alerte à {{asOf}} · de 3 jours avant à 1 jour après',
				LAST_DAYS: 'Derniers {{days}} jours de données disponibles',
				CHART_FULL: 'Au plus {{max}} tags peuvent être tracés ensemble',
				TIME_SERIES: 'Série temporelle',
				LOOK_NEXT: 'À regarder ensuite',
				CONTEXT_FAILED: 'Impossible de charger les tags liés',
				CONTEXT_UNKNOWN: 'Ce tag n\'est pas dans le catalogue des capteurs',
				LOOP_N: 'Boucle {{loop}}',
				SAME_LOOP: 'Même boucle',
				SAME_EQUIPMENT: 'Même équipement',
				UPSTREAM: 'Unités en amont',
				DOWNSTREAM: 'Unités en aval',
				SERVICE: 'Utilités desservant',
				NONE_WITH_DATA: 'Aucun avec données d\'historien',
				SHOW_MORE: 'Afficher {{count}} de plus',
				NO_UNITS: 'Aucune unité connectée',
				HOPS: '{{count}} saut(s)',
				OPEN_DRAWING: 'Ouvrir le plan',
				MORE_SENSORS: '+{{count}} autres capteurs',
				TWIN: 'Train jumeau : {{unit}}',
				TWIN_ON_CHART: 'Le tag jumeau est sur le graphique',
				COMPARE_TWIN: 'Comparer avec le jumeau',
				TWIN_NO_TAG: 'Aucun tag de même position connu sur {{unit}}',
				TWIN_SAME_MEASURE: 'Même grandeur sur {{unit}}',
				LOCATE_ON_SHEET: 'Afficher sur cette feuille',
				OTHER_CONNECTORS: 'Utilités et décharge ({{count}})',
				OTHER_CONNECTORS_TIP: 'Connecteurs de contrôle, d\'utilités et de décharge de cette feuille',
				SIDE_BY_SIDE: 'Côte à côte',
				SIDE_BY_SIDE_TIP: 'Plein écran : plan et panneau côte à côte',
				REL: {
					ALERT: 'Tag de l\'alerte',
					LOOP: 'Même boucle',
					EQUIPMENT: 'Même équipement',
				},
			},
			BATCH: {
				TOGGLE: 'Lot',
				TOGGLE_HINT: 'Mode lot : lister les groupes d’alertes d’un même FLOC dans une fenêtre de temps et trier chaque groupe ensemble',
				TOGGLE_OFF_HINT: 'Revenir à la liste des alertes individuelles',
				WINDOW_LABEL: 'Fenêtre de {{hours}} h',
				WINDOW_HINT: 'Fenêtre du lot : les alertes d’un FLOC dans ce nombre d’heures après la première forment un groupe',
				WINDOW_TITLE: 'Fenêtre du lot',
				WINDOW_OPTION: '{{hours}} h',
				HELP: 'Les alertes sont regroupées par FLOC. La fenêtre est ancrée sur la première alerte du groupe ; la date limite est le membre le plus récent, donc chaque membre est évalué avec ce qui était connu à ce moment. Une seule investigation couvre le groupe et donne à chaque membre sa propre disposition. Les groupes utilisent les filtres de date, de recherche, de FLOC, de cible et de statut.',
				GROUPS_TITLE: 'Lots · fenêtre de {{hours}} h',
				GROUPS_COUNT: '({{groups}} groupes · {{alerts}} sur {{considered}} alertes)',
				NEWEST_FIRST: 'Plus récents d’abord',
				EMPTY: 'Aucun lot',
				EMPTY_HINT: 'Avec les filtres actuels, aucun FLOC n’a deux alertes ou plus dans la fenêtre.',
				COL_SIZE: 'Taille',
				COL_SPAN: 'Durée',
				COL_DETECTORS: 'Détecteurs',
				COL_CLASSES: 'Classes actuelles',
				COL_TAG: 'Tag',
				COL_AS_OF: 'Au',
				TOGGLE_MEMBERS: 'Afficher ou masquer les alertes de ce groupe',
				N_ALERTS: '{{count}} alertes',
				SPAN: '{{count}} alertes en {{span}}',
				MINUTES: '{{count}} min',
				HOURS_MINUTES: '{{hours}} h {{minutes}} min',
				CUTOFF: 'date limite',
				N_UNTRIAGED: '{{count}} non triées',
				ALL_TRIAGED: 'Toutes triées',
				RUNNING: 'Exécution du lot en cours',
				TRIAGE_BATCH: 'Trier le lot ({{count}})',
				TRIAGE_SELECTED: 'Trier les {{count}} sélectionnées',
				TRIAGE_HINT: 'Une investigation commune de ces alertes à la date du membre le plus récent ; chaque alerte reçoit sa propre disposition',
				SELECT_MIN: 'Sélectionnez au moins {{count}} alertes de ce groupe',
				SELECT_MAX: 'Un lot compte au plus {{count}} alertes : sélectionnez-en jusqu’à {{count}}',
				PAGE_HINT: 'La pagination compte les groupes',
				RANGE: '{{start}}–{{end}} sur {{total}} groupes',
				DONE: 'Lot de {{count}} alertes trié',
				GATED: 'Lot non analysé : le contrôle de qualité des données a bloqué l’exécution (voir le canvas)',
				FAILED: 'L’exécution du lot ne s’est pas terminée',
				ROW_CHIP: 'lot de {{count}}',
				ROW_CHIP_TIP: 'La dernière exécution a trié cette alerte avec {{count}} alertes de son FLOC (une investigation, une disposition par alerte)',
				CARD_TITLE: 'Tri en groupe',
				CARD_META: 'Lot de {{count}} · fenêtre de {{hours}} h · date limite {{time}}',
				EPISODE_CLASS: 'Épisode',
				EPISODE_HINT: 'Classification du groupe dans son ensemble',
				THIS_MEMBER: 'Cette alerte',
				MEMBERS: 'Alertes du lot',
				THIS_ALERT: 'cette alerte',
				NOW_IN_GROUP: 'Cette alerte fait maintenant partie d’un groupe de {{count}} sur son FLOC (fenêtre de {{hours}} h, {{span}} min, {{untriaged}} non triées).',
				MORE_DETECTORS: '+{{count}} autres',
				TRIAGE_WITH: 'Trier avec {{count}} alertes de ce FLOC',
			},
			UEV: {
				TITLE: 'Preuves et retours',
				HINT: "Les observations terrain, avis SAP, tags de l'historien et fichiers ajoutés ici sont transmis à l'agent lors d'une relance, marqués comme fournis par l'utilisateur et pondérés à part du dossier à date.",
				BADGE_N: '{{count}} élément(s)',
				BADGE_CHANGED: 'a changé la réponse',
				EMPTY: 'Aucune preuve ajoutée.',
				LOAD_ERROR: 'Impossible de charger les preuves',
				ADD: 'Ajouter une preuve',
				ADDED: 'Preuve ajoutée',
				UPDATED: 'Preuve mise à jour',
				REMOVED_NOTICE: 'Preuve retirée',
				TYPE_OBSERVATION: 'Retour / observation',
				TYPE_SAP: 'Avis SAP',
				TYPE_TAG: "Tag de l'historien",
				TYPE_FILE: 'Fichier',
				TEXT_LABEL: 'Ce qui a été observé ou mesuré',
				TEXT_PLACEHOLDER: 'ex. le manomètre local indique 30 scfm ; vanne de purge non étanche',
				CONTEXT_LABEL: "Pourquoi c'est important pour cette alerte",
				CONTEXT_PLACEHOLDER: "Note de contexte pour l'agent (facultatif)",
				NOTIF_LABEL: "Numéro d'avis",
				LOOKUP: 'Rechercher',
				NOTIF_NOT_FOUND: 'Avis introuvable',
				NOTIF_AFTER: "Créé {{hours}} h après l'alerte",
				NOTIF_BEFORE: "Créé avant l'alerte",
				NOTIF_NAMES_TAG: "Cite le tag de l'alerte {{tag}}",
				FLOC_EQUIPMENT: 'Même équipement',
				FLOC_UNIT: 'Même unité',
				FLOC_FACILITY: 'Autre équipement',
				RAISED: 'Créé {{time}}',
				COMPLETED: 'Clôturé {{time}}',
				TAG_LABEL: "Tag de l'historien",
				TAG_PLACEHOLDER: 'Rechercher des tags (ex. LIC0920)',
				TAG_HINT: "L'agent lit ce tag à l'heure de l'alerte, comme tout autre tag.",
				FILE_CHOOSE: 'Choisir un fichier',
				FILE_HINT: "PDF, image, texte, CSV, Word ou Excel, jusqu'à 10 Mo",
				FILE_TYPE_ERROR: 'Type de fichier non pris en charge : envoyez un PDF, PNG, JPG, texte, CSV, Word ou Excel',
				FILE_SIZE_ERROR: 'Le fichier dépasse 10 Mo',
				FILE_META: '{{pages}} page(s), {{size}} Ko',
				FILE_NO_TEXT: 'aucun texte extrait ({{note}})',
				OPEN_FILE: 'Ouvrir le fichier',
				SAVE: 'Ajouter',
				CANCEL: 'Annuler',
				EDIT: 'Modifier',
				REMOVE: 'Retirer',
				REMOVE_CONFIRM: 'Retirer cet élément ? Les versions antérieures sont conservées et les exécutions qui les ont utilisées les citent toujours.',
				REASON: 'Motif (facultatif)',
				SAVE_EDIT: 'Enregistrer une nouvelle version',
				VERSIONS: 'Historique',
				REMOVED: 'Retiré',
				SHOW_REMOVED: 'Afficher les retirés',
				HIDE_REMOVED: 'Masquer les retirés',
				BY: 'Ajouté par {{name}} · {{time}}',
				EDITED_BY: 'v{{n}} par {{name}} · {{time}}',
				AFTER_CUTOFF: 'après la coupure',
				RERUN: 'Relancer avec les preuves',
				RERUN_HINT: "Relance l'Agent de Triage avec les {{count}} élément(s) actifs ; suivez-le en direct sur le canevas",
				RERUN_BATCH: 'Relancer le lot ({{count}} alertes)',
				RERUN_BATCH_HINT: 'Relance le lot avec les preuves actives de tous ses membres',
				LAST_RUN: 'La dernière relance a utilisé {{refs}}',
				OUTCOME_CHANGED: 'Réponse changée : {{from}} → {{to}}',
				OUTCOME_UNCHANGED: 'Réponse inchangée',
				OUTCOME_NOT_ATTRIBUTED: 'Réponse changée ({{from}} → {{to}}), non attribuée aux preuves',
				OUTCOME_NO_BASELINE: "L'agent indique que les preuves ont décidé la réponse",
				AGENT_LINE: "Réponse d'une relance avec preuves utilisateur {{refs}}",
				NODE: 'Preuves utilisateur',
				CANVAS_BADGE: 'Preuves utilisateur · {{count}}',
				CANVAS_HINT: "Relance avec des preuves fournies par l'utilisateur : {{refs}}",
				PICKER: 'preuves utilisateur',
				INSPECTOR_ITEMS: 'Éléments utilisés ({{count}})',
				INSPECTOR_BASELINE: 'Réponse sans ces preuves : {{cls}}',
				INSPECTOR_NO_BASELINE: 'Aucune exécution antérieure sans preuves utilisateur',
				INSPECTOR_AUDIT: "Les éléments fournis par l'utilisateur restent hors de la vue à date ; le contrôle de fuite ne couvre que les faits du harnais.",
				ATTRIBUTION_USER_EVIDENCE: 'Changée par les preuves : {{from}} → {{to}}',
				ATTRIBUTION_USER_EVIDENCE_NO_BASELINE: "Décidée par les preuves (pas d'exécution antérieure)",
				ATTRIBUTION_NOT_ATTRIBUTED: 'Changée, non attribuée : {{from}} → {{to}}',
				ATTRIBUTION_UNCHANGED: 'Inchangée',
				EFFECT_CHANGED_ANSWER: 'a changé la réponse',
				EFFECT_SUPPORTED_ANSWER: 'soutient la réponse',
				EFFECT_CONTRADICTED: 'contredit, non retenu',
				EFFECT_NO_BEARING: 'sans rapport',
				EFFECT_NOT_ADDRESSED: 'non traité',
			},
			WATCH: {
				STATUS_WATCHING: 'Sous surveillance',
				ACTION: 'Surveiller',
				ACTION_HINT: 'Revoir cette alerte plus tard, avec les données enregistrées après cette évaluation',
				UNWATCH: 'Ne plus surveiller',
				DIALOG_TITLE: 'Surveiller l’alerte',
				DIALOG_LEAD: 'L’alerte reste sous surveillance jusqu’à l’échéance ; elle peut ensuite être réévaluée avec tout ce qui a été enregistré depuis cette évaluation.',
				ASSESSED_AS_OF: 'Évaluation actuelle au',
				ASSESSED_HINT: 'La date limite de l’évaluation affichée. Les préréglages comptent à partir de ce moment, pas d’aujourd’hui.',
				LOOK_AGAIN: 'Revoir',
				PRESET_HOURS: '+{{count}} h',
				PRESET_DAYS: '+{{count}} j',
				PRESET_CUSTOM: 'Date et heure',
				DUE_AT: 'Échéance le',
				DUE_LINE: 'Échéance {{time}}',
				DUE_BEFORE_ASSESSMENT: 'doit être postérieure à l’évaluation',
				SUGGESTED: 'Suggéré par l’agent',
				USE_SUGGESTION: 'Utiliser comme motif',
				REASON: 'Motif',
				REASON_HINT: 'Ce qu’il faut vérifier à l’échéance (obligatoire)',
				CONFIRM: 'Surveiller',
				SET_NOTICE: 'Alerte placée sous surveillance',
				BANNER_DUE: 'Surveillance échue',
				BANNER_WAITING: 'Sous surveillance',
				CHIP_DUE: 'Échue · {{time}}',
				CHIP_WAITING: 'Surveillée · échéance {{time}}',
				TIP_DUE: 'Sous surveillance, échue depuis {{time}} : réévaluer avec les nouvelles données',
				TIP_WAITING: 'Sous surveillance jusqu’au {{time}}',
				SET_BY: 'Définie par {{name}} le {{date}}',
				BASELINE: 'Surveillance de l’évaluation au {{time}}',
				CHECKING: 'Vérification de ce qui a été enregistré depuis…',
				NOTHING_NEW: 'Rien de nouveau n’a encore été enregistré depuis l’évaluation.',
				LATER_ALERTS: 'Alertes ultérieures',
				BEYOND: '+{{count}} après',
				OPEN_LATER: 'Ouvrir cette alerte',
				SAP_RECORDS: 'Enregistrements SAP',
				SUPERVISOR_REPORTS: 'Rapports du superviseur',
				HISTORIAN: 'Historian',
				HOURS: '{{count}} h',
				ON_TAGS: 'sur {{count}} tags',
				WINDOW: 'Nouvelles données du {{from}} au {{to}}',
				REASSESS: 'Réévaluer avec les nouvelles données',
				REASSESS_HINT: 'Trier à nouveau avec la date limite déplacée à l’échéance (jamais après maintenant) ; le canvas suit l’exécution',
				REASSESS_WAIT: 'Disponible lorsque la surveillance est échue',
				NEW_DATA: 'nouvelles données',
				NEW_DATA_DOT: 'Échue, avec des données enregistrées depuis l’évaluation',
				FILTER_LABEL: 'Surveillance',
				FILTER_DUE: 'Échue',
				FILTER_WAITING: 'Surveillée (non échue)',
				REASSESSED_HEADER: 'Réévaluée au {{time}} (première évaluation au {{previous}} : {{cls}})',
			},
			SHELL: {
				TOGGLE: 'Afficher les libellés HIL',
				TOGGLE_HINT: 'Ajoute le libellé de vérification HIL (humain dans la boucle) et son commentaire en colonnes pour comparer. Données de validation uniquement : jamais une entrée de l\'agent de triage.',
				VALIDATION_ONLY: 'Les libellés HIL (humain dans la boucle) sont des données de validation. Ils ne sont jamais une entrée de l\'agent de triage.',
				COLUMN: 'Libellé HIL',
				NOT_VETTED: 'Non vérifiée',
				NOT_VETTED_TIP: 'Aucun libellé HIL pour cette alerte',
				STATE: 'État HIL',
				COMMENT: 'Commentaire',
				ACTION_TAKEN: 'Action menée',
				RELIABILITY: 'Fiabilité',
				INHERITED: 'Hérité de l’épisode parent',
				AGREES: 'D\'accord avec HIL',
				DIFFERS: 'Diffère de HIL',
				AGREES_TIP: 'Notre classification concorde avec le libellé HIL',
				DIFFERS_TIP: 'La nôtre : {{ours}} · HIL : {{shell}}',
				AGREEMENT: 'D\'accord avec HIL sur {{agree}} des {{compared}} triées',
				AGREEMENT_TIP: 'Alertes filtrées triées (non en attente) avec un libellé HIL, et combien ont la même classe.\nLes libellés HIL sont des données de validation, jamais une entrée de l\'agent.',
				CARD_TITLE: 'Vérification HIL',
				FILTER_LABEL: 'Libellé HIL',
				FILTER_NONE: 'Non vérifiée',
				COLUMN_COMMENT: 'Commentaire HIL',
			},
			FACTS: {
				TITLE: 'Éléments lus — du plus ancien → au plus récent (tous avant la date limite)',
				HINT: 'Période des faits que l’exécution a lus dans chaque source. Chaque requête s’arrête à la date limite.',
				CUTOFF: 'Date limite {{time}}',
				COL_SOURCE: 'Source',
				COL_OLDEST: 'Plus ancien',
				COL_NEWEST: 'Plus récent',
				COL_GAP: 'Avant la date limite',
				SOURCE_HISTORIAN: 'Historian',
				SOURCE_SAP_NOTIFICATION: 'Avis SAP',
				SOURCE_SAP_WORKORDER: 'Ordres de travail SAP',
				SOURCE_SUPERVISOR_REPORT: 'Rapports du superviseur',
				SOURCE_ALERTS: 'Alertes',
				SOURCE_MEMORY: 'Mémoire',
				NOT_READ: 'Aucun fait lu',
				POST_ALERT: 'Enregistrements postérieurs à l’alerte',
				POST_ALERT_NONE: 'aucun récupéré : chaque requête s’arrête à la date limite',
				AFTER_CUTOFF: 'après la date limite',
				GAP_SECONDS: '{{count}} s',
				GAP_MINUTES: '{{count}} min',
				GAP_HOURS: '{{count}} h',
				GAP_DAYS: '{{count}} j',
			},
			SENSOR: {
				MEASURE: {
					temperature: 'Température',
					pressure: 'Pression',
					differential_pressure: 'Pression différentielle',
					level: 'Niveau',
					flow: 'Débit',
					vibration: 'Vibration',
					axial_position: 'Position axiale',
					speed: 'Vitesse',
					current: 'Courant',
					power: 'Puissance',
					voltage: 'Tension',
					valve_position: 'Position de vanne',
					status: 'État',
					composition: 'Composition',
				},
				GROUP: {
					vibration: 'Vibration',
					bearing_temperature: 'Température des paliers',
					axial_position: 'Position axiale',
					speed_run: 'Vitesse et marche',
					lube_oil: 'Huile de graissage',
					seal_gas: 'Gaz d\'étanchéité',
					suction: 'Aspiration',
					discharge: 'Refoulement',
					cooling: 'Refroidissement',
					anti_surge: 'Anti-pompage',
					scrubber_level: 'Niveau du séparateur',
					control_valve: 'Vanne de régulation',
					motor_electrical: 'Moteur électrique',
					turbine: 'Turbine',
				},
				ROLE: {
					process_value: 'Valeur procédé',
					setpoint: 'Consigne',
					controller_output: 'Sortie du régulateur',
					limit: 'Limite',
					mode: 'Mode',
					totaliser: 'Totalisateur',
				},
				GROUP_NONE: 'Autres',
				COL_SENSOR: 'Capteur',
				CONVENTION_ONLY: 'convention du tag seulement',
				TIP_MEASURES: 'Mesure : {{value}}',
				TIP_WHY: 'Pourquoi il est surveillé (plan technique de surveillance)',
				TIP_NO_REASON: 'Aucune raison de surveillance n\'est enregistrée pour ce capteur.',
				TIP_CONVENTION: 'Décrit uniquement par la convention de tags des P&ID ; le plan de surveillance ne le couvre pas.',
				TIP_ACTION: 'Action recommandée',
				TIP_UNIT: 'Unité : {{unit}}',
				TIP_LIMITS: 'Limites : {{value}}',
				TIP_SOURCES: 'Sources : {{value}}',
				TIP_LOW: 'Seul le nom du tag décrit ce capteur ; sa signification est donc moins certaine.',
				LIMIT_LOW: 'bas',
				LIMIT_HIGH: 'haut',
			},
			CONNECTED: {
				USUALLY_LEADS: 'précède habituellement de {{t}} (r {{r}})',
				USUALLY_LAGS: 'suit habituellement avec {{t}} de retard (r {{r}})',
				USUALLY_WITH: 'évolue habituellement en même temps (r {{r}})',
				NOT_COUPLED: 'habituellement non couplé (r {{r}})',
				USUAL_DELAY: 'a bougé avec son délai habituel',
				NOT_USUAL_DELAY: 'pas avec son délai habituel',
				COUPLING_HINT: 'Relation habituelle de ce capteur avec le tag d’alerte sur la référence en marche : le délai de meilleure corrélation et son r. « Délai habituel » compare la chronologie de cette fois avec lui.',
				TITLE: 'Systèmes connectés',
				VERDICT: {
					upstream_led: 'L\'amont a bougé en premier',
					service_related: 'Une utilité qui l\'alimente a bougé avec elle',
					downstream_followed: 'L\'aval a suivi — le changement commence ici',
					moved_together: 'Les unités connectées ont bougé ensemble',
					isolated: 'Les systèmes connectés sont restés stables — local à cet équipement',
					background_drift: 'Unités connectées hors référence depuis des jours (arrière-plan)',
					moved_unordered: 'Les unités connectées ont bougé, ordre incertain',
					insufficient: 'Trop peu de capteurs pour juger',
				},
				UPSTREAM: 'Amont',
				DOWNSTREAM: 'Aval',
				SERVICE: 'Utilités alimentant',
				REL_UPSTREAM: 'amont',
				REL_DOWNSTREAM: 'aval',
				REL_SERVICE: 'utilité',
				AS_OF: 'Lu à l\'heure de l\'alerte — rien d\'enregistré après n\'est utilisé',
				OF_SENSORS: 'sur {{total}} capteurs avec données',
				RATIO_HINT: 'Capteurs d\'interface des unités voisines avec des mesures exploitables avant l\'alerte',
				ANCHOR_ONSET: 'Début du tag d\'alerte',
				PLOT: 'Tag d\'alerte et capteurs d\'interface',
				PLOT_TITLE: 'Graphique des systèmes connectés',
				PLOT_CAPTION: 'Noir = tag d\'alerte · zone grise = machine à l\'arrêt · ligne pointillée = début du tag d\'alerte · bande grise = dans ±3 sd de la référence en marche. Cliquer pour agrandir.',
				NEIGHBOURS: 'Unités connectées',
				NEIGHBOURS_META: '{{total}} unités connectées lues, {{moved}} ont bougé',
				EXPAND_ALL: 'Tout développer',
				COLLAPSE_ALL: 'Réduire les stables',
				NO_NEIGHBOURS: 'Aucune unité connectée n\'a été lue.',
				OPEN_UNIT: 'Ouvrir cette unité dans la vue procédé',
				LINK_HIGH: 'liaison : forte',
				LINK_MEDIUM: 'liaison : moyenne',
				LINK_LOW: 'liaison : faible',
				LINK_HINT: 'Degré de certitude des plans que ces deux unités sont reliées',
				STATE_MOVED: 'a bougé',
				STATE_HELD: 'stable',
				STATE_NO_DATA: 'pas de données',
				SENSORS_N: '{{count}} capteurs',
				COL_SENSOR: 'Capteur d\'interface',
				COL_STATE: 'État',
				COL_Z_LAST: 'z dernier',
				COL_Z_LAST_HINT: 'Écart de la dernière mesure avant l\'alerte par rapport à la référence en marche, en écarts-types',
				COL_Z_DAY: 'z 24 h',
				COL_Z_DAY_HINT: 'Écart médian par rapport à la référence en marche sur les 24 h avant l\'alerte, en écarts-types',
				COL_ONSET: 'L\'écart a commencé',
				NO_READINGS: 'Pas de mesures exploitables avant l\'alerte',
				RELIEF: 'Collecteurs de décharge',
				MORE: 'Afficher plus',
				LESS: 'Afficher moins',
				DUR_MIN: '{{n}} min',
				DUR_H: '{{n}} h',
				DUR_D: '{{n}} jours',
				TIMING_BEFORE: 'a bougé {{t}} avant le tag d\'alerte',
				TIMING_BEFORE_SHORT: '{{t}} avant',
				TIMING_AFTER: 'a bougé {{t}} après le tag d\'alerte',
				TIMING_AFTER_SHORT: '{{t}} après',
				TIMING_TOGETHER: 'a bougé en même temps que le tag d\'alerte',
				TIMING_TOGETHER_SHORT: 'ensemble',
				TIMING_EARLIER: 'a commencé {{t}} avant le tag d\'alerte — arrière-plan',
				TIMING_EARLIER_SHORT: '{{t}} plus tôt · arrière-plan',
				TIMING_EARLIER_NO_DUR: 'a commencé bien avant le tag d\'alerte — arrière-plan',
				TIMING_EARLIER_NO_DUR_SHORT: 'bien avant · arrière-plan',
				TIMING_HELD: 'est resté proche de sa référence',
				TIMING_NO_DATA: 'pas de mesures exploitables avant l\'alerte',
				TIMING_UNCLEAR: 'a bougé, moment incertain',
			},
			GAPS: {
				TITLE: 'Capteurs attendus sans tag ({{count}})',
				LINK: 'Capteurs attendus sans tag ({{count}})',
				LINK_HINT: 'Capteurs attendus par le modèle de machine sans tag historian',
				EXPLAIN: 'Ce sont des capteurs que le modèle d\'actif C3 attend pour cette machine, mais qui n\'ont pas pu être associés à un tag historian ; aucune donnée ne peut donc être lue. Cette liste est informative et ne peut pas être modifiée ici.',
				NONE: 'Aucun capteur non associé.',
				COL_MACHINE: 'Machine',
				COL_SENSOR: 'Capteur attendu',
				COL_FAILURE_GROUP: 'Groupe de défaillance',
				COL_UNIT_TYPE: 'Type d\'unité',
			},
			FLOC: {
				LEVEL_1: 'Actif',
				LEVEL_2: 'Installation',
				LEVEL_3: 'Système',
				LEVEL_4: 'Sous-système',
				LEVEL_5: 'Équipement',
				PATH: 'Chemin FLOC',
				LEGEND_TITLE: 'Niveaux FLOC',
				LEGEND_HINT: 'Chaque emplacement est identifié par son code d\'emplacement fonctionnel SAP (FLOC). Les niveaux vont de l\'actif à l\'équipement.',
				TREE_FILTER_PLACEHOLDER: 'Rechercher un système ou un équipement (nom ou FLOC)…',
				SCOPE_N: '{{count}} FLOC',
				SCOPE_TIP: 'La file est filtrée sur ce FLOC et tout ce qu\'il contient',
				SCOPE_CLEAR: 'Effacer le filtre d\'emplacement',
				UNPLACED_TIP: 'Alertes sans emplacement fonctionnel',
				ALERTS_TOTAL: '{{count}} alertes',
				SOURCE_ASSET_CODE: 'Placé d\'après le code du nom de l\'actif',
				SOURCE_WELL: 'Placé d\'après le numéro du puits sous-marin',
				SOURCE_TRAIN: 'Placé d\'après le code de train ou de package',
				SOURCE_TAG_MAPPING: 'Placé d\'après la correspondance des tags historian',
				EXTRACT_HAD: 'l\'extraction de l\'alerte indiquait {{floc}}',
			},
			PMAP: {
				KEY_SENSORS: 'Capteurs clés ({{count}})',
				KEY_SENSORS_HINT: 'Les capteurs qui décrivent le mieux l\'état de cette unité',
				TITLE: 'Vue procédé',
				BUTTON: 'Vue procédé',
				OPEN: 'Ouvrir la vue procédé',
				OPEN_HINT: 'Zones de l\'installation et unités de procédé, reliées comme sur les P&ID',
				BACK: 'Retour à la file',
				UNITS_META: '{{units}} unités de procédé dans {{areas}} zones',
				LAYERS: 'Couches de liaison',
				SECONDARY: 'Afficher les liaisons secondaires ({{count}})',
				RELIEF: 'Décharge / torche ({{count}})',
				UTILITY: 'Utilités ({{count}})',
				CONTROL: 'Signaux de commande ({{count}})',
				TARGET_ONLY: 'Cibles seulement',
				LEGEND_BACKBONE: 'Liaison procédé',
				LEGEND_LINK: 'Liaison secondaire',
				LEGEND_RELIEF: 'Décharge / torche',
				LEGEND_UTILITY: 'Utilité',
				LEGEND_CONTROL: 'Signal de commande',
				LEGEND_UP: 'Amont',
				LEGEND_DOWN: 'Aval',
				LEGEND_TARGET: 'Contient des FLOC cibles',
				LEGEND_LOAD: 'Charge d\'alertes',
				LANE_META: 'Unités : {{units}} · Alertes : {{alerts}}',
				LANE_TIP: '{{units}} unités, {{alerts}} alertes, {{targets}} unités avec des FLOC cibles',
				EXPAND_LANE: 'Développer {{name}}',
				COLLAPSE_LANE: 'Réduire {{name}}',
				LINKS: 'Liaisons entre unités de procédé',
				EDGE_ARIA: 'Liaison de {{from}} vers {{to}}, {{medium}}',
				UNIT_ALERTS: '{{total}} alertes ({{scope}} dans le périmètre)',
				IN_SCOPE_N: '{{count}} dans le périmètre',
				TARGETS_N: '{{count}} FLOC cibles',
				SHEET_N: 'feuille {{sheet}}',
				CHIP: 'Procédé : {{name}}',
				CHIP_HINT: 'Ouvrir la vue procédé sur cette unité',
				UNITS_LABEL: 'Unités de procédé',
				N_MORE: '+{{count}} de plus',
				FROM_TO: '{{from}} → {{to}}',
				MEDIUM: 'Fluide',
				CONFIDENCE: 'Confiance',
				CONF_HIGH: 'Élevée',
				CONF_MEDIUM: 'Moyenne',
				CONF_LOW: 'Faible',
				WEAK: 'liaison faible',
				ONE_END: 'vu sur un seul plan',
				TYPE: 'Type',
				LAYER_BACKBONE: 'Liaison procédé',
				LAYER_LINK: 'Liaison secondaire',
				LAYER_RELIEF: 'Décharge / torche',
				LAYER_UTILITY: 'Utilité',
				LAYER_CONTROL: 'Signal de commande',
				CONNECTORS_N: '{{count}} connecteurs sur les plans',
				EVIDENCE_LOADING: 'Lecture des preuves sur les plans…',
				PANEL_ARIA: 'Détails de l\'unité de procédé',
				LOADING: 'Chargement…',
				SHOW_ALERTS: 'Afficher les alertes de cette unité',
				OPEN_EXPLORER: 'Ouvrir dans l\'explorateur d\'actifs',
				ALERTS: 'Alertes',
				NO_ALERTS: 'Aucune alerte',
				DRAWINGS: 'Plans ({{count}})',
				NO_DRAWINGS: 'Aucun plan n\'est lié à cette unité',
				OPEN_DRAWING: 'Ouvrir le P&ID',
				FLOCS: 'FLOC ({{count}})',
				NO_FLOCS: 'Aucun FLOC n\'est placé sur cette unité',
				OPEN_NODE: 'Ouvrir dans l\'explorateur d\'actifs',
				SHOW_FLOC_ALERTS: 'Afficher les alertes de ce FLOC',
				SHARED_FLOCS: 'Partagés avec d\'autres unités ({{count}})',
				INBOUND: 'Entrantes ({{count}})',
				OUTBOUND: 'Sortantes ({{count}})',
				NO_CONNECTIONS: 'Aucune liaison trouvée sur les plans',
				SHOW_ALL: 'Afficher les {{count}}',
				SHOW_FEWER: 'Afficher moins',
			},
			SEARCH_ALERTS_PLACEHOLDER: 'Rechercher alerte, ID, ID de définition, tag, FLOC…',
			CANVAS: {
				CAUSAL: {
					QUERIES: 'Questions ({{n}})',
					COL_HYPOTHESIS: 'Hypothèse',
					COL_FACET: 'Facette',
					COL_QUERY: 'Question',
					COL_ADMITTED: 'Admis',
					NOTHING: 'rien d\'admis',
					ADMITTED: 'Extraits admis ({{n}})',
					EXCERPTS_FROM_TRACE: 'Extraits issus de la trace de l\'étape (les six premiers) ; les résultats rejetés apparaissent une fois le document de l\'exécution chargé.',
					REJECTED: 'Résultats rejetés ({{n}})',
					NONE_REJECTED: 'Aucun résultat rejeté.',
					FACET_DESIGN_BASIS: 'Base de conception / enveloppe',
					FACET_ORIGINATING_CHANGE: 'Changement d\'origine',
					FACET_MECHANISM_SENSITIVITY: 'Sensibilité du mécanisme',
					FACET_PROTECTION_DETECTION: 'Protection / détection',
					FACET_SYMPTOM_DIAGNOSTIC: 'Symptôme / diagnostic',
					FACET_CORRECTIVE_ACTION: 'Action corrective',
				},
				TIER: {
					STAGE_QUICK: 'Étape 1 · Triage rapide (mini-agent)',
					STAGE_DEEP: 'Étape 2 · Investigation approfondie',
					QUICK_ANSWER: 'Réponse rapide',
					FINAL_ANSWER: 'Réponse finale',
					OUTCOME: 'Résultat',
					ACCEPTED: 'Acceptée',
					ESCALATED: 'Escaladée',
					ROUTE_ACCEPTED: 'Acceptée → Résultat',
					ROUTE_ESCALATED: 'Escaladée → Étape 2',
					NO_GATE: 'Pas de porte (triage rapide seul)',
					DECIDING: 'Vérification de la réponse rapide…',
					WAITING: 'Attend la réponse rapide',
					NOT_NEEDED: 'Inutile — la réponse rapide a passé la porte ; le temps et les tokens de l\'investigation approfondie ont été économisés.',
					NOT_RUN: 'Non exécutée — cette exécution était un triage rapide seul.',
					WOULD_HAVE_RUN: 'Aurait exécuté',
					DEEP_SPECIALISTS: 'Spécialistes lents',
					SKIP_VERDICTS: 'Nouvelle vérification des verdicts',
					SKIP_ADJUDICATION: 'Contrôle d\'exhaustivité et seconde adjudication',
					CHECK_NO_ACTION: 'Réponse sans action',
					CHECK_CONFIDENCE: 'Confiance',
					CHECK_NOT_CAPPED: 'Non plafonnée',
					CHECK_MODEL: 'Le modèle a répondu',
					CHECK_NO_REAL_EVENT: 'Aucun verdict d\'événement réel',
					CEILING: 'plafond {{pct}}',
					RULE_FALLBACK: 'repli sur règles',
					QUICK_NODE_NOTE: 'Étape 1 · triage rapide : passe du mini-agent, avant la porte.',
					ESCALATED_NOTE: 'Escaladée : au moins une vérification a échoué, l\'investigation approfondie a donc été exécutée.',
					ACCEPTED_NOTE: 'Acceptée : toutes les vérifications ont réussi ; la réponse rapide est le résultat.',
					CHECKS: 'Vérifications de la porte',
					COL_CHECK: 'Vérification',
					COL_VALUE: 'Valeur',
					COL_THRESHOLD: 'Seuil',
					COL_RESULT: 'Résultat',
					PASSED: 'Réussie',
					FAILED: 'Échouée',
					REASONS: 'Pourquoi elle a été escaladée',
					QUICK_VS_FINAL: 'Réponse rapide vs finale',
				},
				TITLE: 'Canevas d\'exécution',
				OPEN: 'Ouvrir le canevas',
				OPEN_HINT: 'Suivre l\'exécution étape par étape : chaque agent, appel de modèle et recherche',
				BACK: 'Retour à l\'alerte',
				RUN_PICKER: 'Exécution',
				RUN_PICKER_EMPTY: 'Aucune exécution pour l\'instant',
				LIVE: 'En direct',
				LIVE_HINT: 'Suivi de l\'exécution en temps réel (actualisation toutes les 1,5 s)',
				ELAPSED: 'Écoulé',
				DURATION: 'Durée',
				TOKENS: '{{input}} entrée / {{output}} sortie jetons',
				EVALUATION: 'Évaluation',
				EVENTS_N: '{{count}} événements',
				EVENTS_HINT: '{{llm}} appels de modèle · {{lookups}} recherches',
				ZOOM_FIT: 'Ajuster à la largeur',
				ZOOM_100: 'Taille réelle',
				POLL_ERROR: 'Impossible de récupérer les nouveaux événements : {{error}} — nouvelle tentative',
				LOADING: 'Chargement de l\'exécution…',
				NO_RUNS: 'Cette alerte n\'a pas encore d\'exécution',
				NO_EVENTS: 'Aucun événement enregistré pour cette exécution (antérieure au canevas)',
				PICK_NODE: 'Sélectionnez un nœud pour voir ce qu\'il a reçu et produit',
				IN_PROGRESS: 'L\'agent de triage est en cours d\'exécution. Elle se poursuit même si vous quittez cette page.',
				STALLED_NOTICE: 'Contact perdu avec l\'exécution ; le résultat apparaîtra après actualisation de la page.',
				RECONSTRUCTED: 'Reconstruit à partir de la trace enregistrée : cette exécution est antérieure au flux d\'événements ; entrées, sorties, appels de modèle et recherches ne sont pas disponibles.',
				PASS_N: 'Passe {{n}}',
				ROUND_N: 'Tour {{n}}',
				STATUS: {
					RUNNING: 'En cours',
					COMPLETED: 'Terminée',
					FAILED: 'Échouée',
					GATED: 'Non analysée',
					PENDING: 'En attente',
					NO_DATA: 'Pas de données',
					SKIPPED: 'Ignoré',
					STALLED: 'Connexion perdue',
				},
				COL: {
					PRE_RUN: 'Préparation',
					RESOLVE: 'Résolution et signal',
					SPECIALISTS: 'Spécialistes',
					VERDICTS: 'Verdicts',
					LOOP: 'Boucle de raisonnement',
					DECISION: 'Décision',
				},
				NODE: {
					LIBRARY_CAUSAL: 'Bibliothèque · ancrage causal',
					ESCALATION: 'Porte d\'escalade',
					LIBRARY: 'Spécialiste bibliothèque',
					CONNECTED: 'Systèmes connectés',
					GATE: 'Porte DQ',
					TOPOLOGY: 'Topologie',
					EVIDENCE: 'Preuves',
					VIEW: 'Vue à date',
					FINAL: 'Résultat',
					RESOLVER: 'Résolveur',
					SIGNAL: 'Signal',
					COHORT: 'Cohorte',
					MAINTENANCE: 'Maintenance',
					MANUAL_PRECEDENT: 'Précédent d\'alerte',
					LEARNINGS: 'Apprentissages',
					PROFILE: 'Profil',
					MULTIVARIATE: 'Multivarié',
					TMP: 'TMP',
					SHIFT_DPR: 'Quart et DPR',
					VISUAL: 'Analyste visuel',
					VERDICTS: 'Verdicts',
					HYPOTHESIZE: 'Hypothèses',
					INVESTIGATE: 'Investigation',
					COMPLETENESS: 'Complétude',
					ADJUDICATOR: 'Arbitre',
					SUPERVISOR: 'Superviseur',
				},
				BADGE: {
					CAUSAL_N: '{{admitted}} extraits · {{queries}} questions',
					HEADROOM: '{{kind}} {{value}} · {{pct}}%',
					LIBRARY_N: '{{n}} extraits · {{docs}} docs',
					LIBRARY_LIMITS: '{{n}} extraits · {{limits}} limites',
					GATE_PASS: 'Réussie',
					GATE_FAIL: 'Échouée',
					TAGS_N: '{{count}} tags',
					RECORDS_N: '{{count}} enregistrements',
					WITHHELD_N: '{{count}} retenus',
					RESOLVED: 'Résolu',
					NOT_RESOLVED: 'Non résolu',
					ALERTS_N: '{{count}} alertes',
					FACTS_N: '{{count}} faits',
					PRIOR_N: '{{count}} antérieures',
					LEARNINGS_N: '{{count}} apprentissages',
					LOADED: 'Chargé',
					NONE: 'Aucun',
					MOVED_N: '{{moved}} sur {{of}} ont bougé',
					VERDICTS_N: '{{count}} verdicts',
					LOOKUPS_N: '{{count}} recherches',
					CHECKS_N: '{{ran}} sur {{of}} contrôles',
					SPECIALISTS_N: '{{n}} sur {{of}} spécialistes',
				},
				BATCH_BADGE: 'Lot de {{count}} alertes sur {{floc}}',
				BATCH_HINT: 'Évaluées ensemble comme un épisode : {{ids}}',
				REASSESS_BADGE: 'Réévaluation à la date du {{t}}',
				REASSESS_HINT: 'Évaluation précédente : {{cls}}',
				ZONE: {
					EVIDENCE: 'Collecte des éléments',
					PARALLEL: 'en parallèle',
					LOOP: 'Boucle de raisonnement',
					DECISION: 'Décision',
				},
				LOOP: {
					CAUSAL_HINT: 'Après le premier passage du tableau, la Bibliothèque pose pour chaque hypothèse des questions d\'ingénierie (base de conception, changement, sensibilité, protection, diagnostic, action corrective) et n\'admet que les extraits portant sur cet instrument ou équipement comme preuve LIB-n',
					BOARD: 'Tableau des hypothèses',
					INVESTIGATOR: 'Enquêteur',
					ROUND_OF: 'Tour {{n}} sur max. {{max}}',
					HINT: 'le tableau propose et demande, l\'Enquêteur consulte, le tableau repondère',
					ROUNDS_USED: '{{n}} tours sur max. {{max}}',
					REQUESTS_N: '{{count}} demandes',
					REWEIGH: 'résultats → repondérer',
					LEAD_HINT: 'Hypothèse en tête, son poids et l\'évolution depuis la passe précédente',
					WEIGHING: 'Pondération des hypothèses…',
					NEXT_PASS: 'Passe suivante : repondération',
					CALL_NO_HINT: 'Appel {{n}} de {{tool}} dans cette exécution',
					CITED_HINT: 'Cité par la passe suivante : {{hyps}}',
					REPEAT_OF: 'identique au tour {{n}}',
					CALLING: 'Consultations en cours…',
					MOVED: 'Passe {{n}} :',
					MOVED_HINT: 'Comment le tableau a bougé après lecture des résultats de ce tour',
					SETTLED_FIRST: 'Tranché à la passe {{n}} : aucune consultation nécessaire',
					SETTLED_AT: 'Tranché à la passe {{n}} : plus de consultation nécessaire',
					BUDGET_SPENT: 'Budget de tours épuisé ({{max}} sur {{max}})',
					SHELF: 'Étagère d\'outils',
					SHELF_HINT: 'l\'Enquêteur peut appeler n\'importe quel outil, autant de fois que nécessaire, avec d\'autres arguments',
					UNUSED: 'non utilisé dans cette exécution',
				},
				TOOL: {
					SEARCH_LIBRARY: 'Chercher dans la bibliothèque',
					SEARCH_LEARNINGS: 'Rechercher des apprentissages',
					CONNECTED_EQUIPMENT: 'Équipements connectés',
					UNIT_SENSORS: 'Capteurs de l\'unité',
					FIND_SENSORS: 'Trouver des capteurs',
					PARALLEL_SYSTEMS: 'Systèmes parallèles',
					SISTER_TRAIN: 'Train jumeau',
					UNIT_ALERTS: 'Alertes de l\'unité',
					TAG_WINDOW: 'Fenêtre du tag',
					TAG_HISTORY: 'Historique du tag',
					SEARCH_RECORDS: 'Chercher des enregistrements',
					SEARCH_REPORTS: 'Chercher des rapports',
				},
				TOOL_HINT: {
					SEARCH_LEARNINGS: 'Apprentissages et règles du guide du site en vigueur à l’heure de l’alerte, classés par sens par rapport à une question.',
					CONNECTED_EQUIPMENT: 'Unités de procédé amont, aval ou voisines (d\'après les connecteurs du schéma de procédé), leurs capteurs d\'interface, et s\'ils ont bougé avant, avec ou après le tag de l\'alerte.',
					UNIT_SENSORS: 'Comportement d\'une unité de procédé nommée, capteur par capteur, pour les grandeurs demandées.',
					FIND_SENSORS: 'Quels capteurs existent pour une question et ce que chacun mesure.',
					PARALLEL_SYSTEMS: 'Le train jumeau (FGC A ↔ B, GLC A ↔ B …) : ses capteurs et alertes aux mêmes heures — cause commune ou locale ?',
					SISTER_TRAIN: 'L\'autre train ou la sonde redondante de la même boucle : cause commune ou locale ?',
					UNIT_ALERTS: 'Alertes de surveillance levées sur une unité (amont, aval, jumelle) dans les heures précédant l\'alerte.',
					TAG_WINDOW: 'Statistiques de n\'importe quel tag sur les N dernières heures avant l\'alerte.',
					TAG_HISTORY: 'Fréquence à laquelle un tag est sorti de sa bande sur 180 jours au plus, et si des travaux ont suivi.',
					SEARCH_RECORDS: 'Recherche par mots-clés dans les avis et ordres SAP (1 an) et les rapports de quart (6 mois).',
					SEARCH_REPORTS: 'Rapports de supervision et de production jusqu\'à un an ; chaque mot doit correspondre, des passages sont renvoyés.',
				},
				CALL: {
					NTH: 'Appel n° {{n}} de {{tool}} dans cette exécution',
					ARGS: 'Arguments',
					NO_ARGS: 'Aucun argument',
					REPEAT_NOTE: 'Identique à la demande du tour {{n}} : non relancé, le résultat précédent a été repris.',
					CITED: 'Cité par la passe {{n}}',
					CALLS_N: '{{count}} appels',
					ROUNDS_LIST: 'tours {{rounds}}',
					NOT_USED: 'L\'Enquêteur n\'a pas utilisé cet outil dans cette exécution.',
					GROUPED: '{{count}} consultations · outils utilisés : {{tools}}',
					CARRIED: '{{count}} observations des tours précédents reprises',
				},
				EVO: {
					TITLE: 'Comment les éléments ont fait bouger la conviction : poids des hypothèses par passe',
					HYPOTHESIS: 'Hypothèse',
					AFTER_N: 'après le tour {{n}} · {{count}} consultations',
					NOT_ON_BOARD: 'Absente du tableau à cette passe',
					AFTER_ROUND: 'après le tour {{n}} ({{count}} consultations)',
					CITES: 'les nouveaux éléments citent {{calls}}',
					MOVE_AFTER: 'Après le tour {{n}} :',
					PRECEDED_BY: 'consultations qui ont précédé :',
				},
				INSPECTOR: {
					TAB_INPUT: 'Entrée',
					TAB_OUTPUT: 'Sortie',
					TAB_MODEL_CALLS: 'Appels de modèle',
					TAB_LOOKUPS: 'Recherches',
					TAB_TRACE: 'Trace',
					EMPTY: 'vide',
					NOT_STARTED: 'Cette étape n\'a pas encore commencé',
					NO_INPUT: 'Aucune entrée enregistrée pour cette étape',
					STILL_RUNNING: 'Toujours en cours — la sortie apparaîtra à la fin de l\'étape',
					NO_OUTPUT: 'Aucune sortie enregistrée',
					HYPOTHESES_N: '{{count}} hypothèses',
					REQUESTS: 'Recherches demandées',
					WINDOWS: 'Lectures par fenêtre',
					LEAK_CHECK: 'Contrôle de fuite : {{value}}',
					MACHINE_STATE: 'État de la machine',
					PACKAGE_TEXT: 'Paquet de signal tel que lu par le modèle',
					ANOMALY_TEXT: 'Texte du modèle d\'anomalie',
					NO_LOOKUPS: 'Aucune recherche dans cette étape',
					RAW: 'Toute la sortie en données',
					NO_MODEL_CALLS: 'Aucun appel de modèle dans cette étape',
					ATTEMPT_N: 'Tentative {{n}}',
					PROMPT: 'Prompt',
					PROMPT_SIZE: '{{chars}} caractères, {{images}} images',
					IMAGE_PART: 'image ({{kb}} Ko)',
					RESPONSE: 'Réponse',
					NO_TRACE: 'Aucune ligne de trace pour ce nœud',
				},
			},
			VALIDATION: {
				COLUMN: 'Validation',
				FILTER: 'Validation',
				HUMAN: 'Humaine',
				AGENT: 'Agent',
				NONE: 'Non triée',
				HUMAN_VALIDATED: 'Validée par un humain',
				HUMAN_CORRECTED: 'Corrigée par un humain',
				AGENT_VALIDATED: 'Validée par l’agent',
				TIP_AGENT: 'Triée par l’agent ; aucune personne ne l’a encore revue',
				TIP_HUMAN_UNKNOWN: 'Validée par une personne',
				TIP_REPLAY: 'Libellé HIL rejoué par {{reviewer}} le {{date}}',
				TIP_UI: 'Revue dans UptimeAI par {{reviewer}} le {{date}}',
				TIP_CORRECTED: 'Un humain a corrigé l’agent : {{agent}} → {{human}}',
				TIP_ABSTAINED: 'L’agent l’a laissée à la revue humaine ; classée {{human}} par l’humain',
				TIP_AGREED: 'L’humain est d’accord avec l’agent : {{human}}',
				CSV: {
					VALIDATED_BY: 'Validée par',
					REVIEWER: 'Réviseur',
					REVIEW_SOURCE: 'Source de la revue',
				},
			},
			REVIEW: {
				TITLE: 'Revue SME',
				SOURCE_REPLAY: 'Label HIL (rejoué)',
				SOURCE_UI: 'Revue dans UptimeAI',
				BY: '{{reviewer}} · {{date}}',
				N_REVIEWS: '{{count}} revues',
				LABEL: 'Libellé',
				RELIABILITY: 'Fiabilité : {{value}}',
				RELIABILITY_HIGH: 'élevée',
				RELIABILITY_MEDIUM: 'moyenne',
				RELIABILITY_LOW: 'faible',
				RELIABILITY_HINT: 'Dans quelle mesure le libellé peut servir de vérité terrain — les libellés humains sont faillibles',
				ACTION_TAKEN: 'Action menée',
				NO_LABEL: 'Aucun libellé enregistré',
				AGENT_VS_HUMAN: 'Agent vs humain',
				AGREEMENT_AGREE: 'D’accord',
				AGREEMENT_DISAGREE: 'Désaccord',
				AGREEMENT_ABSTAINED: 'Abstention',
				AGENT_CONFIDENCE: 'Confiance de l’agent {{value}}',
				OUTCOMES: 'Avis SAP dans les 30 jours suivants (a posteriori)',
				REASONS: 'Motifs',
				AGENT_SAW_CHART: 'Jugement de l’agent sur le graphique',
				AGENT_SAW_STATE: 'État de la machine à ce moment',
				LEARNINGS_CHANGED: 'Apprentissages modifiés par cette revue ({{count}})',
				EARLIER: 'Revues précédentes',
				VERDICT: {
					CONFIRMED: 'Confirmée',
					CONFIRMED_HINT: 'L’agent et l’humain ont choisi la même classe.',
					AGENT_WRONG: 'Agent dans l’erreur',
					AGENT_WRONG_HINT: 'La classe du réviseur prévaut sur celle de l’agent ; l’agent a été corrigé.',
					AGENT_ABSTAINED: 'Agent abstenu',
					AGENT_ABSTAINED_HINT: 'L’agent l’a laissée à la revue humaine ; le libellé humain fixe la classe.',
					HUMAN_LIKELY_WRONG: 'Humain probablement dans l’erreur',
					HUMAN_LIKELY_WRONG_HINT: 'Libellée sans action, mais des avis SAP ont suivi sur cet équipement sous 30 jours ; exclue de la mémoire.',
					CONTESTED: 'Contestée',
					CONTESTED_HINT: 'L’agent et l’humain sont en désaccord et les éléments ultérieurs ne tranchent pas.',
					HUMAN_OVERRIDE: 'Décision humaine',
					HUMAN_OVERRIDE_HINT: 'Une personne dans UptimeAI a choisi une autre classe que l’agent ; sa décision prévaut.',
				},
			},
			MEMORY: {
				SIMILAR: 'similaire {{sim}}',
				SIMILAR_HINT: 'Hors du périmètre propre de cette alerte : ajouté car son sens est proche de l’alerte (similarité 0–1)',
				PROFILE: 'Profil du détecteur',
				TITLE: 'Mémoire opérationnelle utilisée',
				CHIP: 'Mémoire : {{learnings}} apprentissages, {{precedents}} précédents revus',
				CHIP_HINT: 'Apprentissages et précédents revus par des humains, connus avant cette alerte, que l’agent a consultés',
				NO_LEARNINGS: 'Aucun apprentissage appliqué',
				PRECEDENTS: '{{count}} précédents revus',
				SHOW_TRACE: 'Voir dans la trace',
			},
			LEARNINGS: {
				STATUS_RETIRED: 'Retiré',
				SCOPE_PLAYBOOK: 'Guide du site',
				SCOPE_PROFILE: 'Profil du détecteur',
				ALL_SCOPES: 'Tous les types de périmètre',
				MEANING_PLACEHOLDER: 'Rechercher par le sens, ex. température de palier après redémarrage',
				MEANING_SEARCH: 'Rechercher',
				MEANING_HINT: 'Classe les apprentissages actuels selon la proximité de leur sens avec vos mots (embeddings), pas selon les mots exacts. Entrée pour rechercher ; videz le champ pour tout afficher.',
				RANKED_BY: 'Classé par sens : « {{q}} »',
				COL_SIMILARITY: 'Similarité',
				SIMILARITY_HINT: 'Similarité cosinus du sens (0–1) ; au-delà d’environ 0,8, correspondance proche',
				COL_LEARNING: 'Apprentissage',
				COL_EDITED: 'Modifié par',
				EDITED_BY: 'Modifié par {{name}}',
				EDIT_REASON: 'Motif : {{reason}}',
				NO_DISPOSITION: 'aucune (contexte)',
				N_ALERTS: '{{count}} alertes',
				NO_MATCH: 'Rien de proche par le sens',
				NO_MATCH_HINT: 'Essayez d’autres mots, ou videz la recherche pour lister tous les apprentissages.',
				BUTTON: 'Apprentissages',
				BUTTON_HINT: 'Apprentissages et mémoire opérationnelle issus des revues humaines',
				TITLE: 'Apprentissages et mémoire opérationnelle',
				SUBTITLE: 'Règles tirées des revues humaines d’alertes comparables ; l’agent ne consulte que celles connues avant chaque alerte',
				REFRESH: 'Actualiser',
				STAT_REVIEWS: 'Revues humaines',
				STAT_REPLAYED: '{{count}} libellés HIL rejoués',
				STAT_IN_APP: '{{count}} dans UptimeAI',
				STAT_AGREEMENT: 'Agent vs humain',
				STAT_RECONCILIATION: 'Rapprochement',
				STAT_LEARNINGS: 'Apprentissages',
				STATUS_ACTIVE: 'Actif',
				STATUS_CANDIDATE: 'Candidat',
				STATUS_CONTESTED: 'Contesté',
				SCOPE_SIGNAL: 'Signal',
				SCOPE_EQUIPMENT: 'Équipement + détecteur',
				SCOPE_DETECTOR: 'Détecteur',
				SEARCH: 'Rechercher un périmètre, un détecteur ou une règle',
				N_SHOWN: '{{shown}} sur {{total}}',
				EMPTY: 'Aucun apprentissage pour l’instant',
				EMPTY_HINT: 'Les apprentissages apparaissent dès que des personnes revoient des alertes triées.',
				COL_SCOPE: 'Périmètre',
				COL_SCOPE_TYPE: 'Type de périmètre',
				COL_DISPOSITION: 'Disposition',
				COL_SUPPORT: 'Appui',
				COL_SUPPORT_HINT: 'Revues conformes à la disposition / revues du périmètre · cohérence',
				COL_STATUS: 'Statut',
				COL_EFFECTIVE: 'En vigueur depuis',
				COL_CORRECTED: 'Agent corrigé',
				COL_CORRECTED_HINT: 'Revues où la personne a corrigé l’agent',
				COL_VERSION: 'Version',
				RULE: 'Règle opérationnelle',
				AUTHOR: 'Auteur : {{author}}',
				CLASS_COUNTS: 'Classes humaines',
				REASONS: 'Motifs',
				CHART_PATTERNS: 'Motifs du graphique',
				MACHINE_STATES: 'États de la machine',
				SOURCE_ALERTS: 'Alertes sources ({{count}})',
				OPEN_ALERT: 'Ouvrir l’alerte',
				VERSIONS: 'Historique des versions',
				SUPERSEDED: 'Remplacée',
				CURRENT: 'Actuelle',
			},
			PROCESS: {
				TITLE: 'Topologie du procédé et hiérarchie',
				FLOW_SUMMARY: '{{up}} en amont · {{down}} en aval',
				FLOW_SUMMARY_UNITS: '{{up}} en amont · {{down}} en aval (unités de procédé)',
				PROCESS_UNITS: 'Unités de procédé (PEFS)',
				NO_PID_LINE: 'Aucune ligne tracée sur les P&ID numérisés ; liens issus des connecteurs des schémas de procédé',
				IN_UNIT: 'Unité de procédé : {{name}}',
				SERVING: 'Utilités desservantes',
				RELIEF: 'Décharge',
				UNIT_TIP: '{{hops}} saut(s) · {{media}} · confiance {{confidence}}',
				SOURCE_PID: 'Flux d\'équipements issu des P&ID numérisés (lignes tracées sur un plan).',
				SOURCE_BOTH: 'Flux d\'équipements issu des P&ID numérisés (un plan à la fois) ; unités de procédé issues des renvois de feuilles PEFS, la même vue que l\'analyse des systèmes connectés.',
				HIERARCHY: 'Hiérarchie des actifs',
				LEVEL_SITE: 'Site',
				LEVEL_SYSTEM: 'Système',
				LEVEL_SUBSYSTEM: 'Sous-système',
				LEVEL_EQUIPMENT: 'Équipement',
				LEVEL_PACKAGE: 'Package',
				LEVEL_OTHER: 'Niveau',
				NOT_IN_TREE: 'Absent de l\'arborescence des actifs',
				NOT_IN_TREE_HINT: 'L\'équipement de l\'alerte n\'a pas de poste technique dans l\'arborescence SAP.',
				PARTIAL_TREE: 'Seule une partie du chemin a pu être placée dans l\'arborescence.',
				SIBLINGS: '{{count}} autres équipements dans {{parent}}',
				SHOW_ALL: 'Afficher les {{count}}',
				SHOW_FEWER: 'Afficher moins',
				N_TAGS: '{{count}} tags',
				NO_TREE_TAGS: 'Aucun tag historien placé sur ce nœud',
				FLOW: 'Flux du procédé',
				UPSTREAM: 'Amont',
				DOWNSTREAM: 'Aval',
				ALERT_EQUIPMENT: 'Équipement en alerte',
				MEASURED_BY: 'Instrument de l\'alerte',
				HOPS: 'À {{count}} saut(s)',
				NONE_UPSTREAM: 'Rien en amont',
				NONE_DOWNSTREAM: 'Rien en aval',
				NO_FLOW: 'Aucun lien de flux procédé pour cet équipement dans les P&ID numérisés',
				NOT_IN_PIDS: 'Équipement introuvable dans les P&ID numérisés',
				NOT_IN_PIDS_HINT: 'Sans correspondance P&ID pour l\'équipement de l\'alerte, l\'amont et l\'aval ne peuvent pas être affichés.',
				CONNECTED: 'Éléments connectés',
				NO_CONNECTED: 'Aucun autre élément n\'est connecté à cet équipement dans les P&ID numérisés.',
				EDGE_SERVES: 'Dessert',
				EDGE_SENSES: 'Détecte',
				EDGE_CONTROLS: 'Régule',
				EDGE_PROTECTS: 'Protège',
				EDGE_SAME_LINE: 'Même ligne de procédé',
				EDGE_MEASURES: 'Mesure',
				EDGE_FLOWS_TO: 'S\'écoule vers',
				EDGE_OTHER: 'Autres liens',
				CHART_TAGS: 'Tracer les tags de cet élément dans l\'onglet Tags',
				NO_TAGS_FOR_ITEM: 'Aucun tag historien n\'est lié à cet élément',
				NO_DATA_TAGS: 'L\'arborescence ne place aucun tag sur cet élément',
				TAGS_FAILED: 'Impossible de charger les tags de cet élément',
				FROM_TREE: 'Nombre de tags issu de l\'arborescence',
				CLICK_HINT: 'Cliquez sur un élément pour tracer ses tags historien (jusqu\'à 8, tags avec données en premier).',
			},
			ANALYSIS: {
				FOUND_BY_MEANING: 'trouvé par le sens',
				FOUND_BY_MEANING_SIM: 'trouvé par le sens · {{sim}}',
				FOUND_BY_MEANING_HINT: 'Recherche hybride : les enregistrements sont trouvés par leurs mots et par leur sens (embeddings). Celui-ci a été ajouté par la recherche sémantique dans le même sous-système ; le nombre est sa similarité avec l’alerte (0–1).',
				LEVEL_SHIFTS: 'Changements de niveau',
				LEVEL_SHIFTS_HINT: 'Instants avant la date limite où un tag modélisé est passé à un nouveau niveau et y est resté (amplitude en écarts-types de référence, moyenne avant → après).',
				MODEL_CACHED: 'modèle réutilisé (entraîné une fois par machine et par jour)',
				MODEL_CACHED_HINT: 'La même machine avait déjà un modèle entraîné pour ce jour, sur des données qui s’arrêtent toutes avant cette date limite ; il a été réutilisé au lieu d’être réentraîné.',
				REGIMES: 'Ajusté par régime de fonctionnement de {{tag}} : {{parts}} (écart de {{sep}} sd)',
				REGIMES_HINT: 'Le tag de marche montrait deux niveaux de fonctionnement distincts (part du temps @ niveau) ; le normal a donc été appris séparément pour chacun.',
				TRAINED_ON: 'Entraîné sur {{from}} – {{to}}',
				WINDOW_3M: '3 mois',
				WINDOW_1W: '1 semaine',
				WINDOW_1D: '1 jour',
				REASONING: 'Raisonnement',
				SETTLED: 'Tranché',
				UNSETTLED: 'Non tranché',
				SETTLED_HINT: 'Le tableau des hypothèses s’est arrêté car aucune recherche supplémentaire ne pouvait changer l’hypothèse en tête',
				UNSETTLED_HINT: 'Le tableau s’est arrêté à sa limite de passes alors que des recherches étaient encore demandées',
				BOARD_META: '{{passes}} passes · {{lookups}} recherches',
				HYPOTHESES: 'Hypothèses',
				WEIGHT_HINT: 'Poids de cette hypothèse sur le tableau (toutes les hypothèses totalisent 100 %)',
				IMPLIES_HINT: 'Classification qu’implique cette hypothèse si elle se vérifie',
				STATUS_VALIDATED: 'Validée',
				STATUS_REFINED: 'Affinée',
				STATUS_DEBUNKED: 'Réfutée',
				STATUS_OPEN: 'Ouverte',
				FOR: 'Pour',
				AGAINST: 'Contre',
				NONE: 'Aucun',
				CONFLICTS: 'Contradictions',
				LOOKUPS: 'Recherches de l’enquêteur',
				ROUND_N: 'Tour {{n}}',
				ROUND_OTHER: 'Autres recherches',
				WHY_ASKED: 'Pourquoi :',
				RESULT: 'Résultat',
				SIGNAL_TITLE: 'Signal et machine',
				N_TAGS: '{{n}} tags',
				RUNNING_AT_CUTOFF: 'En marche à l’heure limite',
				STOPPED_AT_CUTOFF: 'À l’arrêt à l’heure limite',
				SINCE_RESTART: 'Depuis le redémarrage',
				SINCE_STOP: 'Depuis l’arrêt',
				HOURS: '{{n}} h',
				LAST_SHUTDOWN: 'Dernier arrêt',
				ONGOING: 'en cours',
				RUN_SOURCE: 'État de marche : {{source}} ({{tag}})',
				RUNNING_PCT_HINT: 'Part de la fenêtre où la machine était en marche (vert) ou à l’arrêt (rouge)',
				RUNNING: 'en marche',
				SHUTDOWNS: 'arrêts',
				DOWN: 'à l’arrêt',
				MACHINE_UNKNOWN: 'État de marche inconnu : aucun tag d’état de marche pour cet équipement.',
				CHARTS_READ: 'Graphiques lus par le modèle',
				ANOMALY_SCORE: 'Score d’anomalie',
				ENLARGE: 'Cliquer pour agrandir',
				READ_ALERT_TAG: 'Tag d’alerte',
				READ_RELATED: 'Tags liés',
				READ_MACHINE: 'Machine',
				READ_ANOMALY: 'Lecture du modèle',
				CONSISTENT_WITH_HISTORY: 'Cohérent avec l’historique',
				NOT_CONSISTENT_WITH_HISTORY: 'Incohérent avec l’historique',
				STATS_TITLE: 'Statistiques vs référence',
				STATS_HINT: '— survolez une cellule pour p5–p95, la pente et le premier dépassement de 3 sd',
				COL_TAG: 'Tag',
				COL_MEDIAN: 'Médiane',
				COL_LAST: 'Dernière',
				COL_Z: 'z (méd.)',
				COL_Z_HINT: 'Médiane de la fenêtre en écarts-types de référence',
				COL_OUT: '% hors',
				COL_OUT_HINT: 'Part des mesures hors de la bande de référence p5–p95',
				ALERT_TAG: 'alerte',
				RUN_TAG: 'marche',
				TIP_BASELINE: 'Référence : médiane {{median}} ± {{sd}} sd, p5–p95 {{p5}}–{{p95}} {{unit}}',
				TIP_SPIKES: 'Pics supprimés : {{value}}',
				TIP_MASKED: 'Mesures en défaut masquées : {{n}}',
				TIP_RANGE: 'p5–p95 : {{p5}} – {{p95}} {{unit}}',
				TIP_SLOPE: 'Pente : {{value}} {{unit}}/jour',
				TIP_Z_LAST: 'z (dernière) : {{value}} · |z| max : {{max}}',
				TIP_FIRST_3SD: 'Premier dépassement de 3 sd : {{value}} UTC',
				TIP_NEVER_3SD: 'Jamais au-delà de 3 sd dans cette fenêtre',
				FOOT_SPIKES: 'Pics isolés supprimés avant les statistiques : {{value}}.',
				FOOT_MASKED: '{{n}} mesures en défaut (mauvaise qualité / hors plage) masquées.',
				ANOMALY_TITLE: 'Modèle d’anomalie',
				NOT_AVAILABLE: 'Non disponible',
				VERDICT_CONSISTENT: 'Cohérent',
				VERDICT_CHANGED: 'Modifié',
				VERDICT_STARTUP: 'Transitoire de démarrage',
				VERDICT_INSUFFICIENT: 'Données insuffisantes',
				MODEL_META: 'PCA {{k}} comp. · {{pct}} de variance · {{rows}} lignes d’entraînement',
				ONSET: 'Début durable',
				NO_ONSET: 'aucun',
				FIRST_TO_DEVIATE: 'Premier tag à dévier',
				ABOVE_LIMIT_24H: 'Dernières 24 h au-dessus de la limite',
				T2_SPE_HINT: 'Les scores sont relatifs au 99,5e centile de l’entraînement (1,0 = limite). T² élevé = les tags ont bougé ensemble vers un point de fonctionnement inhabituel ; SPE élevé = un tag ne concorde plus avec les autres (défaut local ou instrument) ; AE = erreur de reconstruction de l’autoencodeur.',
				AT_CUTOFF: 'À l’heure limite',
				AT_PEAK: 'Pic des dernières 24 h',
				IN_TRANSIENT: 'Dans le transitoire de démarrage',
				SCORE: 'Score',
				KIND_NORMAL: 'Dans la normale',
				KIND_SPE: 'Relation rompue (SPE) : un tag ne concorde plus avec les autres',
				KIND_T2: 'Point de fonctionnement déplacé (T²) : tags déplacés ensemble, relations conservées',
				KIND_BOTH: 'Point de fonctionnement inhabituel et relations rompues',
				ACTUAL_VS_EXPECTED: 'Réel vs attendu d’après les autres tags',
				NOT_MODELLED: 'Non modélisés (historique de marche insuffisant) : {{tags}}',
				RECORDS_TITLE: 'Enregistrements lus',
				OPEN_KNOWN_ISSUE: 'Problème connu ouvert',
				NO_OPEN_KNOWN_ISSUE: 'Aucun problème connu ouvert',
				OPEN_KNOWN_ISSUE_HINT: 'Si un avis ou un ordre de travail ouvert couvre déjà cet état au moment de l’alerte',
				RECORDS_COUNT: '{{read}} sur {{total}} enregistrements lus · {{cited}} cités',
				RECORDS_COUNT_HINT: 'Enregistrements existants avant l’alerte : {{work}} maintenance, {{reports}} rapports de quart, {{deferments}} pertes de production ; les mieux classés ont été lus',
				OPERATING_EVENTS: 'Événements d’exploitation avant l’alerte',
				FACTS: 'Faits cités',
				NO_FACTS: 'Aucun enregistrement ne concerne cette alerte.',
				RELEVANCE_DIRECT: 'Direct',
				RELEVANCE_RELATED: 'Lié',
				RELEVANCE_BACKGROUND: 'Contexte',
				IMPL_KNOWN_ISSUE: 'Problème connu ouvert',
				IMPL_RECENT_WORK: 'Travaux récents l’expliquent',
				IMPL_OPERATING_EVENT: 'Événement d’exploitation',
				IMPL_INSTRUMENT: 'Problème d’instrument',
				IMPL_DEGRADATION: 'Signe de dégradation',
				DIR_NO_ACTION: 'Pour aucune action',
				DIR_SERVICE: 'Pour intervention',
				DIR_NEUTRAL: 'Neutre',
				OPEN_IN_MAINTENANCE: 'Afficher dans l’onglet Maintenance',
				OPEN_IN_REPORTS: 'Afficher dans l’onglet Rapports',
				DROPPED: '{{n}} lus mais non pertinents : {{ids}}',
			},
			VISUAL: {
				TITLE: 'Revue des graphiques',
				PATTERN_TOGETHER: 'Les tags ont évolué ensemble',
				PATTERN_DEPARTED: 'Un tag a dévié seul',
				PATTERN_SHUTDOWN: 'Arrêt / démarrage',
				PATTERN_NO_CHANGE: 'Aucun changement significatif',
				PATTERN_SPLIT: 'Tags liés divergents',
				PATTERN_INSUFFICIENT: 'Trop peu de données pour juger',
				PATTERN_UNKNOWN: 'Non classé',
				CONFIDENCE: 'Confiance {{value}}',
				CONFIDENCE_HINT: 'Confiance du jugement final',
				MOVED_TOGETHER_YES: 'Évolution commune',
				MOVED_TOGETHER_NO: 'Pas d\'évolution commune',
				DISAGREE: 'Les statistiques et les graphiques divergent — examinez les graphiques avant de vous fier à ce jugement.',
				AGREE: 'Les graphiques confirment les statistiques',
				STATISTICS_SAY: 'Selon les statistiques',
				CHARTS_SAY: 'Selon les graphiques',
				LED_BY: 'Mené par',
				LED_BY_HINT: 'Le tag qui a bougé en premier',
				DEPARTED_ALONE: 'A dévié seul',
				DEPARTED_ALONE_HINT: 'Le tag qui a bougé alors que les tags liés restaient stables',
				REASONING: 'Raisonnement',
				CHARTS: 'Graphiques lus par le modèle ({{count}})',
				NO_CHARTS: 'Aucune image de graphique n\'a été enregistrée pour cette exécution.',
				OPEN_CHART: 'Ouvrir le graphique {{n}}',
				CHART_ALT: 'Graphique {{n}} jusqu\'à l\'heure de l\'alerte',
				CHART_FAILED: 'Impossible de charger l\'image du graphique',
				CHART_N_OF: 'Graphique {{n}} sur {{total}}',
				CHART_DIALOG_HINT: 'Les graphiques s\'arrêtent juste avant l\'alerte. Utilisez ← / → pour naviguer.',
				PREV_CHART: 'Graphique précédent',
				NEXT_CHART: 'Graphique suivant',
				REVIEWS: 'Revues par tag ({{count}})',
				LEVEL: 'Niveau : {{value}}',
				FLUCTUATION: 'Fluctuation : {{value}}',
				MODEL: 'Revu par {{model}}',
			},
			CONTEXT: {
				MODE_PID: 'P&ID',
				MODE_GRAPH: 'Graphe de contexte',
				CHOOSE_DRAWING: 'Choisir un plan',
				ITEMS_COUNT: '{{count}} mis en évidence',
				HAS_INSTRUMENT: 'instrument de l’alerte',
				HAS_EQUIPMENT: 'équipement de l’alerte',
				TITLE_INSTRUMENT: 'Emplacement mis en évidence de l’instrument {{tag}}',
				TITLE_EQUIPMENT: 'Emplacement mis en évidence de l’équipement {{tag}}',
				LOADING: 'Chargement du contexte procédé…',
				LOAD_FAILED: 'Impossible de charger le contexte procédé de cette alerte.',
				UNRESOLVED: 'L’équipement et l’instrument de l’alerte ne figurent pas dans le graphe de connaissances',
				UNRESOLVED_HINT: 'Impossible d’afficher l’emplacement sur le P&ID ou les actifs connectés.',
				NO_DRAWING: 'Aucun P&ID numérisé ne montre cet équipement',
				NO_DRAWING_HINT: 'Utilisez le graphe de contexte pour voir les actifs connectés.',
				SAME_LINE: 'Sur la même ligne',
				SAME_LINE_EMPTY: 'Aucun élément sur la même ligne de procédé.',
				CONNECTED_ON_DRAWING: 'Connectés sur le plan',
				CONNECTED_EMPTY: 'Aucun élément connecté sur ce plan.',
				CONNECTED_ELSEWHERE: 'Connectés, hors de ce plan',
				LOCATE: 'Afficher sur le plan',
				ADD_TO_CHART: 'Ajouter {{tag}} aux graphiques',
				NOT_LINKED: 'non lié',
				GRAPH_EMPTY: 'Aucun actif connecté trouvé pour cette alerte.',
				GRAPH_HINT: 'Taille = nombre de tags · cliquez sur un nœud avec tag historien pour le tracer',
				ROLE: {
					ALERT_EQUIPMENT: 'Équipement de l’alerte',
					ALERT_INSTRUMENT: 'Instrument de l’alerte',
					CONNECTED: 'Connecté',
					SAME_LINE: 'Même ligne de procédé',
					OTHER: 'Autre',
				},
				EDGE: {
					FLOWS_TO: 'S’écoule vers',
					SERVES: 'Dessert',
					SENSES: 'Détecte',
					CONTROLS: 'Commande',
					PROTECTS: 'Protège',
					SAME_LINE: 'Même ligne',
					MEASURES: 'Mesure',
					RELATED: 'Associé',
				},
				NODE_TYPE: {
					EQUIPMENT: 'Équipement',
					INSTRUMENT: 'Instrument',
					CONTROLVALVE: 'Vanne de régulation',
					PROCESSLINE: 'Ligne de procédé',
				},
				TOOLTIP: {
					TAG: 'Tag',
					HISTORIAN_TAG: 'Tag historien',
					TYPE: 'Type',
					ROLE: 'Rôle',
					TAG_COUNT: 'Tags historien',
					LINE: 'Ligne',
					DRAWING: 'Plan',
				},
			},
			PAGE_TITLE: 'Alertes',
			ENTERPRISE: 'Shell',
			SEARCH_PLACEHOLDER: 'Rechercher...',
			SEARCH_OWNER: 'Rechercher un responsable...',
			OWNER_FILTER: 'Filtrer par responsable',
			CHOOSE_STATUSES: 'Choisir les statuts à afficher',
			ALL_STATUSES: 'Tous les statuts',
			FILTERS: 'Filtres',
			MORE: 'Plus',
			WATCHERS: 'Observateurs',
			COLLAPSE_PANEL: 'Réduire le panneau',
			EXPAND_PANEL: 'Développer le panneau',
			RETRY: 'Réessayer',
			CLOSE: 'Fermer',
			PREVIOUS: 'Alerte précédente',
			NEXT: 'Alerte suivante',
			SCORE: 'Score',
			SEE_MORE: 'Voir plus',
			SEE_LESS: 'Voir moins',
			CLASS: {
				FALSE_NO_ACTION: 'Fausse – Sans action',
				FALSE_DQ: 'Fausse – Qualité des données (DQ)',
				VALID_NO_ACTION: 'Valide – Sans action',
				CREATE_SERVICE: 'Valide – Créer un service',
				HUMAN_REVIEW: 'Revue SME',
				PENDING: 'En attente',
			},
			CLASS_OPTION: {
				FALSE_DQ: 'False – DQ (raised on bad data: instrument or data feed)',
				HUMAN_REVIEW: 'Revue SME (évaluation manuelle requise)',
				CREATE_SERVICE: 'Créer un cas (lancer l\'investigation et l\'action)',
				VALID_NO_ACTION: 'Valide – aucune action (clore l\'événement – pas de service)',
				FALSE_NO_ACTION: 'Faux – aucune action (clore l\'événement – pas de service)',
			},
			STATUS: {
				ACKNOWLEDGED: 'Acknowledged',
				UNACKNOWLEDGED: 'Unacknowledged',
				DEFECT_RAISED: 'Pending – Defect Raised',
				UNACTIONED: 'Non traitée',
				APPROVED: 'Approuvée',
				RELEARNED: 'Réapprise',
			},
			STATE: {
				ACTIVE: 'Active',
				RETURNED_TO_NORMAL: 'Retour à la normale',
			},
			TELEMETRY: {
				TITLE: 'Série temporelle',
				AVAILABLE: 'Disponible',
				MISSING: 'Manquante',
				TIP_AVAILABLE: 'Relevés historiques de {{tag}} dans les 24 h précédant l\'alerte',
				TIP_NO_DATA: 'Aucun relevé historique de {{tag}} dans les 24 h précédant l\'alerte',
				TIP_NOT_IN_HISTORIAN: '{{tag}} n\'est pas dans l\'historien',
				TIP_NO_TAG: 'L\'alerte ne cite aucune balise de l\'historien',
				UNUSABLE: 'Inutilisable',
				TIP_UNKNOWN: 'Disponibilité non vérifiable',
			},
			TAGX: {
				THIS_EQUIPMENT: 'Cet équipement',
				ALL_EQUIPMENT: 'Tous les équipements liés ({{count}})',
				FILTER: 'Filtrer',
				HISTORIAN_RESULTS: 'Recherche historian',
				MODE_FUNCTION: 'Par fonction',
				MODE_RELATION: 'Par relation',
				FILTER_MEASURE: 'Filtrer par grandeur mesurée',
				FILTER_GROUP: 'Filtrer par groupe fonctionnel',
				CLEAR_FILTERS: 'Effacer les filtres',
				SHOW_ALL: 'Tout afficher ({{count}} de plus)',
				NO_MATCHES_FILTERED: 'Aucun résultat pour les filtres sélectionnés',
				TITLE: 'Afficher d’autres tags',
				SEARCH_PLACEHOLDER: 'Rechercher des tags par nom ou description',
				MIN_CHARS: 'Saisissez au moins 2 caractères',
				SEARCHING: 'Recherche…',
				NO_MATCHES: 'Aucun tag correspondant',
				HAS_DATA: 'Données d’historien disponibles',
				NO_DATA: 'Aucune donnée d’historien',
				SELECTED: '{{count}} / {{max}} sélectionnés',
				MAX_REACHED: '{{max}} tags au maximum peuvent être sélectionnés',
				CLEAR: 'Effacer la sélection',
				CHART_TOGETHER: 'Tracer ensemble',
				HIDE_CHART: 'Masquer le graphique',
				IN_LIST: 'Dans la liste',
				VIA: 'via {{via}}',
				GROUP_ALERT: 'Tag de l’alerte',
				GROUP_COMPONENT: 'Même composant',
				GROUP_EQUIPMENT: 'Même package / équipement',
				GROUP_CONNECTED: 'Équipements connectés',
				GROUP_PID: 'Instruments P&ID',
				GROUP_OTHER: 'Autres liés',
				GROUP_SEARCH: 'Ajoutés depuis la recherche',
				NO_TAGS: 'Aucun tag lié trouvé',
				LOADING: 'Chargement des tags liés…',
				FILTER_EMPTY: 'Aucun tag lié ne correspond à « {{q}} »',
			},
			QUEUE: {
				DATE_FIELD: 'Filtrer par champ de date',
				DATE_FIELD_EVENT: 'Heure de l\'événement',
				DATE_FIELD_RAISED: 'Déclenchée',
				SORT_OLDEST: 'Plus anciennes d\'abord (cliquer pour inverser)',
				SORT_NEWEST: 'Plus récentes d\'abord (cliquer pour inverser)',
				PAGE_SIZE: 'Lignes par page',
				RANGE: '{{start}}–{{end}} sur {{total}}',
				FIRST_PAGE: 'Première page',
				PREV_PAGE: 'Page précédente',
				NEXT_PAGE: 'Page suivante',
				LAST_PAGE: 'Dernière page',
				GROUPED_PAGE_HINT: 'Les groupes sont formés à partir des alertes de cette page',
				ON_THIS_PAGE: 'sur cette page',
				SIGNAL_START: 'Début de l\'événement',
				RAISED: 'Créée le',
				RETURNED_TO_NORMAL_AT: 'Dernière activité (retour à la normale)',
				BASELINE_REF: 'Référence de base',
				BASELINE_REF_TIP: 'Heure de référence de base du détecteur ({{time}}) : l\'heure « last recorded on … » citée dans la description de l\'alerte. Ce n\'est pas l\'heure de l\'événement.',
				NOT_ANALYSED: 'Non analysée : {{reason}}',
				NOT_ON_PAGE: 'Occurrence récurrente absente de cette page. Ouvrez-la pour les détails.',
				COLUMNS: 'Colonnes',
				RESET_COLUMNS: 'Afficher toutes les colonnes',
				SET_STATUS: 'Définir le statut des alertes sélectionnées',
				CSV: {
					PROCESS_UNIT: 'UNITE_PROCEDE',
					FLOC: 'FLOC',
					POINTS: 'TAGS',
					DEFINITION_ID: 'ID_DEFINITION',
					NUMBER: '#',
					ALERT_ID: 'ID d\'alerte',
					SYSTEM_NAME: 'Nom du système',
					SYSTEM: 'Système',
					STATUS: 'Statut',
					CLASSIFICATION: 'Classification',
					CONFIDENCE: 'Confiance',
					ALERT_NAME: 'Nom de l\'alerte',
					SOURCE: 'Source',
					EVENT_TIME: 'Début de l\'événement (début du signal)',
					RAISED: 'Créée le',
					RETURNED_TO_NORMAL: 'Dernière activité (retour à la normale)',
					BASELINE_REF: 'Référence de base',
					STATE: 'État',
					TIME_SERIES: 'Série temporelle',
					ANCHOR_TAG: 'Tag d\'ancrage',
					NOT_ANALYSED: 'Non analysée (contrôle DQ)',
					OWNER: 'Responsable',
				},
				COLUMN_NUMBER: 'Numéro',
				SORT_BY_COLUMN: 'Trier par cette colonne',
				DATE_ON_EVENT: 'La période s\'applique au début de l\'événement',
				DATE_ON_CREATED: 'La période s\'applique à Créée le (colonne triée)',
				SHOW_COLUMNS: 'Afficher les colonnes',
				SEARCH_COLUMNS: 'Rechercher...',
				SELECT_ALL_COLUMNS: 'Tout sélectionner',
				RESET_DEFAULT_COLUMNS: 'Réinitialiser',
				RESIZE_COLUMN: 'Faire glisser pour redimensionner',
				STILL_ACTIVE: 'Toujours active',
			},
			GROUP_BY: {
				TITLE: 'Grouper par',
				EQUIPMENT: 'Equipment',
				NONE: 'Aucun',
				SYSTEM: 'Système',
				FACILITY: 'Site',
				SOURCE: 'Source',
				CLASSIFICATION: 'Classification',
				ALERT_STATUS: 'Statut de l\'alerte',
			},
			MENU: {
				EXPORT: 'Exporter les données',
				COLLAPSE_GROUPS: 'Réduire tous les groupes',
				EXPAND_WITHIN_GROUP: 'Développer tous les éléments du groupe',
				AUTO_REFRESH: 'Actualisation automatique',
			},
			AUTO_REFRESH: {
				OFF: 'Désactivée',
				LIVE: 'En direct',
				MIN_5: '5 minutes',
				MIN_15: '15 minutes',
				MIN_30: '30 minutes',
				HOUR_1: '1 heure',
			},
			FILTER: {
				TITLE: 'Filtrer par',
				SEARCH_ALERT_NAME: 'Rechercher par nom d\'alerte...',
				START_TYPING: 'Saisissez pour rechercher',
				APPLY: 'Appliquer',
				CLEAR_ALL: 'Tout effacer',
				TARGET_ONLY: 'FLOC cibles uniquement',
				TARGET_TIP: 'Uniquement les alertes sur les FLOC cibles listés dans Hiérarchies d\'actifs → Hiérarchie FLOC',
				TARGET_COUNT: '{{count}} alertes dans la vue actuelle',
			},
			TABLE: {
				STEP: 'Step',
				STEP_HINT: 'The triage-path step that decided the alert (amber: held for SME review)',
				TYPE: 'Type',
				PLUS_TAGS: '+{{count}} tags',
				DEFINITION_ID: 'ID de définition',
				ALERTS: 'Alertes',
				N_ALERTS: '{{count}} alertes',
				SYSTEM_NAME: 'Nom du système',
				STATUS: 'Statut',
				CLASSIFICATION: 'Classification',
				CONFIDENCE: 'Conf.',
				ALERT_NAME: 'Nom de l\'alerte',
				SOURCE: 'Source',
				EVENT_TIME: 'Début de l\'événement',
				STATE: 'État',
				OWNER: 'Responsable',
				EMPTY: 'Aucune alerte ne correspond aux filtres actuels',
				RECURRING: 'Récurrente : {{count}} occurrences dans cet épisode',
				TOGGLE_RECURRING: 'Afficher les alertes récurrentes',
				CREATED_ON: 'Créée le',
				LAST_ACTIVE: 'Dernière activité',
			},
			BULK: {
				ITEMS: 'éléments',
				ASSIGN_OWNER: 'Attribuer un responsable aux alertes sélectionnées',
				CHANGE_CLASSIFICATION: 'Modifier la classification',
				DONE: '{{count}} alertes mises à jour',
				PARTIAL: '{{ok}} alertes mises à jour, {{failed}} n\'ont pas pu l\'être',
			},
			ACTIONS: {
				APPROVE: 'Approuver',
				APPROVED: 'Approuvée',
				RELEARN: 'Réapprendre',
				RELEARNED: 'Réapprise',
				CLASSIFY: 'Classer',
			},
			DETECTOR: {
				POINTS_FROM_SIGNAL_TEXT: 'Tags lus dans SignalMeasurementText',
				POINTS_FROM_DESCRIPTION: 'Tags lus dans la description de l\'alerte',
				PRIMARY: 'principal',
				TAGS_TIP: 'Tags concernés par cette alerte ({{count}}) :',
				TAGS_N: 'Tags ({{count}})',
				LABEL: 'Détecteur',
				MECHANISM: 'Mécanisme de détection',
				MONITORED_TAG: 'Tag surveillé',
				CLUSTER_SIZE: 'Taille du groupe',
				FREQUENCY: 'Fréquence',
				WINDOW_SPAN: 'Durée de la fenêtre',
				N_ALERTS: '{{count}} alertes',
				PER_HOUR: '{{value}} alertes/h',
				HOURS: '{{value}} heures',
			},
			DQ: {
				STATUS_UNUSABLE: 'Unusable',
				PENDING_DEFECT: 'Defect raised',
				PENDING_DEFECT_TIP: 'Instrument work order {{wo}}: pending',
				TITLE: 'Évaluation de la qualité des données (DQ)',
				FROZEN: 'Signal plat',
				IMPOSSIBLE_ROC: 'Taux de variation',
				DOMAIN_RANGE: 'Hors plage',
				JITTER: 'Erratique',
				PASS_FROZEN: 'Réussi (dynamique)',
				PASS_IMPOSSIBLE_ROC: 'Réussi',
				PASS_DOMAIN_RANGE: 'Dans les limites',
				PASS_JITTER: 'Signal normal',
				FAIL_FROZEN: 'Figé',
				FAIL_IMPOSSIBLE_ROC: 'Échec',
				FAIL_DOMAIN_RANGE: 'Hors plage',
				FAIL_JITTER: 'Signal erratique',
				NOT_ASSESSED: 'Non évalué',
				STATUS_PASS: 'Réussi',
				STATUS_WARN: 'Avertissement',
				STATUS_FAIL: 'Échoué',
				STATUS_NO_DATA: 'Aucune donnée',
				STATUS_UNKNOWN: 'Non évalué',
				NOT_ANALYSED: 'Non analysé',
				READINGS: '{{n}} mesures · {{bad}} masquées',
				CHECK_INFO: 'Informatif',
				NO_GATE: 'La qualité des données n’a pas été évaluée pour cette alerte',
				SCORE: 'Score DQ : {{status}}',
			},
			AGENT: {
				NO_RUN: 'Not triaged yet',
				TIER_ACCEPTED: 'Triage rapide · accepté à {{pct}} ({{time}} · {{tokens}} tokens) — investigation approfondie inutile',
				TIER_QUICK_ONLY: 'Triage rapide seul · {{pct}} ({{time}} · {{tokens}} tokens)',
				TIER_ESCALATED: 'Escaladé vers l\'investigation approfondie :',
				TIER_QUICK_WAS: 'Réponse rapide : {{cls}} {{pct}} ({{time}} · {{tokens}} tokens)',
				TIER_FINAL_IS: 'finale : {{cls}} {{pct}}',
				MANUAL_CHIP: 'Manuel · {{label}}',
				TITLE: 'Agent de tri',
				RECOMMENDATION: 'Recommandation',
				NOT_RUN: 'L\'agent de tri n\'a pas encore été exécuté pour cette alerte. Cliquez sur « Exécuter l\'agent de tri » pour la classer automatiquement.',
				NO_RECOMMENDATION: 'Aucune recommandation enregistrée.',
				RUN: 'Exécuter l\'agent de tri',
				RUNNING: 'En cours…',
				RERUN: 'Relancer l\'agent de tri',
				CREATES_CASE: 'Crée un dossier',
				CONFIDENCE: '{{value}} de confiance',
				CAPPED: 'plafonnée',
				CAPPED_HINT: 'Confiance plafonnée à {{value}} car certains contrôles n\'ont pas pu être exécutés',
				VERIFIED_FACTS: 'Faits vérifiés et télémétrie',
				N_VERIFIED: '{{count}} vérifiés',
				HYPOTHESIS: 'Hypothèse de travail et mécanisme physique (pourquoi)',
				SUPPORTING_TAGS: 'Tags justificatifs',
				FMEA: 'AMDE dynamique',
				FAILURE_MODE: 'Mode de défaillance',
				MECHANISM: 'Mécanisme physique',
				IMPACT: 'Impact systémique',
				REMEDIATION: 'Remédiation',
				DISCIPLINE: 'Discipline',
				ACTIONABLE: 'Recommandations d\'ingénierie actionnables',
				WHAT_WOULD_CHANGE: 'Ce qui changerait cette conclusion',
				DECIDED_BY: 'Arbitré par {{model}}',
				HARNESS_VERSION: 'harness {{v}}',
				STALE_RUN: "Obsolète : exécution antérieure à la mise à jour du {{date}} ; relancez pour voir l'agent actuel",
				DEGRADED: 'Règle de repli',
				DEGRADED_HINT: 'Le LLM d\'arbitrage était indisponible ; cette décision provient de règles déterministes. Vérifiez avant d\'approuver.',
			},
			DIALOG: {
				APPROVE_TITLE: 'Approve classification',
				APPROVING: 'You agree with the agent: {{x}}',
				FEEDBACK_OPTIONAL: 'Optional: anything the agent should learn from this case',
				CORRECT_FINDING: 'Correct finding',
				SELECT_FINDING: 'Select the finding…',
				MAPS_TO: 'Shown to the customer as: {{x}} (mapping in force)',
				PROPOSE_TOGGLE: 'The finding “{{x}}” is right; the customer label should be different',
				PROPOSE_HELP: 'The alert keeps its finding. An administrator sees the proposal in Settings › Labels; a mapping change relabels every alert with this finding.',
				WANTED_LABEL: 'Label the customer expects',
				PROPOSED: 'Mapping change proposed to the administrators',
				RELEARN_TITLE: 'Réapprendre la classification',
				CLASSIFY_TITLE: 'Classer',
				CORRECT_CLASSIFICATION: 'Classification correcte',
				SELECT_CLASS: 'Sélectionnez une nouvelle catégorie...',
				FEEDBACK: 'Commentaire',
				FEEDBACK_REQUIRED: 'Obligatoire pour la révision',
				CANCEL: 'Annuler',
				CONFIRM: 'Confirmer',
			},
			EVIDENCE: {
				GROUP: {
					SERIES: 'Time series',
					RECORDS: 'Plant records',
				},
				ALL_TAGS: 'All tags',
				ON_DRAWING: 'Picked on the drawing:',
				CONTEXT_GRAPH: 'Context graph',
				SEARCH_REPORTS: 'Search the reports (any word in any section)',
				SEARCH_MATCHES: '{{n}} report(s) match',
				CITED_HERE: 'cited',
				AXES_UNIT: 'Axis per unit',
				AXES_TAG: 'Axis per tag',
				AXES_HINT: 'Overlay y-axes: share one axis per unit, or give every tag its own',
				SOURCE_ALERT: 'Source Alert',
				SOURCE_ALERT_FROM: 'Source alert · {{source}}',
				SYSTEM_DETAILS: 'System Details',
				REASONING_NOT_IN_RUN: 'Non enregistré pour cette exécution (exécutions antérieures à cette section).',
				DROP_TAGS_HINT: 'Faites glisser des tags depuis le panneau Afficher les tags pour ajouter des graphiques',
				TAGS: 'Tags',
				MAINTENANCE: 'Maintenance',
				REPORTS: 'Rapports',
				ALERTS: 'Alertes',
				DOCUMENTS: 'Documents',
				REASONING: 'Raisonnement',
				REASONING_SECTION: {
					DECISION: 'Decision',
					BOARD: 'Hypothesis board',
					EVIDENCE: 'Evidence used',
					MEMORY: 'Learnings used',
					LIBRARY: 'Bibliothèque',
					LIMITS: 'Limites',
					REASONING: 'Raisonnement',
					PLAYBOOK: 'Contrôles du playbook',
					SIGNAL: 'Signal et machine',
					CONNECTED: 'Systèmes connectés',
					ANOMALY: 'Modèle d\'anomalie',
					RECORDS: 'Enregistrements lus',
				},
				NO_TELEMETRY: 'Aucune donnée historique pour ces tags',
				NO_TELEMETRY_HINT: 'L\'historique ne couvre pas la fenêtre de l\'alerte pour ces tags.',
				NO_DATA_FOR: 'Aucune donnée historique pour',
				NOTIFICATIONS: 'Avis',
				NOTIFICATION: 'Avis',
				WORK_ORDERS: 'Ordres de travail',
				WORK_ORDER: 'Ordre de travail',
				NONE: 'Aucun enregistrement',
				ON_THIS_ITEM: 'Sur cet équipement',
				DESCRIPTION: 'Description',
				NOTIFICATION_NO: 'N° d\'avis',
				TYPE: 'Type',
				PRIORITY: 'Priorité',
				RAISED_ON: 'Créé le',
				COMPLETED_ON: 'Terminé le',
				FLOC: 'Poste technique',
				HIERARCHY_TIER: 'Niveau hiérarchique',
				SUPERVISOR_REPORTS: 'Rapports du superviseur',
				SHIFT_LOGS: 'Journaux de quart',
				RECENT_ALERTS: 'Alertes récentes',
				RELATED_ALERTS: 'Alertes associées',
				FIRED_AT: 'Déclenchée le',
				CONTEXT: 'Contexte',
				SHOW_AFTER_ALERT: 'Afficher les enregistrements postérieurs à l\'alerte',
				HINDSIGHT_HINT: 'Désactivé : uniquement ce qui était enregistré au déclenchement de l\'alerte, tel que vu par l\'agent. Activé : également les enregistrements créés ensuite.',
				HINDSIGHT_ON: 'Rétrospective activée : les enregistrements créés après l\'alerte sont affichés et marqués « Après l\'alerte ». L\'agent ne les a pas vus.',
				AFTER_ALERT: 'Après l\'alerte',
				HIDDEN_AFTER_ALERT: '{{n}} enregistrés après l\'alerte masqués',
				NONE_AT_ALERT: 'Aucun enregistrement au moment de l\'alerte',
				NOT_ANALYSED: 'Non analysé',
				NO_TIME_SERIES: 'Aucune série temporelle : {{reason}}',
				TELEMETRY_NO_DATA: 'l\'historien ne contient aucune mesure du tag de l\'alerte dans les 24 h précédentes',
				TELEMETRY_NOT_IN_HISTORIAN: 'le tag de l\'alerte n\'existe pas dans l\'historien',
				TELEMETRY_NO_TAG: 'l\'alerte n\'a pas de tag surveillé',
				TELEMETRY_UNKNOWN: 'disponibilité dans l\'historien inconnue',
				ADD_TAGS: 'Ajouter des tags',
				HIDE_TAG_LIST: 'Masquer la liste des tags',
				INCLUDE_BASELINE: 'Inclure la référence de base',
				ALERT_WINDOW: 'Fenêtre de l\'alerte',
				BASELINE_REF_AT: 'Référence de base du détecteur : {{at}}',
				CHARTED_TOGETHER: 'Tags tracés ensemble',
				NO_TAGS_CHARTED: 'Aucun tag tracé',
				NO_TAGS_CHARTED_HINT: 'Recherchez ou sélectionnez des tags liés dans la liste pour les tracer.',
				TAG_LOAD_FAILED: 'Impossible de charger ce tag',
				OVERLAY: 'Superposition – valeurs réelles, un axe Y par unité',
				OVERLAY_NORMALISED: 'Tous les tags sur un axe (z-score, unités différentes)',
				STATUS_AT_ALERT: 'Statut à l\'alerte',
				STATUS_NOW: 'actuel',
				OPEN_AT_ALERT: 'Ouvert à l\'alerte',
				CLOSED_AT_ALERT: 'Clôturé à l\'alerte',
				NOT_RAISED_AT_ALERT: 'Non créé à l\'alerte',
				SCOPE_ITEM: 'Cet élément',
				SCOPE_PARENT: 'Parent',
				BREAKDOWN: 'Panne',
				NUMBER: 'Numéro',
				EQUIPMENT: 'Équipement',
				REPORTED_BY: 'Signalé par',
				PLANNING_GROUP: 'Groupe de planification',
				WORK_CENTER: 'Poste de travail',
				SYMPTOM: 'Symptôme',
				CREATED_ON: 'Créé le',
				SCHEDULED_START: 'Début planifié',
				SCHEDULED_FINISH: 'Fin planifiée',
				ESTIMATED_DURATION: 'Durée estimée',
				HOURS_N: '{{n}} h',
				COST_ESTIMATE: 'Coût estimé',
				KNOWN_AT: 'Enregistré depuis',
				LONG_TEXT: 'Détails',
				STATUS_HISTORY: 'Historique des statuts',
				PRODUCTION_REPORTS: 'Rapports de production',
				DEFERMENT_REPORTS: 'Rapports de pertes de production',
				SUPERVISOR_REPORT: 'Rapport du superviseur',
				PRODUCTION_REPORT: 'Rapport de production journalier',
				DEFERMENT_REPORT: 'Rapport de perte de production',
				FULL_SCREEN: 'Plein écran',
				EXIT_FULL_SCREEN: 'Quitter le plein écran',
				BACK_TO_DOCUMENTS: 'Retour aux documents',
				DOWNLOAD: 'Télécharger',
				HSSE: 'HSSE',
				PRODUCTION: 'Production',
				HSSE_GRADE: 'Note HSSE',
				PRODUCTION_GRADE: 'Note de production',
				REPORT_DATE: 'Date du rapport',
				SOURCE_FILE: 'Fichier source',
				SUMMARY: 'Résumé',
				PRODUCTION_COMMENT: 'Commentaire de production',
				SUPERVISOR_COMMENTS: 'Commentaires du superviseur',
				ACTIVITIES: 'Activités',
				FORECAST: 'Prévisions / planning à venir',
				ALARMS: 'Alarmes',
				DEFERMENT: 'Pertes de production',
				OOS: 'Équipements hors service',
				IOW: 'Dépassements DOW / IOW',
				MOCS: 'MOC temporaires',
				NO_REPORT_TEXT: 'Aucun texte de rapport',
				CATEGORY: 'Catégorie',
				MAIN_CAUSE: 'Cause principale',
				SUB_CAUSE: 'Cause secondaire',
				EQUIPMENT_SYSTEM: 'Système d\'équipement',
				EQUIPMENT_TYPE: 'Type d\'équipement',
				EVENT_START: 'Début de l\'événement',
				EVENT_END: 'Fin de l\'événement',
				ENDED_BEFORE_ALERT: 'Terminé avant l\'alerte',
				ONGOING_AT_ALERT: 'En cours à l\'alerte',
				RECENT_ALERTS_HINT: 'sur ce tag / poste technique',
				RELATED_ALERTS_HINT: 'à ±60 min, même système en premier',
				SUB_ALERTS: 'Sous-alertes de l\'épisode',
				SUB_ALERTS_HINT: 'regroupées dans cet épisode',
				SAME_SYSTEM: 'Même système',
				OPEN_ALERT: 'Ouvrir cette alerte',
				NO_DOCUMENTS: 'Aucun document lié à cet équipement',
				PID: 'P&ID',
				PAGES_N: '{{n}} pages',
				UPDATED: 'Mis à jour',
				SOURCE: 'Source',
				REVISION: 'Révision',
				DOCUMENT_TYPE: 'Type de document',
				DOCUMENT_PREVIEW: 'Aperçu du document',
				FILE_NAME: 'Nom du fichier',
				PREVIEW_UNAVAILABLE: 'Aperçu indisponible',
				PREVIEW_UNAVAILABLE_HINT: 'Le fichier de ce document n\'est pas dans la base documentaire.',
				SHOWING_ALL_WO: 'Showing all {{shown}} of {{total}} work orders & notifications',
				SHOWING_EVIDENCE_WO: 'Showing {{shown}} condition-evidence records (of {{total}} total)',
				SHOW_ALL_EQUIPMENT_WO: 'Show all work orders for {{equipment}}',
				CITED_IN_PATH: 'Cited',
				LINKED_WO: 'Linked WO',
				ROOT_CAUSE: 'Root Cause',
				AGENT_READ_SUMMARY: 'Lors de sa dernière exécution, l\'agent a lu {{read}} rapports de supervision et en a cité {{cited}} — lisez d\'abord ceux cités.',
				ONLY_AGENT_READ: 'Seulement les rapports lus par l\'agent',
				AGENT_CITED: 'Cité par l\'agent · {{relevance}}',
				AGENT_READ: 'Lu par l\'agent · non cité',
			},
			CHART: {
				JUDGED_AT: 'Judged at (raised later)',
				NO_DATA: 'No data in the historian',
				SEPARATE: 'Separate',
				OVERLAY: 'Overlay',
				SEPARATE_HINT: 'One panel per tag, sharing the time axis',
				OVERLAY_HINT: 'All tags on one panel, one y-axis per unit',
				ALL_READINGS: '*All good readings in the window',
				INSTRUMENT_RANGE: 'Instrument range',
				MEDIAN: 'Median',
				STEADY_ONLY: '*Steady running only (shutdown and start-up excluded)',
				THRESHOLD_LIMIT: 'Threshold limit',
				TRIP_LIMIT: 'Trip limit',
				LIMIT_TRIP: 'Déclenchement',
				LIMIT_ALARM: 'Alarme',
				LIMIT_THRESHOLD: 'Seuil',
				LIMIT_INSTRUMENT: 'Instrument',
				LIMIT: 'limite',
				LIMIT_NONE: 'Aucune valeur chargée pour ce tag',
				TAG_LEGEND: 'Légende des tags',
				MASKED_HIDDEN: '{{count}} relevés masqués (qualité des données) exclus du graphique',
				NO_UNIT: 'Sans unité',
				HIGH: 'High',
				LOW: 'Low',
				AVERAGE: 'Average',
				ACTUAL: 'Réel',
				BASELINE: 'Référence',
				SIGNAL_START: 'Début du signal',
				RAISED: 'Déclenchée',
				RTN: 'Dernière activité',
				BASELINE_REF: 'Réf. de référence',
				NORMAL_MIN: 'Min. normal',
				NORMAL_MAX: 'Max. normal',
				MASKED: 'Mesures masquées (DQ)',
				MASKED_HOVER: 'Mesure masquée',
				ARTEFACT: 'Valeur de substitution / artefact de données',
				ARTEFACT_HOVER: 'Artefact de données (pas une mesure de procédé)',
				TIME_AXIS: 'Heure ({{zone}})',
				OFF_SCALE: 'hors échelle',
				MIN: 'min.',
				MAX: 'max.',
				RANGE_BAND: 'Min.–max.',
				LOADING: 'Chargement des données…',
				LOAD_ERROR: 'Impossible de charger les données pour cette plage',
				NO_DATA_IN_WINDOW: 'Aucune mesure dans cette fenêtre',
				HISTORIAN_SPAN: 'L’historien contient des données du {{first}} au {{last}}',
				CLOSE: 'Fermer le graphique',
				ZOOM_HINT: 'Faites glisser pour zoomer ou déplacer — les données se chargent automatiquement. Double-cliquez pour réinitialiser.',
				LAYOUT_STACKED: 'Empilé',
				LAYOUT_OVERLAY: 'Superposé',
				NORM_NONE: 'Valeurs brutes',
				NORM_ZSCORE: 'Score z',
				NORM_RANGE: '% de la plage',
				NORMALISED_Z: 'Score z (σ)',
				NORMALISED_PCT: '% de la plage',
				REMOVE_TAG: 'Retirer le tag',
				NO_TAGS: 'Sélectionnez des tags à tracer ensemble',
				TOGETHER_TITLE: 'Tags tracés ensemble',
			},
			DETAIL: {
				CHANGE_STATUS: 'Change status',
				ACK_HINT: 'Approve the current classification',
				REOPEN_HINT: 'Undo the last decision',
				REOPENED: 'Alert reopened',
				TARGET_FLOC: 'FLOC cible',
				OPEN_ALERT: 'Ouvrir l\'alerte',
				BACK_TO_QUEUE: 'Retour aux alertes',
				ALERT_ANALYSIS: 'Analyse de l\'alerte',
				EVIDENCE: 'Éléments de preuve',
				EVENT_TIME: 'Heure de l\'événement',
				EVENT_TIME_HINT: 'Début du signal (début de l\'écart)',
				RAISED: 'Déclenchée',
				RAISED_HINT: 'Moment où le système de surveillance a créé l\'alerte. L\'agent n\'utilise que ce qui était connu à ce moment-là.',
				RTN: 'Retour à la normale',
				BASELINE_REF: 'Réf. ligne de base',
				BASELINE_REF_HINT: 'Heure de référence du détecteur (dernier enregistrement de sa ligne de base), pas l\'heure de l\'événement',
				CLASSIFICATION_HINT: 'Classification actuelle. Choisissez une autre classe pour classer ou réapprendre cette alerte.',
				CHANGE_CLASS: 'Modifier la classification',
				CURRENT_CLASS: 'Classification actuelle : {{value}}',
				PREVIOUSLY_APPROVED: 'Précédemment approuvée',
				PREVIOUSLY_RELEARNED: 'Précédemment réapprise',
				HUMAN_REVIEW_REQUIRED: 'Revue SME — évaluation manuelle requise',
				NOT_CLASSIFIED: 'Pas encore classée',
				AGENT_PROPOSED: 'Proposée par l\'Agent de triage',
				NOT_ANALYSED_HINT: 'L\'Agent de triage n\'analyse pas cette alerte : ses données n\'ont pas passé les contrôles préalables. Classez-la manuellement si nécessaire.',
				NOT_ANALYSED_REASON: 'Non analysée : {{reason}}',
				RUN_BLOCKED: 'Non analysable',
				RUN_BLOCKED_WHY: 'Pas d\'analyse : {{reason}}',
				RUN_GATED: 'Non analysée',
				EVENT_START: 'Début de l\'événement',
				CREATED_ON: 'Créé le',
				LAST_ACTIVE: 'Dernière activité',
				LAST_ACTIVE_HINT: 'Retour à la normale de l\'alerte (dernière activité) ; « Active » tant qu\'elle est active',
			},
			CASE: {
				CHIP: 'Dossier n°{{id}}',
				CREATE: 'Créer un dossier',
				MANAGE_HINT: 'Créez un dossier pour gérer le suivi',
				CREATED: 'Dossier n°{{id}} créé',
				EXISTS: 'Le dossier n°{{id}} est déjà lié à cette alerte',
				CREATE_FAILED: 'Impossible de créer le dossier',
				BULK_CREATED: '{{count}} dossier(s) créé(s).',
			},
			RAIL: {
				LIMITS: 'Limits',
				ACTIVITY: 'Journal d\'activité',
				DISCUSSION: 'Discussion',
				TRACES: 'Traces',
				PREFERENCES: 'Préférences',
				ANALYSIS: 'Analyses et vues',
				OTHER_TAGS: 'Afficher les tags',
				OTHER_TAGS_HINT: 'Cliquez sur un tag ou faites-le glisser sur les graphiques pour l\'ajouter à l\'onglet Tags.',
				DOCUMENTS: 'Documents',
				NO_DOCUMENTS: 'Aucun document lié à cette alerte',
				NO_DOCUMENTS_HINT: 'Aucun manuel, P&ID ou rapport ne fait référence à cet équipement.',
				OPEN_IN_DOCUMENTS: 'Afficher dans l\'onglet Documents',
				REVISION: 'Rév. {{value}}',
				PID: 'P&ID',
				EXPORT_TAGS: 'Exporter les tags sélectionnés vers un système externe',
				SAVED_ANALYSIS: 'Analyses enregistrées',
				SAVED_VIEWS: 'Vues enregistrées',
				SAVED_DASHBOARDS: 'Tableaux de bord enregistrés',
				NOT_AVAILABLE: 'Pas encore disponible pour les alertes de triage',
				PREFERENCES_NOTE: 'L\'ombrage des périodes d\'arrêt et les lignes de déclenchement / d\'alarme / de seuil ne sont pas encore disponibles pour les graphiques de triage.',
			},
			ACTIVITY: {
				N_ACTIONS: 'Actions ({{count}})',
				EMPTY: 'Aucune activité pour le moment',
			},
			DISCUSSION: {
				N_COMMENTS: 'Commentaires ({{count}})',
				EMPTY: 'Aucun commentaire pour le moment',
				PLACEHOLDER: 'Écrire un commentaire...',
				REPLY: 'Répondre',
				REPLY_PLACEHOLDER: 'Écrire une réponse...',
				SEND: 'Envoyer',
			},
			TRACE: {
				SEARCH: 'Search the trace (agent, finding, record id…)',
				SEARCH_MATCHES: '{{n}} agent(s) match',
				TMP_NOT_APPLIED: 'Ligne TMP classée sous {{component}}, non appliquée',
				TITLE: 'Trace du pipeline d\'agents',
				EXPAND_ALL: 'Tout développer',
				COLLAPSE_ALL: 'Tout réduire',
				COMPLETED: 'Terminé',
				FAILED: 'Échec',
				N_AGENTS: '{{count}} agents',
				NO_RUN: 'Aucune exécution du pipeline',
				NO_RUN_HINT: 'Exécutez l\'agent de tri pour voir la trace détaillée des 14 agents.',
				STATUS_COMPLETED: 'Terminé',
				STATUS_NO_DATA: 'Aucune donnée disponible',
				STATUS_FAILED: 'Échec',
				STATUS_SKIPPED: 'Ignoré',
				TOKENS: 'Jetons LLM : {{input}} en entrée / {{output}} en sortie',
			},
			ERRORS: {
				LOAD: 'Impossible de charger les données de tri',
				ACTION: 'L\'action n\'a pas pu être effectuée',
				RUN_FAILED: 'L\'exécution de l\'agent de tri a échoué',
			},
			TIMELINE: {
				TITLE: 'Chronologie des événements',
				N_EVENTS: '{{n}} événements',
				RELATED_ALERTS: 'Alertes récentes et liées',
				RANGE_ALL: 'Tout',
				RANGE_90D: '90 j',
				RANGE_30D: '30 j',
				RANGE_7D: '7 j',
				RANGE_1D: '24 h',
				RESET_ZOOM: 'Réinitialiser le zoom',
				ZOOM_IN: 'Zoomer',
				N_MORE: '+{{n}} de plus',
				EMPTY: 'Aucun ordre de travail, avis, rapport ni report enregistré pour cette alerte.',
				CLICK_TO_OPEN: 'Cliquez pour l\'ouvrir ci-dessous',
				MINUTES: '{{n}} min',
				HOURS: '{{n}} h',
				DAYS: '{{n}} jours',
				N_ALERTS_IN: '{{n}} alertes en {{span}}',
				N_EVENTS_IN: '{{n}} événements en {{span}}',
				KIND_SELF: 'Cette alerte',
				KIND_ALERT: 'Alerte',
				KIND_WORK_ORDER: 'Ordre de travail',
				KIND_NOTIFICATION: 'Avis',
				KIND_SUPERVISOR: 'Rapport de supervision',
				KIND_PRODUCTION: 'Rapport de production',
				KIND_DEFERMENT: 'Report de production',
			},
			CANCEL: 'Cancel',
			SAVE: 'Save',
			PATH: {
				CITE_HINT: 'Open this record on the right',
				LAST_RECORDED: 'Detector: last recorded',
				LAST_RECORDED_TIP: 'The time the detector states in its text ("last recorded on …"); its meaning depends on the detector.',
				PLAIN_PENDING: 'A plain-language explanation is being written; reopen in a moment.',
				WHY: 'Why',
				STEP: 'Decided at',
				SHOW_DATA: 'Show data',
				HIDE_DATA: 'Hide data',
				DATA: 'Data',
				DETECTOR_CROSSED: 'crossed: why the alert fired',
				DETECTOR_OWN: 'the detector\'s rule',
				DETECTOR_OWN_TIP: 'The detector\'s own threshold. Crossing it is what raised the alert, so it is not evidence for a service; only an independent engineering limit is.',
				AGENT_DECIDED: 'agent decided',
				AGENT_DECISION: 'Agent decision',
				BASELINE: 'Baseline',
				CHECK: {
					FROZEN: 'Frozen',
					IMPOSSIBLE_ROC: 'Spikes',
					DOMAIN_RANGE: 'Out of range / codes',
					JITTER: 'Jitter',
					NODE_SUBSTITUTION: 'Feed substitution',
					TRIGGER_READINGS: 'Trigger readings',
				},
				CLEAR: 'clear',
				CONF_HIGH: 'High',
				CONF_LOW: 'Low',
				CONF_MEDIUM: 'Medium',
				DECIDED_AT: 'Decided at step {{n}} · {{title}}',
				DELAY: 'Delay',
				DISAGREE: 'The first check that matched (step {{n}}) points to {{outcome}}; the agent chose {{agent}}.',
				DISAGREE_SHORT: 'differs from path',
				DISAGREE_SHORT_TIP: 'The first matching check (step {{n}}) gives another class than the agent chose',
				DQ_ROUTE_FEED: 'Route: data-feed issue for the PI / historian owner (no work order)',
				DQ_ROUTE_INSTRUMENT: 'Route: instrument work order (I&E)',
				EXPORT_PDF: 'Export as PDF',
				FIRST_MATCH_AT: 'First match at step {{n}} · {{title}}',
				HELD_AT: 'Held at step {{n}} · {{title}}',
				JUSTIFICATION_STEP: 'Agent justification · step {{n}}',
				LIMIT: 'Limit',
				LINK_CLOSE: 'Valid – No Action (link)',
				MACHINE_SENSORS: 'Sensors on the machine',
				MATCHED: 'matched',
				NEAR: 'near',
				NONE: 'none',
				NOT_RUNNING: 'Not running steadily:',
				NO_FINDING: 'No finding recorded for this check',
				NO_LIMITS: 'No engineering limit is known for this tag',
				PEAK_24H: '24 h peak',
				PILL_ABNORMAL: 'Abnormal → continue',
				PILL_DECIDED: 'Decided',
				PILL_HELD: 'Held: not enough evidence',
				PILL_MATCHED: 'Matched',
				PILL_NOT_REACHED: 'Not reached',
				PILL_NO_MATCH: 'No match → continue',
				PROCESS_TOPOLOGY: 'Process topology',
				REACHED: 'reached',
				RECOMMENDATIONS: 'Recommendations ({{n}})',
				REPLAY_NO: 'Rule did not reproduce on raw data',
				REPLAY_YES: 'Rule reproduced on raw data',
				RULE: 'Rule',
				RUN_AT: 'Run {{at}}',
				RUN_INDICATOR: 'Run indicator',
				SELECT_SENSOR: 'select a sensor to chart it',
				SME_INTERNAL: 'SME / HIL label (internal, validation only; never an agent input)',
				STEP_AGREE: 'This check is right',
				STEP_DISAGREE: 'This check is wrong',
				STEP_EVIDENCE: '{{tags}} tags, {{records}} records, {{docs}} docs',
				SUBTITLE: '{{n}} checks · select a step',
				TITLE: 'Triage path',
				TRUST: 'Status',
				UNTRUSTED: 'not trusted',
				VALUE: 'Value',
				DECISION_TITLE: 'Decision',
				RCA_TITLE: 'Decision & Triage Path',
				RCA_PANE_TITLE: 'Decision & Triage Path',
				PROPOSED_EVIDENCE_TITLE: 'Proposed Evidence',
				MINI_TITLE: '8-Step Triage Path',
				JUSTIFICATION: 'Justification',
				ORDERED_TITLE: 'Ordered 8-Step Triage Path',
				ORDERED_SUBTITLE: '7 checks in order — the first check that matches decides the outcome',
				STEP_PASSED: 'Passed',
				STEP_NOT_REACHED: 'Not Reached',
				RULE_FLAGGED: 'Rule Flagged for Tuning',
				RULE_FLAGGED_NOTICE: 'Alert approved & detector rule flagged for tuning',
				FLAG_RULE_CTA: 'Close & Flag Rule for Tuning',
				CREATE_INSTRUMENT_WO: 'Create Instrument Work Order',
				INSTRUMENT_WO_TITLE: 'Create Instrument Work Order (Data Quality Policy)',
				INSTRUMENT_WO_POLICY: 'Routed to I&E Discipline',
				INSTRUMENT_TAG: 'Instrument Tag',
				DEFECT_DESCRIPTION: 'Defect Description',
				SUBMIT_INSTRUMENT_WO: 'Create Instrument Work Order',
				INSTRUMENT_WO_CREATED: 'Instrument Work Order {{id}} raised — Status moved to Pending – Defect Raised',
				ROOTY: 'Rooty',
				ROOTY_HINT: 'Ask Rooty or open discussion on this alert',
				ASK_ROOTY_STEP: 'Ask Rooty about this step',
				STEP_COMMENT: 'Comment on this step',
				STEP_COMMENT_PLACEHOLDER: 'Add a note on this triage step…',
				PLOT_TAG_HINT: 'Plot this tag in Proposed Evidence',
				PLOT_ALL_STEP_TAGS: 'Plot all {{count}} step tags',
				OPEN_WO_HINT: 'Open this Work Order in the Work Orders tab',
				OPEN_ALERT_EVIDENCE_HINT: 'Open this alert in the Alerts tab',
				STEP3_VISUAL_TITLE: 'Machine Diagram & Operating State',
				STEP3_VISUAL_HINT: 'Click any sensor to plot it on the right',
				STEP4_VISUAL_TITLE: 'P&ID Process Flow & Event Timeline',
				STEP4_VISUAL_HINT: 'Driver and response tags are plotted on the right',
				STEP5_VISUAL_TITLE: 'Event Timeline — Cited Work Orders & Open Alerts',
				STEP5_VISUAL_HINT: 'Click a marker or chip to inspect the Work Order or Alert on the right',
				DEEP_DETAILS: 'Deep RCA Details (Verified Facts, Hypotheses & FMEA)',
			},
		},
	}
};
